import * as Apollo from "@apollo/client"
import { gql } from "@apollo/client"
import * as ApolloReactComponents from "@apollo/client/react/components"
import * as React from "react"
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
const defaultOptions = {} as const

export type PossibleTypesResultData = {
  possibleTypes: {
    GenericMorph: [
      "Aoi",
      "Application",
      "ApplicationMethod",
      "ApplicationNature",
      "ApplicationType",
      "Approval",
      "Area",
      "AssistanceRequest",
      "ByLaw",
      "Company",
      "CompanyUpdateRequest",
      "CompletionCertificate",
      "ComponentDataAgentInfo",
      "ComponentDataApplicationServiceProvider",
      "ComponentDataEntry",
      "ComponentDataGeometrySetting",
      "ComponentDataMediaItem",
      "ComponentDataPaymentItem",
      "ComponentDataRequiredDocuments",
      "ComponentDataSet",
      "ComponentDataSubsidiary",
      "ComponentDataTextField",
      "ComponentPageContactUs",
      "ComponentPageFreeQuote",
      "ComponentPageHome",
      "ComponentPageInfoPage",
      "ComponentPageOrgHome",
      "ComponentPageTerms",
      "ComponentSharedMetaSocial",
      "ComponentSharedSeo",
      "ComponentUiCard",
      "ComponentUiGrid",
      "ComponentUiHeadline",
      "ComponentUiImages",
      "ComponentUiLink",
      "ComponentUiMediaCollection",
      "ComponentUiOrgHowItWorks",
      "ComponentUiParagraph",
      "ComponentUiReview",
      "ComponentUiSection",
      "ComponentUiTab",
      "ComponentUiText",
      "Configuration",
      "ContactRequest",
      "CountryBorder",
      "DeliveryConfirmation",
      "Deposit",
      "DiscussionTopic",
      "DistrictMunicipalityBorder",
      "DocumentTemplate",
      "DocumentType",
      "EmailDesignerEmailTemplate",
      "EmailEmitterEmail",
      "EmailMessage",
      "Enforcement",
      "FrequentlyAskedQuestion",
      "GuideTopic",
      "I18NLocale",
      "Incident",
      "InviteRequiredDocumentType",
      "Invoice",
      "KickoffInvite",
      "KickoffRecord",
      "LetterTemplate",
      "LicenseUpdateRequest",
      "LocalMunicipalityBorder",
      "MenusMenu",
      "MenusMenuItem",
      "MigrationJob",
      "Note",
      "NotificationMessage",
      "OrgWebsite",
      "Organization",
      "Payment",
      "Project",
      "Province",
      "ProvinceBorder",
      "Quotation",
      "QuoteItem",
      "QuoteRequest",
      "RefreshToken",
      "Report",
      "Setting",
      "SpatialGrid",
      "SpatialLayer",
      "SupportTopic",
      "Survey",
      "Task",
      "TemplateSubject",
      "TrustedDevice",
      "UploadFile",
      "UploadFolder",
      "UserProfile",
      "UsersPermissionsPermission",
      "UsersPermissionsRole",
      "UsersPermissionsUser",
      "WayleaveForm",
      "WayleaveRequest",
      "Website",
      "WebsiteMediaFile",
    ]
    OrgWebsiteOrgHomePageDynamicZone: ["ComponentPageOrgHome", "Error"]
    WebsiteContentDynamicZone: ["ComponentPageFreeQuote", "ComponentPageHome", "ComponentPageInfoPage", "Error"]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    GenericMorph: [
      "Aoi",
      "Application",
      "ApplicationMethod",
      "ApplicationNature",
      "ApplicationType",
      "Approval",
      "Area",
      "AssistanceRequest",
      "ByLaw",
      "Company",
      "CompanyUpdateRequest",
      "CompletionCertificate",
      "ComponentDataAgentInfo",
      "ComponentDataApplicationServiceProvider",
      "ComponentDataEntry",
      "ComponentDataGeometrySetting",
      "ComponentDataMediaItem",
      "ComponentDataPaymentItem",
      "ComponentDataRequiredDocuments",
      "ComponentDataSet",
      "ComponentDataSubsidiary",
      "ComponentDataTextField",
      "ComponentPageContactUs",
      "ComponentPageFreeQuote",
      "ComponentPageHome",
      "ComponentPageInfoPage",
      "ComponentPageOrgHome",
      "ComponentPageTerms",
      "ComponentSharedMetaSocial",
      "ComponentSharedSeo",
      "ComponentUiCard",
      "ComponentUiGrid",
      "ComponentUiHeadline",
      "ComponentUiImages",
      "ComponentUiLink",
      "ComponentUiMediaCollection",
      "ComponentUiOrgHowItWorks",
      "ComponentUiParagraph",
      "ComponentUiReview",
      "ComponentUiSection",
      "ComponentUiTab",
      "ComponentUiText",
      "Configuration",
      "ContactRequest",
      "CountryBorder",
      "DeliveryConfirmation",
      "Deposit",
      "DiscussionTopic",
      "DistrictMunicipalityBorder",
      "DocumentTemplate",
      "DocumentType",
      "EmailDesignerEmailTemplate",
      "EmailEmitterEmail",
      "EmailMessage",
      "Enforcement",
      "FrequentlyAskedQuestion",
      "GuideTopic",
      "I18NLocale",
      "Incident",
      "InviteRequiredDocumentType",
      "Invoice",
      "KickoffInvite",
      "KickoffRecord",
      "LetterTemplate",
      "LicenseUpdateRequest",
      "LocalMunicipalityBorder",
      "MenusMenu",
      "MenusMenuItem",
      "MigrationJob",
      "Note",
      "NotificationMessage",
      "OrgWebsite",
      "Organization",
      "Payment",
      "Project",
      "Province",
      "ProvinceBorder",
      "Quotation",
      "QuoteItem",
      "QuoteRequest",
      "RefreshToken",
      "Report",
      "Setting",
      "SpatialGrid",
      "SpatialLayer",
      "SupportTopic",
      "Survey",
      "Task",
      "TemplateSubject",
      "TrustedDevice",
      "UploadFile",
      "UploadFolder",
      "UserProfile",
      "UsersPermissionsPermission",
      "UsersPermissionsRole",
      "UsersPermissionsUser",
      "WayleaveForm",
      "WayleaveRequest",
      "Website",
      "WebsiteMediaFile",
    ],
    OrgWebsiteOrgHomePageDynamicZone: ["ComponentPageOrgHome", "Error"],
    WebsiteContentDynamicZone: ["ComponentPageFreeQuote", "ComponentPageHome", "ComponentPageInfoPage", "Error"],
  },
}
export default result

export const FileFragmentDoc = gql`
  fragment File on UploadFileEntity {
    id
    attributes {
      name
      url
      ext
      size
      previewUrl
      alternativeText
    }
  }
`
export const AoiFragmentDoc = gql`
  fragment Aoi on AoiEntity {
    id
    attributes {
      uid
      name
      status
      standCount
      approvedDate
      submittedDate
      notes
      createdAt
      approvalConditions
      backhaulLocation
      commercialViability
      contractorAddress
      contractorCompanyRegNo
      contractorCompanyVat
      contractorEmail
      contractorPhone
      distanceToExistingInfrastructure
      distributionCabinetArea
      municipalityName
      wayleaveConditions
      wayleaveContactEmail
      wayleaveContactFullName
      wayleaveContactPhone
      proximityScoring
      riskLevel
      province
      projectCenter
      decisionStatus
      expiryDate
      createdDate
      isCompetitors
      competitorsName
      fnoComments
      externalApplicant
      isExternalApplicant
      preAssessmentStatus
      existingOverbuildStatus
      overbuildPercentage
      overbuildAgentPercentage
      isOverbuildPercentageCorrect
      reasonForRejection
      intersectedAois {
        data {
          id
          attributes {
            name
            geoJson {
              data {
                ...File
              }
            }
          }
        }
      }
      provinces {
        data {
          id
          attributes {
            name
          }
        }
      }
      applicantCompany {
        data {
          id
          attributes {
            name
          }
        }
      }
      organization {
        data {
          id
          attributes {
            slug
            name
          }
        }
      }
      applicant {
        data {
          id
          attributes {
            fullName
            primaryEmail
          }
        }
      }
      documents {
        data {
          ...File
        }
      }
      approvalDocuments {
        data {
          ...File
        }
      }
      drawings {
        data {
          ...File
        }
      }
      photos {
        data {
          ...File
        }
      }
      wayleaveApprovalDocs {
        data {
          ...File
        }
      }
      supportingDocs {
        data {
          ...File
        }
      }
      complianceDocs {
        data {
          ...File
        }
      }
      approvalLetter {
        data {
          ...File
        }
      }
      mapSnapshots {
        data {
          ...File
        }
      }
      geoJson {
        data {
          ...File
        }
      }
      kml {
        data {
          ...File
        }
      }
    }
  }
`
export const LetterTemplateFragmentDoc = gql`
  fragment LetterTemplate on LetterTemplateEntity {
    id
    attributes {
      name
      description
      signatoryName
      signatoryPosition
      letterTitle
      letterBg {
        data {
          ...File
        }
      }
      preview {
        data {
          ...File
        }
      }
      companies {
        data {
          id
          attributes {
            name
          }
        }
      }
      organization {
        data {
          id
          attributes {
            name
          }
        }
      }
      affectedText
      notAffectedText
      rejectedText
      headerSpace
      footerSpace
      createdAt
      outsideServiceMessage
      type
    }
  }
`
export const ApplicationMethodFragmentDoc = gql`
  fragment ApplicationMethod on ApplicationMethodEntity {
    id
    attributes {
      title
      slug
    }
  }
`
export const DocumentTypeFragmentDoc = gql`
  fragment DocumentType on DocumentTypeEntity {
    id
    attributes {
      slug
      title
      requirements
      default
      uuid
    }
  }
`
export const ApplicationTypeFragmentDoc = gql`
  fragment ApplicationType on ApplicationTypeEntity {
    id
    attributes {
      title
      subtitle
      description
      includes
      excludes
      requirements
      turnaround
      slug
      color
      suffix
      documentTypes {
        data {
          id
          attributes {
            title
            requirements
          }
        }
      }
    }
  }
`
export const CompanyBaseFragmentDoc = gql`
  fragment CompanyBase on CompanyEntity {
    id
    attributes {
      name
      address
      phone
      logo {
        data {
          ...File
        }
      }
      vatNumber
      companyType
      createdAt
      thirdPartyApprovalsRequired
      statistics
      statisticsUpdate
      isStatisticPublished
      emails
      category
      approvalChainOrder
      isPaymentRequired
      feeAmount
      payfastMerchantId
      fullCountryCoverage
      countryBorders {
        data {
          id
          attributes {
            name
            code
          }
        }
      }
      provincesCoverage
      provinceBorders {
        data {
          id
          attributes {
            name
            code
          }
        }
      }
      districtsCoverage
      districtMunicipalityBorders {
        data {
          id
          attributes {
            name
            code
          }
        }
      }
      localMunicipalitiesCoverage
      localMunicipalityBorders {
        data {
          id
          attributes {
            name
            code
          }
        }
      }
      requiredCompanies {
        data {
          id
          attributes {
            name
          }
        }
      }
      subsidiaryCompany {
        data {
          id
          attributes {
            name
          }
        }
      }
      approvalChain {
        id
        level
        company {
          data {
            id
            attributes {
              name
            }
          }
        }
      }
      letterTemplates {
        data {
          ...LetterTemplate
        }
      }
      applicationMethods {
        data {
          ...ApplicationMethod
        }
      }
      documentTemplates {
        data {
          ...File
        }
      }
      appMethodDescription
      documentTypes {
        data {
          ...DocumentType
        }
      }
      byLaws {
        data {
          id
          attributes {
            title
            description
            documents {
              data {
                ...File
              }
            }
          }
        }
      }
      registrationNumber
      applicationType {
        data {
          ...ApplicationType
        }
      }
      organization {
        data {
          id
          attributes {
            slug
            name
          }
        }
      }
      userProfiles(pagination: { limit: -1 }) {
        data {
          id
          attributes {
            fullName
            primaryEmail
            secondaryEmail
            primaryPhone
            secondaryPhone
            address
            orgAgentStatus
            isDefaultAgent
            profileType
            status
          }
        }
      }
      geometryLastUpdate
      link
    }
  }
`
export const AreaFragmentDoc = gql`
  fragment Area on AreaEntity {
    id
    attributes {
      name
      fillColor
      strokeColor
      active
      status
      statusUpdated
      type
      siteRepresentatives {
        data {
          id
          attributes {
            fullName
            primaryEmail
          }
        }
      }
      kml {
        data {
          ...File
        }
      }
      geoJson {
        data {
          ...File
        }
      }
      geometryType
      company {
        data {
          id
          attributes {
            name
            companyType
            organization {
              data {
                id
                attributes {
                  slug
                }
              }
            }
            applicationType {
              data {
                id
                attributes {
                  slug
                  title
                  color
                }
              }
            }
          }
        }
      }
      category
      provinces {
        data {
          id
          attributes {
            name
          }
        }
      }
    }
  }
`
export const CompanyFragmentDoc = gql`
  fragment Company on CompanyEntity {
    ...CompanyBase
    attributes {
      areas(pagination: { limit: -1 }) {
        data {
          ...Area
        }
      }
    }
  }
`
export const ApplicationNatureFragmentDoc = gql`
  fragment ApplicationNature on ApplicationNatureEntity {
    id
    attributes {
      title
      documentTypes {
        data {
          ...DocumentType
        }
      }
    }
  }
`
export const UserProfileLimitedFragmentDoc = gql`
  fragment UserProfileLimited on UserProfileEntity {
    id
    attributes {
      uuid
      profileType
      isDefaultAgent
      orgAgentStatus
      primaryEmail
      secondaryEmail
      primaryPhone
      secondaryPhone
      address
      fullName
      status
      organization {
        data {
          id
          attributes {
            name
            slug
          }
        }
      }
      company {
        data {
          id
          attributes {
            name
          }
        }
      }
    }
  }
`
export const ApprovalOnApplicationFragmentDoc = gql`
  fragment ApprovalOnApplication on ApprovalEntity {
    id
    attributes {
      uuid
      name
      type
      createdAt
      status
      description
      deliveryNotes
      isRenewalApplied
      isExtensionApplied
      isAffected
      isSiteVisitRequired
      approvalDocumentType
      approvedBy {
        data {
          id
          attributes {
            fullName
            primaryEmail
          }
        }
      }
      feedback
      createdDate
      expiryDate
      renewalSubmitDate
      renewalApprovedDate
      extensionSubmitDate
      extensionApproveDate
      deliveryDate
      deliveryDateTime
      deliveryConfirmation {
        data {
          id
        }
      }
      refApproval {
        data {
          id
        }
      }
      approvalMapLetter {
        data {
          ...File
        }
      }
      approvalLetter {
        data {
          ...File
        }
      }
      attachments {
        data {
          ...File
        }
      }
      application {
        data {
          id
          attributes {
            title
          }
        }
      }
      company {
        data {
          id
          attributes {
            name
            emails
            address
            companyType
            isPaymentRequired
            feeAmount
            payfastMerchantId
            logo {
              data {
                ...File
              }
            }
            organization {
              data {
                id
                attributes {
                  slug
                }
              }
            }
            applicationMethods {
              data {
                id
                attributes {
                  slug
                }
              }
            }
          }
        }
      }
      contacts {
        data {
          ...UserProfileLimited
        }
      }
      agents {
        id
        name
        assignStatus
        agentProfile {
          data {
            ...UserProfileLimited
          }
        }
      }
    }
  }
`
export const ApplicationFragmentDoc = gql`
  fragment Application on ApplicationEntity {
    id
    attributes {
      title
      uuid
      createdAt
      submittedDate
      involvement
      serviceType
      description
      isGovernmentWork
      duplicationIndex
      isInfoPopupShow
      isArchived
      isIncidentRecorded
      isEmergency
      priority
      incident {
        data {
          id
        }
      }
      report {
        data {
          ...File
        }
      }
      appLetter {
        data {
          ...File
        }
      }
      requiredDocuments {
        id
        description
        docTypeName
        documents {
          data {
            ...File
          }
        }
      }
      optionalDocuments {
        id
        description
        docTypeName
        documents {
          data {
            ...File
          }
        }
      }
      projectDocuments {
        id
        description
        docTypeName
        documents {
          data {
            ...File
          }
        }
      }
      company {
        data {
          ...Company
        }
      }
      applicationType {
        data {
          id
          attributes {
            description
            title
            slug
          }
        }
      }
      progress
      project {
        data {
          id
          attributes {
            uuid
            title
            start
            end
            locationInfo
            description
            category
            projectCenter
            refNumber
            levelOfServices
            submissionTermsAcceptance
            provinces {
              data {
                id
                attributes {
                  name
                }
              }
            }
            municipalCompanies {
              data {
                id
                attributes {
                  name
                }
              }
            }
            otherNatureDescription
            projectNature {
              data {
                ...ApplicationNature
              }
            }
            owner {
              data {
                ...UserProfileLimited
              }
            }
            organization {
              data {
                id
                attributes {
                  slug
                  name
                  email
                }
              }
            }
            mapSnapshot {
              data {
                ...File
              }
            }
            geoJson {
              data {
                ...File
              }
            }
            kml {
              data {
                ...File
              }
            }
            applicantCompany {
              data {
                id
                attributes {
                  name
                  emails
                }
              }
            }
            applicant {
              data {
                id
                attributes {
                  primaryEmail
                  fullName
                }
              }
            }
            externalApplicant
          }
        }
      }
      serviceProviders {
        data {
          id
        }
      }
      agentsInfo {
        id
        name
        assignStatus
        agentProfile {
          data {
            ...UserProfileLimited
          }
        }
      }
      status
      approvedDate
      renewalSubmitDate
      renewalApproveDate
      extensionSubmitDate
      extensionApproveDate
      approvalMode
      spIsAffected
      applicationLetter
      payments {
        data {
          id
          attributes {
            type
            status
          }
        }
      }
      quotation {
        data {
          id
          attributes {
            status
          }
        }
      }
      invoice {
        data {
          id
          attributes {
            status
          }
        }
      }
      notes {
        data {
          id
          attributes {
            name
            description
          }
        }
      }
      approvals(pagination: { limit: -1 }) {
        data {
          ...ApprovalOnApplication
        }
      }
      renewals(pagination: { limit: -1 }) {
        data {
          ...ApprovalOnApplication
        }
      }
      category
      isPaymentSkipped
      feePaymentConfirmed
      payfastPaymentId
      paymentSkipReason
      submissionType
      paymentDocuments {
        data {
          ...File
        }
      }
    }
  }
`
export const ApplicationTableFragmentDoc = gql`
  fragment ApplicationTable on ApplicationEntity {
    id
    attributes {
      title
      uuid
      createdAt
      submittedDate
      submittedDateTime
      approvedDate
      renewalSubmitDate
      renewalApproveDate
      extensionSubmitDate
      extensionApproveDate
      effectiveDate
      effectiveDateOnly
      submissionType
      isIncidentRecorded
      isEmergency
      priority
      applicationType {
        data {
          id
          attributes {
            title
            slug
          }
        }
      }
      category
      progress
      status
      isArchived
      agentsInfo {
        id
        assignStatus
        agentProfile {
          data {
            id
            attributes {
              fullName
              primaryEmail
              status
            }
          }
        }
      }
      approvals(pagination: { limit: -1 }) {
        data {
          id
          attributes {
            status
            name
            type
            feedback
            isAffected
            createdDate
            deliveryDate
            expiryDate
            renewalSubmitDate
            extensionSubmitDate
            agents {
              name
              assignStatus
              agentProfile {
                data {
                  id
                  attributes {
                    fullName
                    primaryEmail
                  }
                }
              }
            }
            company {
              data {
                id
                attributes {
                  name
                  emails
                  organization {
                    data {
                      id
                      attributes {
                        slug
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      renewals {
        data {
          id
          attributes {
            createdDate
          }
        }
      }
      project {
        data {
          id
          attributes {
            title
            start
            end
            externalApplicant
            externalClientCompany {
              data {
                id
                attributes {
                  name
                }
              }
            }
            organization {
              data {
                id
                attributes {
                  name
                  slug
                }
              }
            }
            applicant {
              data {
                id
                attributes {
                  fullName
                  primaryEmail
                  company {
                    data {
                      id
                      attributes {
                        name
                      }
                    }
                  }
                }
              }
            }
            applicantCompany {
              data {
                id
                attributes {
                  name
                  organization {
                    data {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export const ApprovalFragmentDoc = gql`
  fragment Approval on ApprovalEntity {
    id
    attributes {
      uuid
      name
      type
      createdAt
      status
      description
      deliveryNotes
      isRenewalApplied
      isAffected
      isSiteVisitRequired
      approvalDocumentType
      approvedBy {
        data {
          id
          attributes {
            fullName
            primaryEmail
          }
        }
      }
      feedback
      createdDate
      expiryDate
      renewalSubmitDate
      renewalApprovedDate
      extensionSubmitDate
      extensionApproveDate
      deliveryDate
      deliveryDateTime
      deliveryConfirmation {
        data {
          id
        }
      }
      application {
        data {
          id
          attributes {
            status
            title
            project {
              data {
                id
                attributes {
                  title
                  organization {
                    data {
                      id
                      attributes {
                        slug
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      refApproval {
        data {
          id
        }
      }
      approvalMapLetter {
        data {
          ...File
        }
      }
      approvalLetter {
        data {
          ...File
        }
      }
      attachments {
        data {
          ...File
        }
      }
      company {
        data {
          id
          attributes {
            name
            emails
            address
            companyType
            feeAmount
            payfastMerchantId
            logo {
              data {
                ...File
              }
            }
            organization {
              data {
                id
                attributes {
                  slug
                }
              }
            }
            applicationMethods {
              data {
                id
                attributes {
                  slug
                }
              }
            }
          }
        }
      }
      contacts {
        data {
          ...UserProfileLimited
        }
      }
      agents {
        id
        assignStatus
        agentProfile {
          data {
            ...UserProfileLimited
          }
        }
      }
    }
  }
`
export const ApprovalTableFragmentDoc = gql`
  fragment ApprovalTable on ApprovalEntity {
    id
    attributes {
      type
      status
      contacts {
        data {
          id
          attributes {
            fullName
          }
        }
      }
      deliveryDate
      isAffected
      feedback
      expiryDate
      company {
        data {
          id
          attributes {
            name
          }
        }
      }
      application {
        data {
          id
          attributes {
            uuid
            title
            isIncidentRecorded
            project {
              data {
                id
                attributes {
                  title
                  organization {
                    data {
                      id
                      attributes {
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export const AssistanceRequestFragmentDoc = gql`
  fragment AssistanceRequest on AssistanceRequestEntity {
    id
    attributes {
      status
      userProfile {
        data {
          id
          attributes {
            fullName
          }
        }
      }
      project {
        data {
          id
          attributes {
            uuid
            title
            category
          }
        }
      }
      createdAt
      message
    }
  }
`
export const CompanyInfoFragmentDoc = gql`
  fragment CompanyInfo on CompanyEntity {
    id
    attributes {
      name
      emails
    }
  }
`
export const CompanyUpdateRequestFragmentDoc = gql`
  fragment CompanyUpdateRequest on CompanyUpdateRequestEntity {
    id
    attributes {
      name
      status
      createdAt
      isArchived
      link
      applicant {
        data {
          id
          attributes {
            fullName
            primaryEmail
          }
        }
      }
      email
      phone
      address
      applicationMethods {
        data {
          id
          attributes {
            title
            slug
          }
        }
      }
      documents {
        data {
          ...File
        }
      }
      company {
        data {
          id
          attributes {
            name
          }
        }
      }
      comments
      applicationMethodDescription
      employees
    }
  }
`
export const UserProfileFragmentDoc = gql`
  fragment UserProfile on UserProfileEntity {
    id
    attributes {
      uuid
      createdAt
      profileType
      isDefaultAgent
      orgAgentStatus
      statistics
      statisticsUpdate
      licenseType
      position
      isTermsAccepted
      isNda
      isOnboarded
      batchAutoApproval
      platformType
      customerOf(pagination: { limit: -1 }) {
        data {
          id
          attributes {
            name
          }
        }
      }
      signature {
        data {
          ...File
        }
      }
      avatar {
        data {
          ...File
        }
      }
      applicantProjects(pagination: { limit: -1 }) {
        data {
          id
          attributes {
            applications(pagination: { limit: -1 }) {
              data {
                id
              }
            }
          }
        }
      }
      ownerProjects(pagination: { limit: -1 }) {
        data {
          id
          attributes {
            applications(pagination: { limit: -1 }) {
              data {
                id
              }
            }
          }
        }
      }
      primaryEmail
      secondaryEmail
      primaryPhone
      secondaryPhone
      address
      fullName
      responsibility
      levelOfApproval
      status
      isStartNoticeShown
      isZoomNotice
      isPrimaryApplicant
      aoiGeneralStats
      aoiProvincesStats
      organization {
        data {
          id
          attributes {
            name
            slug
            activationDate
            createdAt
            processingType
            customers {
              data {
                id
                attributes {
                  fullName
                }
              }
            }
          }
        }
      }
      company {
        data {
          ...Company
        }
      }
      consultingCompanies {
        data {
          ...Company
        }
      }
      contractingCompanies {
        data {
          ...Company
        }
      }
      tasks {
        data {
          id
        }
      }
      user {
        data {
          id
          attributes {
            email
            createdAt
            confirmed
            blocked
            organization {
              data {
                id
                attributes {
                  slug
                  name
                }
              }
            }
            role {
              data {
                id
                attributes {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`
export const CompletionCertificateFragmentDoc = gql`
  fragment CompletionCertificate on CompletionCertificateEntity {
    id
    attributes {
      date
      description
      location
      status
      pdfDocumentLink
      discussionTopics {
        data {
          id
        }
      }
      owner {
        data {
          ...UserProfile
        }
      }
      participants {
        data {
          ...UserProfile
        }
      }
      application {
        data {
          id
        }
      }
      documents {
        data {
          ...File
        }
      }
      photos {
        data {
          ...File
        }
      }
      mapSnapshots {
        data {
          ...File
        }
      }
    }
  }
`
export const DepositFragmentDoc = gql`
  fragment Deposit on DepositEntity {
    id
    attributes {
      refNumber
      openedDate
      closedDate
      expiryDate
      description
      documents {
        data {
          ...File
        }
      }
      status
      application {
        data {
          id
        }
      }
      amount
    }
  }
`
export const DiscussionTopicFragmentDoc = gql`
  fragment DiscussionTopic on DiscussionTopicEntity {
    id
    attributes {
      title
      category
    }
  }
`
export const EmailMessageFragmentDoc = gql`
  fragment EmailMessage on EmailMessageEntity {
    id
    attributes {
      status
      direction
      deliveryStatus
      kind
      createdAt
      subject
      deliveryMessage
      deliveredAt
      openedAt
      markedAsSpam
      spamComplaintAt
      to
      from
      cc
      replyTo
      isRead
      replies {
        data {
          id
        }
      }
      rootEmail {
        data {
          id
        }
      }
      messageId
      html
      text
      organization {
        data {
          id
          attributes {
            slug
            name
          }
        }
      }
      application {
        data {
          id
          attributes {
            title
            uuid
            project {
              data {
                id
                attributes {
                  organization {
                    data {
                      id
                      attributes {
                        email
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      approval {
        data {
          id
          attributes {
            type
          }
        }
      }
      attachments {
        data {
          ...File
        }
      }
    }
  }
`
export const EnforcementFragmentDoc = gql`
  fragment Enforcement on EnforcementEntity {
    id
    attributes {
      title
      description
      location
      issueDate
      status
      companyName
      representativeEmail
      representativeName
      representativePosition
      address
      phone
      notes
      createdAt
      closedDate
      isArchived
      uuid
      topics {
        data {
          id
        }
      }
      owner {
        data {
          ...UserProfile
        }
      }
      generatedInvoice {
        data {
          ...File
        }
      }
      issuedDocuments {
        data {
          ...File
        }
      }
      receivedDocuments {
        data {
          ...File
        }
      }
      photos {
        data {
          ...File
        }
      }
    }
  }
`
export const ExternalApiClientFragmentDoc = gql`
  fragment ExternalApiClient on ExternalApiClient {
    id
    name
    clientId
    secretLast4
    scopes
    organizationId
    organizationSlug
    active
    expiresAt
    revokedAt
    lastUsedAt
    issuedBy
    revokedBy
    createdAt
  }
`
export const InviteRequiredDocumentTypeFragmentDoc = gql`
  fragment InviteRequiredDocumentType on InviteRequiredDocumentTypeEntity {
    id
    attributes {
      slug
      name
      description
    }
  }
`
export const InvoiceFragmentDoc = gql`
  fragment Invoice on InvoiceEntity {
    id
    attributes {
      name
      status
      totalAmount
      createdAt
      updatedAt
      dueDate
      pdfLink
      paymentLink
      successPaymentConfirmed
      paymentDocuments {
        data {
          ...File
        }
      }
      quotation {
        data {
          id
        }
      }
      billTo {
        data {
          id
        }
      }
      application {
        data {
          id
        }
      }
    }
  }
`
export const KickoffInviteFragmentDoc = gql`
  fragment KickoffInvite on KickoffInviteEntity {
    id
    attributes {
      date
      time
      location
      status
      description
      docDescription
      inviteRequiredDocumentTypes {
        data {
          id
          attributes {
            name
            description
          }
        }
      }
      application {
        data {
          id
        }
      }
      owner {
        data {
          ...UserProfile
        }
      }
      participants {
        data {
          ...UserProfile
        }
      }
      mapSnapshot {
        data {
          ...File
        }
      }
    }
  }
`
export const KickoffRecordFragmentDoc = gql`
  fragment KickoffRecord on KickoffRecordEntity {
    id
    attributes {
      date
      time
      description
      location
      status
      discussionTopics {
        data {
          id
        }
      }
      kickoffInvite {
        data {
          id
        }
      }
      owner {
        data {
          ...UserProfile
        }
      }
      participants {
        data {
          ...UserProfile
        }
      }
      application {
        data {
          id
        }
      }
      approvalDocuments {
        data {
          ...File
        }
      }
      photos {
        data {
          ...File
        }
      }
      mapSnapshot {
        data {
          ...File
        }
      }
    }
  }
`
export const NoteFragmentDoc = gql`
  fragment Note on NoteEntity {
    id
    attributes {
      name
      description
      attachment {
        data {
          ...File
        }
      }
      owner {
        data {
          id
        }
      }
      createdAt
    }
  }
`
export const NotificationMessageFragmentDoc = gql`
  fragment NotificationMessage on NotificationMessageEntity {
    id
    attributes {
      createdAt
      message
      title
      isHidden
      isNew
      images {
        data {
          ...File
        }
      }
      files {
        data {
          ...File
        }
      }
      to {
        data {
          id
          attributes {
            fullName
          }
        }
      }
      from {
        data {
          id
          attributes {
            fullName
          }
        }
      }
      application {
        data {
          id
          attributes {
            title
            uuid
          }
        }
      }
      type
      requestType
    }
  }
`
export const OrgHomeFragmentDoc = gql`
  fragment OrgHome on ComponentPageOrgHome {
    id
    hero {
      subtitle
      title
      mainBackground {
        data {
          attributes {
            url
          }
        }
      }
    }
    aoiHero {
      title
      subtitle
      mainBackground {
        data {
          attributes {
            url
          }
        }
      }
    }
    orgHowItWorks {
      titleBlock {
        title
        subtitle
      }
      hexItems {
        id
        value
      }
      bannerText
    }
    partners {
      titleBlock {
        title
        subtitle
      }
      pictures {
        data {
          ...File
        }
      }
    }
  }
`
export const ConfigurationFragmentDoc = gql`
  fragment Configuration on ConfigurationEntity {
    id
    attributes {
      name
      automatedApproval
      generalCheckBuffer
      utilityCheckBuffer
      daysBeforeExpired
      noResponseLimit
      expiredIn
      approvalExpiredIn
      maxProjectArea
      maxProjectLength
      aoiDistance
      maxProjectAreaExtended
      maxProjectLengthExtended
      organization {
        data {
          id
        }
      }
    }
  }
`
export const OrganizationFragmentDoc = gql`
  fragment Organization on OrganizationEntity {
    id
    attributes {
      uuid
      name
      slug
      approvalEmail
      submissionEmail
      statistics
      letterTemplates {
        data {
          id
          attributes {
            type
            name
            signatoryPosition
            signatoryName
            letterTitle
            description
            affectedText
            notAffectedText
            rejectedText
            letterBg {
              data {
                ...File
              }
            }
            preview {
              data {
                ...File
              }
            }
          }
        }
      }
      singleLogo {
        data {
          ...File
        }
      }
      logoWithCompanyName {
        data {
          ...File
        }
      }
      logoWithCompanyNameDark {
        data {
          ...File
        }
      }
      heroLogo {
        data {
          ...File
        }
      }
      users {
        data {
          id
          attributes {
            userProfile {
              data {
                id
                attributes {
                  fullName
                  primaryEmail
                  orgAgentStatus
                }
              }
            }
          }
        }
      }
      userGuide {
        data {
          ...File
        }
      }
      companies {
        data {
          id
          attributes {
            name
            companyType
            userProfiles {
              data {
                id
                attributes {
                  fullName
                  primaryEmail
                  avatar {
                    data {
                      id
                      attributes {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      isActive
      primaryColor
      fontColor
      activationDate
      licenceExpiryDate
      orgGeneralStats
      heroSection {
        id
        title
        subtitle
        description
        media {
          data {
            ...File
          }
        }
      }
      configuration {
        data {
          ...Configuration
        }
      }
    }
  }
`
export const PaymentFragmentDoc = gql`
  fragment Payment on PaymentEntity {
    id
    attributes {
      title
      status
      createdAt
      type
      link
      stripeProductPriceId
      amount
      totalAmount
      vat
      application {
        data {
          id
          attributes {
            uuid
          }
        }
      }
      documents {
        data {
          ...File
        }
      }
      itemDetails
      invoiceDate
      invoiceDueDate
      items {
        id
        name
        quantity
      }
      quotationPdfLink
      invoicePdfLink
    }
  }
`
export const ProvinceFragmentDoc = gql`
  fragment Province on ProvinceEntity {
    id
    attributes {
      uuid
      name
      fillColor
      strokeColor
      geoJson {
        data {
          ...File
        }
      }
    }
  }
`
export const ProjectFragmentDoc = gql`
  fragment Project on ProjectEntity {
    id
    attributes {
      uuid
      title
      refNumber
      innerRefNumber
      start
      end
      status
      createdAt
      createdDate
      description
      category
      isArchived
      externalApplicant
      intersectionCheckResult
      isEmergency
      submissionTermsAcceptance
      externalClientCompany {
        data {
          id
        }
      }
      reportInfo
      provinces {
        data {
          ...Province
        }
      }
      municipalCompanies {
        data {
          ...Company
        }
      }
      otherNatureDescription
      projectNature {
        data {
          ...ApplicationNature
        }
      }
      organization {
        data {
          id
          attributes {
            slug
          }
        }
      }
      applicantCompany {
        data {
          id
          attributes {
            name
            emails
          }
        }
      }
      applicant {
        data {
          id
          attributes {
            fullName
            primaryEmail
          }
        }
      }
      owner {
        data {
          id
          attributes {
            primaryEmail
            company {
              data {
                attributes {
                  name
                }
              }
            }
          }
        }
      }
      applications(pagination: { limit: -1 }) {
        data {
          id
          attributes {
            uuid
            createdAt
            title
            status
            duplicationIndex
            submittedDate
            progress
            approvalMode
            approvedDate
            category
            requiredDocuments {
              id
              docTypeName
              description
            }
            agentsInfo {
              id
              name
              assignStatus
              agentProfile {
                data {
                  id
                }
              }
            }
            applicationType {
              data {
                id
                attributes {
                  title
                  slug
                }
              }
            }
            approvals(pagination: { limit: -1 }) {
              data {
                id
                attributes {
                  name
                  isAffected
                  company {
                    data {
                      id
                      attributes {
                        name
                        organization {
                          data {
                            id
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      projectCenter
      locationInfo
      mapSnapshot {
        data {
          ...File
        }
      }
      geoJson {
        data {
          ...File
        }
      }
      kml {
        data {
          ...File
        }
      }
    }
  }
`
export const ProjectTableFragmentDoc = gql`
  fragment ProjectTable on ProjectEntity {
    id
    attributes {
      uuid
      title
      levelOfServices
      start
      end
      status
      createdAt
      description
      category
      isArchived
      reportInfo
      createdDate
      isEmergency
      applicantCompany {
        data {
          id
          attributes {
            name
          }
        }
      }
      organization {
        data {
          id
          attributes {
            name
            slug
          }
        }
      }
      owner {
        data {
          id
          attributes {
            primaryEmail
            fullName
            company {
              data {
                attributes {
                  name
                }
              }
            }
          }
        }
      }
      applications(pagination: { limit: -1 }) {
        data {
          id
          attributes {
            uuid
            title
            duplicationIndex
            status
            isArchived
            agentsInfo {
              id
              name
              assignStatus
              agentProfile {
                data {
                  id
                  attributes {
                    fullName
                    primaryEmail
                  }
                }
              }
            }
            approvals {
              data {
                id
                attributes {
                  name
                  status
                  deliveryNotes
                  company {
                    data {
                      id
                      attributes {
                        organization {
                          data {
                            id
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export const QuoteItemFragmentDoc = gql`
  fragment QuoteItem on QuoteItemEntity {
    id
    attributes {
      name
      description
      price
    }
  }
`
export const QuotationFragmentDoc = gql`
  fragment Quotation on QuotationEntity {
    id
    attributes {
      name
      status
      totalAmount
      vat
      invoice {
        data {
          id
        }
      }
      quoteItems {
        id
        name
        quantity
        quoteItem {
          data {
            ...QuoteItem
          }
        }
      }
      createdAt
      updatedAt
      dueDate
      quotationPdfLink
    }
  }
`
export const ReportFragmentDoc = gql`
  fragment Report on ReportEntity {
    id
    attributes {
      category
      createdAt
      startDate
      endDate
      status
      organization {
        data {
          id
        }
      }
      generatedBy {
        data {
          id
          attributes {
            fullName
          }
        }
      }
      excelReport {
        data {
          ...File
        }
      }
      filesArchive {
        data {
          ...File
        }
      }
    }
  }
`
export const RoleFragmentDoc = gql`
  fragment Role on UsersPermissionsRoleEntity {
    id
    attributes {
      name
      description
    }
  }
`
export const SettingsFragmentDoc = gql`
  fragment Settings on SettingEntity {
    id
    attributes {
      afrigisBuffer
      description
      easetechSearchBuffer
      usePostgisGeometryProcessing
      maxProjectArea
      maxProjectLength
      maxProjectAreaIncoming
      maxProjectLengthIncoming
      quotationVat
      geometryOutdated
      testingCompanyEmail
      testingUserProfileEmail
      countryBoundary {
        data {
          ...File
        }
      }
      geometrySettings {
        id
        applicationType {
          data {
            id
            attributes {
              title
            }
          }
        }
        name
        slug
        color
      }
    }
  }
`
export const SurveyFragmentDoc = gql`
  fragment Survey on SurveyEntity {
    id
    attributes {
      name
      result
      documents {
        data {
          ...File
        }
      }
      owner {
        data {
          id
          attributes {
            fullName
            primaryEmail
          }
        }
      }
      affectedCompanies {
        data {
          id
          attributes {
            name
          }
        }
      }
      report {
        data {
          ...File
        }
      }
      mapSnapshots {
        data {
          ...File
        }
      }
      kml {
        data {
          ...File
        }
      }
      geoJson {
        data {
          ...File
        }
      }
    }
  }
`
export const TaskFragmentDoc = gql`
  fragment Task on TaskEntity {
    id
    attributes {
      uuid
      title
      description
      createdAt
      start
      end
      owner {
        data {
          id
          attributes {
            uuid
          }
        }
      }
      applicant {
        data {
          id
          attributes {
            fullName
            primaryEmail
          }
        }
      }
      project {
        data {
          id
          attributes {
            title
          }
        }
      }
      application {
        data {
          id
          attributes {
            title
          }
        }
      }
      status
    }
  }
`
export const DocumentTemplateFragmentDoc = gql`
  fragment DocumentTemplate on DocumentTemplateEntity {
    id
    attributes {
      name
      description
      status
      size
      updatedAt
      slug
    }
  }
`
export const TemplateSubjectFragmentDoc = gql`
  fragment TemplateSubject on TemplateSubjectEntity {
    id
    attributes {
      name
      description
      updatedAt
      createdAt
      group
      document_templates {
        data {
          ...DocumentTemplate
        }
      }
    }
  }
`
export const SeoFragmentDoc = gql`
  fragment Seo on ComponentSharedSeo {
    id
    canonicalURL
    keywords
    metaTitle
    metaViewport
    metaDescription
  }
`
export const HomeFragmentDoc = gql`
  fragment Home on ComponentPageHome {
    pathname
    hero {
      subtitle
      id
      description
      title
      media {
        data {
          ...File
        }
      }
    }
    clientReviews {
      id
      title
      content
      clientName
      feedbackDate
      rate
    }
    partnerLogos {
      id
      image {
        data {
          ...File
        }
      }
    }
    heroLogos {
      id
      image {
        data {
          ...File
        }
      }
    }
    benefitsHeadline {
      title
      subtitle
    }
    benefits {
      id
      title
      subtitle
    }
  }
`
export const FreeQuoteFragmentDoc = gql`
  fragment FreeQuote on ComponentPageFreeQuote {
    id
    pathname
    hero {
      subtitle
      id
      description
      title
      media {
        data {
          ...File
        }
      }
    }
    heroBenefits {
      id
      title
      subtitle
    }
  }
`
export const InfoPageFragmentDoc = gql`
  fragment InfoPage on ComponentPageInfoPage {
    id
    pathname
    title
    content
  }
`
export const WebsiteFragmentDoc = gql`
  fragment Website on WebsiteEntity {
    id
    attributes {
      seo {
        ...Seo
      }
      content {
        __typename
        ...Home
        ...FreeQuote
        ...InfoPage
      }
    }
  }
`
export const PaginationFragmentDoc = gql`
  fragment Pagination on Pagination {
    page
    pageCount
    pageSize
    total
  }
`
export const MetaFragmentDoc = gql`
  fragment Meta on ResponseCollectionMeta {
    pagination {
      ...Pagination
    }
  }
`
export const AddApplicationToProjectDocument = gql`
  mutation addApplicationToProject($input: AddApplicationToProjectInput!) {
    addApplicationToProject(input: $input) {
      applicationId
      title
    }
  }
`
export type AddApplicationToProjectMutationFn = Apollo.MutationFunction<
  AddApplicationToProjectMutation,
  AddApplicationToProjectMutationVariables
>
export type AddApplicationToProjectComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddApplicationToProjectMutation,
    AddApplicationToProjectMutationVariables
  >,
  "mutation"
>

export const AddApplicationToProjectComponent = (props: AddApplicationToProjectComponentProps) => (
  <ApolloReactComponents.Mutation<AddApplicationToProjectMutation, AddApplicationToProjectMutationVariables>
    mutation={AddApplicationToProjectDocument}
    {...props}
  />
)

export function useAddApplicationToProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<AddApplicationToProjectMutation, AddApplicationToProjectMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddApplicationToProjectMutation, AddApplicationToProjectMutationVariables>(
    AddApplicationToProjectDocument,
    options
  )
}
export type AddApplicationToProjectMutationHookResult = ReturnType<typeof useAddApplicationToProjectMutation>
export type AddApplicationToProjectMutationResult = Apollo.MutationResult<AddApplicationToProjectMutation>
export const AgentProfilesStatsUpdateDocument = gql`
  mutation agentProfilesStatsUpdate($input: AgentProfilesStatisticsInput!) {
    agentProfilesStatsUpdate(input: $input) {
      status
    }
  }
`
export type AgentProfilesStatsUpdateMutationFn = Apollo.MutationFunction<
  AgentProfilesStatsUpdateMutation,
  AgentProfilesStatsUpdateMutationVariables
>
export type AgentProfilesStatsUpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AgentProfilesStatsUpdateMutation,
    AgentProfilesStatsUpdateMutationVariables
  >,
  "mutation"
>

export const AgentProfilesStatsUpdateComponent = (props: AgentProfilesStatsUpdateComponentProps) => (
  <ApolloReactComponents.Mutation<AgentProfilesStatsUpdateMutation, AgentProfilesStatsUpdateMutationVariables>
    mutation={AgentProfilesStatsUpdateDocument}
    {...props}
  />
)

export function useAgentProfilesStatsUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<AgentProfilesStatsUpdateMutation, AgentProfilesStatsUpdateMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AgentProfilesStatsUpdateMutation, AgentProfilesStatsUpdateMutationVariables>(
    AgentProfilesStatsUpdateDocument,
    options
  )
}
export type AgentProfilesStatsUpdateMutationHookResult = ReturnType<typeof useAgentProfilesStatsUpdateMutation>
export type AgentProfilesStatsUpdateMutationResult = Apollo.MutationResult<AgentProfilesStatsUpdateMutation>
export const AllocateEmailDocument = gql`
  mutation allocateEmail($input: AllocateEmailInput!) {
    allocateEmail(input: $input) {
      data {
        id
      }
    }
  }
`
export type AllocateEmailMutationFn = Apollo.MutationFunction<AllocateEmailMutation, AllocateEmailMutationVariables>
export type AllocateEmailComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<AllocateEmailMutation, AllocateEmailMutationVariables>,
  "mutation"
>

export const AllocateEmailComponent = (props: AllocateEmailComponentProps) => (
  <ApolloReactComponents.Mutation<AllocateEmailMutation, AllocateEmailMutationVariables>
    mutation={AllocateEmailDocument}
    {...props}
  />
)

export function useAllocateEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<AllocateEmailMutation, AllocateEmailMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AllocateEmailMutation, AllocateEmailMutationVariables>(AllocateEmailDocument, options)
}
export type AllocateEmailMutationHookResult = ReturnType<typeof useAllocateEmailMutation>
export type AllocateEmailMutationResult = Apollo.MutationResult<AllocateEmailMutation>
export const AoiApprovalLetterDocument = gql`
  mutation aoiApprovalLetter($input: AoiApprovalLetterInput!) {
    aoiApprovalLetter(input: $input) {
      id
      url
      name
    }
  }
`
export type AoiApprovalLetterMutationFn = Apollo.MutationFunction<
  AoiApprovalLetterMutation,
  AoiApprovalLetterMutationVariables
>
export type AoiApprovalLetterComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<AoiApprovalLetterMutation, AoiApprovalLetterMutationVariables>,
  "mutation"
>

export const AoiApprovalLetterComponent = (props: AoiApprovalLetterComponentProps) => (
  <ApolloReactComponents.Mutation<AoiApprovalLetterMutation, AoiApprovalLetterMutationVariables>
    mutation={AoiApprovalLetterDocument}
    {...props}
  />
)

export function useAoiApprovalLetterMutation(
  baseOptions?: Apollo.MutationHookOptions<AoiApprovalLetterMutation, AoiApprovalLetterMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AoiApprovalLetterMutation, AoiApprovalLetterMutationVariables>(
    AoiApprovalLetterDocument,
    options
  )
}
export type AoiApprovalLetterMutationHookResult = ReturnType<typeof useAoiApprovalLetterMutation>
export type AoiApprovalLetterMutationResult = Apollo.MutationResult<AoiApprovalLetterMutation>
export const AoiGeneralStatsUpdateDocument = gql`
  mutation aoiGeneralStatsUpdate($input: AoiGeneralStatsUpdateInput!) {
    aoiGeneralStatsUpdate(input: $input)
  }
`
export type AoiGeneralStatsUpdateMutationFn = Apollo.MutationFunction<
  AoiGeneralStatsUpdateMutation,
  AoiGeneralStatsUpdateMutationVariables
>
export type AoiGeneralStatsUpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<AoiGeneralStatsUpdateMutation, AoiGeneralStatsUpdateMutationVariables>,
  "mutation"
>

export const AoiGeneralStatsUpdateComponent = (props: AoiGeneralStatsUpdateComponentProps) => (
  <ApolloReactComponents.Mutation<AoiGeneralStatsUpdateMutation, AoiGeneralStatsUpdateMutationVariables>
    mutation={AoiGeneralStatsUpdateDocument}
    {...props}
  />
)

export function useAoiGeneralStatsUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<AoiGeneralStatsUpdateMutation, AoiGeneralStatsUpdateMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AoiGeneralStatsUpdateMutation, AoiGeneralStatsUpdateMutationVariables>(
    AoiGeneralStatsUpdateDocument,
    options
  )
}
export type AoiGeneralStatsUpdateMutationHookResult = ReturnType<typeof useAoiGeneralStatsUpdateMutation>
export type AoiGeneralStatsUpdateMutationResult = Apollo.MutationResult<AoiGeneralStatsUpdateMutation>
export const AoiProvinceStatsUpdateDocument = gql`
  mutation aoiProvinceStatsUpdate($input: AoiProvinceStatsUpdateInput!) {
    aoiProvinceStatsUpdate(input: $input)
  }
`
export type AoiProvinceStatsUpdateMutationFn = Apollo.MutationFunction<
  AoiProvinceStatsUpdateMutation,
  AoiProvinceStatsUpdateMutationVariables
>
export type AoiProvinceStatsUpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AoiProvinceStatsUpdateMutation,
    AoiProvinceStatsUpdateMutationVariables
  >,
  "mutation"
>

export const AoiProvinceStatsUpdateComponent = (props: AoiProvinceStatsUpdateComponentProps) => (
  <ApolloReactComponents.Mutation<AoiProvinceStatsUpdateMutation, AoiProvinceStatsUpdateMutationVariables>
    mutation={AoiProvinceStatsUpdateDocument}
    {...props}
  />
)

export function useAoiProvinceStatsUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<AoiProvinceStatsUpdateMutation, AoiProvinceStatsUpdateMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AoiProvinceStatsUpdateMutation, AoiProvinceStatsUpdateMutationVariables>(
    AoiProvinceStatsUpdateDocument,
    options
  )
}
export type AoiProvinceStatsUpdateMutationHookResult = ReturnType<typeof useAoiProvinceStatsUpdateMutation>
export type AoiProvinceStatsUpdateMutationResult = Apollo.MutationResult<AoiProvinceStatsUpdateMutation>
export const AppApprovalProgressUpdateDocument = gql`
  mutation appApprovalProgressUpdate($input: AppApprovalProgressUpdateInput!) {
    appApprovalProgressUpdate(input: $input)
  }
`
export type AppApprovalProgressUpdateMutationFn = Apollo.MutationFunction<
  AppApprovalProgressUpdateMutation,
  AppApprovalProgressUpdateMutationVariables
>
export type AppApprovalProgressUpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AppApprovalProgressUpdateMutation,
    AppApprovalProgressUpdateMutationVariables
  >,
  "mutation"
>

export const AppApprovalProgressUpdateComponent = (props: AppApprovalProgressUpdateComponentProps) => (
  <ApolloReactComponents.Mutation<AppApprovalProgressUpdateMutation, AppApprovalProgressUpdateMutationVariables>
    mutation={AppApprovalProgressUpdateDocument}
    {...props}
  />
)

export function useAppApprovalProgressUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AppApprovalProgressUpdateMutation,
    AppApprovalProgressUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AppApprovalProgressUpdateMutation, AppApprovalProgressUpdateMutationVariables>(
    AppApprovalProgressUpdateDocument,
    options
  )
}
export type AppApprovalProgressUpdateMutationHookResult = ReturnType<typeof useAppApprovalProgressUpdateMutation>
export type AppApprovalProgressUpdateMutationResult = Apollo.MutationResult<AppApprovalProgressUpdateMutation>
export const ApplicationLetterDocument = gql`
  mutation applicationLetter($input: ApplicationLetterInput!) {
    applicationLetter(input: $input)
  }
`
export type ApplicationLetterMutationFn = Apollo.MutationFunction<
  ApplicationLetterMutation,
  ApplicationLetterMutationVariables
>
export type ApplicationLetterComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ApplicationLetterMutation, ApplicationLetterMutationVariables>,
  "mutation"
>

export const ApplicationLetterComponent = (props: ApplicationLetterComponentProps) => (
  <ApolloReactComponents.Mutation<ApplicationLetterMutation, ApplicationLetterMutationVariables>
    mutation={ApplicationLetterDocument}
    {...props}
  />
)

export function useApplicationLetterMutation(
  baseOptions?: Apollo.MutationHookOptions<ApplicationLetterMutation, ApplicationLetterMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ApplicationLetterMutation, ApplicationLetterMutationVariables>(
    ApplicationLetterDocument,
    options
  )
}
export type ApplicationLetterMutationHookResult = ReturnType<typeof useApplicationLetterMutation>
export type ApplicationLetterMutationResult = Apollo.MutationResult<ApplicationLetterMutation>
export const ApplicationReportDocument = gql`
  mutation applicationReport($input: ApplicationReportInput!) {
    applicationReport(input: $input)
  }
`
export type ApplicationReportMutationFn = Apollo.MutationFunction<
  ApplicationReportMutation,
  ApplicationReportMutationVariables
>
export type ApplicationReportComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ApplicationReportMutation, ApplicationReportMutationVariables>,
  "mutation"
>

export const ApplicationReportComponent = (props: ApplicationReportComponentProps) => (
  <ApolloReactComponents.Mutation<ApplicationReportMutation, ApplicationReportMutationVariables>
    mutation={ApplicationReportDocument}
    {...props}
  />
)

export function useApplicationReportMutation(
  baseOptions?: Apollo.MutationHookOptions<ApplicationReportMutation, ApplicationReportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ApplicationReportMutation, ApplicationReportMutationVariables>(
    ApplicationReportDocument,
    options
  )
}
export type ApplicationReportMutationHookResult = ReturnType<typeof useApplicationReportMutation>
export type ApplicationReportMutationResult = Apollo.MutationResult<ApplicationReportMutation>
export const ApplicationsReportDocument = gql`
  mutation applicationsReport($input: ApplicationsReportInput!) {
    applicationsReport(input: $input) {
      reportId
      status
      url
      estimatedDurationSeconds
    }
  }
`
export type ApplicationsReportMutationFn = Apollo.MutationFunction<
  ApplicationsReportMutation,
  ApplicationsReportMutationVariables
>
export type ApplicationsReportComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ApplicationsReportMutation, ApplicationsReportMutationVariables>,
  "mutation"
>

export const ApplicationsReportComponent = (props: ApplicationsReportComponentProps) => (
  <ApolloReactComponents.Mutation<ApplicationsReportMutation, ApplicationsReportMutationVariables>
    mutation={ApplicationsReportDocument}
    {...props}
  />
)

export function useApplicationsReportMutation(
  baseOptions?: Apollo.MutationHookOptions<ApplicationsReportMutation, ApplicationsReportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ApplicationsReportMutation, ApplicationsReportMutationVariables>(
    ApplicationsReportDocument,
    options
  )
}
export type ApplicationsReportMutationHookResult = ReturnType<typeof useApplicationsReportMutation>
export type ApplicationsReportMutationResult = Apollo.MutationResult<ApplicationsReportMutation>
export const ApprovalLetterDocument = gql`
  mutation approvalLetter($input: ApprovalTemplateLetterInput!) {
    approvalTemplateLetter(input: $input) {
      id
      url
      name
    }
  }
`
export type ApprovalLetterMutationFn = Apollo.MutationFunction<ApprovalLetterMutation, ApprovalLetterMutationVariables>
export type ApprovalLetterComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ApprovalLetterMutation, ApprovalLetterMutationVariables>,
  "mutation"
>

export const ApprovalLetterComponent = (props: ApprovalLetterComponentProps) => (
  <ApolloReactComponents.Mutation<ApprovalLetterMutation, ApprovalLetterMutationVariables>
    mutation={ApprovalLetterDocument}
    {...props}
  />
)

export function useApprovalLetterMutation(
  baseOptions?: Apollo.MutationHookOptions<ApprovalLetterMutation, ApprovalLetterMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ApprovalLetterMutation, ApprovalLetterMutationVariables>(ApprovalLetterDocument, options)
}
export type ApprovalLetterMutationHookResult = ReturnType<typeof useApprovalLetterMutation>
export type ApprovalLetterMutationResult = Apollo.MutationResult<ApprovalLetterMutation>
export const ApprovalMapLetterDocument = gql`
  mutation approvalMapLetter($input: ApprovalTemplateMapDataInput!) {
    approvalTemplateMapData(input: $input) {
      id
      url
      name
    }
  }
`
export type ApprovalMapLetterMutationFn = Apollo.MutationFunction<
  ApprovalMapLetterMutation,
  ApprovalMapLetterMutationVariables
>
export type ApprovalMapLetterComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ApprovalMapLetterMutation, ApprovalMapLetterMutationVariables>,
  "mutation"
>

export const ApprovalMapLetterComponent = (props: ApprovalMapLetterComponentProps) => (
  <ApolloReactComponents.Mutation<ApprovalMapLetterMutation, ApprovalMapLetterMutationVariables>
    mutation={ApprovalMapLetterDocument}
    {...props}
  />
)

export function useApprovalMapLetterMutation(
  baseOptions?: Apollo.MutationHookOptions<ApprovalMapLetterMutation, ApprovalMapLetterMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ApprovalMapLetterMutation, ApprovalMapLetterMutationVariables>(
    ApprovalMapLetterDocument,
    options
  )
}
export type ApprovalMapLetterMutationHookResult = ReturnType<typeof useApprovalMapLetterMutation>
export type ApprovalMapLetterMutationResult = Apollo.MutationResult<ApprovalMapLetterMutation>
export const ApprovedApplicationDocument = gql`
  mutation approvedApplication($input: ApprovedApplicationInput!) {
    approvedApplication(input: $input)
  }
`
export type ApprovedApplicationMutationFn = Apollo.MutationFunction<
  ApprovedApplicationMutation,
  ApprovedApplicationMutationVariables
>
export type ApprovedApplicationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ApprovedApplicationMutation, ApprovedApplicationMutationVariables>,
  "mutation"
>

export const ApprovedApplicationComponent = (props: ApprovedApplicationComponentProps) => (
  <ApolloReactComponents.Mutation<ApprovedApplicationMutation, ApprovedApplicationMutationVariables>
    mutation={ApprovedApplicationDocument}
    {...props}
  />
)

export function useApprovedApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<ApprovedApplicationMutation, ApprovedApplicationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ApprovedApplicationMutation, ApprovedApplicationMutationVariables>(
    ApprovedApplicationDocument,
    options
  )
}
export type ApprovedApplicationMutationHookResult = ReturnType<typeof useApprovedApplicationMutation>
export type ApprovedApplicationMutationResult = Apollo.MutationResult<ApprovedApplicationMutation>
export const ArchiveProjectDocument = gql`
  mutation archiveProject($input: ArchiveProjectInput!) {
    archiveProject(input: $input)
  }
`
export type ArchiveProjectMutationFn = Apollo.MutationFunction<ArchiveProjectMutation, ArchiveProjectMutationVariables>
export type ArchiveProjectComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ArchiveProjectMutation, ArchiveProjectMutationVariables>,
  "mutation"
>

export const ArchiveProjectComponent = (props: ArchiveProjectComponentProps) => (
  <ApolloReactComponents.Mutation<ArchiveProjectMutation, ArchiveProjectMutationVariables>
    mutation={ArchiveProjectDocument}
    {...props}
  />
)

export function useArchiveProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<ArchiveProjectMutation, ArchiveProjectMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ArchiveProjectMutation, ArchiveProjectMutationVariables>(ArchiveProjectDocument, options)
}
export type ArchiveProjectMutationHookResult = ReturnType<typeof useArchiveProjectMutation>
export type ArchiveProjectMutationResult = Apollo.MutationResult<ArchiveProjectMutation>
export const AutoApprovalDocument = gql`
  mutation autoApproval($input: AutoApprovalInput!) {
    autoApproval(input: $input)
  }
`
export type AutoApprovalMutationFn = Apollo.MutationFunction<AutoApprovalMutation, AutoApprovalMutationVariables>
export type AutoApprovalComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<AutoApprovalMutation, AutoApprovalMutationVariables>,
  "mutation"
>

export const AutoApprovalComponent = (props: AutoApprovalComponentProps) => (
  <ApolloReactComponents.Mutation<AutoApprovalMutation, AutoApprovalMutationVariables>
    mutation={AutoApprovalDocument}
    {...props}
  />
)

export function useAutoApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<AutoApprovalMutation, AutoApprovalMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AutoApprovalMutation, AutoApprovalMutationVariables>(AutoApprovalDocument, options)
}
export type AutoApprovalMutationHookResult = ReturnType<typeof useAutoApprovalMutation>
export type AutoApprovalMutationResult = Apollo.MutationResult<AutoApprovalMutation>
export const AutoApprovalExternalAppDocument = gql`
  mutation autoApprovalExternalApp($input: AutoApprovalExternalAppInput!) {
    autoApprovalExternalApp(input: $input)
  }
`
export type AutoApprovalExternalAppMutationFn = Apollo.MutationFunction<
  AutoApprovalExternalAppMutation,
  AutoApprovalExternalAppMutationVariables
>
export type AutoApprovalExternalAppComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AutoApprovalExternalAppMutation,
    AutoApprovalExternalAppMutationVariables
  >,
  "mutation"
>

export const AutoApprovalExternalAppComponent = (props: AutoApprovalExternalAppComponentProps) => (
  <ApolloReactComponents.Mutation<AutoApprovalExternalAppMutation, AutoApprovalExternalAppMutationVariables>
    mutation={AutoApprovalExternalAppDocument}
    {...props}
  />
)

export function useAutoApprovalExternalAppMutation(
  baseOptions?: Apollo.MutationHookOptions<AutoApprovalExternalAppMutation, AutoApprovalExternalAppMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AutoApprovalExternalAppMutation, AutoApprovalExternalAppMutationVariables>(
    AutoApprovalExternalAppDocument,
    options
  )
}
export type AutoApprovalExternalAppMutationHookResult = ReturnType<typeof useAutoApprovalExternalAppMutation>
export type AutoApprovalExternalAppMutationResult = Apollo.MutationResult<AutoApprovalExternalAppMutation>
export const AutoApprovalInternalAppDocument = gql`
  mutation autoApprovalInternalApp($input: AutoApprovalInternalAppInput!) {
    autoApprovalInternalApp(input: $input) {
      applicationId
      status
    }
  }
`
export type AutoApprovalInternalAppMutationFn = Apollo.MutationFunction<
  AutoApprovalInternalAppMutation,
  AutoApprovalInternalAppMutationVariables
>
export type AutoApprovalInternalAppComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AutoApprovalInternalAppMutation,
    AutoApprovalInternalAppMutationVariables
  >,
  "mutation"
>

export const AutoApprovalInternalAppComponent = (props: AutoApprovalInternalAppComponentProps) => (
  <ApolloReactComponents.Mutation<AutoApprovalInternalAppMutation, AutoApprovalInternalAppMutationVariables>
    mutation={AutoApprovalInternalAppDocument}
    {...props}
  />
)

export function useAutoApprovalInternalAppMutation(
  baseOptions?: Apollo.MutationHookOptions<AutoApprovalInternalAppMutation, AutoApprovalInternalAppMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AutoApprovalInternalAppMutation, AutoApprovalInternalAppMutationVariables>(
    AutoApprovalInternalAppDocument,
    options
  )
}
export type AutoApprovalInternalAppMutationHookResult = ReturnType<typeof useAutoApprovalInternalAppMutation>
export type AutoApprovalInternalAppMutationResult = Apollo.MutationResult<AutoApprovalInternalAppMutation>
export const AutoApprovalRenewalsDocument = gql`
  mutation autoApprovalRenewals($input: AutoApprovalRenewalsInput!) {
    autoApprovalRenewals(input: $input)
  }
`
export type AutoApprovalRenewalsMutationFn = Apollo.MutationFunction<
  AutoApprovalRenewalsMutation,
  AutoApprovalRenewalsMutationVariables
>
export type AutoApprovalRenewalsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<AutoApprovalRenewalsMutation, AutoApprovalRenewalsMutationVariables>,
  "mutation"
>

export const AutoApprovalRenewalsComponent = (props: AutoApprovalRenewalsComponentProps) => (
  <ApolloReactComponents.Mutation<AutoApprovalRenewalsMutation, AutoApprovalRenewalsMutationVariables>
    mutation={AutoApprovalRenewalsDocument}
    {...props}
  />
)

export function useAutoApprovalRenewalsMutation(
  baseOptions?: Apollo.MutationHookOptions<AutoApprovalRenewalsMutation, AutoApprovalRenewalsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AutoApprovalRenewalsMutation, AutoApprovalRenewalsMutationVariables>(
    AutoApprovalRenewalsDocument,
    options
  )
}
export type AutoApprovalRenewalsMutationHookResult = ReturnType<typeof useAutoApprovalRenewalsMutation>
export type AutoApprovalRenewalsMutationResult = Apollo.MutationResult<AutoApprovalRenewalsMutation>
export const CheckDeliveryConfirmationDocument = gql`
  mutation checkDeliveryConfirmation($input: CheckDeliveryConfirmationInput!) {
    checkDeliveryConfirmation(input: $input) {
      result {
        isDeliveryConfirmed
      }
    }
  }
`
export type CheckDeliveryConfirmationMutationFn = Apollo.MutationFunction<
  CheckDeliveryConfirmationMutation,
  CheckDeliveryConfirmationMutationVariables
>
export type CheckDeliveryConfirmationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CheckDeliveryConfirmationMutation,
    CheckDeliveryConfirmationMutationVariables
  >,
  "mutation"
>

export const CheckDeliveryConfirmationComponent = (props: CheckDeliveryConfirmationComponentProps) => (
  <ApolloReactComponents.Mutation<CheckDeliveryConfirmationMutation, CheckDeliveryConfirmationMutationVariables>
    mutation={CheckDeliveryConfirmationDocument}
    {...props}
  />
)

export function useCheckDeliveryConfirmationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckDeliveryConfirmationMutation,
    CheckDeliveryConfirmationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CheckDeliveryConfirmationMutation, CheckDeliveryConfirmationMutationVariables>(
    CheckDeliveryConfirmationDocument,
    options
  )
}
export type CheckDeliveryConfirmationMutationHookResult = ReturnType<typeof useCheckDeliveryConfirmationMutation>
export type CheckDeliveryConfirmationMutationResult = Apollo.MutationResult<CheckDeliveryConfirmationMutation>
export const CheckGeometryIntersectionsDocument = gql`
  mutation checkGeometryIntersections($input: CheckGeometryIntersectionInput!) {
    checkGeometryIntersections(input: $input) {
      result {
        companyId
        geometryIds
        props {
          geometryId
          props
        }
      }
    }
  }
`
export type CheckGeometryIntersectionsMutationFn = Apollo.MutationFunction<
  CheckGeometryIntersectionsMutation,
  CheckGeometryIntersectionsMutationVariables
>
export type CheckGeometryIntersectionsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CheckGeometryIntersectionsMutation,
    CheckGeometryIntersectionsMutationVariables
  >,
  "mutation"
>

export const CheckGeometryIntersectionsComponent = (props: CheckGeometryIntersectionsComponentProps) => (
  <ApolloReactComponents.Mutation<CheckGeometryIntersectionsMutation, CheckGeometryIntersectionsMutationVariables>
    mutation={CheckGeometryIntersectionsDocument}
    {...props}
  />
)

export function useCheckGeometryIntersectionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckGeometryIntersectionsMutation,
    CheckGeometryIntersectionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CheckGeometryIntersectionsMutation, CheckGeometryIntersectionsMutationVariables>(
    CheckGeometryIntersectionsDocument,
    options
  )
}
export type CheckGeometryIntersectionsMutationHookResult = ReturnType<typeof useCheckGeometryIntersectionsMutation>
export type CheckGeometryIntersectionsMutationResult = Apollo.MutationResult<CheckGeometryIntersectionsMutation>
export const CompaniesApprovalStatisticsAllDocument = gql`
  mutation companiesApprovalStatisticsAll {
    companiesApprovalsStatisticsAll {
      totalUpdated
    }
  }
`
export type CompaniesApprovalStatisticsAllMutationFn = Apollo.MutationFunction<
  CompaniesApprovalStatisticsAllMutation,
  CompaniesApprovalStatisticsAllMutationVariables
>
export type CompaniesApprovalStatisticsAllComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CompaniesApprovalStatisticsAllMutation,
    CompaniesApprovalStatisticsAllMutationVariables
  >,
  "mutation"
>

export const CompaniesApprovalStatisticsAllComponent = (props: CompaniesApprovalStatisticsAllComponentProps) => (
  <ApolloReactComponents.Mutation<
    CompaniesApprovalStatisticsAllMutation,
    CompaniesApprovalStatisticsAllMutationVariables
  >
    mutation={CompaniesApprovalStatisticsAllDocument}
    {...props}
  />
)

export function useCompaniesApprovalStatisticsAllMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompaniesApprovalStatisticsAllMutation,
    CompaniesApprovalStatisticsAllMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CompaniesApprovalStatisticsAllMutation, CompaniesApprovalStatisticsAllMutationVariables>(
    CompaniesApprovalStatisticsAllDocument,
    options
  )
}
export type CompaniesApprovalStatisticsAllMutationHookResult = ReturnType<
  typeof useCompaniesApprovalStatisticsAllMutation
>
export type CompaniesApprovalStatisticsAllMutationResult = Apollo.MutationResult<CompaniesApprovalStatisticsAllMutation>
export const CompanyApprovalStatisticDocument = gql`
  mutation companyApprovalStatistic($input: CompanyStatisticsInput!) {
    companyApprovalsStatistic(input: $input) {
      all {
        total {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
        lastMonth {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
        thisMonth {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
      }
      incoming {
        total {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
        lastMonth {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
        thisMonth {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
      }
      outgoing {
        total {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
        lastMonth {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
        thisMonth {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
      }
    }
  }
`
export type CompanyApprovalStatisticMutationFn = Apollo.MutationFunction<
  CompanyApprovalStatisticMutation,
  CompanyApprovalStatisticMutationVariables
>
export type CompanyApprovalStatisticComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CompanyApprovalStatisticMutation,
    CompanyApprovalStatisticMutationVariables
  >,
  "mutation"
>

export const CompanyApprovalStatisticComponent = (props: CompanyApprovalStatisticComponentProps) => (
  <ApolloReactComponents.Mutation<CompanyApprovalStatisticMutation, CompanyApprovalStatisticMutationVariables>
    mutation={CompanyApprovalStatisticDocument}
    {...props}
  />
)

export function useCompanyApprovalStatisticMutation(
  baseOptions?: Apollo.MutationHookOptions<CompanyApprovalStatisticMutation, CompanyApprovalStatisticMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CompanyApprovalStatisticMutation, CompanyApprovalStatisticMutationVariables>(
    CompanyApprovalStatisticDocument,
    options
  )
}
export type CompanyApprovalStatisticMutationHookResult = ReturnType<typeof useCompanyApprovalStatisticMutation>
export type CompanyApprovalStatisticMutationResult = Apollo.MutationResult<CompanyApprovalStatisticMutation>
export const ConfirmDeliveryApprovalItemDocument = gql`
  mutation confirmDeliveryApprovalItem($input: ConfirmDeliveryApprovalItemInput!) {
    confirmDeliveryApprovalItem(input: $input)
  }
`
export type ConfirmDeliveryApprovalItemMutationFn = Apollo.MutationFunction<
  ConfirmDeliveryApprovalItemMutation,
  ConfirmDeliveryApprovalItemMutationVariables
>
export type ConfirmDeliveryApprovalItemComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConfirmDeliveryApprovalItemMutation,
    ConfirmDeliveryApprovalItemMutationVariables
  >,
  "mutation"
>

export const ConfirmDeliveryApprovalItemComponent = (props: ConfirmDeliveryApprovalItemComponentProps) => (
  <ApolloReactComponents.Mutation<ConfirmDeliveryApprovalItemMutation, ConfirmDeliveryApprovalItemMutationVariables>
    mutation={ConfirmDeliveryApprovalItemDocument}
    {...props}
  />
)

export function useConfirmDeliveryApprovalItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmDeliveryApprovalItemMutation,
    ConfirmDeliveryApprovalItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ConfirmDeliveryApprovalItemMutation, ConfirmDeliveryApprovalItemMutationVariables>(
    ConfirmDeliveryApprovalItemDocument,
    options
  )
}
export type ConfirmDeliveryApprovalItemMutationHookResult = ReturnType<typeof useConfirmDeliveryApprovalItemMutation>
export type ConfirmDeliveryApprovalItemMutationResult = Apollo.MutationResult<ConfirmDeliveryApprovalItemMutation>
export const ConfirmEmailDocument = gql`
  mutation confirmEmail($confirmation: String!) {
    emailConfirmation(confirmation: $confirmation) {
      jwt
      user {
        id
      }
    }
  }
`
export type ConfirmEmailMutationFn = Apollo.MutationFunction<ConfirmEmailMutation, ConfirmEmailMutationVariables>
export type ConfirmEmailComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>,
  "mutation"
>

export const ConfirmEmailComponent = (props: ConfirmEmailComponentProps) => (
  <ApolloReactComponents.Mutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>
    mutation={ConfirmEmailDocument}
    {...props}
  />
)

export function useConfirmEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument, options)
}
export type ConfirmEmailMutationHookResult = ReturnType<typeof useConfirmEmailMutation>
export type ConfirmEmailMutationResult = Apollo.MutationResult<ConfirmEmailMutation>
export const CreateAoiDocument = gql`
  mutation createAoi($input: AoiInput!) {
    createAoi(data: $input) {
      data {
        id
      }
    }
  }
`
export type CreateAoiMutationFn = Apollo.MutationFunction<CreateAoiMutation, CreateAoiMutationVariables>
export type CreateAoiComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateAoiMutation, CreateAoiMutationVariables>,
  "mutation"
>

export const CreateAoiComponent = (props: CreateAoiComponentProps) => (
  <ApolloReactComponents.Mutation<CreateAoiMutation, CreateAoiMutationVariables>
    mutation={CreateAoiDocument}
    {...props}
  />
)

export function useCreateAoiMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAoiMutation, CreateAoiMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateAoiMutation, CreateAoiMutationVariables>(CreateAoiDocument, options)
}
export type CreateAoiMutationHookResult = ReturnType<typeof useCreateAoiMutation>
export type CreateAoiMutationResult = Apollo.MutationResult<CreateAoiMutation>
export const CreateApplicationDocument = gql`
  mutation createApplication($input: ApplicationInput!) {
    createApplication(data: $input) {
      data {
        id
      }
    }
  }
`
export type CreateApplicationMutationFn = Apollo.MutationFunction<
  CreateApplicationMutation,
  CreateApplicationMutationVariables
>
export type CreateApplicationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateApplicationMutation, CreateApplicationMutationVariables>,
  "mutation"
>

export const CreateApplicationComponent = (props: CreateApplicationComponentProps) => (
  <ApolloReactComponents.Mutation<CreateApplicationMutation, CreateApplicationMutationVariables>
    mutation={CreateApplicationDocument}
    {...props}
  />
)

export function useCreateApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateApplicationMutation, CreateApplicationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateApplicationMutation, CreateApplicationMutationVariables>(
    CreateApplicationDocument,
    options
  )
}
export type CreateApplicationMutationHookResult = ReturnType<typeof useCreateApplicationMutation>
export type CreateApplicationMutationResult = Apollo.MutationResult<CreateApplicationMutation>
export const CreateApprovalDocument = gql`
  mutation createApproval($input: ApprovalInput!) {
    createApproval(data: $input) {
      data {
        id
      }
    }
  }
`
export type CreateApprovalMutationFn = Apollo.MutationFunction<CreateApprovalMutation, CreateApprovalMutationVariables>
export type CreateApprovalComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateApprovalMutation, CreateApprovalMutationVariables>,
  "mutation"
>

export const CreateApprovalComponent = (props: CreateApprovalComponentProps) => (
  <ApolloReactComponents.Mutation<CreateApprovalMutation, CreateApprovalMutationVariables>
    mutation={CreateApprovalDocument}
    {...props}
  />
)

export function useCreateApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateApprovalMutation, CreateApprovalMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateApprovalMutation, CreateApprovalMutationVariables>(CreateApprovalDocument, options)
}
export type CreateApprovalMutationHookResult = ReturnType<typeof useCreateApprovalMutation>
export type CreateApprovalMutationResult = Apollo.MutationResult<CreateApprovalMutation>
export const CreateApprovalItemsDocument = gql`
  mutation createApprovalItems($input: CreateApprovalItemInput!) {
    createApprovalItem(input: $input) {
      approvals
    }
  }
`
export type CreateApprovalItemsMutationFn = Apollo.MutationFunction<
  CreateApprovalItemsMutation,
  CreateApprovalItemsMutationVariables
>
export type CreateApprovalItemsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateApprovalItemsMutation, CreateApprovalItemsMutationVariables>,
  "mutation"
>

export const CreateApprovalItemsComponent = (props: CreateApprovalItemsComponentProps) => (
  <ApolloReactComponents.Mutation<CreateApprovalItemsMutation, CreateApprovalItemsMutationVariables>
    mutation={CreateApprovalItemsDocument}
    {...props}
  />
)

export function useCreateApprovalItemsMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateApprovalItemsMutation, CreateApprovalItemsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateApprovalItemsMutation, CreateApprovalItemsMutationVariables>(
    CreateApprovalItemsDocument,
    options
  )
}
export type CreateApprovalItemsMutationHookResult = ReturnType<typeof useCreateApprovalItemsMutation>
export type CreateApprovalItemsMutationResult = Apollo.MutationResult<CreateApprovalItemsMutation>
export const CreateAreaDocument = gql`
  mutation createArea($input: AreaInput!) {
    createArea(data: $input) {
      data {
        ...Area
      }
    }
  }
  ${AreaFragmentDoc}
  ${FileFragmentDoc}
`
export type CreateAreaMutationFn = Apollo.MutationFunction<CreateAreaMutation, CreateAreaMutationVariables>
export type CreateAreaComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateAreaMutation, CreateAreaMutationVariables>,
  "mutation"
>

export const CreateAreaComponent = (props: CreateAreaComponentProps) => (
  <ApolloReactComponents.Mutation<CreateAreaMutation, CreateAreaMutationVariables>
    mutation={CreateAreaDocument}
    {...props}
  />
)

export function useCreateAreaMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAreaMutation, CreateAreaMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateAreaMutation, CreateAreaMutationVariables>(CreateAreaDocument, options)
}
export type CreateAreaMutationHookResult = ReturnType<typeof useCreateAreaMutation>
export type CreateAreaMutationResult = Apollo.MutationResult<CreateAreaMutation>
export const CreateCertificateDocument = gql`
  mutation createCertificate($input: CompletionCertificateInput!) {
    createCompletionCertificate(data: $input) {
      data {
        ...CompletionCertificate
      }
    }
  }
  ${CompletionCertificateFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type CreateCertificateMutationFn = Apollo.MutationFunction<
  CreateCertificateMutation,
  CreateCertificateMutationVariables
>
export type CreateCertificateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateCertificateMutation, CreateCertificateMutationVariables>,
  "mutation"
>

export const CreateCertificateComponent = (props: CreateCertificateComponentProps) => (
  <ApolloReactComponents.Mutation<CreateCertificateMutation, CreateCertificateMutationVariables>
    mutation={CreateCertificateDocument}
    {...props}
  />
)

export function useCreateCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCertificateMutation, CreateCertificateMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCertificateMutation, CreateCertificateMutationVariables>(
    CreateCertificateDocument,
    options
  )
}
export type CreateCertificateMutationHookResult = ReturnType<typeof useCreateCertificateMutation>
export type CreateCertificateMutationResult = Apollo.MutationResult<CreateCertificateMutation>
export const CreateCompanyDocument = gql`
  mutation createCompany($input: CompanyInput!) {
    createCompany(data: $input) {
      data {
        ...Company
      }
    }
  }
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${FileFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>
export type CreateCompanyComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateCompanyMutation, CreateCompanyMutationVariables>,
  "mutation"
>

export const CreateCompanyComponent = (props: CreateCompanyComponentProps) => (
  <ApolloReactComponents.Mutation<CreateCompanyMutation, CreateCompanyMutationVariables>
    mutation={CreateCompanyDocument}
    {...props}
  />
)

export function useCreateCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options)
}
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>
export const CreateCompanyInfoUpdateRequestNotificationDocument = gql`
  mutation createCompanyInfoUpdateRequestNotification($input: CreateCompanyInfoUpdateRequestNotificationInput!) {
    createCompanyInfoUpdateRequestNotification(input: $input)
  }
`
export type CreateCompanyInfoUpdateRequestNotificationMutationFn = Apollo.MutationFunction<
  CreateCompanyInfoUpdateRequestNotificationMutation,
  CreateCompanyInfoUpdateRequestNotificationMutationVariables
>
export type CreateCompanyInfoUpdateRequestNotificationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateCompanyInfoUpdateRequestNotificationMutation,
    CreateCompanyInfoUpdateRequestNotificationMutationVariables
  >,
  "mutation"
>

export const CreateCompanyInfoUpdateRequestNotificationComponent = (
  props: CreateCompanyInfoUpdateRequestNotificationComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CreateCompanyInfoUpdateRequestNotificationMutation,
    CreateCompanyInfoUpdateRequestNotificationMutationVariables
  >
    mutation={CreateCompanyInfoUpdateRequestNotificationDocument}
    {...props}
  />
)

export function useCreateCompanyInfoUpdateRequestNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCompanyInfoUpdateRequestNotificationMutation,
    CreateCompanyInfoUpdateRequestNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCompanyInfoUpdateRequestNotificationMutation,
    CreateCompanyInfoUpdateRequestNotificationMutationVariables
  >(CreateCompanyInfoUpdateRequestNotificationDocument, options)
}
export type CreateCompanyInfoUpdateRequestNotificationMutationHookResult = ReturnType<
  typeof useCreateCompanyInfoUpdateRequestNotificationMutation
>
export type CreateCompanyInfoUpdateRequestNotificationMutationResult =
  Apollo.MutationResult<CreateCompanyInfoUpdateRequestNotificationMutation>
export const CreateCompanyUpdateRequestDocument = gql`
  mutation createCompanyUpdateRequest($input: CompanyUpdateRequestInput!) {
    createCompanyUpdateRequest(data: $input) {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`
export type CreateCompanyUpdateRequestMutationFn = Apollo.MutationFunction<
  CreateCompanyUpdateRequestMutation,
  CreateCompanyUpdateRequestMutationVariables
>
export type CreateCompanyUpdateRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateCompanyUpdateRequestMutation,
    CreateCompanyUpdateRequestMutationVariables
  >,
  "mutation"
>

export const CreateCompanyUpdateRequestComponent = (props: CreateCompanyUpdateRequestComponentProps) => (
  <ApolloReactComponents.Mutation<CreateCompanyUpdateRequestMutation, CreateCompanyUpdateRequestMutationVariables>
    mutation={CreateCompanyUpdateRequestDocument}
    {...props}
  />
)

export function useCreateCompanyUpdateRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCompanyUpdateRequestMutation,
    CreateCompanyUpdateRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCompanyUpdateRequestMutation, CreateCompanyUpdateRequestMutationVariables>(
    CreateCompanyUpdateRequestDocument,
    options
  )
}
export type CreateCompanyUpdateRequestMutationHookResult = ReturnType<typeof useCreateCompanyUpdateRequestMutation>
export type CreateCompanyUpdateRequestMutationResult = Apollo.MutationResult<CreateCompanyUpdateRequestMutation>
export const CreateContactRequestDocument = gql`
  mutation createContactRequest($input: ContactRequestInput!) {
    createContactRequest(data: $input) {
      data {
        id
      }
    }
  }
`
export type CreateContactRequestMutationFn = Apollo.MutationFunction<
  CreateContactRequestMutation,
  CreateContactRequestMutationVariables
>
export type CreateContactRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateContactRequestMutation, CreateContactRequestMutationVariables>,
  "mutation"
>

export const CreateContactRequestComponent = (props: CreateContactRequestComponentProps) => (
  <ApolloReactComponents.Mutation<CreateContactRequestMutation, CreateContactRequestMutationVariables>
    mutation={CreateContactRequestDocument}
    {...props}
  />
)

export function useCreateContactRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateContactRequestMutation, CreateContactRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateContactRequestMutation, CreateContactRequestMutationVariables>(
    CreateContactRequestDocument,
    options
  )
}
export type CreateContactRequestMutationHookResult = ReturnType<typeof useCreateContactRequestMutation>
export type CreateContactRequestMutationResult = Apollo.MutationResult<CreateContactRequestMutation>
export const CreateDeliveryConfirmationDocument = gql`
  mutation createDeliveryConfirmation($input: DeliveryConfirmationInput!) {
    createDeliveryConfirmation(data: $input) {
      data {
        id
        attributes {
          contactFullName
          position
          phone
          email
          notes
          company
          address
          deliveryDateTime
          byCompany
          byFullName
          byPhone
          byEmail
          applicationName
          deliveryPoint
          files {
            data {
              id
            }
          }
        }
      }
    }
  }
`
export type CreateDeliveryConfirmationMutationFn = Apollo.MutationFunction<
  CreateDeliveryConfirmationMutation,
  CreateDeliveryConfirmationMutationVariables
>
export type CreateDeliveryConfirmationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateDeliveryConfirmationMutation,
    CreateDeliveryConfirmationMutationVariables
  >,
  "mutation"
>

export const CreateDeliveryConfirmationComponent = (props: CreateDeliveryConfirmationComponentProps) => (
  <ApolloReactComponents.Mutation<CreateDeliveryConfirmationMutation, CreateDeliveryConfirmationMutationVariables>
    mutation={CreateDeliveryConfirmationDocument}
    {...props}
  />
)

export function useCreateDeliveryConfirmationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDeliveryConfirmationMutation,
    CreateDeliveryConfirmationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDeliveryConfirmationMutation, CreateDeliveryConfirmationMutationVariables>(
    CreateDeliveryConfirmationDocument,
    options
  )
}
export type CreateDeliveryConfirmationMutationHookResult = ReturnType<typeof useCreateDeliveryConfirmationMutation>
export type CreateDeliveryConfirmationMutationResult = Apollo.MutationResult<CreateDeliveryConfirmationMutation>
export const CreateDepositDocument = gql`
  mutation createDeposit($input: DepositInput!) {
    createDeposit(data: $input) {
      data {
        ...Deposit
      }
    }
  }
  ${DepositFragmentDoc}
  ${FileFragmentDoc}
`
export type CreateDepositMutationFn = Apollo.MutationFunction<CreateDepositMutation, CreateDepositMutationVariables>
export type CreateDepositComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateDepositMutation, CreateDepositMutationVariables>,
  "mutation"
>

export const CreateDepositComponent = (props: CreateDepositComponentProps) => (
  <ApolloReactComponents.Mutation<CreateDepositMutation, CreateDepositMutationVariables>
    mutation={CreateDepositDocument}
    {...props}
  />
)

export function useCreateDepositMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateDepositMutation, CreateDepositMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDepositMutation, CreateDepositMutationVariables>(CreateDepositDocument, options)
}
export type CreateDepositMutationHookResult = ReturnType<typeof useCreateDepositMutation>
export type CreateDepositMutationResult = Apollo.MutationResult<CreateDepositMutation>
export const CreateEnforcementDocument = gql`
  mutation createEnforcement($input: EnforcementInput!) {
    createEnforcement(data: $input) {
      data {
        ...Enforcement
      }
    }
  }
  ${EnforcementFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type CreateEnforcementMutationFn = Apollo.MutationFunction<
  CreateEnforcementMutation,
  CreateEnforcementMutationVariables
>
export type CreateEnforcementComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateEnforcementMutation, CreateEnforcementMutationVariables>,
  "mutation"
>

export const CreateEnforcementComponent = (props: CreateEnforcementComponentProps) => (
  <ApolloReactComponents.Mutation<CreateEnforcementMutation, CreateEnforcementMutationVariables>
    mutation={CreateEnforcementDocument}
    {...props}
  />
)

export function useCreateEnforcementMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateEnforcementMutation, CreateEnforcementMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateEnforcementMutation, CreateEnforcementMutationVariables>(
    CreateEnforcementDocument,
    options
  )
}
export type CreateEnforcementMutationHookResult = ReturnType<typeof useCreateEnforcementMutation>
export type CreateEnforcementMutationResult = Apollo.MutationResult<CreateEnforcementMutation>
export const CreateIncidentDocument = gql`
  mutation createIncident($input: IncidentInput!) {
    createIncident(data: $input) {
      data {
        id
      }
    }
  }
`
export type CreateIncidentMutationFn = Apollo.MutationFunction<CreateIncidentMutation, CreateIncidentMutationVariables>
export type CreateIncidentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateIncidentMutation, CreateIncidentMutationVariables>,
  "mutation"
>

export const CreateIncidentComponent = (props: CreateIncidentComponentProps) => (
  <ApolloReactComponents.Mutation<CreateIncidentMutation, CreateIncidentMutationVariables>
    mutation={CreateIncidentDocument}
    {...props}
  />
)

export function useCreateIncidentMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateIncidentMutation, CreateIncidentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateIncidentMutation, CreateIncidentMutationVariables>(CreateIncidentDocument, options)
}
export type CreateIncidentMutationHookResult = ReturnType<typeof useCreateIncidentMutation>
export type CreateIncidentMutationResult = Apollo.MutationResult<CreateIncidentMutation>
export const CreateKickoffInviteDocument = gql`
  mutation createKickoffInvite($input: KickoffInviteInput!) {
    createKickoffInvite(data: $input) {
      data {
        ...KickoffInvite
      }
    }
  }
  ${KickoffInviteFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type CreateKickoffInviteMutationFn = Apollo.MutationFunction<
  CreateKickoffInviteMutation,
  CreateKickoffInviteMutationVariables
>
export type CreateKickoffInviteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateKickoffInviteMutation, CreateKickoffInviteMutationVariables>,
  "mutation"
>

export const CreateKickoffInviteComponent = (props: CreateKickoffInviteComponentProps) => (
  <ApolloReactComponents.Mutation<CreateKickoffInviteMutation, CreateKickoffInviteMutationVariables>
    mutation={CreateKickoffInviteDocument}
    {...props}
  />
)

export function useCreateKickoffInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateKickoffInviteMutation, CreateKickoffInviteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateKickoffInviteMutation, CreateKickoffInviteMutationVariables>(
    CreateKickoffInviteDocument,
    options
  )
}
export type CreateKickoffInviteMutationHookResult = ReturnType<typeof useCreateKickoffInviteMutation>
export type CreateKickoffInviteMutationResult = Apollo.MutationResult<CreateKickoffInviteMutation>
export const CreateInvoiceDocument = gql`
  mutation createInvoice($input: InvoiceInput!) {
    createInvoice(data: $input) {
      data {
        ...Invoice
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${FileFragmentDoc}
`
export type CreateInvoiceMutationFn = Apollo.MutationFunction<CreateInvoiceMutation, CreateInvoiceMutationVariables>
export type CreateInvoiceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>,
  "mutation"
>

export const CreateInvoiceComponent = (props: CreateInvoiceComponentProps) => (
  <ApolloReactComponents.Mutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>
    mutation={CreateInvoiceDocument}
    {...props}
  />
)

export function useCreateInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument, options)
}
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>
export type CreateInvoiceMutationResult = Apollo.MutationResult<CreateInvoiceMutation>
export const CreateNoteDocument = gql`
  mutation createNote($input: NoteInput!) {
    createNote(data: $input) {
      data {
        ...Note
      }
    }
  }
  ${NoteFragmentDoc}
  ${FileFragmentDoc}
`
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>
export type CreateNoteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateNoteMutation, CreateNoteMutationVariables>,
  "mutation"
>

export const CreateNoteComponent = (props: CreateNoteComponentProps) => (
  <ApolloReactComponents.Mutation<CreateNoteMutation, CreateNoteMutationVariables>
    mutation={CreateNoteDocument}
    {...props}
  />
)

export function useCreateNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options)
}
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>
export const CreateNotificationMessageDocument = gql`
  mutation createNotificationMessage($input: NotificationMessageInput!) {
    createNotificationMessage(data: $input) {
      data {
        ...NotificationMessage
      }
    }
  }
  ${NotificationMessageFragmentDoc}
  ${FileFragmentDoc}
`
export type CreateNotificationMessageMutationFn = Apollo.MutationFunction<
  CreateNotificationMessageMutation,
  CreateNotificationMessageMutationVariables
>
export type CreateNotificationMessageComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateNotificationMessageMutation,
    CreateNotificationMessageMutationVariables
  >,
  "mutation"
>

export const CreateNotificationMessageComponent = (props: CreateNotificationMessageComponentProps) => (
  <ApolloReactComponents.Mutation<CreateNotificationMessageMutation, CreateNotificationMessageMutationVariables>
    mutation={CreateNotificationMessageDocument}
    {...props}
  />
)

export function useCreateNotificationMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNotificationMessageMutation,
    CreateNotificationMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateNotificationMessageMutation, CreateNotificationMessageMutationVariables>(
    CreateNotificationMessageDocument,
    options
  )
}
export type CreateNotificationMessageMutationHookResult = ReturnType<typeof useCreateNotificationMessageMutation>
export type CreateNotificationMessageMutationResult = Apollo.MutationResult<CreateNotificationMessageMutation>
export const CreatePayFastCheckoutDocument = gql`
  mutation createPayFastCheckout($input: CreatePayFastCheckoutInput!) {
    createPayFastCheckout(input: $input) {
      processUrl
      fields {
        name
        value
      }
    }
  }
`
export type CreatePayFastCheckoutMutationFn = Apollo.MutationFunction<
  CreatePayFastCheckoutMutation,
  CreatePayFastCheckoutMutationVariables
>
export type CreatePayFastCheckoutComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreatePayFastCheckoutMutation, CreatePayFastCheckoutMutationVariables>,
  "mutation"
>

export const CreatePayFastCheckoutComponent = (props: CreatePayFastCheckoutComponentProps) => (
  <ApolloReactComponents.Mutation<CreatePayFastCheckoutMutation, CreatePayFastCheckoutMutationVariables>
    mutation={CreatePayFastCheckoutDocument}
    {...props}
  />
)

export function useCreatePayFastCheckoutMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePayFastCheckoutMutation, CreatePayFastCheckoutMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreatePayFastCheckoutMutation, CreatePayFastCheckoutMutationVariables>(
    CreatePayFastCheckoutDocument,
    options
  )
}
export type CreatePayFastCheckoutMutationHookResult = ReturnType<typeof useCreatePayFastCheckoutMutation>
export type CreatePayFastCheckoutMutationResult = Apollo.MutationResult<CreatePayFastCheckoutMutation>
export const CreatePaymentDocument = gql`
  mutation createPayment($input: PaymentInput!) {
    createPayment(data: $input) {
      data {
        ...Payment
      }
    }
  }
  ${PaymentFragmentDoc}
  ${FileFragmentDoc}
`
export type CreatePaymentMutationFn = Apollo.MutationFunction<CreatePaymentMutation, CreatePaymentMutationVariables>
export type CreatePaymentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreatePaymentMutation, CreatePaymentMutationVariables>,
  "mutation"
>

export const CreatePaymentComponent = (props: CreatePaymentComponentProps) => (
  <ApolloReactComponents.Mutation<CreatePaymentMutation, CreatePaymentMutationVariables>
    mutation={CreatePaymentDocument}
    {...props}
  />
)

export function useCreatePaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePaymentMutation, CreatePaymentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument, options)
}
export type CreatePaymentMutationHookResult = ReturnType<typeof useCreatePaymentMutation>
export type CreatePaymentMutationResult = Apollo.MutationResult<CreatePaymentMutation>
export const CreateProjectDocument = gql`
  mutation createProject($input: ProjectInput!) {
    createProject(data: $input) {
      data {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
  ${ProvinceFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${ApplicationNatureFragmentDoc}
`
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>
export type CreateProjectComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateProjectMutation, CreateProjectMutationVariables>,
  "mutation"
>

export const CreateProjectComponent = (props: CreateProjectComponentProps) => (
  <ApolloReactComponents.Mutation<CreateProjectMutation, CreateProjectMutationVariables>
    mutation={CreateProjectDocument}
    {...props}
  />
)

export function useCreateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options)
}
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>
export const CreateProjectEmailNotificationInputDocument = gql`
  mutation createProjectEmailNotificationInput($input: CreateProjectEmailNotificationInput!) {
    createProjectEmailNotification(input: $input)
  }
`
export type CreateProjectEmailNotificationInputMutationFn = Apollo.MutationFunction<
  CreateProjectEmailNotificationInputMutation,
  CreateProjectEmailNotificationInputMutationVariables
>
export type CreateProjectEmailNotificationInputComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateProjectEmailNotificationInputMutation,
    CreateProjectEmailNotificationInputMutationVariables
  >,
  "mutation"
>

export const CreateProjectEmailNotificationInputComponent = (
  props: CreateProjectEmailNotificationInputComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CreateProjectEmailNotificationInputMutation,
    CreateProjectEmailNotificationInputMutationVariables
  >
    mutation={CreateProjectEmailNotificationInputDocument}
    {...props}
  />
)

export function useCreateProjectEmailNotificationInputMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectEmailNotificationInputMutation,
    CreateProjectEmailNotificationInputMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateProjectEmailNotificationInputMutation,
    CreateProjectEmailNotificationInputMutationVariables
  >(CreateProjectEmailNotificationInputDocument, options)
}
export type CreateProjectEmailNotificationInputMutationHookResult = ReturnType<
  typeof useCreateProjectEmailNotificationInputMutation
>
export type CreateProjectEmailNotificationInputMutationResult =
  Apollo.MutationResult<CreateProjectEmailNotificationInputMutation>
export const CreateProjectOwnerEmailNotificationDocument = gql`
  mutation createProjectOwnerEmailNotification($input: CreateProjectOwnerEmailNotificationInput!) {
    createProjectOwnerEmailNotification(input: $input)
  }
`
export type CreateProjectOwnerEmailNotificationMutationFn = Apollo.MutationFunction<
  CreateProjectOwnerEmailNotificationMutation,
  CreateProjectOwnerEmailNotificationMutationVariables
>
export type CreateProjectOwnerEmailNotificationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateProjectOwnerEmailNotificationMutation,
    CreateProjectOwnerEmailNotificationMutationVariables
  >,
  "mutation"
>

export const CreateProjectOwnerEmailNotificationComponent = (
  props: CreateProjectOwnerEmailNotificationComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CreateProjectOwnerEmailNotificationMutation,
    CreateProjectOwnerEmailNotificationMutationVariables
  >
    mutation={CreateProjectOwnerEmailNotificationDocument}
    {...props}
  />
)

export function useCreateProjectOwnerEmailNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectOwnerEmailNotificationMutation,
    CreateProjectOwnerEmailNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateProjectOwnerEmailNotificationMutation,
    CreateProjectOwnerEmailNotificationMutationVariables
  >(CreateProjectOwnerEmailNotificationDocument, options)
}
export type CreateProjectOwnerEmailNotificationMutationHookResult = ReturnType<
  typeof useCreateProjectOwnerEmailNotificationMutation
>
export type CreateProjectOwnerEmailNotificationMutationResult =
  Apollo.MutationResult<CreateProjectOwnerEmailNotificationMutation>
export const CreateProjectWithApplicationsDocument = gql`
  mutation createProjectWithApplications($input: CreateProjectWithApplicationsInput!) {
    createProjectWithApplications(input: $input) {
      projectId
      projectUuid
      innerRefNumber
      applicationIds
      alreadySaved
    }
  }
`
export type CreateProjectWithApplicationsMutationFn = Apollo.MutationFunction<
  CreateProjectWithApplicationsMutation,
  CreateProjectWithApplicationsMutationVariables
>
export type CreateProjectWithApplicationsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateProjectWithApplicationsMutation,
    CreateProjectWithApplicationsMutationVariables
  >,
  "mutation"
>

export const CreateProjectWithApplicationsComponent = (props: CreateProjectWithApplicationsComponentProps) => (
  <ApolloReactComponents.Mutation<CreateProjectWithApplicationsMutation, CreateProjectWithApplicationsMutationVariables>
    mutation={CreateProjectWithApplicationsDocument}
    {...props}
  />
)

export function useCreateProjectWithApplicationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectWithApplicationsMutation,
    CreateProjectWithApplicationsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateProjectWithApplicationsMutation, CreateProjectWithApplicationsMutationVariables>(
    CreateProjectWithApplicationsDocument,
    options
  )
}
export type CreateProjectWithApplicationsMutationHookResult = ReturnType<
  typeof useCreateProjectWithApplicationsMutation
>
export type CreateProjectWithApplicationsMutationResult = Apollo.MutationResult<CreateProjectWithApplicationsMutation>
export const CreateProvinceDocument = gql`
  mutation createProvince($input: ProvinceInput!) {
    createProvince(data: $input) {
      data {
        ...Province
      }
    }
  }
  ${ProvinceFragmentDoc}
  ${FileFragmentDoc}
`
export type CreateProvinceMutationFn = Apollo.MutationFunction<CreateProvinceMutation, CreateProvinceMutationVariables>
export type CreateProvinceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateProvinceMutation, CreateProvinceMutationVariables>,
  "mutation"
>

export const CreateProvinceComponent = (props: CreateProvinceComponentProps) => (
  <ApolloReactComponents.Mutation<CreateProvinceMutation, CreateProvinceMutationVariables>
    mutation={CreateProvinceDocument}
    {...props}
  />
)

export function useCreateProvinceMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateProvinceMutation, CreateProvinceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateProvinceMutation, CreateProvinceMutationVariables>(CreateProvinceDocument, options)
}
export type CreateProvinceMutationHookResult = ReturnType<typeof useCreateProvinceMutation>
export type CreateProvinceMutationResult = Apollo.MutationResult<CreateProvinceMutation>
export const CreateQuoteItemDocument = gql`
  mutation createQuoteItem($input: QuoteItemInput!) {
    createQuoteItem(data: $input) {
      data {
        ...QuoteItem
      }
    }
  }
  ${QuoteItemFragmentDoc}
`
export type CreateQuoteItemMutationFn = Apollo.MutationFunction<
  CreateQuoteItemMutation,
  CreateQuoteItemMutationVariables
>
export type CreateQuoteItemComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateQuoteItemMutation, CreateQuoteItemMutationVariables>,
  "mutation"
>

export const CreateQuoteItemComponent = (props: CreateQuoteItemComponentProps) => (
  <ApolloReactComponents.Mutation<CreateQuoteItemMutation, CreateQuoteItemMutationVariables>
    mutation={CreateQuoteItemDocument}
    {...props}
  />
)

export function useCreateQuoteItemMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateQuoteItemMutation, CreateQuoteItemMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateQuoteItemMutation, CreateQuoteItemMutationVariables>(CreateQuoteItemDocument, options)
}
export type CreateQuoteItemMutationHookResult = ReturnType<typeof useCreateQuoteItemMutation>
export type CreateQuoteItemMutationResult = Apollo.MutationResult<CreateQuoteItemMutation>
export const CreateQuoteRequestDocument = gql`
  mutation createQuoteRequest($input: QuoteRequestInput!) {
    createQuoteRequest(data: $input) {
      data {
        id
      }
    }
  }
`
export type CreateQuoteRequestMutationFn = Apollo.MutationFunction<
  CreateQuoteRequestMutation,
  CreateQuoteRequestMutationVariables
>
export type CreateQuoteRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateQuoteRequestMutation, CreateQuoteRequestMutationVariables>,
  "mutation"
>

export const CreateQuoteRequestComponent = (props: CreateQuoteRequestComponentProps) => (
  <ApolloReactComponents.Mutation<CreateQuoteRequestMutation, CreateQuoteRequestMutationVariables>
    mutation={CreateQuoteRequestDocument}
    {...props}
  />
)

export function useCreateQuoteRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateQuoteRequestMutation, CreateQuoteRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateQuoteRequestMutation, CreateQuoteRequestMutationVariables>(
    CreateQuoteRequestDocument,
    options
  )
}
export type CreateQuoteRequestMutationHookResult = ReturnType<typeof useCreateQuoteRequestMutation>
export type CreateQuoteRequestMutationResult = Apollo.MutationResult<CreateQuoteRequestMutation>
export const CreateKickoffRecordDocument = gql`
  mutation createKickoffRecord($input: KickoffRecordInput!) {
    createKickoffRecord(data: $input) {
      data {
        ...KickoffRecord
      }
    }
  }
  ${KickoffRecordFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type CreateKickoffRecordMutationFn = Apollo.MutationFunction<
  CreateKickoffRecordMutation,
  CreateKickoffRecordMutationVariables
>
export type CreateKickoffRecordComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateKickoffRecordMutation, CreateKickoffRecordMutationVariables>,
  "mutation"
>

export const CreateKickoffRecordComponent = (props: CreateKickoffRecordComponentProps) => (
  <ApolloReactComponents.Mutation<CreateKickoffRecordMutation, CreateKickoffRecordMutationVariables>
    mutation={CreateKickoffRecordDocument}
    {...props}
  />
)

export function useCreateKickoffRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateKickoffRecordMutation, CreateKickoffRecordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateKickoffRecordMutation, CreateKickoffRecordMutationVariables>(
    CreateKickoffRecordDocument,
    options
  )
}
export type CreateKickoffRecordMutationHookResult = ReturnType<typeof useCreateKickoffRecordMutation>
export type CreateKickoffRecordMutationResult = Apollo.MutationResult<CreateKickoffRecordMutation>
export const CreateSurveyDocument = gql`
  mutation createSurvey($input: SurveyInput!) {
    createSurvey(data: $input) {
      data {
        id
      }
    }
  }
`
export type CreateSurveyMutationFn = Apollo.MutationFunction<CreateSurveyMutation, CreateSurveyMutationVariables>
export type CreateSurveyComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateSurveyMutation, CreateSurveyMutationVariables>,
  "mutation"
>

export const CreateSurveyComponent = (props: CreateSurveyComponentProps) => (
  <ApolloReactComponents.Mutation<CreateSurveyMutation, CreateSurveyMutationVariables>
    mutation={CreateSurveyDocument}
    {...props}
  />
)

export function useCreateSurveyMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSurveyMutation, CreateSurveyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateSurveyMutation, CreateSurveyMutationVariables>(CreateSurveyDocument, options)
}
export type CreateSurveyMutationHookResult = ReturnType<typeof useCreateSurveyMutation>
export type CreateSurveyMutationResult = Apollo.MutationResult<CreateSurveyMutation>
export const CreateTaskDocument = gql`
  mutation createTask($input: TaskInput!) {
    createTask(data: $input) {
      data {
        ...Task
      }
    }
  }
  ${TaskFragmentDoc}
`
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>
export type CreateTaskComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateTaskMutation, CreateTaskMutationVariables>,
  "mutation"
>

export const CreateTaskComponent = (props: CreateTaskComponentProps) => (
  <ApolloReactComponents.Mutation<CreateTaskMutation, CreateTaskMutationVariables>
    mutation={CreateTaskDocument}
    {...props}
  />
)

export function useCreateTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options)
}
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>
export const CreateUserProfileDocument = gql`
  mutation createUserProfile($input: UserProfileInput!) {
    createUserProfile(data: $input) {
      data {
        ...UserProfile
      }
    }
  }
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type CreateUserProfileMutationFn = Apollo.MutationFunction<
  CreateUserProfileMutation,
  CreateUserProfileMutationVariables
>
export type CreateUserProfileComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateUserProfileMutation, CreateUserProfileMutationVariables>,
  "mutation"
>

export const CreateUserProfileComponent = (props: CreateUserProfileComponentProps) => (
  <ApolloReactComponents.Mutation<CreateUserProfileMutation, CreateUserProfileMutationVariables>
    mutation={CreateUserProfileDocument}
    {...props}
  />
)

export function useCreateUserProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateUserProfileMutation, CreateUserProfileMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateUserProfileMutation, CreateUserProfileMutationVariables>(
    CreateUserProfileDocument,
    options
  )
}
export type CreateUserProfileMutationHookResult = ReturnType<typeof useCreateUserProfileMutation>
export type CreateUserProfileMutationResult = Apollo.MutationResult<CreateUserProfileMutation>
export const CustomChangePasswordDocument = gql`
  mutation customChangePassword($input: CustomChangePasswordInput!) {
    customChangePassword(input: $input) {
      success
      invalidCurrentPassword
    }
  }
`
export type CustomChangePasswordMutationFn = Apollo.MutationFunction<
  CustomChangePasswordMutation,
  CustomChangePasswordMutationVariables
>
export type CustomChangePasswordComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CustomChangePasswordMutation, CustomChangePasswordMutationVariables>,
  "mutation"
>

export const CustomChangePasswordComponent = (props: CustomChangePasswordComponentProps) => (
  <ApolloReactComponents.Mutation<CustomChangePasswordMutation, CustomChangePasswordMutationVariables>
    mutation={CustomChangePasswordDocument}
    {...props}
  />
)

export function useCustomChangePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomChangePasswordMutation, CustomChangePasswordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CustomChangePasswordMutation, CustomChangePasswordMutationVariables>(
    CustomChangePasswordDocument,
    options
  )
}
export type CustomChangePasswordMutationHookResult = ReturnType<typeof useCustomChangePasswordMutation>
export type CustomChangePasswordMutationResult = Apollo.MutationResult<CustomChangePasswordMutation>
export const CustomForgotPasswordDocument = gql`
  mutation customForgotPassword($input: ForgotPasswordInput!) {
    customForgotPassword(input: $input) {
      sent
      accountNotFound
      anotherOrgUser
      orgIds
    }
  }
`
export type CustomForgotPasswordMutationFn = Apollo.MutationFunction<
  CustomForgotPasswordMutation,
  CustomForgotPasswordMutationVariables
>
export type CustomForgotPasswordComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CustomForgotPasswordMutation, CustomForgotPasswordMutationVariables>,
  "mutation"
>

export const CustomForgotPasswordComponent = (props: CustomForgotPasswordComponentProps) => (
  <ApolloReactComponents.Mutation<CustomForgotPasswordMutation, CustomForgotPasswordMutationVariables>
    mutation={CustomForgotPasswordDocument}
    {...props}
  />
)

export function useCustomForgotPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomForgotPasswordMutation, CustomForgotPasswordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CustomForgotPasswordMutation, CustomForgotPasswordMutationVariables>(
    CustomForgotPasswordDocument,
    options
  )
}
export type CustomForgotPasswordMutationHookResult = ReturnType<typeof useCustomForgotPasswordMutation>
export type CustomForgotPasswordMutationResult = Apollo.MutationResult<CustomForgotPasswordMutation>
export const CustomGoogleLoginDocument = gql`
  mutation customGoogleLogin($input: GoogleLoginInput!) {
    customGoogleLogin(input: $input) {
      jwt
      refreshTokenExpiresAt
      twoFactorRequired
      challengeId
      emailNotConfirmed
      isNewUser
      outgoingOnlyClient
      paymentOverdue
      user {
        id
      }
    }
  }
`
export type CustomGoogleLoginMutationFn = Apollo.MutationFunction<
  CustomGoogleLoginMutation,
  CustomGoogleLoginMutationVariables
>
export type CustomGoogleLoginComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CustomGoogleLoginMutation, CustomGoogleLoginMutationVariables>,
  "mutation"
>

export const CustomGoogleLoginComponent = (props: CustomGoogleLoginComponentProps) => (
  <ApolloReactComponents.Mutation<CustomGoogleLoginMutation, CustomGoogleLoginMutationVariables>
    mutation={CustomGoogleLoginDocument}
    {...props}
  />
)

export function useCustomGoogleLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomGoogleLoginMutation, CustomGoogleLoginMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CustomGoogleLoginMutation, CustomGoogleLoginMutationVariables>(
    CustomGoogleLoginDocument,
    options
  )
}
export type CustomGoogleLoginMutationHookResult = ReturnType<typeof useCustomGoogleLoginMutation>
export type CustomGoogleLoginMutationResult = Apollo.MutationResult<CustomGoogleLoginMutation>
export const CustomLoginDocument = gql`
  mutation customLogin($input: LoginUserInput!) {
    customLogin(input: $input) {
      jwt
      refreshTokenExpiresAt
      anotherOrgUser
      orgIds
      emailNotConfirmed
      invalidCredentials
      accountBlocked
      twoFactorRequired
      challengeId
      invalidCode
      codeExpired
      tooManyAttempts
      outgoingOnlyClient
      paymentOverdue
      accountLocked
      lockedUntil
      passwordUpdateRequired
      passwordUpdateDueBy
      rateLimited
      retryAfterSeconds
      user {
        id
      }
    }
  }
`
export type CustomLoginMutationFn = Apollo.MutationFunction<CustomLoginMutation, CustomLoginMutationVariables>
export type CustomLoginComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CustomLoginMutation, CustomLoginMutationVariables>,
  "mutation"
>

export const CustomLoginComponent = (props: CustomLoginComponentProps) => (
  <ApolloReactComponents.Mutation<CustomLoginMutation, CustomLoginMutationVariables>
    mutation={CustomLoginDocument}
    {...props}
  />
)

export function useCustomLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomLoginMutation, CustomLoginMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CustomLoginMutation, CustomLoginMutationVariables>(CustomLoginDocument, options)
}
export type CustomLoginMutationHookResult = ReturnType<typeof useCustomLoginMutation>
export type CustomLoginMutationResult = Apollo.MutationResult<CustomLoginMutation>
export const CustomLogoutDocument = gql`
  mutation customLogout {
    customLogout {
      success
    }
  }
`
export type CustomLogoutMutationFn = Apollo.MutationFunction<CustomLogoutMutation, CustomLogoutMutationVariables>
export type CustomLogoutComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CustomLogoutMutation, CustomLogoutMutationVariables>,
  "mutation"
>

export const CustomLogoutComponent = (props: CustomLogoutComponentProps) => (
  <ApolloReactComponents.Mutation<CustomLogoutMutation, CustomLogoutMutationVariables>
    mutation={CustomLogoutDocument}
    {...props}
  />
)

export function useCustomLogoutMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomLogoutMutation, CustomLogoutMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CustomLogoutMutation, CustomLogoutMutationVariables>(CustomLogoutDocument, options)
}
export type CustomLogoutMutationHookResult = ReturnType<typeof useCustomLogoutMutation>
export type CustomLogoutMutationResult = Apollo.MutationResult<CustomLogoutMutation>
export const CustomRegisterDocument = gql`
  mutation customRegister($input: RegisterUserInput!) {
    customRegister(input: $input) {
      jwt
      user {
        id
      }
      isExistingProfile
    }
  }
`
export type CustomRegisterMutationFn = Apollo.MutationFunction<CustomRegisterMutation, CustomRegisterMutationVariables>
export type CustomRegisterComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CustomRegisterMutation, CustomRegisterMutationVariables>,
  "mutation"
>

export const CustomRegisterComponent = (props: CustomRegisterComponentProps) => (
  <ApolloReactComponents.Mutation<CustomRegisterMutation, CustomRegisterMutationVariables>
    mutation={CustomRegisterDocument}
    {...props}
  />
)

export function useCustomRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomRegisterMutation, CustomRegisterMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CustomRegisterMutation, CustomRegisterMutationVariables>(CustomRegisterDocument, options)
}
export type CustomRegisterMutationHookResult = ReturnType<typeof useCustomRegisterMutation>
export type CustomRegisterMutationResult = Apollo.MutationResult<CustomRegisterMutation>
export const CustomResetPasswordDocument = gql`
  mutation customResetPassword($input: ResetPasswordInput!) {
    customResetPassword(input: $input)
  }
`
export type CustomResetPasswordMutationFn = Apollo.MutationFunction<
  CustomResetPasswordMutation,
  CustomResetPasswordMutationVariables
>
export type CustomResetPasswordComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CustomResetPasswordMutation, CustomResetPasswordMutationVariables>,
  "mutation"
>

export const CustomResetPasswordComponent = (props: CustomResetPasswordComponentProps) => (
  <ApolloReactComponents.Mutation<CustomResetPasswordMutation, CustomResetPasswordMutationVariables>
    mutation={CustomResetPasswordDocument}
    {...props}
  />
)

export function useCustomResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomResetPasswordMutation, CustomResetPasswordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CustomResetPasswordMutation, CustomResetPasswordMutationVariables>(
    CustomResetPasswordDocument,
    options
  )
}
export type CustomResetPasswordMutationHookResult = ReturnType<typeof useCustomResetPasswordMutation>
export type CustomResetPasswordMutationResult = Apollo.MutationResult<CustomResetPasswordMutation>
export const DeleteApplicationDocument = gql`
  mutation deleteApplication($id: ID!) {
    deleteApplication(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteApplicationMutationFn = Apollo.MutationFunction<
  DeleteApplicationMutation,
  DeleteApplicationMutationVariables
>
export type DeleteApplicationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteApplicationMutation, DeleteApplicationMutationVariables>,
  "mutation"
>

export const DeleteApplicationComponent = (props: DeleteApplicationComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteApplicationMutation, DeleteApplicationMutationVariables>
    mutation={DeleteApplicationDocument}
    {...props}
  />
)

export function useDeleteApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteApplicationMutation, DeleteApplicationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteApplicationMutation, DeleteApplicationMutationVariables>(
    DeleteApplicationDocument,
    options
  )
}
export type DeleteApplicationMutationHookResult = ReturnType<typeof useDeleteApplicationMutation>
export type DeleteApplicationMutationResult = Apollo.MutationResult<DeleteApplicationMutation>
export const DeleteApprovalDocument = gql`
  mutation deleteApproval($id: ID!) {
    deleteApproval(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteApprovalMutationFn = Apollo.MutationFunction<DeleteApprovalMutation, DeleteApprovalMutationVariables>
export type DeleteApprovalComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteApprovalMutation, DeleteApprovalMutationVariables>,
  "mutation"
>

export const DeleteApprovalComponent = (props: DeleteApprovalComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteApprovalMutation, DeleteApprovalMutationVariables>
    mutation={DeleteApprovalDocument}
    {...props}
  />
)

export function useDeleteApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteApprovalMutation, DeleteApprovalMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteApprovalMutation, DeleteApprovalMutationVariables>(DeleteApprovalDocument, options)
}
export type DeleteApprovalMutationHookResult = ReturnType<typeof useDeleteApprovalMutation>
export type DeleteApprovalMutationResult = Apollo.MutationResult<DeleteApprovalMutation>
export const DeleteAreaDocument = gql`
  mutation deleteArea($id: ID!) {
    deleteArea(id: $id) {
      data {
        ...Area
      }
    }
  }
  ${AreaFragmentDoc}
  ${FileFragmentDoc}
`
export type DeleteAreaMutationFn = Apollo.MutationFunction<DeleteAreaMutation, DeleteAreaMutationVariables>
export type DeleteAreaComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteAreaMutation, DeleteAreaMutationVariables>,
  "mutation"
>

export const DeleteAreaComponent = (props: DeleteAreaComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteAreaMutation, DeleteAreaMutationVariables>
    mutation={DeleteAreaDocument}
    {...props}
  />
)

export function useDeleteAreaMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAreaMutation, DeleteAreaMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteAreaMutation, DeleteAreaMutationVariables>(DeleteAreaDocument, options)
}
export type DeleteAreaMutationHookResult = ReturnType<typeof useDeleteAreaMutation>
export type DeleteAreaMutationResult = Apollo.MutationResult<DeleteAreaMutation>
export const DeleteAssistanceRequestDocument = gql`
  mutation deleteAssistanceRequest($id: ID!) {
    deleteAssistanceRequest(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteAssistanceRequestMutationFn = Apollo.MutationFunction<
  DeleteAssistanceRequestMutation,
  DeleteAssistanceRequestMutationVariables
>
export type DeleteAssistanceRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteAssistanceRequestMutation,
    DeleteAssistanceRequestMutationVariables
  >,
  "mutation"
>

export const DeleteAssistanceRequestComponent = (props: DeleteAssistanceRequestComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteAssistanceRequestMutation, DeleteAssistanceRequestMutationVariables>
    mutation={DeleteAssistanceRequestDocument}
    {...props}
  />
)

export function useDeleteAssistanceRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAssistanceRequestMutation, DeleteAssistanceRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteAssistanceRequestMutation, DeleteAssistanceRequestMutationVariables>(
    DeleteAssistanceRequestDocument,
    options
  )
}
export type DeleteAssistanceRequestMutationHookResult = ReturnType<typeof useDeleteAssistanceRequestMutation>
export type DeleteAssistanceRequestMutationResult = Apollo.MutationResult<DeleteAssistanceRequestMutation>
export const DeleteCertificateDocument = gql`
  mutation deleteCertificate($id: ID!) {
    deleteCompletionCertificate(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteCertificateMutationFn = Apollo.MutationFunction<
  DeleteCertificateMutation,
  DeleteCertificateMutationVariables
>
export type DeleteCertificateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteCertificateMutation, DeleteCertificateMutationVariables>,
  "mutation"
>

export const DeleteCertificateComponent = (props: DeleteCertificateComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteCertificateMutation, DeleteCertificateMutationVariables>
    mutation={DeleteCertificateDocument}
    {...props}
  />
)

export function useDeleteCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCertificateMutation, DeleteCertificateMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCertificateMutation, DeleteCertificateMutationVariables>(
    DeleteCertificateDocument,
    options
  )
}
export type DeleteCertificateMutationHookResult = ReturnType<typeof useDeleteCertificateMutation>
export type DeleteCertificateMutationResult = Apollo.MutationResult<DeleteCertificateMutation>
export const DeleteCompanyDocument = gql`
  mutation deleteCompany($id: ID!) {
    deleteCompany(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteCompanyMutationFn = Apollo.MutationFunction<DeleteCompanyMutation, DeleteCompanyMutationVariables>
export type DeleteCompanyComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>,
  "mutation"
>

export const DeleteCompanyComponent = (props: DeleteCompanyComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteCompanyMutation, DeleteCompanyMutationVariables>
    mutation={DeleteCompanyDocument}
    {...props}
  />
)

export function useDeleteCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCompanyMutation, DeleteCompanyMutationVariables>(DeleteCompanyDocument, options)
}
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>
export type DeleteCompanyMutationResult = Apollo.MutationResult<DeleteCompanyMutation>
export const DeleteDepositDocument = gql`
  mutation deleteDeposit($id: ID!) {
    deleteDeposit(id: $id) {
      data {
        ...Deposit
      }
    }
  }
  ${DepositFragmentDoc}
  ${FileFragmentDoc}
`
export type DeleteDepositMutationFn = Apollo.MutationFunction<DeleteDepositMutation, DeleteDepositMutationVariables>
export type DeleteDepositComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteDepositMutation, DeleteDepositMutationVariables>,
  "mutation"
>

export const DeleteDepositComponent = (props: DeleteDepositComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteDepositMutation, DeleteDepositMutationVariables>
    mutation={DeleteDepositDocument}
    {...props}
  />
)

export function useDeleteDepositMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteDepositMutation, DeleteDepositMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteDepositMutation, DeleteDepositMutationVariables>(DeleteDepositDocument, options)
}
export type DeleteDepositMutationHookResult = ReturnType<typeof useDeleteDepositMutation>
export type DeleteDepositMutationResult = Apollo.MutationResult<DeleteDepositMutation>
export const DeleteEmailMessageDocument = gql`
  mutation deleteEmailMessage($id: ID!) {
    deleteEmailMessage(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteEmailMessageMutationFn = Apollo.MutationFunction<
  DeleteEmailMessageMutation,
  DeleteEmailMessageMutationVariables
>
export type DeleteEmailMessageComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteEmailMessageMutation, DeleteEmailMessageMutationVariables>,
  "mutation"
>

export const DeleteEmailMessageComponent = (props: DeleteEmailMessageComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteEmailMessageMutation, DeleteEmailMessageMutationVariables>
    mutation={DeleteEmailMessageDocument}
    {...props}
  />
)

export function useDeleteEmailMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteEmailMessageMutation, DeleteEmailMessageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteEmailMessageMutation, DeleteEmailMessageMutationVariables>(
    DeleteEmailMessageDocument,
    options
  )
}
export type DeleteEmailMessageMutationHookResult = ReturnType<typeof useDeleteEmailMessageMutation>
export type DeleteEmailMessageMutationResult = Apollo.MutationResult<DeleteEmailMessageMutation>
export const DeleteEnforcementDocument = gql`
  mutation deleteEnforcement($id: ID!) {
    deleteEnforcement(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteEnforcementMutationFn = Apollo.MutationFunction<
  DeleteEnforcementMutation,
  DeleteEnforcementMutationVariables
>
export type DeleteEnforcementComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteEnforcementMutation, DeleteEnforcementMutationVariables>,
  "mutation"
>

export const DeleteEnforcementComponent = (props: DeleteEnforcementComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteEnforcementMutation, DeleteEnforcementMutationVariables>
    mutation={DeleteEnforcementDocument}
    {...props}
  />
)

export function useDeleteEnforcementMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteEnforcementMutation, DeleteEnforcementMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteEnforcementMutation, DeleteEnforcementMutationVariables>(
    DeleteEnforcementDocument,
    options
  )
}
export type DeleteEnforcementMutationHookResult = ReturnType<typeof useDeleteEnforcementMutation>
export type DeleteEnforcementMutationResult = Apollo.MutationResult<DeleteEnforcementMutation>
export const DeleteFileDocument = gql`
  mutation deleteFile($id: ID!) {
    deleteUploadFile(id: $id) {
      data {
        ...File
      }
    }
  }
  ${FileFragmentDoc}
`
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>
export type DeleteFileComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteFileMutation, DeleteFileMutationVariables>,
  "mutation"
>

export const DeleteFileComponent = (props: DeleteFileComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteFileMutation, DeleteFileMutationVariables>
    mutation={DeleteFileDocument}
    {...props}
  />
)

export function useDeleteFileMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options)
}
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>
export const DeleteKickoffInviteDocument = gql`
  mutation deleteKickoffInvite($id: ID!) {
    deleteKickoffInvite(id: $id) {
      data {
        ...KickoffInvite
      }
    }
  }
  ${KickoffInviteFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type DeleteKickoffInviteMutationFn = Apollo.MutationFunction<
  DeleteKickoffInviteMutation,
  DeleteKickoffInviteMutationVariables
>
export type DeleteKickoffInviteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteKickoffInviteMutation, DeleteKickoffInviteMutationVariables>,
  "mutation"
>

export const DeleteKickoffInviteComponent = (props: DeleteKickoffInviteComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteKickoffInviteMutation, DeleteKickoffInviteMutationVariables>
    mutation={DeleteKickoffInviteDocument}
    {...props}
  />
)

export function useDeleteKickoffInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteKickoffInviteMutation, DeleteKickoffInviteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteKickoffInviteMutation, DeleteKickoffInviteMutationVariables>(
    DeleteKickoffInviteDocument,
    options
  )
}
export type DeleteKickoffInviteMutationHookResult = ReturnType<typeof useDeleteKickoffInviteMutation>
export type DeleteKickoffInviteMutationResult = Apollo.MutationResult<DeleteKickoffInviteMutation>
export const DeleteKickoffRecordDocument = gql`
  mutation deleteKickoffRecord($id: ID!) {
    deleteKickoffRecord(id: $id) {
      data {
        ...KickoffRecord
      }
    }
  }
  ${KickoffRecordFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type DeleteKickoffRecordMutationFn = Apollo.MutationFunction<
  DeleteKickoffRecordMutation,
  DeleteKickoffRecordMutationVariables
>
export type DeleteKickoffRecordComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteKickoffRecordMutation, DeleteKickoffRecordMutationVariables>,
  "mutation"
>

export const DeleteKickoffRecordComponent = (props: DeleteKickoffRecordComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteKickoffRecordMutation, DeleteKickoffRecordMutationVariables>
    mutation={DeleteKickoffRecordDocument}
    {...props}
  />
)

export function useDeleteKickoffRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteKickoffRecordMutation, DeleteKickoffRecordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteKickoffRecordMutation, DeleteKickoffRecordMutationVariables>(
    DeleteKickoffRecordDocument,
    options
  )
}
export type DeleteKickoffRecordMutationHookResult = ReturnType<typeof useDeleteKickoffRecordMutation>
export type DeleteKickoffRecordMutationResult = Apollo.MutationResult<DeleteKickoffRecordMutation>
export const DeleteLicenseUpdateRequestDocument = gql`
  mutation deleteLicenseUpdateRequest($id: ID!) {
    deleteLicenseUpdateRequest(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteLicenseUpdateRequestMutationFn = Apollo.MutationFunction<
  DeleteLicenseUpdateRequestMutation,
  DeleteLicenseUpdateRequestMutationVariables
>
export type DeleteLicenseUpdateRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteLicenseUpdateRequestMutation,
    DeleteLicenseUpdateRequestMutationVariables
  >,
  "mutation"
>

export const DeleteLicenseUpdateRequestComponent = (props: DeleteLicenseUpdateRequestComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteLicenseUpdateRequestMutation, DeleteLicenseUpdateRequestMutationVariables>
    mutation={DeleteLicenseUpdateRequestDocument}
    {...props}
  />
)

export function useDeleteLicenseUpdateRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteLicenseUpdateRequestMutation,
    DeleteLicenseUpdateRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteLicenseUpdateRequestMutation, DeleteLicenseUpdateRequestMutationVariables>(
    DeleteLicenseUpdateRequestDocument,
    options
  )
}
export type DeleteLicenseUpdateRequestMutationHookResult = ReturnType<typeof useDeleteLicenseUpdateRequestMutation>
export type DeleteLicenseUpdateRequestMutationResult = Apollo.MutationResult<DeleteLicenseUpdateRequestMutation>
export const DeleteNoteDocument = gql`
  mutation deleteNote($id: ID!) {
    deleteNote(id: $id) {
      data {
        ...Note
      }
    }
  }
  ${NoteFragmentDoc}
  ${FileFragmentDoc}
`
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>
export type DeleteNoteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteNoteMutation, DeleteNoteMutationVariables>,
  "mutation"
>

export const DeleteNoteComponent = (props: DeleteNoteComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteNoteMutation, DeleteNoteMutationVariables>
    mutation={DeleteNoteDocument}
    {...props}
  />
)

export function useDeleteNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options)
}
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>
export const DeleteNotificationMessageDocument = gql`
  mutation deleteNotificationMessage($id: ID!) {
    deleteNotificationMessage(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteNotificationMessageMutationFn = Apollo.MutationFunction<
  DeleteNotificationMessageMutation,
  DeleteNotificationMessageMutationVariables
>
export type DeleteNotificationMessageComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteNotificationMessageMutation,
    DeleteNotificationMessageMutationVariables
  >,
  "mutation"
>

export const DeleteNotificationMessageComponent = (props: DeleteNotificationMessageComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteNotificationMessageMutation, DeleteNotificationMessageMutationVariables>
    mutation={DeleteNotificationMessageDocument}
    {...props}
  />
)

export function useDeleteNotificationMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteNotificationMessageMutation,
    DeleteNotificationMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteNotificationMessageMutation, DeleteNotificationMessageMutationVariables>(
    DeleteNotificationMessageDocument,
    options
  )
}
export type DeleteNotificationMessageMutationHookResult = ReturnType<typeof useDeleteNotificationMessageMutation>
export type DeleteNotificationMessageMutationResult = Apollo.MutationResult<DeleteNotificationMessageMutation>
export const DeleteProjectDocument = gql`
  mutation deleteProject($id: ID!) {
    deleteProject(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>
export type DeleteProjectComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteProjectMutation, DeleteProjectMutationVariables>,
  "mutation"
>

export const DeleteProjectComponent = (props: DeleteProjectComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteProjectMutation, DeleteProjectMutationVariables>
    mutation={DeleteProjectDocument}
    {...props}
  />
)

export function useDeleteProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options)
}
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>
export const DeleteProvinceDocument = gql`
  mutation deleteProvince($id: ID!) {
    deleteProvince(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteProvinceMutationFn = Apollo.MutationFunction<DeleteProvinceMutation, DeleteProvinceMutationVariables>
export type DeleteProvinceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteProvinceMutation, DeleteProvinceMutationVariables>,
  "mutation"
>

export const DeleteProvinceComponent = (props: DeleteProvinceComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteProvinceMutation, DeleteProvinceMutationVariables>
    mutation={DeleteProvinceDocument}
    {...props}
  />
)

export function useDeleteProvinceMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteProvinceMutation, DeleteProvinceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteProvinceMutation, DeleteProvinceMutationVariables>(DeleteProvinceDocument, options)
}
export type DeleteProvinceMutationHookResult = ReturnType<typeof useDeleteProvinceMutation>
export type DeleteProvinceMutationResult = Apollo.MutationResult<DeleteProvinceMutation>
export const DeleteQuoteRequestDocument = gql`
  mutation deleteQuoteRequest($id: ID!) {
    deleteQuoteRequest(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteQuoteRequestMutationFn = Apollo.MutationFunction<
  DeleteQuoteRequestMutation,
  DeleteQuoteRequestMutationVariables
>
export type DeleteQuoteRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteQuoteRequestMutation, DeleteQuoteRequestMutationVariables>,
  "mutation"
>

export const DeleteQuoteRequestComponent = (props: DeleteQuoteRequestComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteQuoteRequestMutation, DeleteQuoteRequestMutationVariables>
    mutation={DeleteQuoteRequestDocument}
    {...props}
  />
)

export function useDeleteQuoteRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteQuoteRequestMutation, DeleteQuoteRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteQuoteRequestMutation, DeleteQuoteRequestMutationVariables>(
    DeleteQuoteRequestDocument,
    options
  )
}
export type DeleteQuoteRequestMutationHookResult = ReturnType<typeof useDeleteQuoteRequestMutation>
export type DeleteQuoteRequestMutationResult = Apollo.MutationResult<DeleteQuoteRequestMutation>
export const DeleteReportDocument = gql`
  mutation deleteReport($id: ID!) {
    deleteReport(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteReportMutationFn = Apollo.MutationFunction<DeleteReportMutation, DeleteReportMutationVariables>
export type DeleteReportComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteReportMutation, DeleteReportMutationVariables>,
  "mutation"
>

export const DeleteReportComponent = (props: DeleteReportComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteReportMutation, DeleteReportMutationVariables>
    mutation={DeleteReportDocument}
    {...props}
  />
)

export function useDeleteReportMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteReportMutation, DeleteReportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteReportMutation, DeleteReportMutationVariables>(DeleteReportDocument, options)
}
export type DeleteReportMutationHookResult = ReturnType<typeof useDeleteReportMutation>
export type DeleteReportMutationResult = Apollo.MutationResult<DeleteReportMutation>
export const DeleteSurveyDocument = gql`
  mutation deleteSurvey($id: ID!) {
    deleteSurvey(id: $id) {
      data {
        id
      }
    }
  }
`
export type DeleteSurveyMutationFn = Apollo.MutationFunction<DeleteSurveyMutation, DeleteSurveyMutationVariables>
export type DeleteSurveyComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteSurveyMutation, DeleteSurveyMutationVariables>,
  "mutation"
>

export const DeleteSurveyComponent = (props: DeleteSurveyComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteSurveyMutation, DeleteSurveyMutationVariables>
    mutation={DeleteSurveyDocument}
    {...props}
  />
)

export function useDeleteSurveyMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteSurveyMutation, DeleteSurveyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteSurveyMutation, DeleteSurveyMutationVariables>(DeleteSurveyDocument, options)
}
export type DeleteSurveyMutationHookResult = ReturnType<typeof useDeleteSurveyMutation>
export type DeleteSurveyMutationResult = Apollo.MutationResult<DeleteSurveyMutation>
export const DeleteTaskDocument = gql`
  mutation deleteTask($id: ID!) {
    deleteTask(id: $id) {
      data {
        ...Task
      }
    }
  }
  ${TaskFragmentDoc}
`
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>
export type DeleteTaskComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeleteTaskMutation, DeleteTaskMutationVariables>,
  "mutation"
>

export const DeleteTaskComponent = (props: DeleteTaskComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteTaskMutation, DeleteTaskMutationVariables>
    mutation={DeleteTaskDocument}
    {...props}
  />
)

export function useDeleteTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options)
}
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>
export const DeliveryReportPdfDocument = gql`
  mutation deliveryReportPdf($input: DeliveryConfirmationPdfInput!) {
    deliveryConfirmationPdf(input: $input) {
      url
    }
  }
`
export type DeliveryReportPdfMutationFn = Apollo.MutationFunction<
  DeliveryReportPdfMutation,
  DeliveryReportPdfMutationVariables
>
export type DeliveryReportPdfComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DeliveryReportPdfMutation, DeliveryReportPdfMutationVariables>,
  "mutation"
>

export const DeliveryReportPdfComponent = (props: DeliveryReportPdfComponentProps) => (
  <ApolloReactComponents.Mutation<DeliveryReportPdfMutation, DeliveryReportPdfMutationVariables>
    mutation={DeliveryReportPdfDocument}
    {...props}
  />
)

export function useDeliveryReportPdfMutation(
  baseOptions?: Apollo.MutationHookOptions<DeliveryReportPdfMutation, DeliveryReportPdfMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeliveryReportPdfMutation, DeliveryReportPdfMutationVariables>(
    DeliveryReportPdfDocument,
    options
  )
}
export type DeliveryReportPdfMutationHookResult = ReturnType<typeof useDeliveryReportPdfMutation>
export type DeliveryReportPdfMutationResult = Apollo.MutationResult<DeliveryReportPdfMutation>
export const DetectGeometryProvincesDocument = gql`
  mutation detectGeometryProvinces($input: DetectGeometryProvincesInput!) {
    detectGeometryProvinces(input: $input) {
      provinceIds
      available
    }
  }
`
export type DetectGeometryProvincesMutationFn = Apollo.MutationFunction<
  DetectGeometryProvincesMutation,
  DetectGeometryProvincesMutationVariables
>
export type DetectGeometryProvincesComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DetectGeometryProvincesMutation,
    DetectGeometryProvincesMutationVariables
  >,
  "mutation"
>

export const DetectGeometryProvincesComponent = (props: DetectGeometryProvincesComponentProps) => (
  <ApolloReactComponents.Mutation<DetectGeometryProvincesMutation, DetectGeometryProvincesMutationVariables>
    mutation={DetectGeometryProvincesDocument}
    {...props}
  />
)

export function useDetectGeometryProvincesMutation(
  baseOptions?: Apollo.MutationHookOptions<DetectGeometryProvincesMutation, DetectGeometryProvincesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DetectGeometryProvincesMutation, DetectGeometryProvincesMutationVariables>(
    DetectGeometryProvincesDocument,
    options
  )
}
export type DetectGeometryProvincesMutationHookResult = ReturnType<typeof useDetectGeometryProvincesMutation>
export type DetectGeometryProvincesMutationResult = Apollo.MutationResult<DetectGeometryProvincesMutation>
export const DownloadApplicationApprovalDocsDocument = gql`
  mutation downloadApplicationApprovalDocs($input: ApplicationReportInput!) {
    downloadApplicationApprovalDocs(input: $input) {
      url
    }
  }
`
export type DownloadApplicationApprovalDocsMutationFn = Apollo.MutationFunction<
  DownloadApplicationApprovalDocsMutation,
  DownloadApplicationApprovalDocsMutationVariables
>
export type DownloadApplicationApprovalDocsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DownloadApplicationApprovalDocsMutation,
    DownloadApplicationApprovalDocsMutationVariables
  >,
  "mutation"
>

export const DownloadApplicationApprovalDocsComponent = (props: DownloadApplicationApprovalDocsComponentProps) => (
  <ApolloReactComponents.Mutation<
    DownloadApplicationApprovalDocsMutation,
    DownloadApplicationApprovalDocsMutationVariables
  >
    mutation={DownloadApplicationApprovalDocsDocument}
    {...props}
  />
)

export function useDownloadApplicationApprovalDocsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DownloadApplicationApprovalDocsMutation,
    DownloadApplicationApprovalDocsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DownloadApplicationApprovalDocsMutation, DownloadApplicationApprovalDocsMutationVariables>(
    DownloadApplicationApprovalDocsDocument,
    options
  )
}
export type DownloadApplicationApprovalDocsMutationHookResult = ReturnType<
  typeof useDownloadApplicationApprovalDocsMutation
>
export type DownloadApplicationApprovalDocsMutationResult =
  Apollo.MutationResult<DownloadApplicationApprovalDocsMutation>
export const DuplicateApplicationDocument = gql`
  mutation duplicateApplication($input: DuplicateApplicationInput!) {
    duplicateApplication(input: $input)
  }
`
export type DuplicateApplicationMutationFn = Apollo.MutationFunction<
  DuplicateApplicationMutation,
  DuplicateApplicationMutationVariables
>
export type DuplicateApplicationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<DuplicateApplicationMutation, DuplicateApplicationMutationVariables>,
  "mutation"
>

export const DuplicateApplicationComponent = (props: DuplicateApplicationComponentProps) => (
  <ApolloReactComponents.Mutation<DuplicateApplicationMutation, DuplicateApplicationMutationVariables>
    mutation={DuplicateApplicationDocument}
    {...props}
  />
)

export function useDuplicateApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<DuplicateApplicationMutation, DuplicateApplicationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DuplicateApplicationMutation, DuplicateApplicationMutationVariables>(
    DuplicateApplicationDocument,
    options
  )
}
export type DuplicateApplicationMutationHookResult = ReturnType<typeof useDuplicateApplicationMutation>
export type DuplicateApplicationMutationResult = Apollo.MutationResult<DuplicateApplicationMutation>
export const EmailMessagePdfDocument = gql`
  mutation emailMessagePdf($input: EmailMessagePdfInput!) {
    emailMessagePdf(input: $input) {
      id
      url
      name
    }
  }
`
export type EmailMessagePdfMutationFn = Apollo.MutationFunction<
  EmailMessagePdfMutation,
  EmailMessagePdfMutationVariables
>
export type EmailMessagePdfComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<EmailMessagePdfMutation, EmailMessagePdfMutationVariables>,
  "mutation"
>

export const EmailMessagePdfComponent = (props: EmailMessagePdfComponentProps) => (
  <ApolloReactComponents.Mutation<EmailMessagePdfMutation, EmailMessagePdfMutationVariables>
    mutation={EmailMessagePdfDocument}
    {...props}
  />
)

export function useEmailMessagePdfMutation(
  baseOptions?: Apollo.MutationHookOptions<EmailMessagePdfMutation, EmailMessagePdfMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EmailMessagePdfMutation, EmailMessagePdfMutationVariables>(EmailMessagePdfDocument, options)
}
export type EmailMessagePdfMutationHookResult = ReturnType<typeof useEmailMessagePdfMutation>
export type EmailMessagePdfMutationResult = Apollo.MutationResult<EmailMessagePdfMutation>
export const FinalizeApprovalItemDocument = gql`
  mutation finalizeApprovalItem($input: FinalizeApprovalItemInput!) {
    finalizeApprovalItem(input: $input) {
      outcome
      applicationStatus
      pendingCount
      relevantPendingCount
      pendingCompanies
      warnings
      isPartnerOrganization
    }
  }
`
export type FinalizeApprovalItemMutationFn = Apollo.MutationFunction<
  FinalizeApprovalItemMutation,
  FinalizeApprovalItemMutationVariables
>
export type FinalizeApprovalItemComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<FinalizeApprovalItemMutation, FinalizeApprovalItemMutationVariables>,
  "mutation"
>

export const FinalizeApprovalItemComponent = (props: FinalizeApprovalItemComponentProps) => (
  <ApolloReactComponents.Mutation<FinalizeApprovalItemMutation, FinalizeApprovalItemMutationVariables>
    mutation={FinalizeApprovalItemDocument}
    {...props}
  />
)

export function useFinalizeApprovalItemMutation(
  baseOptions?: Apollo.MutationHookOptions<FinalizeApprovalItemMutation, FinalizeApprovalItemMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<FinalizeApprovalItemMutation, FinalizeApprovalItemMutationVariables>(
    FinalizeApprovalItemDocument,
    options
  )
}
export type FinalizeApprovalItemMutationHookResult = ReturnType<typeof useFinalizeApprovalItemMutation>
export type FinalizeApprovalItemMutationResult = Apollo.MutationResult<FinalizeApprovalItemMutation>
export const ForwardApprovalItemEmailDocument = gql`
  mutation forwardApprovalItemEmail($input: ForwardApprovalItemEmailInput!) {
    forwardApprovalItemEmail(input: $input)
  }
`
export type ForwardApprovalItemEmailMutationFn = Apollo.MutationFunction<
  ForwardApprovalItemEmailMutation,
  ForwardApprovalItemEmailMutationVariables
>
export type ForwardApprovalItemEmailComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ForwardApprovalItemEmailMutation,
    ForwardApprovalItemEmailMutationVariables
  >,
  "mutation"
>

export const ForwardApprovalItemEmailComponent = (props: ForwardApprovalItemEmailComponentProps) => (
  <ApolloReactComponents.Mutation<ForwardApprovalItemEmailMutation, ForwardApprovalItemEmailMutationVariables>
    mutation={ForwardApprovalItemEmailDocument}
    {...props}
  />
)

export function useForwardApprovalItemEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<ForwardApprovalItemEmailMutation, ForwardApprovalItemEmailMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ForwardApprovalItemEmailMutation, ForwardApprovalItemEmailMutationVariables>(
    ForwardApprovalItemEmailDocument,
    options
  )
}
export type ForwardApprovalItemEmailMutationHookResult = ReturnType<typeof useForwardApprovalItemEmailMutation>
export type ForwardApprovalItemEmailMutationResult = Apollo.MutationResult<ForwardApprovalItemEmailMutation>
export const GeneralStatsUpdateDocument = gql`
  mutation generalStatsUpdate {
    generalStatsUpdate
  }
`
export type GeneralStatsUpdateMutationFn = Apollo.MutationFunction<
  GeneralStatsUpdateMutation,
  GeneralStatsUpdateMutationVariables
>
export type GeneralStatsUpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<GeneralStatsUpdateMutation, GeneralStatsUpdateMutationVariables>,
  "mutation"
>

export const GeneralStatsUpdateComponent = (props: GeneralStatsUpdateComponentProps) => (
  <ApolloReactComponents.Mutation<GeneralStatsUpdateMutation, GeneralStatsUpdateMutationVariables>
    mutation={GeneralStatsUpdateDocument}
    {...props}
  />
)

export function useGeneralStatsUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<GeneralStatsUpdateMutation, GeneralStatsUpdateMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<GeneralStatsUpdateMutation, GeneralStatsUpdateMutationVariables>(
    GeneralStatsUpdateDocument,
    options
  )
}
export type GeneralStatsUpdateMutationHookResult = ReturnType<typeof useGeneralStatsUpdateMutation>
export type GeneralStatsUpdateMutationResult = Apollo.MutationResult<GeneralStatsUpdateMutation>
export const InvoiceLetterDocument = gql`
  mutation invoiceLetter($input: InvoiceTemplateLetterInput!) {
    enforcementTemplateInvoice(input: $input) {
      id
      url
      name
    }
  }
`
export type InvoiceLetterMutationFn = Apollo.MutationFunction<InvoiceLetterMutation, InvoiceLetterMutationVariables>
export type InvoiceLetterComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<InvoiceLetterMutation, InvoiceLetterMutationVariables>,
  "mutation"
>

export const InvoiceLetterComponent = (props: InvoiceLetterComponentProps) => (
  <ApolloReactComponents.Mutation<InvoiceLetterMutation, InvoiceLetterMutationVariables>
    mutation={InvoiceLetterDocument}
    {...props}
  />
)

export function useInvoiceLetterMutation(
  baseOptions?: Apollo.MutationHookOptions<InvoiceLetterMutation, InvoiceLetterMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<InvoiceLetterMutation, InvoiceLetterMutationVariables>(InvoiceLetterDocument, options)
}
export type InvoiceLetterMutationHookResult = ReturnType<typeof useInvoiceLetterMutation>
export type InvoiceLetterMutationResult = Apollo.MutationResult<InvoiceLetterMutation>
export const IssueExternalApiClientDocument = gql`
  mutation issueExternalApiClient($input: IssueExternalApiClientInput!) {
    issueExternalApiClient(input: $input) {
      clientSecret
      client {
        ...ExternalApiClient
      }
    }
  }
  ${ExternalApiClientFragmentDoc}
`
export type IssueExternalApiClientMutationFn = Apollo.MutationFunction<
  IssueExternalApiClientMutation,
  IssueExternalApiClientMutationVariables
>
export type IssueExternalApiClientComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    IssueExternalApiClientMutation,
    IssueExternalApiClientMutationVariables
  >,
  "mutation"
>

export const IssueExternalApiClientComponent = (props: IssueExternalApiClientComponentProps) => (
  <ApolloReactComponents.Mutation<IssueExternalApiClientMutation, IssueExternalApiClientMutationVariables>
    mutation={IssueExternalApiClientDocument}
    {...props}
  />
)

export function useIssueExternalApiClientMutation(
  baseOptions?: Apollo.MutationHookOptions<IssueExternalApiClientMutation, IssueExternalApiClientMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IssueExternalApiClientMutation, IssueExternalApiClientMutationVariables>(
    IssueExternalApiClientDocument,
    options
  )
}
export type IssueExternalApiClientMutationHookResult = ReturnType<typeof useIssueExternalApiClientMutation>
export type IssueExternalApiClientMutationResult = Apollo.MutationResult<IssueExternalApiClientMutation>
export const LinkDeliveryToApprovalDocument = gql`
  mutation linkDeliveryToApproval($input: LinkDeliveryToApprovalInput!) {
    linkDeliveryToApproval(input: $input) {
      success
    }
  }
`
export type LinkDeliveryToApprovalMutationFn = Apollo.MutationFunction<
  LinkDeliveryToApprovalMutation,
  LinkDeliveryToApprovalMutationVariables
>
export type LinkDeliveryToApprovalComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    LinkDeliveryToApprovalMutation,
    LinkDeliveryToApprovalMutationVariables
  >,
  "mutation"
>

export const LinkDeliveryToApprovalComponent = (props: LinkDeliveryToApprovalComponentProps) => (
  <ApolloReactComponents.Mutation<LinkDeliveryToApprovalMutation, LinkDeliveryToApprovalMutationVariables>
    mutation={LinkDeliveryToApprovalDocument}
    {...props}
  />
)

export function useLinkDeliveryToApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<LinkDeliveryToApprovalMutation, LinkDeliveryToApprovalMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<LinkDeliveryToApprovalMutation, LinkDeliveryToApprovalMutationVariables>(
    LinkDeliveryToApprovalDocument,
    options
  )
}
export type LinkDeliveryToApprovalMutationHookResult = ReturnType<typeof useLinkDeliveryToApprovalMutation>
export type LinkDeliveryToApprovalMutationResult = Apollo.MutationResult<LinkDeliveryToApprovalMutation>
export const MarkEmailReadDocument = gql`
  mutation markEmailRead($emailId: ID!) {
    markEmailRead(input: { emailId: $emailId }) {
      data {
        id
        attributes {
          isRead
        }
      }
    }
  }
`
export type MarkEmailReadMutationFn = Apollo.MutationFunction<MarkEmailReadMutation, MarkEmailReadMutationVariables>
export type MarkEmailReadComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<MarkEmailReadMutation, MarkEmailReadMutationVariables>,
  "mutation"
>

export const MarkEmailReadComponent = (props: MarkEmailReadComponentProps) => (
  <ApolloReactComponents.Mutation<MarkEmailReadMutation, MarkEmailReadMutationVariables>
    mutation={MarkEmailReadDocument}
    {...props}
  />
)

export function useMarkEmailReadMutation(
  baseOptions?: Apollo.MutationHookOptions<MarkEmailReadMutation, MarkEmailReadMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MarkEmailReadMutation, MarkEmailReadMutationVariables>(MarkEmailReadDocument, options)
}
export type MarkEmailReadMutationHookResult = ReturnType<typeof useMarkEmailReadMutation>
export type MarkEmailReadMutationResult = Apollo.MutationResult<MarkEmailReadMutation>
export const MigrateFilesDocument = gql`
  mutation migrateFiles($input: MigrateFilesInput!) {
    migrateFiles(input: $input) {
      jobId
      status
      id
      message
    }
  }
`
export type MigrateFilesMutationFn = Apollo.MutationFunction<MigrateFilesMutation, MigrateFilesMutationVariables>
export type MigrateFilesComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<MigrateFilesMutation, MigrateFilesMutationVariables>,
  "mutation"
>

export const MigrateFilesComponent = (props: MigrateFilesComponentProps) => (
  <ApolloReactComponents.Mutation<MigrateFilesMutation, MigrateFilesMutationVariables>
    mutation={MigrateFilesDocument}
    {...props}
  />
)

export function useMigrateFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<MigrateFilesMutation, MigrateFilesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MigrateFilesMutation, MigrateFilesMutationVariables>(MigrateFilesDocument, options)
}
export type MigrateFilesMutationHookResult = ReturnType<typeof useMigrateFilesMutation>
export type MigrateFilesMutationResult = Apollo.MutationResult<MigrateFilesMutation>
export const NearestUtilityAreasPostgisDocument = gql`
  mutation nearestUtilityAreasPostgis($input: NearestUtilityAreasInput!) {
    nearestUtilityAreasPostgis(input: $input) {
      areas {
        areaId
        distanceKm
      }
      totalOrgAreaCount
      durationMs
    }
  }
`
export type NearestUtilityAreasPostgisMutationFn = Apollo.MutationFunction<
  NearestUtilityAreasPostgisMutation,
  NearestUtilityAreasPostgisMutationVariables
>
export type NearestUtilityAreasPostgisComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    NearestUtilityAreasPostgisMutation,
    NearestUtilityAreasPostgisMutationVariables
  >,
  "mutation"
>

export const NearestUtilityAreasPostgisComponent = (props: NearestUtilityAreasPostgisComponentProps) => (
  <ApolloReactComponents.Mutation<NearestUtilityAreasPostgisMutation, NearestUtilityAreasPostgisMutationVariables>
    mutation={NearestUtilityAreasPostgisDocument}
    {...props}
  />
)

export function useNearestUtilityAreasPostgisMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NearestUtilityAreasPostgisMutation,
    NearestUtilityAreasPostgisMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<NearestUtilityAreasPostgisMutation, NearestUtilityAreasPostgisMutationVariables>(
    NearestUtilityAreasPostgisDocument,
    options
  )
}
export type NearestUtilityAreasPostgisMutationHookResult = ReturnType<typeof useNearestUtilityAreasPostgisMutation>
export type NearestUtilityAreasPostgisMutationResult = Apollo.MutationResult<NearestUtilityAreasPostgisMutation>
export const NearestUtilityDistancePostgisDocument = gql`
  mutation nearestUtilityDistancePostgis($input: NearestUtilityDistanceInput!) {
    nearestUtilityDistancePostgis(input: $input) {
      distanceKm
      areaCount
      durationMs
    }
  }
`
export type NearestUtilityDistancePostgisMutationFn = Apollo.MutationFunction<
  NearestUtilityDistancePostgisMutation,
  NearestUtilityDistancePostgisMutationVariables
>
export type NearestUtilityDistancePostgisComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    NearestUtilityDistancePostgisMutation,
    NearestUtilityDistancePostgisMutationVariables
  >,
  "mutation"
>

export const NearestUtilityDistancePostgisComponent = (props: NearestUtilityDistancePostgisComponentProps) => (
  <ApolloReactComponents.Mutation<NearestUtilityDistancePostgisMutation, NearestUtilityDistancePostgisMutationVariables>
    mutation={NearestUtilityDistancePostgisDocument}
    {...props}
  />
)

export function useNearestUtilityDistancePostgisMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NearestUtilityDistancePostgisMutation,
    NearestUtilityDistancePostgisMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<NearestUtilityDistancePostgisMutation, NearestUtilityDistancePostgisMutationVariables>(
    NearestUtilityDistancePostgisDocument,
    options
  )
}
export type NearestUtilityDistancePostgisMutationHookResult = ReturnType<
  typeof useNearestUtilityDistancePostgisMutation
>
export type NearestUtilityDistancePostgisMutationResult = Apollo.MutationResult<NearestUtilityDistancePostgisMutation>
export const OrgGeneralStatsUpdateDocument = gql`
  mutation orgGeneralStatsUpdate($input: OrgStatsUpdateInput!) {
    orgGeneralStatsUpdate(input: $input)
  }
`
export type OrgGeneralStatsUpdateMutationFn = Apollo.MutationFunction<
  OrgGeneralStatsUpdateMutation,
  OrgGeneralStatsUpdateMutationVariables
>
export type OrgGeneralStatsUpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<OrgGeneralStatsUpdateMutation, OrgGeneralStatsUpdateMutationVariables>,
  "mutation"
>

export const OrgGeneralStatsUpdateComponent = (props: OrgGeneralStatsUpdateComponentProps) => (
  <ApolloReactComponents.Mutation<OrgGeneralStatsUpdateMutation, OrgGeneralStatsUpdateMutationVariables>
    mutation={OrgGeneralStatsUpdateDocument}
    {...props}
  />
)

export function useOrgGeneralStatsUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<OrgGeneralStatsUpdateMutation, OrgGeneralStatsUpdateMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OrgGeneralStatsUpdateMutation, OrgGeneralStatsUpdateMutationVariables>(
    OrgGeneralStatsUpdateDocument,
    options
  )
}
export type OrgGeneralStatsUpdateMutationHookResult = ReturnType<typeof useOrgGeneralStatsUpdateMutation>
export type OrgGeneralStatsUpdateMutationResult = Apollo.MutationResult<OrgGeneralStatsUpdateMutation>
export const PaymentLinkDocument = gql`
  mutation paymentLink($input: PaymentLinkInput!) {
    paymentLink(input: $input)
  }
`
export type PaymentLinkMutationFn = Apollo.MutationFunction<PaymentLinkMutation, PaymentLinkMutationVariables>
export type PaymentLinkComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<PaymentLinkMutation, PaymentLinkMutationVariables>,
  "mutation"
>

export const PaymentLinkComponent = (props: PaymentLinkComponentProps) => (
  <ApolloReactComponents.Mutation<PaymentLinkMutation, PaymentLinkMutationVariables>
    mutation={PaymentLinkDocument}
    {...props}
  />
)

export function usePaymentLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<PaymentLinkMutation, PaymentLinkMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<PaymentLinkMutation, PaymentLinkMutationVariables>(PaymentLinkDocument, options)
}
export type PaymentLinkMutationHookResult = ReturnType<typeof usePaymentLinkMutation>
export type PaymentLinkMutationResult = Apollo.MutationResult<PaymentLinkMutation>
export const PricingSubmitRequestDocument = gql`
  mutation pricingSubmitRequest($input: PricingRequestFormSubmitInput!) {
    pricingRequestFormSubmit(input: $input)
  }
`
export type PricingSubmitRequestMutationFn = Apollo.MutationFunction<
  PricingSubmitRequestMutation,
  PricingSubmitRequestMutationVariables
>
export type PricingSubmitRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<PricingSubmitRequestMutation, PricingSubmitRequestMutationVariables>,
  "mutation"
>

export const PricingSubmitRequestComponent = (props: PricingSubmitRequestComponentProps) => (
  <ApolloReactComponents.Mutation<PricingSubmitRequestMutation, PricingSubmitRequestMutationVariables>
    mutation={PricingSubmitRequestDocument}
    {...props}
  />
)

export function usePricingSubmitRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<PricingSubmitRequestMutation, PricingSubmitRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<PricingSubmitRequestMutation, PricingSubmitRequestMutationVariables>(
    PricingSubmitRequestDocument,
    options
  )
}
export type PricingSubmitRequestMutationHookResult = ReturnType<typeof usePricingSubmitRequestMutation>
export type PricingSubmitRequestMutationResult = Apollo.MutationResult<PricingSubmitRequestMutation>
export const ProfileStatisticResolverDocument = gql`
  mutation profileStatisticResolver($input: AppIncomingStatisticsInput!) {
    profileApprovalStatistics(input: $input) {
      all {
        total {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
        lastMonth {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
        thisMonth {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
      }
      incoming {
        total {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
        lastMonth {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
        thisMonth {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
      }
      outgoing {
        total {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
        lastMonth {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
        thisMonth {
          all
          approved
          ratio
          responseTime
          responseTimeString
        }
      }
    }
  }
`
export type ProfileStatisticResolverMutationFn = Apollo.MutationFunction<
  ProfileStatisticResolverMutation,
  ProfileStatisticResolverMutationVariables
>
export type ProfileStatisticResolverComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ProfileStatisticResolverMutation,
    ProfileStatisticResolverMutationVariables
  >,
  "mutation"
>

export const ProfileStatisticResolverComponent = (props: ProfileStatisticResolverComponentProps) => (
  <ApolloReactComponents.Mutation<ProfileStatisticResolverMutation, ProfileStatisticResolverMutationVariables>
    mutation={ProfileStatisticResolverDocument}
    {...props}
  />
)

export function useProfileStatisticResolverMutation(
  baseOptions?: Apollo.MutationHookOptions<ProfileStatisticResolverMutation, ProfileStatisticResolverMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ProfileStatisticResolverMutation, ProfileStatisticResolverMutationVariables>(
    ProfileStatisticResolverDocument,
    options
  )
}
export type ProfileStatisticResolverMutationHookResult = ReturnType<typeof useProfileStatisticResolverMutation>
export type ProfileStatisticResolverMutationResult = Apollo.MutationResult<ProfileStatisticResolverMutation>
export const ProfileStatisticAllResolverDocument = gql`
  mutation profileStatisticAllResolver {
    profileApprovalStatisticsAll {
      total
      updated
      failed
    }
  }
`
export type ProfileStatisticAllResolverMutationFn = Apollo.MutationFunction<
  ProfileStatisticAllResolverMutation,
  ProfileStatisticAllResolverMutationVariables
>
export type ProfileStatisticAllResolverComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ProfileStatisticAllResolverMutation,
    ProfileStatisticAllResolverMutationVariables
  >,
  "mutation"
>

export const ProfileStatisticAllResolverComponent = (props: ProfileStatisticAllResolverComponentProps) => (
  <ApolloReactComponents.Mutation<ProfileStatisticAllResolverMutation, ProfileStatisticAllResolverMutationVariables>
    mutation={ProfileStatisticAllResolverDocument}
    {...props}
  />
)

export function useProfileStatisticAllResolverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProfileStatisticAllResolverMutation,
    ProfileStatisticAllResolverMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ProfileStatisticAllResolverMutation, ProfileStatisticAllResolverMutationVariables>(
    ProfileStatisticAllResolverDocument,
    options
  )
}
export type ProfileStatisticAllResolverMutationHookResult = ReturnType<typeof useProfileStatisticAllResolverMutation>
export type ProfileStatisticAllResolverMutationResult = Apollo.MutationResult<ProfileStatisticAllResolverMutation>
export const QuoteIssuedEmailNotificationDocument = gql`
  mutation quoteIssuedEmailNotification($input: QuoteIssuedEmailNotificationInput!) {
    quoteIssuedEmailNotification(input: $input)
  }
`
export type QuoteIssuedEmailNotificationMutationFn = Apollo.MutationFunction<
  QuoteIssuedEmailNotificationMutation,
  QuoteIssuedEmailNotificationMutationVariables
>
export type QuoteIssuedEmailNotificationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    QuoteIssuedEmailNotificationMutation,
    QuoteIssuedEmailNotificationMutationVariables
  >,
  "mutation"
>

export const QuoteIssuedEmailNotificationComponent = (props: QuoteIssuedEmailNotificationComponentProps) => (
  <ApolloReactComponents.Mutation<QuoteIssuedEmailNotificationMutation, QuoteIssuedEmailNotificationMutationVariables>
    mutation={QuoteIssuedEmailNotificationDocument}
    {...props}
  />
)

export function useQuoteIssuedEmailNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    QuoteIssuedEmailNotificationMutation,
    QuoteIssuedEmailNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<QuoteIssuedEmailNotificationMutation, QuoteIssuedEmailNotificationMutationVariables>(
    QuoteIssuedEmailNotificationDocument,
    options
  )
}
export type QuoteIssuedEmailNotificationMutationHookResult = ReturnType<typeof useQuoteIssuedEmailNotificationMutation>
export type QuoteIssuedEmailNotificationMutationResult = Apollo.MutationResult<QuoteIssuedEmailNotificationMutation>
export const QuoteRequestReportDocument = gql`
  mutation quoteRequestReport($input: QuoteRequestPdfReportInput!) {
    quoteRequestPdfReport(input: $input) {
      url
    }
  }
`
export type QuoteRequestReportMutationFn = Apollo.MutationFunction<
  QuoteRequestReportMutation,
  QuoteRequestReportMutationVariables
>
export type QuoteRequestReportComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<QuoteRequestReportMutation, QuoteRequestReportMutationVariables>,
  "mutation"
>

export const QuoteRequestReportComponent = (props: QuoteRequestReportComponentProps) => (
  <ApolloReactComponents.Mutation<QuoteRequestReportMutation, QuoteRequestReportMutationVariables>
    mutation={QuoteRequestReportDocument}
    {...props}
  />
)

export function useQuoteRequestReportMutation(
  baseOptions?: Apollo.MutationHookOptions<QuoteRequestReportMutation, QuoteRequestReportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<QuoteRequestReportMutation, QuoteRequestReportMutationVariables>(
    QuoteRequestReportDocument,
    options
  )
}
export type QuoteRequestReportMutationHookResult = ReturnType<typeof useQuoteRequestReportMutation>
export type QuoteRequestReportMutationResult = Apollo.MutationResult<QuoteRequestReportMutation>
export const RefreshAccessTokenDocument = gql`
  mutation refreshAccessToken($input: RefreshAccessInput) {
    refreshAccessToken(input: $input) {
      jwt
    }
  }
`
export type RefreshAccessTokenMutationFn = Apollo.MutationFunction<
  RefreshAccessTokenMutation,
  RefreshAccessTokenMutationVariables
>
export type RefreshAccessTokenComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>,
  "mutation"
>

export const RefreshAccessTokenComponent = (props: RefreshAccessTokenComponentProps) => (
  <ApolloReactComponents.Mutation<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>
    mutation={RefreshAccessTokenDocument}
    {...props}
  />
)

export function useRefreshAccessTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>(
    RefreshAccessTokenDocument,
    options
  )
}
export type RefreshAccessTokenMutationHookResult = ReturnType<typeof useRefreshAccessTokenMutation>
export type RefreshAccessTokenMutationResult = Apollo.MutationResult<RefreshAccessTokenMutation>
export const RegistrationSubmitHsDocument = gql`
  mutation registrationSubmitHs($input: RegistrationFormSubmitInput!) {
    registrationFormSubmit(input: $input)
  }
`
export type RegistrationSubmitHsMutationFn = Apollo.MutationFunction<
  RegistrationSubmitHsMutation,
  RegistrationSubmitHsMutationVariables
>
export type RegistrationSubmitHsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<RegistrationSubmitHsMutation, RegistrationSubmitHsMutationVariables>,
  "mutation"
>

export const RegistrationSubmitHsComponent = (props: RegistrationSubmitHsComponentProps) => (
  <ApolloReactComponents.Mutation<RegistrationSubmitHsMutation, RegistrationSubmitHsMutationVariables>
    mutation={RegistrationSubmitHsDocument}
    {...props}
  />
)

export function useRegistrationSubmitHsMutation(
  baseOptions?: Apollo.MutationHookOptions<RegistrationSubmitHsMutation, RegistrationSubmitHsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RegistrationSubmitHsMutation, RegistrationSubmitHsMutationVariables>(
    RegistrationSubmitHsDocument,
    options
  )
}
export type RegistrationSubmitHsMutationHookResult = ReturnType<typeof useRegistrationSubmitHsMutation>
export type RegistrationSubmitHsMutationResult = Apollo.MutationResult<RegistrationSubmitHsMutation>
export const ReportMapRenderingIncidentDocument = gql`
  mutation reportMapRenderingIncident($input: ReportMapRenderingIncidentInput!) {
    reportMapRenderingIncident(input: $input) {
      incidentId
      deduplicated
    }
  }
`
export type ReportMapRenderingIncidentMutationFn = Apollo.MutationFunction<
  ReportMapRenderingIncidentMutation,
  ReportMapRenderingIncidentMutationVariables
>
export type ReportMapRenderingIncidentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ReportMapRenderingIncidentMutation,
    ReportMapRenderingIncidentMutationVariables
  >,
  "mutation"
>

export const ReportMapRenderingIncidentComponent = (props: ReportMapRenderingIncidentComponentProps) => (
  <ApolloReactComponents.Mutation<ReportMapRenderingIncidentMutation, ReportMapRenderingIncidentMutationVariables>
    mutation={ReportMapRenderingIncidentDocument}
    {...props}
  />
)

export function useReportMapRenderingIncidentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReportMapRenderingIncidentMutation,
    ReportMapRenderingIncidentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ReportMapRenderingIncidentMutation, ReportMapRenderingIncidentMutationVariables>(
    ReportMapRenderingIncidentDocument,
    options
  )
}
export type ReportMapRenderingIncidentMutationHookResult = ReturnType<typeof useReportMapRenderingIncidentMutation>
export type ReportMapRenderingIncidentMutationResult = Apollo.MutationResult<ReportMapRenderingIncidentMutation>
export const ReportPdfDocument = gql`
  mutation reportPdf($input: ReportPdfInput!) {
    reportPdf(input: $input)
  }
`
export type ReportPdfMutationFn = Apollo.MutationFunction<ReportPdfMutation, ReportPdfMutationVariables>
export type ReportPdfComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ReportPdfMutation, ReportPdfMutationVariables>,
  "mutation"
>

export const ReportPdfComponent = (props: ReportPdfComponentProps) => (
  <ApolloReactComponents.Mutation<ReportPdfMutation, ReportPdfMutationVariables>
    mutation={ReportPdfDocument}
    {...props}
  />
)

export function useReportPdfMutation(
  baseOptions?: Apollo.MutationHookOptions<ReportPdfMutation, ReportPdfMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ReportPdfMutation, ReportPdfMutationVariables>(ReportPdfDocument, options)
}
export type ReportPdfMutationHookResult = ReturnType<typeof useReportPdfMutation>
export type ReportPdfMutationResult = Apollo.MutationResult<ReportPdfMutation>
export const ResendEmailConfirmationMessageDocument = gql`
  mutation resendEmailConfirmationMessage($input: ResendEmailConfirmationMessageInput!) {
    resendEmailConfirmationMessage(input: $input)
  }
`
export type ResendEmailConfirmationMessageMutationFn = Apollo.MutationFunction<
  ResendEmailConfirmationMessageMutation,
  ResendEmailConfirmationMessageMutationVariables
>
export type ResendEmailConfirmationMessageComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ResendEmailConfirmationMessageMutation,
    ResendEmailConfirmationMessageMutationVariables
  >,
  "mutation"
>

export const ResendEmailConfirmationMessageComponent = (props: ResendEmailConfirmationMessageComponentProps) => (
  <ApolloReactComponents.Mutation<
    ResendEmailConfirmationMessageMutation,
    ResendEmailConfirmationMessageMutationVariables
  >
    mutation={ResendEmailConfirmationMessageDocument}
    {...props}
  />
)

export function useResendEmailConfirmationMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendEmailConfirmationMessageMutation,
    ResendEmailConfirmationMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResendEmailConfirmationMessageMutation, ResendEmailConfirmationMessageMutationVariables>(
    ResendEmailConfirmationMessageDocument,
    options
  )
}
export type ResendEmailConfirmationMessageMutationHookResult = ReturnType<
  typeof useResendEmailConfirmationMessageMutation
>
export type ResendEmailConfirmationMessageMutationResult = Apollo.MutationResult<ResendEmailConfirmationMessageMutation>
export const ResendEmailConfirmationOnLoginDocument = gql`
  mutation resendEmailConfirmationOnLogin($input: ResendEmailConfirmationOnLoginInput!) {
    resendEmailConfirmationOnLogin(input: $input)
  }
`
export type ResendEmailConfirmationOnLoginMutationFn = Apollo.MutationFunction<
  ResendEmailConfirmationOnLoginMutation,
  ResendEmailConfirmationOnLoginMutationVariables
>
export type ResendEmailConfirmationOnLoginComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ResendEmailConfirmationOnLoginMutation,
    ResendEmailConfirmationOnLoginMutationVariables
  >,
  "mutation"
>

export const ResendEmailConfirmationOnLoginComponent = (props: ResendEmailConfirmationOnLoginComponentProps) => (
  <ApolloReactComponents.Mutation<
    ResendEmailConfirmationOnLoginMutation,
    ResendEmailConfirmationOnLoginMutationVariables
  >
    mutation={ResendEmailConfirmationOnLoginDocument}
    {...props}
  />
)

export function useResendEmailConfirmationOnLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendEmailConfirmationOnLoginMutation,
    ResendEmailConfirmationOnLoginMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResendEmailConfirmationOnLoginMutation, ResendEmailConfirmationOnLoginMutationVariables>(
    ResendEmailConfirmationOnLoginDocument,
    options
  )
}
export type ResendEmailConfirmationOnLoginMutationHookResult = ReturnType<
  typeof useResendEmailConfirmationOnLoginMutation
>
export type ResendEmailConfirmationOnLoginMutationResult = Apollo.MutationResult<ResendEmailConfirmationOnLoginMutation>
export const ResendLoginTwoFactorDocument = gql`
  mutation resendLoginTwoFactor($input: ResendLoginTwoFactorInput!) {
    resendLoginTwoFactor(input: $input) {
      success
      challengeId
      resendCooldown
      tooManyResends
      invalidChallenge
      accountBlocked
    }
  }
`
export type ResendLoginTwoFactorMutationFn = Apollo.MutationFunction<
  ResendLoginTwoFactorMutation,
  ResendLoginTwoFactorMutationVariables
>
export type ResendLoginTwoFactorComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ResendLoginTwoFactorMutation, ResendLoginTwoFactorMutationVariables>,
  "mutation"
>

export const ResendLoginTwoFactorComponent = (props: ResendLoginTwoFactorComponentProps) => (
  <ApolloReactComponents.Mutation<ResendLoginTwoFactorMutation, ResendLoginTwoFactorMutationVariables>
    mutation={ResendLoginTwoFactorDocument}
    {...props}
  />
)

export function useResendLoginTwoFactorMutation(
  baseOptions?: Apollo.MutationHookOptions<ResendLoginTwoFactorMutation, ResendLoginTwoFactorMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResendLoginTwoFactorMutation, ResendLoginTwoFactorMutationVariables>(
    ResendLoginTwoFactorDocument,
    options
  )
}
export type ResendLoginTwoFactorMutationHookResult = ReturnType<typeof useResendLoginTwoFactorMutation>
export type ResendLoginTwoFactorMutationResult = Apollo.MutationResult<ResendLoginTwoFactorMutation>
export const RestoreProjectDocument = gql`
  mutation restoreProject($input: RestoreProjectInput!) {
    restoreProject(input: $input)
  }
`
export type RestoreProjectMutationFn = Apollo.MutationFunction<RestoreProjectMutation, RestoreProjectMutationVariables>
export type RestoreProjectComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<RestoreProjectMutation, RestoreProjectMutationVariables>,
  "mutation"
>

export const RestoreProjectComponent = (props: RestoreProjectComponentProps) => (
  <ApolloReactComponents.Mutation<RestoreProjectMutation, RestoreProjectMutationVariables>
    mutation={RestoreProjectDocument}
    {...props}
  />
)

export function useRestoreProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<RestoreProjectMutation, RestoreProjectMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RestoreProjectMutation, RestoreProjectMutationVariables>(RestoreProjectDocument, options)
}
export type RestoreProjectMutationHookResult = ReturnType<typeof useRestoreProjectMutation>
export type RestoreProjectMutationResult = Apollo.MutationResult<RestoreProjectMutation>
export const ResubmitApplicationDocument = gql`
  mutation resubmitApplication($input: ResubmitApplicationInput!) {
    resubmittingApplication(input: $input)
  }
`
export type ResubmitApplicationMutationFn = Apollo.MutationFunction<
  ResubmitApplicationMutation,
  ResubmitApplicationMutationVariables
>
export type ResubmitApplicationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ResubmitApplicationMutation, ResubmitApplicationMutationVariables>,
  "mutation"
>

export const ResubmitApplicationComponent = (props: ResubmitApplicationComponentProps) => (
  <ApolloReactComponents.Mutation<ResubmitApplicationMutation, ResubmitApplicationMutationVariables>
    mutation={ResubmitApplicationDocument}
    {...props}
  />
)

export function useResubmitApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<ResubmitApplicationMutation, ResubmitApplicationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResubmitApplicationMutation, ResubmitApplicationMutationVariables>(
    ResubmitApplicationDocument,
    options
  )
}
export type ResubmitApplicationMutationHookResult = ReturnType<typeof useResubmitApplicationMutation>
export type ResubmitApplicationMutationResult = Apollo.MutationResult<ResubmitApplicationMutation>
export const RevokeExternalApiClientDocument = gql`
  mutation revokeExternalApiClient($input: RevokeExternalApiClientInput!) {
    revokeExternalApiClient(input: $input) {
      ...ExternalApiClient
    }
  }
  ${ExternalApiClientFragmentDoc}
`
export type RevokeExternalApiClientMutationFn = Apollo.MutationFunction<
  RevokeExternalApiClientMutation,
  RevokeExternalApiClientMutationVariables
>
export type RevokeExternalApiClientComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RevokeExternalApiClientMutation,
    RevokeExternalApiClientMutationVariables
  >,
  "mutation"
>

export const RevokeExternalApiClientComponent = (props: RevokeExternalApiClientComponentProps) => (
  <ApolloReactComponents.Mutation<RevokeExternalApiClientMutation, RevokeExternalApiClientMutationVariables>
    mutation={RevokeExternalApiClientDocument}
    {...props}
  />
)

export function useRevokeExternalApiClientMutation(
  baseOptions?: Apollo.MutationHookOptions<RevokeExternalApiClientMutation, RevokeExternalApiClientMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RevokeExternalApiClientMutation, RevokeExternalApiClientMutationVariables>(
    RevokeExternalApiClientDocument,
    options
  )
}
export type RevokeExternalApiClientMutationHookResult = ReturnType<typeof useRevokeExternalApiClientMutation>
export type RevokeExternalApiClientMutationResult = Apollo.MutationResult<RevokeExternalApiClientMutation>
export const SendAgentAssignNotificationDocument = gql`
  mutation sendAgentAssignNotification($input: SendAgentAssignNotificationInput!) {
    sendAgentAssignNotification(input: $input)
  }
`
export type SendAgentAssignNotificationMutationFn = Apollo.MutationFunction<
  SendAgentAssignNotificationMutation,
  SendAgentAssignNotificationMutationVariables
>
export type SendAgentAssignNotificationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendAgentAssignNotificationMutation,
    SendAgentAssignNotificationMutationVariables
  >,
  "mutation"
>

export const SendAgentAssignNotificationComponent = (props: SendAgentAssignNotificationComponentProps) => (
  <ApolloReactComponents.Mutation<SendAgentAssignNotificationMutation, SendAgentAssignNotificationMutationVariables>
    mutation={SendAgentAssignNotificationDocument}
    {...props}
  />
)

export function useSendAgentAssignNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendAgentAssignNotificationMutation,
    SendAgentAssignNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendAgentAssignNotificationMutation, SendAgentAssignNotificationMutationVariables>(
    SendAgentAssignNotificationDocument,
    options
  )
}
export type SendAgentAssignNotificationMutationHookResult = ReturnType<typeof useSendAgentAssignNotificationMutation>
export type SendAgentAssignNotificationMutationResult = Apollo.MutationResult<SendAgentAssignNotificationMutation>
export const SendApprovalItemEmailDocument = gql`
  mutation sendApprovalItemEmail($input: SendApprovalItemEmailInput!) {
    sendApprovalItemEmail(input: $input)
  }
`
export type SendApprovalItemEmailMutationFn = Apollo.MutationFunction<
  SendApprovalItemEmailMutation,
  SendApprovalItemEmailMutationVariables
>
export type SendApprovalItemEmailComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<SendApprovalItemEmailMutation, SendApprovalItemEmailMutationVariables>,
  "mutation"
>

export const SendApprovalItemEmailComponent = (props: SendApprovalItemEmailComponentProps) => (
  <ApolloReactComponents.Mutation<SendApprovalItemEmailMutation, SendApprovalItemEmailMutationVariables>
    mutation={SendApprovalItemEmailDocument}
    {...props}
  />
)

export function useSendApprovalItemEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<SendApprovalItemEmailMutation, SendApprovalItemEmailMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendApprovalItemEmailMutation, SendApprovalItemEmailMutationVariables>(
    SendApprovalItemEmailDocument,
    options
  )
}
export type SendApprovalItemEmailMutationHookResult = ReturnType<typeof useSendApprovalItemEmailMutation>
export type SendApprovalItemEmailMutationResult = Apollo.MutationResult<SendApprovalItemEmailMutation>
export const SendAssistanceRequestDocument = gql`
  mutation sendAssistanceRequest($input: SendAssistanceRequestInput!) {
    sendAssistanceRequest(input: $input)
  }
`
export type SendAssistanceRequestMutationFn = Apollo.MutationFunction<
  SendAssistanceRequestMutation,
  SendAssistanceRequestMutationVariables
>
export type SendAssistanceRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<SendAssistanceRequestMutation, SendAssistanceRequestMutationVariables>,
  "mutation"
>

export const SendAssistanceRequestComponent = (props: SendAssistanceRequestComponentProps) => (
  <ApolloReactComponents.Mutation<SendAssistanceRequestMutation, SendAssistanceRequestMutationVariables>
    mutation={SendAssistanceRequestDocument}
    {...props}
  />
)

export function useSendAssistanceRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<SendAssistanceRequestMutation, SendAssistanceRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendAssistanceRequestMutation, SendAssistanceRequestMutationVariables>(
    SendAssistanceRequestDocument,
    options
  )
}
export type SendAssistanceRequestMutationHookResult = ReturnType<typeof useSendAssistanceRequestMutation>
export type SendAssistanceRequestMutationResult = Apollo.MutationResult<SendAssistanceRequestMutation>
export const SendCompaniesNotificationsDocument = gql`
  mutation sendCompaniesNotifications($input: SendCompaniesNotificationsInput!) {
    sendCompaniesNotifications(input: $input)
  }
`
export type SendCompaniesNotificationsMutationFn = Apollo.MutationFunction<
  SendCompaniesNotificationsMutation,
  SendCompaniesNotificationsMutationVariables
>
export type SendCompaniesNotificationsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendCompaniesNotificationsMutation,
    SendCompaniesNotificationsMutationVariables
  >,
  "mutation"
>

export const SendCompaniesNotificationsComponent = (props: SendCompaniesNotificationsComponentProps) => (
  <ApolloReactComponents.Mutation<SendCompaniesNotificationsMutation, SendCompaniesNotificationsMutationVariables>
    mutation={SendCompaniesNotificationsDocument}
    {...props}
  />
)

export function useSendCompaniesNotificationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendCompaniesNotificationsMutation,
    SendCompaniesNotificationsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendCompaniesNotificationsMutation, SendCompaniesNotificationsMutationVariables>(
    SendCompaniesNotificationsDocument,
    options
  )
}
export type SendCompaniesNotificationsMutationHookResult = ReturnType<typeof useSendCompaniesNotificationsMutation>
export type SendCompaniesNotificationsMutationResult = Apollo.MutationResult<SendCompaniesNotificationsMutation>
export const SendFinalNotificationsDocument = gql`
  mutation sendFinalNotifications($input: SendFinalNotificationsInput!) {
    sendFinalNotifications(input: $input)
  }
`
export type SendFinalNotificationsMutationFn = Apollo.MutationFunction<
  SendFinalNotificationsMutation,
  SendFinalNotificationsMutationVariables
>
export type SendFinalNotificationsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendFinalNotificationsMutation,
    SendFinalNotificationsMutationVariables
  >,
  "mutation"
>

export const SendFinalNotificationsComponent = (props: SendFinalNotificationsComponentProps) => (
  <ApolloReactComponents.Mutation<SendFinalNotificationsMutation, SendFinalNotificationsMutationVariables>
    mutation={SendFinalNotificationsDocument}
    {...props}
  />
)

export function useSendFinalNotificationsMutation(
  baseOptions?: Apollo.MutationHookOptions<SendFinalNotificationsMutation, SendFinalNotificationsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendFinalNotificationsMutation, SendFinalNotificationsMutationVariables>(
    SendFinalNotificationsDocument,
    options
  )
}
export type SendFinalNotificationsMutationHookResult = ReturnType<typeof useSendFinalNotificationsMutation>
export type SendFinalNotificationsMutationResult = Apollo.MutationResult<SendFinalNotificationsMutation>
export const SendInviteDocument = gql`
  mutation sendInvite($input: SendInviteInput!) {
    sendInvite(input: $input)
  }
`
export type SendInviteMutationFn = Apollo.MutationFunction<SendInviteMutation, SendInviteMutationVariables>
export type SendInviteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<SendInviteMutation, SendInviteMutationVariables>,
  "mutation"
>

export const SendInviteComponent = (props: SendInviteComponentProps) => (
  <ApolloReactComponents.Mutation<SendInviteMutation, SendInviteMutationVariables>
    mutation={SendInviteDocument}
    {...props}
  />
)

export function useSendInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<SendInviteMutation, SendInviteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendInviteMutation, SendInviteMutationVariables>(SendInviteDocument, options)
}
export type SendInviteMutationHookResult = ReturnType<typeof useSendInviteMutation>
export type SendInviteMutationResult = Apollo.MutationResult<SendInviteMutation>
export const SendLicenseUpdateRequestDocument = gql`
  mutation sendLicenseUpdateRequest($input: SendLicenseUpdateRequestInput!) {
    sendLicenseUpdateRequest(input: $input)
  }
`
export type SendLicenseUpdateRequestMutationFn = Apollo.MutationFunction<
  SendLicenseUpdateRequestMutation,
  SendLicenseUpdateRequestMutationVariables
>
export type SendLicenseUpdateRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendLicenseUpdateRequestMutation,
    SendLicenseUpdateRequestMutationVariables
  >,
  "mutation"
>

export const SendLicenseUpdateRequestComponent = (props: SendLicenseUpdateRequestComponentProps) => (
  <ApolloReactComponents.Mutation<SendLicenseUpdateRequestMutation, SendLicenseUpdateRequestMutationVariables>
    mutation={SendLicenseUpdateRequestDocument}
    {...props}
  />
)

export function useSendLicenseUpdateRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<SendLicenseUpdateRequestMutation, SendLicenseUpdateRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendLicenseUpdateRequestMutation, SendLicenseUpdateRequestMutationVariables>(
    SendLicenseUpdateRequestDocument,
    options
  )
}
export type SendLicenseUpdateRequestMutationHookResult = ReturnType<typeof useSendLicenseUpdateRequestMutation>
export type SendLicenseUpdateRequestMutationResult = Apollo.MutationResult<SendLicenseUpdateRequestMutation>
export const SendQuoteDocument = gql`
  mutation sendQuote($input: SendQuoteInput!) {
    sendQuote(input: $input)
  }
`
export type SendQuoteMutationFn = Apollo.MutationFunction<SendQuoteMutation, SendQuoteMutationVariables>
export type SendQuoteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<SendQuoteMutation, SendQuoteMutationVariables>,
  "mutation"
>

export const SendQuoteComponent = (props: SendQuoteComponentProps) => (
  <ApolloReactComponents.Mutation<SendQuoteMutation, SendQuoteMutationVariables>
    mutation={SendQuoteDocument}
    {...props}
  />
)

export function useSendQuoteMutation(
  baseOptions?: Apollo.MutationHookOptions<SendQuoteMutation, SendQuoteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendQuoteMutation, SendQuoteMutationVariables>(SendQuoteDocument, options)
}
export type SendQuoteMutationHookResult = ReturnType<typeof useSendQuoteMutation>
export type SendQuoteMutationResult = Apollo.MutationResult<SendQuoteMutation>
export const SendQuoteRequestConfirmationDocument = gql`
  mutation sendQuoteRequestConfirmation($input: SendQuoteRequestConfirmationInput!) {
    sendQuoteRequestConfirmation(input: $input)
  }
`
export type SendQuoteRequestConfirmationMutationFn = Apollo.MutationFunction<
  SendQuoteRequestConfirmationMutation,
  SendQuoteRequestConfirmationMutationVariables
>
export type SendQuoteRequestConfirmationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendQuoteRequestConfirmationMutation,
    SendQuoteRequestConfirmationMutationVariables
  >,
  "mutation"
>

export const SendQuoteRequestConfirmationComponent = (props: SendQuoteRequestConfirmationComponentProps) => (
  <ApolloReactComponents.Mutation<SendQuoteRequestConfirmationMutation, SendQuoteRequestConfirmationMutationVariables>
    mutation={SendQuoteRequestConfirmationDocument}
    {...props}
  />
)

export function useSendQuoteRequestConfirmationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendQuoteRequestConfirmationMutation,
    SendQuoteRequestConfirmationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendQuoteRequestConfirmationMutation, SendQuoteRequestConfirmationMutationVariables>(
    SendQuoteRequestConfirmationDocument,
    options
  )
}
export type SendQuoteRequestConfirmationMutationHookResult = ReturnType<typeof useSendQuoteRequestConfirmationMutation>
export type SendQuoteRequestConfirmationMutationResult = Apollo.MutationResult<SendQuoteRequestConfirmationMutation>
export const SendRecordDocument = gql`
  mutation sendRecord($input: SendRecordInput!) {
    sendRecord(input: $input)
  }
`
export type SendRecordMutationFn = Apollo.MutationFunction<SendRecordMutation, SendRecordMutationVariables>
export type SendRecordComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<SendRecordMutation, SendRecordMutationVariables>,
  "mutation"
>

export const SendRecordComponent = (props: SendRecordComponentProps) => (
  <ApolloReactComponents.Mutation<SendRecordMutation, SendRecordMutationVariables>
    mutation={SendRecordDocument}
    {...props}
  />
)

export function useSendRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<SendRecordMutation, SendRecordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendRecordMutation, SendRecordMutationVariables>(SendRecordDocument, options)
}
export type SendRecordMutationHookResult = ReturnType<typeof useSendRecordMutation>
export type SendRecordMutationResult = Apollo.MutationResult<SendRecordMutation>
export const SendRequestInfoNotificationDocument = gql`
  mutation sendRequestInfoNotification($input: SendRequestInfoNotificationInput!) {
    sendRequestInfoNotification(input: $input)
  }
`
export type SendRequestInfoNotificationMutationFn = Apollo.MutationFunction<
  SendRequestInfoNotificationMutation,
  SendRequestInfoNotificationMutationVariables
>
export type SendRequestInfoNotificationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendRequestInfoNotificationMutation,
    SendRequestInfoNotificationMutationVariables
  >,
  "mutation"
>

export const SendRequestInfoNotificationComponent = (props: SendRequestInfoNotificationComponentProps) => (
  <ApolloReactComponents.Mutation<SendRequestInfoNotificationMutation, SendRequestInfoNotificationMutationVariables>
    mutation={SendRequestInfoNotificationDocument}
    {...props}
  />
)

export function useSendRequestInfoNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendRequestInfoNotificationMutation,
    SendRequestInfoNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendRequestInfoNotificationMutation, SendRequestInfoNotificationMutationVariables>(
    SendRequestInfoNotificationDocument,
    options
  )
}
export type SendRequestInfoNotificationMutationHookResult = ReturnType<typeof useSendRequestInfoNotificationMutation>
export type SendRequestInfoNotificationMutationResult = Apollo.MutationResult<SendRequestInfoNotificationMutation>
export const SetOrganizationFeaturesDocument = gql`
  mutation setOrganizationFeatures($input: SetOrganizationFeaturesInput!) {
    setOrganizationFeatures(input: $input)
  }
`
export type SetOrganizationFeaturesMutationFn = Apollo.MutationFunction<
  SetOrganizationFeaturesMutation,
  SetOrganizationFeaturesMutationVariables
>
export type SetOrganizationFeaturesComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetOrganizationFeaturesMutation,
    SetOrganizationFeaturesMutationVariables
  >,
  "mutation"
>

export const SetOrganizationFeaturesComponent = (props: SetOrganizationFeaturesComponentProps) => (
  <ApolloReactComponents.Mutation<SetOrganizationFeaturesMutation, SetOrganizationFeaturesMutationVariables>
    mutation={SetOrganizationFeaturesDocument}
    {...props}
  />
)

export function useSetOrganizationFeaturesMutation(
  baseOptions?: Apollo.MutationHookOptions<SetOrganizationFeaturesMutation, SetOrganizationFeaturesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetOrganizationFeaturesMutation, SetOrganizationFeaturesMutationVariables>(
    SetOrganizationFeaturesDocument,
    options
  )
}
export type SetOrganizationFeaturesMutationHookResult = ReturnType<typeof useSetOrganizationFeaturesMutation>
export type SetOrganizationFeaturesMutationResult = Apollo.MutationResult<SetOrganizationFeaturesMutation>
export const SetOrganizationPaymentOverdueDocument = gql`
  mutation setOrganizationPaymentOverdue($input: SetOrganizationPaymentOverdueInput!) {
    setOrganizationPaymentOverdue(input: $input)
  }
`
export type SetOrganizationPaymentOverdueMutationFn = Apollo.MutationFunction<
  SetOrganizationPaymentOverdueMutation,
  SetOrganizationPaymentOverdueMutationVariables
>
export type SetOrganizationPaymentOverdueComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetOrganizationPaymentOverdueMutation,
    SetOrganizationPaymentOverdueMutationVariables
  >,
  "mutation"
>

export const SetOrganizationPaymentOverdueComponent = (props: SetOrganizationPaymentOverdueComponentProps) => (
  <ApolloReactComponents.Mutation<SetOrganizationPaymentOverdueMutation, SetOrganizationPaymentOverdueMutationVariables>
    mutation={SetOrganizationPaymentOverdueDocument}
    {...props}
  />
)

export function useSetOrganizationPaymentOverdueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetOrganizationPaymentOverdueMutation,
    SetOrganizationPaymentOverdueMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetOrganizationPaymentOverdueMutation, SetOrganizationPaymentOverdueMutationVariables>(
    SetOrganizationPaymentOverdueDocument,
    options
  )
}
export type SetOrganizationPaymentOverdueMutationHookResult = ReturnType<
  typeof useSetOrganizationPaymentOverdueMutation
>
export type SetOrganizationPaymentOverdueMutationResult = Apollo.MutationResult<SetOrganizationPaymentOverdueMutation>
export const SetOrganizationProcessingTypeDocument = gql`
  mutation setOrganizationProcessingType($input: SetOrganizationProcessingTypeInput!) {
    setOrganizationProcessingType(input: $input)
  }
`
export type SetOrganizationProcessingTypeMutationFn = Apollo.MutationFunction<
  SetOrganizationProcessingTypeMutation,
  SetOrganizationProcessingTypeMutationVariables
>
export type SetOrganizationProcessingTypeComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetOrganizationProcessingTypeMutation,
    SetOrganizationProcessingTypeMutationVariables
  >,
  "mutation"
>

export const SetOrganizationProcessingTypeComponent = (props: SetOrganizationProcessingTypeComponentProps) => (
  <ApolloReactComponents.Mutation<SetOrganizationProcessingTypeMutation, SetOrganizationProcessingTypeMutationVariables>
    mutation={SetOrganizationProcessingTypeDocument}
    {...props}
  />
)

export function useSetOrganizationProcessingTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetOrganizationProcessingTypeMutation,
    SetOrganizationProcessingTypeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetOrganizationProcessingTypeMutation, SetOrganizationProcessingTypeMutationVariables>(
    SetOrganizationProcessingTypeDocument,
    options
  )
}
export type SetOrganizationProcessingTypeMutationHookResult = ReturnType<
  typeof useSetOrganizationProcessingTypeMutation
>
export type SetOrganizationProcessingTypeMutationResult = Apollo.MutationResult<SetOrganizationProcessingTypeMutation>
export const ShareApprovalsDocument = gql`
  mutation shareApprovals($input: ShareApprovalInput!) {
    shareApprovals(input: $input)
  }
`
export type ShareApprovalsMutationFn = Apollo.MutationFunction<ShareApprovalsMutation, ShareApprovalsMutationVariables>
export type ShareApprovalsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ShareApprovalsMutation, ShareApprovalsMutationVariables>,
  "mutation"
>

export const ShareApprovalsComponent = (props: ShareApprovalsComponentProps) => (
  <ApolloReactComponents.Mutation<ShareApprovalsMutation, ShareApprovalsMutationVariables>
    mutation={ShareApprovalsDocument}
    {...props}
  />
)

export function useShareApprovalsMutation(
  baseOptions?: Apollo.MutationHookOptions<ShareApprovalsMutation, ShareApprovalsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ShareApprovalsMutation, ShareApprovalsMutationVariables>(ShareApprovalsDocument, options)
}
export type ShareApprovalsMutationHookResult = ReturnType<typeof useShareApprovalsMutation>
export type ShareApprovalsMutationResult = Apollo.MutationResult<ShareApprovalsMutation>
export const SimplifyGeometryDocument = gql`
  mutation simplifyGeometry($input: SimplifyGeometryInput!) {
    simplifyGeometry(input: $input) {
      geoJsonString
      report {
        toleranceMeters
        precisionMeters
        features
        featuresDropped
        invalidFeatures
        invalidAfter
        issues {
          feature
          reason
          lng
          lat
        }
        verticesBefore
        verticesRepaired
        verticesAfter
        areaKm2Before
        areaKm2After
        areaChangePercent
        lengthKmBefore
        lengthKmAfter
        lengthChangePercent
        bytesBefore
        bytesAfter
        maxShiftMeters
        warnings
        status
        durationMs
      }
    }
  }
`
export type SimplifyGeometryMutationFn = Apollo.MutationFunction<
  SimplifyGeometryMutation,
  SimplifyGeometryMutationVariables
>
export type SimplifyGeometryComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<SimplifyGeometryMutation, SimplifyGeometryMutationVariables>,
  "mutation"
>

export const SimplifyGeometryComponent = (props: SimplifyGeometryComponentProps) => (
  <ApolloReactComponents.Mutation<SimplifyGeometryMutation, SimplifyGeometryMutationVariables>
    mutation={SimplifyGeometryDocument}
    {...props}
  />
)

export function useSimplifyGeometryMutation(
  baseOptions?: Apollo.MutationHookOptions<SimplifyGeometryMutation, SimplifyGeometryMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SimplifyGeometryMutation, SimplifyGeometryMutationVariables>(
    SimplifyGeometryDocument,
    options
  )
}
export type SimplifyGeometryMutationHookResult = ReturnType<typeof useSimplifyGeometryMutation>
export type SimplifyGeometryMutationResult = Apollo.MutationResult<SimplifyGeometryMutation>
export const SubmitAppForReviewEmailSendDocument = gql`
  mutation submitAppForReviewEmailSend($input: SubmitAppForReviewEmailSendInput!) {
    submitAppForReviewEmailSend(input: $input)
  }
`
export type SubmitAppForReviewEmailSendMutationFn = Apollo.MutationFunction<
  SubmitAppForReviewEmailSendMutation,
  SubmitAppForReviewEmailSendMutationVariables
>
export type SubmitAppForReviewEmailSendComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SubmitAppForReviewEmailSendMutation,
    SubmitAppForReviewEmailSendMutationVariables
  >,
  "mutation"
>

export const SubmitAppForReviewEmailSendComponent = (props: SubmitAppForReviewEmailSendComponentProps) => (
  <ApolloReactComponents.Mutation<SubmitAppForReviewEmailSendMutation, SubmitAppForReviewEmailSendMutationVariables>
    mutation={SubmitAppForReviewEmailSendDocument}
    {...props}
  />
)

export function useSubmitAppForReviewEmailSendMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitAppForReviewEmailSendMutation,
    SubmitAppForReviewEmailSendMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SubmitAppForReviewEmailSendMutation, SubmitAppForReviewEmailSendMutationVariables>(
    SubmitAppForReviewEmailSendDocument,
    options
  )
}
export type SubmitAppForReviewEmailSendMutationHookResult = ReturnType<typeof useSubmitAppForReviewEmailSendMutation>
export type SubmitAppForReviewEmailSendMutationResult = Apollo.MutationResult<SubmitAppForReviewEmailSendMutation>
export const SubmitApplicationEmailNotificationDocument = gql`
  mutation submitApplicationEmailNotification($input: SubmittedAppEmailNotificationInput!) {
    submittedAppEmailSending(input: $input)
  }
`
export type SubmitApplicationEmailNotificationMutationFn = Apollo.MutationFunction<
  SubmitApplicationEmailNotificationMutation,
  SubmitApplicationEmailNotificationMutationVariables
>
export type SubmitApplicationEmailNotificationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SubmitApplicationEmailNotificationMutation,
    SubmitApplicationEmailNotificationMutationVariables
  >,
  "mutation"
>

export const SubmitApplicationEmailNotificationComponent = (
  props: SubmitApplicationEmailNotificationComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SubmitApplicationEmailNotificationMutation,
    SubmitApplicationEmailNotificationMutationVariables
  >
    mutation={SubmitApplicationEmailNotificationDocument}
    {...props}
  />
)

export function useSubmitApplicationEmailNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitApplicationEmailNotificationMutation,
    SubmitApplicationEmailNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SubmitApplicationEmailNotificationMutation,
    SubmitApplicationEmailNotificationMutationVariables
  >(SubmitApplicationEmailNotificationDocument, options)
}
export type SubmitApplicationEmailNotificationMutationHookResult = ReturnType<
  typeof useSubmitApplicationEmailNotificationMutation
>
export type SubmitApplicationEmailNotificationMutationResult =
  Apollo.MutationResult<SubmitApplicationEmailNotificationMutation>
export const SubmitWayleaveRequestDocument = gql`
  mutation submitWayleaveRequest($input: SubmitWayleaveRequestInput!) {
    submitWayleaveRequest(input: $input)
  }
`
export type SubmitWayleaveRequestMutationFn = Apollo.MutationFunction<
  SubmitWayleaveRequestMutation,
  SubmitWayleaveRequestMutationVariables
>
export type SubmitWayleaveRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<SubmitWayleaveRequestMutation, SubmitWayleaveRequestMutationVariables>,
  "mutation"
>

export const SubmitWayleaveRequestComponent = (props: SubmitWayleaveRequestComponentProps) => (
  <ApolloReactComponents.Mutation<SubmitWayleaveRequestMutation, SubmitWayleaveRequestMutationVariables>
    mutation={SubmitWayleaveRequestDocument}
    {...props}
  />
)

export function useSubmitWayleaveRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<SubmitWayleaveRequestMutation, SubmitWayleaveRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SubmitWayleaveRequestMutation, SubmitWayleaveRequestMutationVariables>(
    SubmitWayleaveRequestDocument,
    options
  )
}
export type SubmitWayleaveRequestMutationHookResult = ReturnType<typeof useSubmitWayleaveRequestMutation>
export type SubmitWayleaveRequestMutationResult = Apollo.MutationResult<SubmitWayleaveRequestMutation>
export const SurveyPdfReportDocument = gql`
  mutation surveyPdfReport($input: SurveyPdfReportInput!) {
    surveyPdfReport(input: $input) {
      id
      url
    }
  }
`
export type SurveyPdfReportMutationFn = Apollo.MutationFunction<
  SurveyPdfReportMutation,
  SurveyPdfReportMutationVariables
>
export type SurveyPdfReportComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<SurveyPdfReportMutation, SurveyPdfReportMutationVariables>,
  "mutation"
>

export const SurveyPdfReportComponent = (props: SurveyPdfReportComponentProps) => (
  <ApolloReactComponents.Mutation<SurveyPdfReportMutation, SurveyPdfReportMutationVariables>
    mutation={SurveyPdfReportDocument}
    {...props}
  />
)

export function useSurveyPdfReportMutation(
  baseOptions?: Apollo.MutationHookOptions<SurveyPdfReportMutation, SurveyPdfReportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SurveyPdfReportMutation, SurveyPdfReportMutationVariables>(SurveyPdfReportDocument, options)
}
export type SurveyPdfReportMutationHookResult = ReturnType<typeof useSurveyPdfReportMutation>
export type SurveyPdfReportMutationResult = Apollo.MutationResult<SurveyPdfReportMutation>
export const SyncAreaToPostgisDocument = gql`
  mutation syncAreaToPostgis($areaId: ID!) {
    syncAreaToPostgis(areaId: $areaId) {
      areaId
      running
      synced
      cellCount
      error
    }
  }
`
export type SyncAreaToPostgisMutationFn = Apollo.MutationFunction<
  SyncAreaToPostgisMutation,
  SyncAreaToPostgisMutationVariables
>
export type SyncAreaToPostgisComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<SyncAreaToPostgisMutation, SyncAreaToPostgisMutationVariables>,
  "mutation"
>

export const SyncAreaToPostgisComponent = (props: SyncAreaToPostgisComponentProps) => (
  <ApolloReactComponents.Mutation<SyncAreaToPostgisMutation, SyncAreaToPostgisMutationVariables>
    mutation={SyncAreaToPostgisDocument}
    {...props}
  />
)

export function useSyncAreaToPostgisMutation(
  baseOptions?: Apollo.MutationHookOptions<SyncAreaToPostgisMutation, SyncAreaToPostgisMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SyncAreaToPostgisMutation, SyncAreaToPostgisMutationVariables>(
    SyncAreaToPostgisDocument,
    options
  )
}
export type SyncAreaToPostgisMutationHookResult = ReturnType<typeof useSyncAreaToPostgisMutation>
export type SyncAreaToPostgisMutationResult = Apollo.MutationResult<SyncAreaToPostgisMutation>
export const Template01Document = gql`
  mutation template01($input: Template01Input!) {
    template01(input: $input)
  }
`
export type Template01MutationFn = Apollo.MutationFunction<Template01Mutation, Template01MutationVariables>
export type Template01ComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<Template01Mutation, Template01MutationVariables>,
  "mutation"
>

export const Template01Component = (props: Template01ComponentProps) => (
  <ApolloReactComponents.Mutation<Template01Mutation, Template01MutationVariables>
    mutation={Template01Document}
    {...props}
  />
)

export function useTemplate01Mutation(
  baseOptions?: Apollo.MutationHookOptions<Template01Mutation, Template01MutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<Template01Mutation, Template01MutationVariables>(Template01Document, options)
}
export type Template01MutationHookResult = ReturnType<typeof useTemplate01Mutation>
export type Template01MutationResult = Apollo.MutationResult<Template01Mutation>
export const TestingEmailGlobalSetUpDocument = gql`
  mutation testingEmailGlobalSetUp {
    testingEmailsGlobalSetUp {
      updated
    }
  }
`
export type TestingEmailGlobalSetUpMutationFn = Apollo.MutationFunction<
  TestingEmailGlobalSetUpMutation,
  TestingEmailGlobalSetUpMutationVariables
>
export type TestingEmailGlobalSetUpComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    TestingEmailGlobalSetUpMutation,
    TestingEmailGlobalSetUpMutationVariables
  >,
  "mutation"
>

export const TestingEmailGlobalSetUpComponent = (props: TestingEmailGlobalSetUpComponentProps) => (
  <ApolloReactComponents.Mutation<TestingEmailGlobalSetUpMutation, TestingEmailGlobalSetUpMutationVariables>
    mutation={TestingEmailGlobalSetUpDocument}
    {...props}
  />
)

export function useTestingEmailGlobalSetUpMutation(
  baseOptions?: Apollo.MutationHookOptions<TestingEmailGlobalSetUpMutation, TestingEmailGlobalSetUpMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<TestingEmailGlobalSetUpMutation, TestingEmailGlobalSetUpMutationVariables>(
    TestingEmailGlobalSetUpDocument,
    options
  )
}
export type TestingEmailGlobalSetUpMutationHookResult = ReturnType<typeof useTestingEmailGlobalSetUpMutation>
export type TestingEmailGlobalSetUpMutationResult = Apollo.MutationResult<TestingEmailGlobalSetUpMutation>
export const TransferApprovalsDocument = gql`
  mutation transferApprovals {
    transferApprovals
  }
`
export type TransferApprovalsMutationFn = Apollo.MutationFunction<
  TransferApprovalsMutation,
  TransferApprovalsMutationVariables
>
export type TransferApprovalsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<TransferApprovalsMutation, TransferApprovalsMutationVariables>,
  "mutation"
>

export const TransferApprovalsComponent = (props: TransferApprovalsComponentProps) => (
  <ApolloReactComponents.Mutation<TransferApprovalsMutation, TransferApprovalsMutationVariables>
    mutation={TransferApprovalsDocument}
    {...props}
  />
)

export function useTransferApprovalsMutation(
  baseOptions?: Apollo.MutationHookOptions<TransferApprovalsMutation, TransferApprovalsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<TransferApprovalsMutation, TransferApprovalsMutationVariables>(
    TransferApprovalsDocument,
    options
  )
}
export type TransferApprovalsMutationHookResult = ReturnType<typeof useTransferApprovalsMutation>
export type TransferApprovalsMutationResult = Apollo.MutationResult<TransferApprovalsMutation>
export const TriggerDateMigrationDocument = gql`
  mutation triggerDateMigration {
    triggerDateMigration {
      updated
    }
  }
`
export type TriggerDateMigrationMutationFn = Apollo.MutationFunction<
  TriggerDateMigrationMutation,
  TriggerDateMigrationMutationVariables
>
export type TriggerDateMigrationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<TriggerDateMigrationMutation, TriggerDateMigrationMutationVariables>,
  "mutation"
>

export const TriggerDateMigrationComponent = (props: TriggerDateMigrationComponentProps) => (
  <ApolloReactComponents.Mutation<TriggerDateMigrationMutation, TriggerDateMigrationMutationVariables>
    mutation={TriggerDateMigrationDocument}
    {...props}
  />
)

export function useTriggerDateMigrationMutation(
  baseOptions?: Apollo.MutationHookOptions<TriggerDateMigrationMutation, TriggerDateMigrationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<TriggerDateMigrationMutation, TriggerDateMigrationMutationVariables>(
    TriggerDateMigrationDocument,
    options
  )
}
export type TriggerDateMigrationMutationHookResult = ReturnType<typeof useTriggerDateMigrationMutation>
export type TriggerDateMigrationMutationResult = Apollo.MutationResult<TriggerDateMigrationMutation>
export const TriggerEmailsChangeDocument = gql`
  mutation triggerEmailsChange {
    triggerEmailsChange
  }
`
export type TriggerEmailsChangeMutationFn = Apollo.MutationFunction<
  TriggerEmailsChangeMutation,
  TriggerEmailsChangeMutationVariables
>
export type TriggerEmailsChangeComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<TriggerEmailsChangeMutation, TriggerEmailsChangeMutationVariables>,
  "mutation"
>

export const TriggerEmailsChangeComponent = (props: TriggerEmailsChangeComponentProps) => (
  <ApolloReactComponents.Mutation<TriggerEmailsChangeMutation, TriggerEmailsChangeMutationVariables>
    mutation={TriggerEmailsChangeDocument}
    {...props}
  />
)

export function useTriggerEmailsChangeMutation(
  baseOptions?: Apollo.MutationHookOptions<TriggerEmailsChangeMutation, TriggerEmailsChangeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<TriggerEmailsChangeMutation, TriggerEmailsChangeMutationVariables>(
    TriggerEmailsChangeDocument,
    options
  )
}
export type TriggerEmailsChangeMutationHookResult = ReturnType<typeof useTriggerEmailsChangeMutation>
export type TriggerEmailsChangeMutationResult = Apollo.MutationResult<TriggerEmailsChangeMutation>
export const TriggerSpatialAreasSyncDocument = gql`
  mutation triggerSpatialAreasSync {
    triggerSpatialAreasSync {
      started
      message
      total
      synced
      skipped
      failed
      cellMapRows
      incidentId
      errors
    }
  }
`
export type TriggerSpatialAreasSyncMutationFn = Apollo.MutationFunction<
  TriggerSpatialAreasSyncMutation,
  TriggerSpatialAreasSyncMutationVariables
>
export type TriggerSpatialAreasSyncComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    TriggerSpatialAreasSyncMutation,
    TriggerSpatialAreasSyncMutationVariables
  >,
  "mutation"
>

export const TriggerSpatialAreasSyncComponent = (props: TriggerSpatialAreasSyncComponentProps) => (
  <ApolloReactComponents.Mutation<TriggerSpatialAreasSyncMutation, TriggerSpatialAreasSyncMutationVariables>
    mutation={TriggerSpatialAreasSyncDocument}
    {...props}
  />
)

export function useTriggerSpatialAreasSyncMutation(
  baseOptions?: Apollo.MutationHookOptions<TriggerSpatialAreasSyncMutation, TriggerSpatialAreasSyncMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<TriggerSpatialAreasSyncMutation, TriggerSpatialAreasSyncMutationVariables>(
    TriggerSpatialAreasSyncDocument,
    options
  )
}
export type TriggerSpatialAreasSyncMutationHookResult = ReturnType<typeof useTriggerSpatialAreasSyncMutation>
export type TriggerSpatialAreasSyncMutationResult = Apollo.MutationResult<TriggerSpatialAreasSyncMutation>
export const TriggerSpatialCellMapRebuildDocument = gql`
  mutation triggerSpatialCellMapRebuild {
    triggerSpatialCellMapRebuild {
      started
      message
    }
  }
`
export type TriggerSpatialCellMapRebuildMutationFn = Apollo.MutationFunction<
  TriggerSpatialCellMapRebuildMutation,
  TriggerSpatialCellMapRebuildMutationVariables
>
export type TriggerSpatialCellMapRebuildComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    TriggerSpatialCellMapRebuildMutation,
    TriggerSpatialCellMapRebuildMutationVariables
  >,
  "mutation"
>

export const TriggerSpatialCellMapRebuildComponent = (props: TriggerSpatialCellMapRebuildComponentProps) => (
  <ApolloReactComponents.Mutation<TriggerSpatialCellMapRebuildMutation, TriggerSpatialCellMapRebuildMutationVariables>
    mutation={TriggerSpatialCellMapRebuildDocument}
    {...props}
  />
)

export function useTriggerSpatialCellMapRebuildMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerSpatialCellMapRebuildMutation,
    TriggerSpatialCellMapRebuildMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<TriggerSpatialCellMapRebuildMutation, TriggerSpatialCellMapRebuildMutationVariables>(
    TriggerSpatialCellMapRebuildDocument,
    options
  )
}
export type TriggerSpatialCellMapRebuildMutationHookResult = ReturnType<typeof useTriggerSpatialCellMapRebuildMutation>
export type TriggerSpatialCellMapRebuildMutationResult = Apollo.MutationResult<TriggerSpatialCellMapRebuildMutation>
export const TriggerSpatialCellMapVerifyDocument = gql`
  mutation triggerSpatialCellMapVerify {
    triggerSpatialCellMapVerify {
      started
      message
    }
  }
`
export type TriggerSpatialCellMapVerifyMutationFn = Apollo.MutationFunction<
  TriggerSpatialCellMapVerifyMutation,
  TriggerSpatialCellMapVerifyMutationVariables
>
export type TriggerSpatialCellMapVerifyComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    TriggerSpatialCellMapVerifyMutation,
    TriggerSpatialCellMapVerifyMutationVariables
  >,
  "mutation"
>

export const TriggerSpatialCellMapVerifyComponent = (props: TriggerSpatialCellMapVerifyComponentProps) => (
  <ApolloReactComponents.Mutation<TriggerSpatialCellMapVerifyMutation, TriggerSpatialCellMapVerifyMutationVariables>
    mutation={TriggerSpatialCellMapVerifyDocument}
    {...props}
  />
)

export function useTriggerSpatialCellMapVerifyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerSpatialCellMapVerifyMutation,
    TriggerSpatialCellMapVerifyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<TriggerSpatialCellMapVerifyMutation, TriggerSpatialCellMapVerifyMutationVariables>(
    TriggerSpatialCellMapVerifyDocument,
    options
  )
}
export type TriggerSpatialCellMapVerifyMutationHookResult = ReturnType<typeof useTriggerSpatialCellMapVerifyMutation>
export type TriggerSpatialCellMapVerifyMutationResult = Apollo.MutationResult<TriggerSpatialCellMapVerifyMutation>
export const TriggerSpatialGridImportDocument = gql`
  mutation triggerSpatialGridImport {
    triggerSpatialGridImport {
      sourceName
      sourceUrl
      imported
      levels {
        level
        count
      }
      srid
      overlapPairs
      invalidCount
    }
  }
`
export type TriggerSpatialGridImportMutationFn = Apollo.MutationFunction<
  TriggerSpatialGridImportMutation,
  TriggerSpatialGridImportMutationVariables
>
export type TriggerSpatialGridImportComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    TriggerSpatialGridImportMutation,
    TriggerSpatialGridImportMutationVariables
  >,
  "mutation"
>

export const TriggerSpatialGridImportComponent = (props: TriggerSpatialGridImportComponentProps) => (
  <ApolloReactComponents.Mutation<TriggerSpatialGridImportMutation, TriggerSpatialGridImportMutationVariables>
    mutation={TriggerSpatialGridImportDocument}
    {...props}
  />
)

export function useTriggerSpatialGridImportMutation(
  baseOptions?: Apollo.MutationHookOptions<TriggerSpatialGridImportMutation, TriggerSpatialGridImportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<TriggerSpatialGridImportMutation, TriggerSpatialGridImportMutationVariables>(
    TriggerSpatialGridImportDocument,
    options
  )
}
export type TriggerSpatialGridImportMutationHookResult = ReturnType<typeof useTriggerSpatialGridImportMutation>
export type TriggerSpatialGridImportMutationResult = Apollo.MutationResult<TriggerSpatialGridImportMutation>
export const TriggerSpatialLayerImportDocument = gql`
  mutation triggerSpatialLayerImport($level: String!) {
    triggerSpatialLayerImport(level: $level) {
      level
      expectedCount
      sourceName
      sourceUrl
      imported
      srid
      invalidCount
      postGisConversion
      notes
      cmsCreated
      cmsUpdated
    }
  }
`
export type TriggerSpatialLayerImportMutationFn = Apollo.MutationFunction<
  TriggerSpatialLayerImportMutation,
  TriggerSpatialLayerImportMutationVariables
>
export type TriggerSpatialLayerImportComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    TriggerSpatialLayerImportMutation,
    TriggerSpatialLayerImportMutationVariables
  >,
  "mutation"
>

export const TriggerSpatialLayerImportComponent = (props: TriggerSpatialLayerImportComponentProps) => (
  <ApolloReactComponents.Mutation<TriggerSpatialLayerImportMutation, TriggerSpatialLayerImportMutationVariables>
    mutation={TriggerSpatialLayerImportDocument}
    {...props}
  />
)

export function useTriggerSpatialLayerImportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerSpatialLayerImportMutation,
    TriggerSpatialLayerImportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<TriggerSpatialLayerImportMutation, TriggerSpatialLayerImportMutationVariables>(
    TriggerSpatialLayerImportDocument,
    options
  )
}
export type TriggerSpatialLayerImportMutationHookResult = ReturnType<typeof useTriggerSpatialLayerImportMutation>
export type TriggerSpatialLayerImportMutationResult = Apollo.MutationResult<TriggerSpatialLayerImportMutation>
export const UpdateAoiDocument = gql`
  mutation updateAoi($id: ID!, $data: AoiInput!) {
    updateAoi(id: $id, data: $data) {
      data {
        ...Aoi
      }
    }
  }
  ${AoiFragmentDoc}
  ${FileFragmentDoc}
`
export type UpdateAoiMutationFn = Apollo.MutationFunction<UpdateAoiMutation, UpdateAoiMutationVariables>
export type UpdateAoiComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateAoiMutation, UpdateAoiMutationVariables>,
  "mutation"
>

export const UpdateAoiComponent = (props: UpdateAoiComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateAoiMutation, UpdateAoiMutationVariables>
    mutation={UpdateAoiDocument}
    {...props}
  />
)

export function useUpdateAoiMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAoiMutation, UpdateAoiMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateAoiMutation, UpdateAoiMutationVariables>(UpdateAoiDocument, options)
}
export type UpdateAoiMutationHookResult = ReturnType<typeof useUpdateAoiMutation>
export type UpdateAoiMutationResult = Apollo.MutationResult<UpdateAoiMutation>
export const UpdateApplicationDocument = gql`
  mutation updateApplication($id: ID!, $data: ApplicationInput!) {
    updateApplication(id: $id, data: $data) {
      data {
        ...Application
      }
    }
  }
  ${ApplicationFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${ApplicationNatureFragmentDoc}
  ${UserProfileLimitedFragmentDoc}
  ${ApprovalOnApplicationFragmentDoc}
`
export type UpdateApplicationMutationFn = Apollo.MutationFunction<
  UpdateApplicationMutation,
  UpdateApplicationMutationVariables
>
export type UpdateApplicationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>,
  "mutation"
>

export const UpdateApplicationComponent = (props: UpdateApplicationComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateApplicationMutation, UpdateApplicationMutationVariables>
    mutation={UpdateApplicationDocument}
    {...props}
  />
)

export function useUpdateApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateApplicationMutation, UpdateApplicationMutationVariables>(
    UpdateApplicationDocument,
    options
  )
}
export type UpdateApplicationMutationHookResult = ReturnType<typeof useUpdateApplicationMutation>
export type UpdateApplicationMutationResult = Apollo.MutationResult<UpdateApplicationMutation>
export const UpdateApprovalDocument = gql`
  mutation updateApproval($id: ID!, $data: ApprovalInput!) {
    updateApproval(id: $id, data: $data) {
      data {
        ...Approval
      }
    }
  }
  ${ApprovalFragmentDoc}
  ${FileFragmentDoc}
  ${UserProfileLimitedFragmentDoc}
`
export type UpdateApprovalMutationFn = Apollo.MutationFunction<UpdateApprovalMutation, UpdateApprovalMutationVariables>
export type UpdateApprovalComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateApprovalMutation, UpdateApprovalMutationVariables>,
  "mutation"
>

export const UpdateApprovalComponent = (props: UpdateApprovalComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateApprovalMutation, UpdateApprovalMutationVariables>
    mutation={UpdateApprovalDocument}
    {...props}
  />
)

export function useUpdateApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateApprovalMutation, UpdateApprovalMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateApprovalMutation, UpdateApprovalMutationVariables>(UpdateApprovalDocument, options)
}
export type UpdateApprovalMutationHookResult = ReturnType<typeof useUpdateApprovalMutation>
export type UpdateApprovalMutationResult = Apollo.MutationResult<UpdateApprovalMutation>
export const UpdateAreaDocument = gql`
  mutation updateArea($id: ID!, $data: AreaInput!) {
    updateArea(id: $id, data: $data) {
      data {
        id
      }
    }
  }
`
export type UpdateAreaMutationFn = Apollo.MutationFunction<UpdateAreaMutation, UpdateAreaMutationVariables>
export type UpdateAreaComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateAreaMutation, UpdateAreaMutationVariables>,
  "mutation"
>

export const UpdateAreaComponent = (props: UpdateAreaComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateAreaMutation, UpdateAreaMutationVariables>
    mutation={UpdateAreaDocument}
    {...props}
  />
)

export function useUpdateAreaMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAreaMutation, UpdateAreaMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateAreaMutation, UpdateAreaMutationVariables>(UpdateAreaDocument, options)
}
export type UpdateAreaMutationHookResult = ReturnType<typeof useUpdateAreaMutation>
export type UpdateAreaMutationResult = Apollo.MutationResult<UpdateAreaMutation>
export const UpdateAssistanceRequestDocument = gql`
  mutation updateAssistanceRequest($id: ID!, $data: AssistanceRequestInput!) {
    updateAssistanceRequest(id: $id, data: $data) {
      data {
        id
      }
    }
  }
`
export type UpdateAssistanceRequestMutationFn = Apollo.MutationFunction<
  UpdateAssistanceRequestMutation,
  UpdateAssistanceRequestMutationVariables
>
export type UpdateAssistanceRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateAssistanceRequestMutation,
    UpdateAssistanceRequestMutationVariables
  >,
  "mutation"
>

export const UpdateAssistanceRequestComponent = (props: UpdateAssistanceRequestComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateAssistanceRequestMutation, UpdateAssistanceRequestMutationVariables>
    mutation={UpdateAssistanceRequestDocument}
    {...props}
  />
)

export function useUpdateAssistanceRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAssistanceRequestMutation, UpdateAssistanceRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateAssistanceRequestMutation, UpdateAssistanceRequestMutationVariables>(
    UpdateAssistanceRequestDocument,
    options
  )
}
export type UpdateAssistanceRequestMutationHookResult = ReturnType<typeof useUpdateAssistanceRequestMutation>
export type UpdateAssistanceRequestMutationResult = Apollo.MutationResult<UpdateAssistanceRequestMutation>
export const UpdateByLawDocument = gql`
  mutation updateByLaw($id: ID!, $data: ByLawInput!) {
    updateByLaw(id: $id, data: $data) {
      data {
        id
        attributes {
          documents {
            data {
              id
              ...File
            }
          }
        }
      }
    }
  }
  ${FileFragmentDoc}
`
export type UpdateByLawMutationFn = Apollo.MutationFunction<UpdateByLawMutation, UpdateByLawMutationVariables>
export type UpdateByLawComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateByLawMutation, UpdateByLawMutationVariables>,
  "mutation"
>

export const UpdateByLawComponent = (props: UpdateByLawComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateByLawMutation, UpdateByLawMutationVariables>
    mutation={UpdateByLawDocument}
    {...props}
  />
)

export function useUpdateByLawMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateByLawMutation, UpdateByLawMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateByLawMutation, UpdateByLawMutationVariables>(UpdateByLawDocument, options)
}
export type UpdateByLawMutationHookResult = ReturnType<typeof useUpdateByLawMutation>
export type UpdateByLawMutationResult = Apollo.MutationResult<UpdateByLawMutation>
export const UpdateCertificateDocument = gql`
  mutation updateCertificate($id: ID!, $data: CompletionCertificateInput!) {
    updateCompletionCertificate(id: $id, data: $data) {
      data {
        id
      }
    }
  }
`
export type UpdateCertificateMutationFn = Apollo.MutationFunction<
  UpdateCertificateMutation,
  UpdateCertificateMutationVariables
>
export type UpdateCertificateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateCertificateMutation, UpdateCertificateMutationVariables>,
  "mutation"
>

export const UpdateCertificateComponent = (props: UpdateCertificateComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateCertificateMutation, UpdateCertificateMutationVariables>
    mutation={UpdateCertificateDocument}
    {...props}
  />
)

export function useUpdateCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCertificateMutation, UpdateCertificateMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCertificateMutation, UpdateCertificateMutationVariables>(
    UpdateCertificateDocument,
    options
  )
}
export type UpdateCertificateMutationHookResult = ReturnType<typeof useUpdateCertificateMutation>
export type UpdateCertificateMutationResult = Apollo.MutationResult<UpdateCertificateMutation>
export const UpdateCompanyDocument = gql`
  mutation updateCompany($id: ID!, $data: CompanyInput!) {
    updateCompany(id: $id, data: $data) {
      data {
        ...Company
      }
    }
  }
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${FileFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>
export type UpdateCompanyComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>,
  "mutation"
>

export const UpdateCompanyComponent = (props: UpdateCompanyComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>
    mutation={UpdateCompanyDocument}
    {...props}
  />
)

export function useUpdateCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options)
}
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>
export const UpdateCompanyUpdateRequestDocument = gql`
  mutation updateCompanyUpdateRequest($id: ID!, $data: CompanyUpdateRequestInput!) {
    updateCompanyUpdateRequest(id: $id, data: $data) {
      data {
        id
      }
    }
  }
`
export type UpdateCompanyUpdateRequestMutationFn = Apollo.MutationFunction<
  UpdateCompanyUpdateRequestMutation,
  UpdateCompanyUpdateRequestMutationVariables
>
export type UpdateCompanyUpdateRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateCompanyUpdateRequestMutation,
    UpdateCompanyUpdateRequestMutationVariables
  >,
  "mutation"
>

export const UpdateCompanyUpdateRequestComponent = (props: UpdateCompanyUpdateRequestComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateCompanyUpdateRequestMutation, UpdateCompanyUpdateRequestMutationVariables>
    mutation={UpdateCompanyUpdateRequestDocument}
    {...props}
  />
)

export function useUpdateCompanyUpdateRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCompanyUpdateRequestMutation,
    UpdateCompanyUpdateRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCompanyUpdateRequestMutation, UpdateCompanyUpdateRequestMutationVariables>(
    UpdateCompanyUpdateRequestDocument,
    options
  )
}
export type UpdateCompanyUpdateRequestMutationHookResult = ReturnType<typeof useUpdateCompanyUpdateRequestMutation>
export type UpdateCompanyUpdateRequestMutationResult = Apollo.MutationResult<UpdateCompanyUpdateRequestMutation>
export const UpdateConfigDocument = gql`
  mutation updateConfig($id: ID!, $data: ConfigurationInput!) {
    updateConfiguration(id: $id, data: $data) {
      data {
        ...Configuration
      }
    }
  }
  ${ConfigurationFragmentDoc}
`
export type UpdateConfigMutationFn = Apollo.MutationFunction<UpdateConfigMutation, UpdateConfigMutationVariables>
export type UpdateConfigComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateConfigMutation, UpdateConfigMutationVariables>,
  "mutation"
>

export const UpdateConfigComponent = (props: UpdateConfigComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateConfigMutation, UpdateConfigMutationVariables>
    mutation={UpdateConfigDocument}
    {...props}
  />
)

export function useUpdateConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateConfigMutation, UpdateConfigMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateConfigMutation, UpdateConfigMutationVariables>(UpdateConfigDocument, options)
}
export type UpdateConfigMutationHookResult = ReturnType<typeof useUpdateConfigMutation>
export type UpdateConfigMutationResult = Apollo.MutationResult<UpdateConfigMutation>
export const UpdateDepositDocument = gql`
  mutation updateDeposit($id: ID!, $data: DepositInput!) {
    updateDeposit(id: $id, data: $data) {
      data {
        ...Deposit
      }
    }
  }
  ${DepositFragmentDoc}
  ${FileFragmentDoc}
`
export type UpdateDepositMutationFn = Apollo.MutationFunction<UpdateDepositMutation, UpdateDepositMutationVariables>
export type UpdateDepositComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateDepositMutation, UpdateDepositMutationVariables>,
  "mutation"
>

export const UpdateDepositComponent = (props: UpdateDepositComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateDepositMutation, UpdateDepositMutationVariables>
    mutation={UpdateDepositDocument}
    {...props}
  />
)

export function useUpdateDepositMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateDepositMutation, UpdateDepositMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateDepositMutation, UpdateDepositMutationVariables>(UpdateDepositDocument, options)
}
export type UpdateDepositMutationHookResult = ReturnType<typeof useUpdateDepositMutation>
export type UpdateDepositMutationResult = Apollo.MutationResult<UpdateDepositMutation>
export const UpdateEnforcementDocument = gql`
  mutation updateEnforcement($id: ID!, $data: EnforcementInput!) {
    updateEnforcement(id: $id, data: $data) {
      data {
        id
      }
    }
  }
`
export type UpdateEnforcementMutationFn = Apollo.MutationFunction<
  UpdateEnforcementMutation,
  UpdateEnforcementMutationVariables
>
export type UpdateEnforcementComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateEnforcementMutation, UpdateEnforcementMutationVariables>,
  "mutation"
>

export const UpdateEnforcementComponent = (props: UpdateEnforcementComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateEnforcementMutation, UpdateEnforcementMutationVariables>
    mutation={UpdateEnforcementDocument}
    {...props}
  />
)

export function useUpdateEnforcementMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateEnforcementMutation, UpdateEnforcementMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateEnforcementMutation, UpdateEnforcementMutationVariables>(
    UpdateEnforcementDocument,
    options
  )
}
export type UpdateEnforcementMutationHookResult = ReturnType<typeof useUpdateEnforcementMutation>
export type UpdateEnforcementMutationResult = Apollo.MutationResult<UpdateEnforcementMutation>
export const UpdateInviteDocument = gql`
  mutation updateInvite($id: ID!, $data: KickoffInviteInput!) {
    updateKickoffInvite(id: $id, data: $data) {
      data {
        id
      }
    }
  }
`
export type UpdateInviteMutationFn = Apollo.MutationFunction<UpdateInviteMutation, UpdateInviteMutationVariables>
export type UpdateInviteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateInviteMutation, UpdateInviteMutationVariables>,
  "mutation"
>

export const UpdateInviteComponent = (props: UpdateInviteComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateInviteMutation, UpdateInviteMutationVariables>
    mutation={UpdateInviteDocument}
    {...props}
  />
)

export function useUpdateInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateInviteMutation, UpdateInviteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateInviteMutation, UpdateInviteMutationVariables>(UpdateInviteDocument, options)
}
export type UpdateInviteMutationHookResult = ReturnType<typeof useUpdateInviteMutation>
export type UpdateInviteMutationResult = Apollo.MutationResult<UpdateInviteMutation>
export const UpdateInvoiceDocument = gql`
  mutation updateInvoice($id: ID!, $data: InvoiceInput!) {
    updateInvoice(id: $id, data: $data) {
      data {
        ...Invoice
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${FileFragmentDoc}
`
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>
export type UpdateInvoiceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>,
  "mutation"
>

export const UpdateInvoiceComponent = (props: UpdateInvoiceComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>
    mutation={UpdateInvoiceDocument}
    {...props}
  />
)

export function useUpdateInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options)
}
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>
export type UpdateInvoiceMutationResult = Apollo.MutationResult<UpdateInvoiceMutation>
export const UpdateLicenseUpdateRequestDocument = gql`
  mutation updateLicenseUpdateRequest($id: ID!, $data: LicenseUpdateRequestInput!) {
    updateLicenseUpdateRequest(id: $id, data: $data) {
      data {
        id
      }
    }
  }
`
export type UpdateLicenseUpdateRequestMutationFn = Apollo.MutationFunction<
  UpdateLicenseUpdateRequestMutation,
  UpdateLicenseUpdateRequestMutationVariables
>
export type UpdateLicenseUpdateRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateLicenseUpdateRequestMutation,
    UpdateLicenseUpdateRequestMutationVariables
  >,
  "mutation"
>

export const UpdateLicenseUpdateRequestComponent = (props: UpdateLicenseUpdateRequestComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateLicenseUpdateRequestMutation, UpdateLicenseUpdateRequestMutationVariables>
    mutation={UpdateLicenseUpdateRequestDocument}
    {...props}
  />
)

export function useUpdateLicenseUpdateRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLicenseUpdateRequestMutation,
    UpdateLicenseUpdateRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateLicenseUpdateRequestMutation, UpdateLicenseUpdateRequestMutationVariables>(
    UpdateLicenseUpdateRequestDocument,
    options
  )
}
export type UpdateLicenseUpdateRequestMutationHookResult = ReturnType<typeof useUpdateLicenseUpdateRequestMutation>
export type UpdateLicenseUpdateRequestMutationResult = Apollo.MutationResult<UpdateLicenseUpdateRequestMutation>
export const UpdateNoteDocument = gql`
  mutation updateNote($id: ID!, $data: NoteInput!) {
    updateNote(id: $id, data: $data) {
      data {
        ...Note
      }
    }
  }
  ${NoteFragmentDoc}
  ${FileFragmentDoc}
`
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>
export type UpdateNoteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateNoteMutation, UpdateNoteMutationVariables>,
  "mutation"
>

export const UpdateNoteComponent = (props: UpdateNoteComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateNoteMutation, UpdateNoteMutationVariables>
    mutation={UpdateNoteDocument}
    {...props}
  />
)

export function useUpdateNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options)
}
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>
export const UpdateNotificationMessageDocument = gql`
  mutation updateNotificationMessage($id: ID!, $data: NotificationMessageInput!) {
    updateNotificationMessage(id: $id, data: $data) {
      data {
        ...NotificationMessage
      }
    }
  }
  ${NotificationMessageFragmentDoc}
  ${FileFragmentDoc}
`
export type UpdateNotificationMessageMutationFn = Apollo.MutationFunction<
  UpdateNotificationMessageMutation,
  UpdateNotificationMessageMutationVariables
>
export type UpdateNotificationMessageComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateNotificationMessageMutation,
    UpdateNotificationMessageMutationVariables
  >,
  "mutation"
>

export const UpdateNotificationMessageComponent = (props: UpdateNotificationMessageComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateNotificationMessageMutation, UpdateNotificationMessageMutationVariables>
    mutation={UpdateNotificationMessageDocument}
    {...props}
  />
)

export function useUpdateNotificationMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNotificationMessageMutation,
    UpdateNotificationMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateNotificationMessageMutation, UpdateNotificationMessageMutationVariables>(
    UpdateNotificationMessageDocument,
    options
  )
}
export type UpdateNotificationMessageMutationHookResult = ReturnType<typeof useUpdateNotificationMessageMutation>
export type UpdateNotificationMessageMutationResult = Apollo.MutationResult<UpdateNotificationMessageMutation>
export const UpdatePaymentDocument = gql`
  mutation updatePayment($id: ID!, $data: PaymentInput!) {
    updatePayment(id: $id, data: $data) {
      data {
        ...Payment
      }
    }
  }
  ${PaymentFragmentDoc}
  ${FileFragmentDoc}
`
export type UpdatePaymentMutationFn = Apollo.MutationFunction<UpdatePaymentMutation, UpdatePaymentMutationVariables>
export type UpdatePaymentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>,
  "mutation"
>

export const UpdatePaymentComponent = (props: UpdatePaymentComponentProps) => (
  <ApolloReactComponents.Mutation<UpdatePaymentMutation, UpdatePaymentMutationVariables>
    mutation={UpdatePaymentDocument}
    {...props}
  />
)

export function useUpdatePaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdatePaymentMutation, UpdatePaymentMutationVariables>(UpdatePaymentDocument, options)
}
export type UpdatePaymentMutationHookResult = ReturnType<typeof useUpdatePaymentMutation>
export type UpdatePaymentMutationResult = Apollo.MutationResult<UpdatePaymentMutation>
export const UpdateProjectDocument = gql`
  mutation updateProject($id: ID!, $data: ProjectInput!) {
    updateProject(id: $id, data: $data) {
      data {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
  ${ProvinceFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${ApplicationNatureFragmentDoc}
`
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>
export type UpdateProjectComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateProjectMutation, UpdateProjectMutationVariables>,
  "mutation"
>

export const UpdateProjectComponent = (props: UpdateProjectComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateProjectMutation, UpdateProjectMutationVariables>
    mutation={UpdateProjectDocument}
    {...props}
  />
)

export function useUpdateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options)
}
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>
export const UpdateQuotationDocument = gql`
  mutation updateQuotation($id: ID!, $data: QuotationInput!) {
    updateQuotation(id: $id, data: $data) {
      data {
        ...Quotation
      }
    }
  }
  ${QuotationFragmentDoc}
  ${QuoteItemFragmentDoc}
`
export type UpdateQuotationMutationFn = Apollo.MutationFunction<
  UpdateQuotationMutation,
  UpdateQuotationMutationVariables
>
export type UpdateQuotationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateQuotationMutation, UpdateQuotationMutationVariables>,
  "mutation"
>

export const UpdateQuotationComponent = (props: UpdateQuotationComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateQuotationMutation, UpdateQuotationMutationVariables>
    mutation={UpdateQuotationDocument}
    {...props}
  />
)

export function useUpdateQuotationMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateQuotationMutation, UpdateQuotationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateQuotationMutation, UpdateQuotationMutationVariables>(UpdateQuotationDocument, options)
}
export type UpdateQuotationMutationHookResult = ReturnType<typeof useUpdateQuotationMutation>
export type UpdateQuotationMutationResult = Apollo.MutationResult<UpdateQuotationMutation>
export const UpdateQuoteRequestDocument = gql`
  mutation updateQuoteRequest($id: ID!, $data: QuoteRequestInput!) {
    updateQuoteRequest(id: $id, data: $data) {
      data {
        id
      }
    }
  }
`
export type UpdateQuoteRequestMutationFn = Apollo.MutationFunction<
  UpdateQuoteRequestMutation,
  UpdateQuoteRequestMutationVariables
>
export type UpdateQuoteRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateQuoteRequestMutation, UpdateQuoteRequestMutationVariables>,
  "mutation"
>

export const UpdateQuoteRequestComponent = (props: UpdateQuoteRequestComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateQuoteRequestMutation, UpdateQuoteRequestMutationVariables>
    mutation={UpdateQuoteRequestDocument}
    {...props}
  />
)

export function useUpdateQuoteRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateQuoteRequestMutation, UpdateQuoteRequestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateQuoteRequestMutation, UpdateQuoteRequestMutationVariables>(
    UpdateQuoteRequestDocument,
    options
  )
}
export type UpdateQuoteRequestMutationHookResult = ReturnType<typeof useUpdateQuoteRequestMutation>
export type UpdateQuoteRequestMutationResult = Apollo.MutationResult<UpdateQuoteRequestMutation>
export const UpdateKickoffRecordDocument = gql`
  mutation updateKickoffRecord($id: ID!, $data: KickoffRecordInput!) {
    updateKickoffRecord(id: $id, data: $data) {
      data {
        id
      }
    }
  }
`
export type UpdateKickoffRecordMutationFn = Apollo.MutationFunction<
  UpdateKickoffRecordMutation,
  UpdateKickoffRecordMutationVariables
>
export type UpdateKickoffRecordComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateKickoffRecordMutation, UpdateKickoffRecordMutationVariables>,
  "mutation"
>

export const UpdateKickoffRecordComponent = (props: UpdateKickoffRecordComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateKickoffRecordMutation, UpdateKickoffRecordMutationVariables>
    mutation={UpdateKickoffRecordDocument}
    {...props}
  />
)

export function useUpdateKickoffRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateKickoffRecordMutation, UpdateKickoffRecordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateKickoffRecordMutation, UpdateKickoffRecordMutationVariables>(
    UpdateKickoffRecordDocument,
    options
  )
}
export type UpdateKickoffRecordMutationHookResult = ReturnType<typeof useUpdateKickoffRecordMutation>
export type UpdateKickoffRecordMutationResult = Apollo.MutationResult<UpdateKickoffRecordMutation>
export const UpdateSettingsDocument = gql`
  mutation updateSettings($data: SettingInput!) {
    updateSetting(data: $data) {
      data {
        id
        ...Settings
      }
    }
  }
  ${SettingsFragmentDoc}
  ${FileFragmentDoc}
`
export type UpdateSettingsMutationFn = Apollo.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>
export type UpdateSettingsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>,
  "mutation"
>

export const UpdateSettingsComponent = (props: UpdateSettingsComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>
    mutation={UpdateSettingsDocument}
    {...props}
  />
)

export function useUpdateSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, options)
}
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>
export type UpdateSettingsMutationResult = Apollo.MutationResult<UpdateSettingsMutation>
export const UpdateSurveyDocument = gql`
  mutation updateSurvey($id: ID!, $input: SurveyInput!) {
    updateSurvey(id: $id, data: $input) {
      data {
        id
      }
    }
  }
`
export type UpdateSurveyMutationFn = Apollo.MutationFunction<UpdateSurveyMutation, UpdateSurveyMutationVariables>
export type UpdateSurveyComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>,
  "mutation"
>

export const UpdateSurveyComponent = (props: UpdateSurveyComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateSurveyMutation, UpdateSurveyMutationVariables>
    mutation={UpdateSurveyDocument}
    {...props}
  />
)

export function useUpdateSurveyMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateSurveyMutation, UpdateSurveyMutationVariables>(UpdateSurveyDocument, options)
}
export type UpdateSurveyMutationHookResult = ReturnType<typeof useUpdateSurveyMutation>
export type UpdateSurveyMutationResult = Apollo.MutationResult<UpdateSurveyMutation>
export const UpdateTaskDocument = gql`
  mutation updateTask($id: ID!, $data: TaskInput!) {
    updateTask(id: $id, data: $data) {
      data {
        ...Task
      }
    }
  }
  ${TaskFragmentDoc}
`
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>
export type UpdateTaskComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateTaskMutation, UpdateTaskMutationVariables>,
  "mutation"
>

export const UpdateTaskComponent = (props: UpdateTaskComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateTaskMutation, UpdateTaskMutationVariables>
    mutation={UpdateTaskDocument}
    {...props}
  />
)

export function useUpdateTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options)
}
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>
export const UpdateUserDocument = gql`
  mutation updateUser($id: ID!, $data: UsersPermissionsUserInput!) {
    updateUsersPermissionsUser(id: $id, data: $data) {
      data {
        id
        attributes {
          role {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
`
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>
export type UpdateUserComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateUserMutation, UpdateUserMutationVariables>,
  "mutation"
>

export const UpdateUserComponent = (props: UpdateUserComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateUserMutation, UpdateUserMutationVariables>
    mutation={UpdateUserDocument}
    {...props}
  />
)

export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options)
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>
export const UpdateUserInOrganizationDocument = gql`
  mutation updateUserInOrganization($input: UpdateUserInOrganizationInput!) {
    updateUserInOrganization(input: $input) {
      id
      email
      blocked
      confirmed
    }
  }
`
export type UpdateUserInOrganizationMutationFn = Apollo.MutationFunction<
  UpdateUserInOrganizationMutation,
  UpdateUserInOrganizationMutationVariables
>
export type UpdateUserInOrganizationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateUserInOrganizationMutation,
    UpdateUserInOrganizationMutationVariables
  >,
  "mutation"
>

export const UpdateUserInOrganizationComponent = (props: UpdateUserInOrganizationComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateUserInOrganizationMutation, UpdateUserInOrganizationMutationVariables>
    mutation={UpdateUserInOrganizationDocument}
    {...props}
  />
)

export function useUpdateUserInOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserInOrganizationMutation, UpdateUserInOrganizationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateUserInOrganizationMutation, UpdateUserInOrganizationMutationVariables>(
    UpdateUserInOrganizationDocument,
    options
  )
}
export type UpdateUserInOrganizationMutationHookResult = ReturnType<typeof useUpdateUserInOrganizationMutation>
export type UpdateUserInOrganizationMutationResult = Apollo.MutationResult<UpdateUserInOrganizationMutation>
export const UpdateUserProfileDocument = gql`
  mutation updateUserProfile($id: ID!, $data: UserProfileInput!) {
    updateUserProfile(id: $id, data: $data) {
      data {
        ...UserProfile
      }
    }
  }
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<
  UpdateUserProfileMutation,
  UpdateUserProfileMutationVariables
>
export type UpdateUserProfileComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>,
  "mutation"
>

export const UpdateUserProfileComponent = (props: UpdateUserProfileComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>
    mutation={UpdateUserProfileDocument}
    {...props}
  />
)

export function useUpdateUserProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(
    UpdateUserProfileDocument,
    options
  )
}
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>
export const VerifyLoginTwoFactorDocument = gql`
  mutation verifyLoginTwoFactor($input: VerifyLoginTwoFactorInput!) {
    verifyLoginTwoFactor(input: $input) {
      jwt
      refreshTokenExpiresAt
      invalidCode
      codeExpired
      tooManyAttempts
      accountBlocked
      emailNotConfirmed
      paymentOverdue
      user {
        id
      }
    }
  }
`
export type VerifyLoginTwoFactorMutationFn = Apollo.MutationFunction<
  VerifyLoginTwoFactorMutation,
  VerifyLoginTwoFactorMutationVariables
>
export type VerifyLoginTwoFactorComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<VerifyLoginTwoFactorMutation, VerifyLoginTwoFactorMutationVariables>,
  "mutation"
>

export const VerifyLoginTwoFactorComponent = (props: VerifyLoginTwoFactorComponentProps) => (
  <ApolloReactComponents.Mutation<VerifyLoginTwoFactorMutation, VerifyLoginTwoFactorMutationVariables>
    mutation={VerifyLoginTwoFactorDocument}
    {...props}
  />
)

export function useVerifyLoginTwoFactorMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyLoginTwoFactorMutation, VerifyLoginTwoFactorMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<VerifyLoginTwoFactorMutation, VerifyLoginTwoFactorMutationVariables>(
    VerifyLoginTwoFactorDocument,
    options
  )
}
export type VerifyLoginTwoFactorMutationHookResult = ReturnType<typeof useVerifyLoginTwoFactorMutation>
export type VerifyLoginTwoFactorMutationResult = Apollo.MutationResult<VerifyLoginTwoFactorMutation>
export const VerifyPayFastPaymentDocument = gql`
  mutation verifyPayFastPayment($input: VerifyPayFastPaymentInput!) {
    verifyPayFastPayment(input: $input) {
      success
      status
      alreadyPaid
      pending
      payfastPaymentId
      message
    }
  }
`
export type VerifyPayFastPaymentMutationFn = Apollo.MutationFunction<
  VerifyPayFastPaymentMutation,
  VerifyPayFastPaymentMutationVariables
>
export type VerifyPayFastPaymentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<VerifyPayFastPaymentMutation, VerifyPayFastPaymentMutationVariables>,
  "mutation"
>

export const VerifyPayFastPaymentComponent = (props: VerifyPayFastPaymentComponentProps) => (
  <ApolloReactComponents.Mutation<VerifyPayFastPaymentMutation, VerifyPayFastPaymentMutationVariables>
    mutation={VerifyPayFastPaymentDocument}
    {...props}
  />
)

export function useVerifyPayFastPaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyPayFastPaymentMutation, VerifyPayFastPaymentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<VerifyPayFastPaymentMutation, VerifyPayFastPaymentMutationVariables>(
    VerifyPayFastPaymentDocument,
    options
  )
}
export type VerifyPayFastPaymentMutationHookResult = ReturnType<typeof useVerifyPayFastPaymentMutation>
export type VerifyPayFastPaymentMutationResult = Apollo.MutationResult<VerifyPayFastPaymentMutation>
export const AoiDocument = gql`
  query aoi($id: ID!) {
    aoi(id: $id) {
      data {
        ...Aoi
      }
    }
  }
  ${AoiFragmentDoc}
  ${FileFragmentDoc}
`
export type AoiComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<AoiQuery, AoiQueryVariables>,
  "query"
> &
  ({ variables: AoiQueryVariables; skip?: boolean } | { skip: boolean })

export const AoiComponent = (props: AoiComponentProps) => (
  <ApolloReactComponents.Query<AoiQuery, AoiQueryVariables> query={AoiDocument} {...props} />
)

export function useAoiQuery(baseOptions: Apollo.QueryHookOptions<AoiQuery, AoiQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AoiQuery, AoiQueryVariables>(AoiDocument, options)
}
export function useAoiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AoiQuery, AoiQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AoiQuery, AoiQueryVariables>(AoiDocument, options)
}
export type AoiQueryHookResult = ReturnType<typeof useAoiQuery>
export type AoiLazyQueryHookResult = ReturnType<typeof useAoiLazyQuery>
export type AoiQueryResult = Apollo.QueryResult<AoiQuery, AoiQueryVariables>
export const AoiCoordinatesDocument = gql`
  query aoiCoordinates($pagination: PaginationArg, $filter: AoiFiltersInput) {
    aois(pagination: $pagination, filters: $filter) {
      data {
        id
        attributes {
          projectCenter
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type AoiCoordinatesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<AoiCoordinatesQuery, AoiCoordinatesQueryVariables>,
  "query"
>

export const AoiCoordinatesComponent = (props: AoiCoordinatesComponentProps) => (
  <ApolloReactComponents.Query<AoiCoordinatesQuery, AoiCoordinatesQueryVariables>
    query={AoiCoordinatesDocument}
    {...props}
  />
)

export function useAoiCoordinatesQuery(
  baseOptions?: Apollo.QueryHookOptions<AoiCoordinatesQuery, AoiCoordinatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AoiCoordinatesQuery, AoiCoordinatesQueryVariables>(AoiCoordinatesDocument, options)
}
export function useAoiCoordinatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AoiCoordinatesQuery, AoiCoordinatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AoiCoordinatesQuery, AoiCoordinatesQueryVariables>(AoiCoordinatesDocument, options)
}
export type AoiCoordinatesQueryHookResult = ReturnType<typeof useAoiCoordinatesQuery>
export type AoiCoordinatesLazyQueryHookResult = ReturnType<typeof useAoiCoordinatesLazyQuery>
export type AoiCoordinatesQueryResult = Apollo.QueryResult<AoiCoordinatesQuery, AoiCoordinatesQueryVariables>
export const AoisDocument = gql`
  query aois($filter: AoiFiltersInput, $sort: [String] = ["createdAt:DESC"], $pagination: PaginationArg) {
    aois(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...Aoi
      }
      meta {
        ...Meta
      }
    }
  }
  ${AoiFragmentDoc}
  ${FileFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type AoisComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<AoisQuery, AoisQueryVariables>,
  "query"
>

export const AoisComponent = (props: AoisComponentProps) => (
  <ApolloReactComponents.Query<AoisQuery, AoisQueryVariables> query={AoisDocument} {...props} />
)

export function useAoisQuery(baseOptions?: Apollo.QueryHookOptions<AoisQuery, AoisQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AoisQuery, AoisQueryVariables>(AoisDocument, options)
}
export function useAoisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AoisQuery, AoisQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AoisQuery, AoisQueryVariables>(AoisDocument, options)
}
export type AoisQueryHookResult = ReturnType<typeof useAoisQuery>
export type AoisLazyQueryHookResult = ReturnType<typeof useAoisLazyQuery>
export type AoisQueryResult = Apollo.QueryResult<AoisQuery, AoisQueryVariables>
export const AoisGeoJsonDocument = gql`
  query aoisGeoJson($filter: AoiFiltersInput, $sort: [String] = ["createdAt:DESC"], $pagination: PaginationArg) {
    aois(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          name
          status
          applicantCompany {
            data {
              id
            }
          }
          geoJson {
            data {
              ...File
            }
          }
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${FileFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type AoisGeoJsonComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<AoisGeoJsonQuery, AoisGeoJsonQueryVariables>,
  "query"
>

export const AoisGeoJsonComponent = (props: AoisGeoJsonComponentProps) => (
  <ApolloReactComponents.Query<AoisGeoJsonQuery, AoisGeoJsonQueryVariables> query={AoisGeoJsonDocument} {...props} />
)

export function useAoisGeoJsonQuery(
  baseOptions?: Apollo.QueryHookOptions<AoisGeoJsonQuery, AoisGeoJsonQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AoisGeoJsonQuery, AoisGeoJsonQueryVariables>(AoisGeoJsonDocument, options)
}
export function useAoisGeoJsonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AoisGeoJsonQuery, AoisGeoJsonQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AoisGeoJsonQuery, AoisGeoJsonQueryVariables>(AoisGeoJsonDocument, options)
}
export type AoisGeoJsonQueryHookResult = ReturnType<typeof useAoisGeoJsonQuery>
export type AoisGeoJsonLazyQueryHookResult = ReturnType<typeof useAoisGeoJsonLazyQuery>
export type AoisGeoJsonQueryResult = Apollo.QueryResult<AoisGeoJsonQuery, AoisGeoJsonQueryVariables>
export const ApplicationDocument = gql`
  query application($id: ID!) {
    application(id: $id) {
      data {
        ...Application
      }
    }
  }
  ${ApplicationFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${ApplicationNatureFragmentDoc}
  ${UserProfileLimitedFragmentDoc}
  ${ApprovalOnApplicationFragmentDoc}
`
export type ApplicationComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApplicationQuery, ApplicationQueryVariables>,
  "query"
> &
  ({ variables: ApplicationQueryVariables; skip?: boolean } | { skip: boolean })

export const ApplicationComponent = (props: ApplicationComponentProps) => (
  <ApolloReactComponents.Query<ApplicationQuery, ApplicationQueryVariables> query={ApplicationDocument} {...props} />
)

export function useApplicationQuery(baseOptions: Apollo.QueryHookOptions<ApplicationQuery, ApplicationQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationQuery, ApplicationQueryVariables>(ApplicationDocument, options)
}
export function useApplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationQuery, ApplicationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationQuery, ApplicationQueryVariables>(ApplicationDocument, options)
}
export type ApplicationQueryHookResult = ReturnType<typeof useApplicationQuery>
export type ApplicationLazyQueryHookResult = ReturnType<typeof useApplicationLazyQuery>
export type ApplicationQueryResult = Apollo.QueryResult<ApplicationQuery, ApplicationQueryVariables>
export const ApplicationApprovalOptionsDocument = gql`
  query applicationApprovalOptions($id: ID) {
    application(id: $id) {
      data {
        id
        attributes {
          uuid
          approvals(pagination: { limit: -1 }) {
            data {
              id
              attributes {
                name
                company {
                  data {
                    attributes {
                      name
                    }
                  }
                }
              }
            }
          }
          renewals(pagination: { limit: -1 }) {
            data {
              id
              attributes {
                name
                company {
                  data {
                    attributes {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export type ApplicationApprovalOptionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ApplicationApprovalOptionsQuery,
    ApplicationApprovalOptionsQueryVariables
  >,
  "query"
>

export const ApplicationApprovalOptionsComponent = (props: ApplicationApprovalOptionsComponentProps) => (
  <ApolloReactComponents.Query<ApplicationApprovalOptionsQuery, ApplicationApprovalOptionsQueryVariables>
    query={ApplicationApprovalOptionsDocument}
    {...props}
  />
)

export function useApplicationApprovalOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationApprovalOptionsQuery, ApplicationApprovalOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationApprovalOptionsQuery, ApplicationApprovalOptionsQueryVariables>(
    ApplicationApprovalOptionsDocument,
    options
  )
}
export function useApplicationApprovalOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationApprovalOptionsQuery, ApplicationApprovalOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationApprovalOptionsQuery, ApplicationApprovalOptionsQueryVariables>(
    ApplicationApprovalOptionsDocument,
    options
  )
}
export type ApplicationApprovalOptionsQueryHookResult = ReturnType<typeof useApplicationApprovalOptionsQuery>
export type ApplicationApprovalOptionsLazyQueryHookResult = ReturnType<typeof useApplicationApprovalOptionsLazyQuery>
export type ApplicationApprovalOptionsQueryResult = Apollo.QueryResult<
  ApplicationApprovalOptionsQuery,
  ApplicationApprovalOptionsQueryVariables
>
export const ApplicationEmailsDocument = gql`
  query applicationEmails($applicationId: ID!) {
    applicationEmails(input: { applicationId: $applicationId }) {
      data {
        id
        attributes {
          status
          direction
          deliveryStatus
          kind
          subject
          from
          to
          createdAt
          deliveredAt
        }
      }
    }
  }
`
export type ApplicationEmailsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApplicationEmailsQuery, ApplicationEmailsQueryVariables>,
  "query"
> &
  ({ variables: ApplicationEmailsQueryVariables; skip?: boolean } | { skip: boolean })

export const ApplicationEmailsComponent = (props: ApplicationEmailsComponentProps) => (
  <ApolloReactComponents.Query<ApplicationEmailsQuery, ApplicationEmailsQueryVariables>
    query={ApplicationEmailsDocument}
    {...props}
  />
)

export function useApplicationEmailsQuery(
  baseOptions: Apollo.QueryHookOptions<ApplicationEmailsQuery, ApplicationEmailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationEmailsQuery, ApplicationEmailsQueryVariables>(ApplicationEmailsDocument, options)
}
export function useApplicationEmailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationEmailsQuery, ApplicationEmailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationEmailsQuery, ApplicationEmailsQueryVariables>(
    ApplicationEmailsDocument,
    options
  )
}
export type ApplicationEmailsQueryHookResult = ReturnType<typeof useApplicationEmailsQuery>
export type ApplicationEmailsLazyQueryHookResult = ReturnType<typeof useApplicationEmailsLazyQuery>
export type ApplicationEmailsQueryResult = Apollo.QueryResult<ApplicationEmailsQuery, ApplicationEmailsQueryVariables>
export const ApplicationMethodsDocument = gql`
  query applicationMethods {
    applicationMethods {
      data {
        ...ApplicationMethod
      }
    }
  }
  ${ApplicationMethodFragmentDoc}
`
export type ApplicationMethodsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApplicationMethodsQuery, ApplicationMethodsQueryVariables>,
  "query"
>

export const ApplicationMethodsComponent = (props: ApplicationMethodsComponentProps) => (
  <ApolloReactComponents.Query<ApplicationMethodsQuery, ApplicationMethodsQueryVariables>
    query={ApplicationMethodsDocument}
    {...props}
  />
)

export function useApplicationMethodsQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationMethodsQuery, ApplicationMethodsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationMethodsQuery, ApplicationMethodsQueryVariables>(ApplicationMethodsDocument, options)
}
export function useApplicationMethodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationMethodsQuery, ApplicationMethodsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationMethodsQuery, ApplicationMethodsQueryVariables>(
    ApplicationMethodsDocument,
    options
  )
}
export type ApplicationMethodsQueryHookResult = ReturnType<typeof useApplicationMethodsQuery>
export type ApplicationMethodsLazyQueryHookResult = ReturnType<typeof useApplicationMethodsLazyQuery>
export type ApplicationMethodsQueryResult = Apollo.QueryResult<
  ApplicationMethodsQuery,
  ApplicationMethodsQueryVariables
>
export const ApplicationSearchOptionsDocument = gql`
  query applicationSearchOptions($filter: ApplicationFiltersInput) {
    applications(filters: $filter, sort: ["createdAt:DESC"], pagination: { limit: 20 }) {
      data {
        id
        attributes {
          title
          project {
            data {
              attributes {
                title
              }
            }
          }
        }
      }
    }
  }
`
export type ApplicationSearchOptionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApplicationSearchOptionsQuery, ApplicationSearchOptionsQueryVariables>,
  "query"
>

export const ApplicationSearchOptionsComponent = (props: ApplicationSearchOptionsComponentProps) => (
  <ApolloReactComponents.Query<ApplicationSearchOptionsQuery, ApplicationSearchOptionsQueryVariables>
    query={ApplicationSearchOptionsDocument}
    {...props}
  />
)

export function useApplicationSearchOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationSearchOptionsQuery, ApplicationSearchOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationSearchOptionsQuery, ApplicationSearchOptionsQueryVariables>(
    ApplicationSearchOptionsDocument,
    options
  )
}
export function useApplicationSearchOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationSearchOptionsQuery, ApplicationSearchOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationSearchOptionsQuery, ApplicationSearchOptionsQueryVariables>(
    ApplicationSearchOptionsDocument,
    options
  )
}
export type ApplicationSearchOptionsQueryHookResult = ReturnType<typeof useApplicationSearchOptionsQuery>
export type ApplicationSearchOptionsLazyQueryHookResult = ReturnType<typeof useApplicationSearchOptionsLazyQuery>
export type ApplicationSearchOptionsQueryResult = Apollo.QueryResult<
  ApplicationSearchOptionsQuery,
  ApplicationSearchOptionsQueryVariables
>
export const ApplicationTypesDocument = gql`
  query applicationTypes($filter: ApplicationTypeFiltersInput, $sort: [String] = ["createdAt:ASC"]) {
    applicationTypes(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...ApplicationType
      }
    }
  }
  ${ApplicationTypeFragmentDoc}
`
export type ApplicationTypesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApplicationTypesQuery, ApplicationTypesQueryVariables>,
  "query"
>

export const ApplicationTypesComponent = (props: ApplicationTypesComponentProps) => (
  <ApolloReactComponents.Query<ApplicationTypesQuery, ApplicationTypesQueryVariables>
    query={ApplicationTypesDocument}
    {...props}
  />
)

export function useApplicationTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationTypesQuery, ApplicationTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationTypesQuery, ApplicationTypesQueryVariables>(ApplicationTypesDocument, options)
}
export function useApplicationTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationTypesQuery, ApplicationTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationTypesQuery, ApplicationTypesQueryVariables>(ApplicationTypesDocument, options)
}
export type ApplicationTypesQueryHookResult = ReturnType<typeof useApplicationTypesQuery>
export type ApplicationTypesLazyQueryHookResult = ReturnType<typeof useApplicationTypesLazyQuery>
export type ApplicationTypesQueryResult = Apollo.QueryResult<ApplicationTypesQuery, ApplicationTypesQueryVariables>
export const ApplicationUnreadRepliesDocument = gql`
  query applicationUnreadReplies($input: ApplicationUnreadRepliesInput!) {
    applicationUnreadReplies(input: $input)
  }
`
export type ApplicationUnreadRepliesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApplicationUnreadRepliesQuery, ApplicationUnreadRepliesQueryVariables>,
  "query"
> &
  ({ variables: ApplicationUnreadRepliesQueryVariables; skip?: boolean } | { skip: boolean })

export const ApplicationUnreadRepliesComponent = (props: ApplicationUnreadRepliesComponentProps) => (
  <ApolloReactComponents.Query<ApplicationUnreadRepliesQuery, ApplicationUnreadRepliesQueryVariables>
    query={ApplicationUnreadRepliesDocument}
    {...props}
  />
)

export function useApplicationUnreadRepliesQuery(
  baseOptions: Apollo.QueryHookOptions<ApplicationUnreadRepliesQuery, ApplicationUnreadRepliesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationUnreadRepliesQuery, ApplicationUnreadRepliesQueryVariables>(
    ApplicationUnreadRepliesDocument,
    options
  )
}
export function useApplicationUnreadRepliesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationUnreadRepliesQuery, ApplicationUnreadRepliesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationUnreadRepliesQuery, ApplicationUnreadRepliesQueryVariables>(
    ApplicationUnreadRepliesDocument,
    options
  )
}
export type ApplicationUnreadRepliesQueryHookResult = ReturnType<typeof useApplicationUnreadRepliesQuery>
export type ApplicationUnreadRepliesLazyQueryHookResult = ReturnType<typeof useApplicationUnreadRepliesLazyQuery>
export type ApplicationUnreadRepliesQueryResult = Apollo.QueryResult<
  ApplicationUnreadRepliesQuery,
  ApplicationUnreadRepliesQueryVariables
>
export const ApplicationsDocument = gql`
  query applications(
    $filter: ApplicationFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    applications(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...Application
      }
      meta {
        ...Meta
      }
    }
  }
  ${ApplicationFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${ApplicationNatureFragmentDoc}
  ${UserProfileLimitedFragmentDoc}
  ${ApprovalOnApplicationFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ApplicationsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApplicationsQuery, ApplicationsQueryVariables>,
  "query"
>

export const ApplicationsComponent = (props: ApplicationsComponentProps) => (
  <ApolloReactComponents.Query<ApplicationsQuery, ApplicationsQueryVariables> query={ApplicationsDocument} {...props} />
)

export function useApplicationsQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationsQuery, ApplicationsQueryVariables>(ApplicationsDocument, options)
}
export function useApplicationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationsQuery, ApplicationsQueryVariables>(ApplicationsDocument, options)
}
export type ApplicationsQueryHookResult = ReturnType<typeof useApplicationsQuery>
export type ApplicationsLazyQueryHookResult = ReturnType<typeof useApplicationsLazyQuery>
export type ApplicationsQueryResult = Apollo.QueryResult<ApplicationsQuery, ApplicationsQueryVariables>
export const ApplicationsAutoApprovalTableDocument = gql`
  query applicationsAutoApprovalTable(
    $filter: ApplicationFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    applications(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          status
          category
          effectiveDateOnly
          title
          submittedDate
          approvedDate
          isIncidentRecorded
          approvals {
            data {
              id
              attributes {
                type
                isAffected
                status
                deliveryDate
                company {
                  data {
                    id
                    attributes {
                      organization {
                        data {
                          id
                          attributes {
                            slug
                          }
                        }
                      }
                      name
                    }
                  }
                }
              }
            }
          }
          project {
            data {
              id
              attributes {
                organization {
                  data {
                    id
                    attributes {
                      slug
                    }
                  }
                }
                geoJson {
                  data {
                    ...File
                  }
                }
              }
            }
          }
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${FileFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ApplicationsAutoApprovalTableComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ApplicationsAutoApprovalTableQuery,
    ApplicationsAutoApprovalTableQueryVariables
  >,
  "query"
>

export const ApplicationsAutoApprovalTableComponent = (props: ApplicationsAutoApprovalTableComponentProps) => (
  <ApolloReactComponents.Query<ApplicationsAutoApprovalTableQuery, ApplicationsAutoApprovalTableQueryVariables>
    query={ApplicationsAutoApprovalTableDocument}
    {...props}
  />
)

export function useApplicationsAutoApprovalTableQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationsAutoApprovalTableQuery, ApplicationsAutoApprovalTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationsAutoApprovalTableQuery, ApplicationsAutoApprovalTableQueryVariables>(
    ApplicationsAutoApprovalTableDocument,
    options
  )
}
export function useApplicationsAutoApprovalTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApplicationsAutoApprovalTableQuery,
    ApplicationsAutoApprovalTableQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationsAutoApprovalTableQuery, ApplicationsAutoApprovalTableQueryVariables>(
    ApplicationsAutoApprovalTableDocument,
    options
  )
}
export type ApplicationsAutoApprovalTableQueryHookResult = ReturnType<typeof useApplicationsAutoApprovalTableQuery>
export type ApplicationsAutoApprovalTableLazyQueryHookResult = ReturnType<
  typeof useApplicationsAutoApprovalTableLazyQuery
>
export type ApplicationsAutoApprovalTableQueryResult = Apollo.QueryResult<
  ApplicationsAutoApprovalTableQuery,
  ApplicationsAutoApprovalTableQueryVariables
>
export const ApplicationsNatureDocument = gql`
  query applicationsNature($filter: ApplicationNatureFiltersInput, $sort: [String] = ["createdAt:ASC"]) {
    applicationNatures(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...ApplicationNature
      }
    }
  }
  ${ApplicationNatureFragmentDoc}
  ${DocumentTypeFragmentDoc}
`
export type ApplicationsNatureComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApplicationsNatureQuery, ApplicationsNatureQueryVariables>,
  "query"
>

export const ApplicationsNatureComponent = (props: ApplicationsNatureComponentProps) => (
  <ApolloReactComponents.Query<ApplicationsNatureQuery, ApplicationsNatureQueryVariables>
    query={ApplicationsNatureDocument}
    {...props}
  />
)

export function useApplicationsNatureQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationsNatureQuery, ApplicationsNatureQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationsNatureQuery, ApplicationsNatureQueryVariables>(ApplicationsNatureDocument, options)
}
export function useApplicationsNatureLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsNatureQuery, ApplicationsNatureQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationsNatureQuery, ApplicationsNatureQueryVariables>(
    ApplicationsNatureDocument,
    options
  )
}
export type ApplicationsNatureQueryHookResult = ReturnType<typeof useApplicationsNatureQuery>
export type ApplicationsNatureLazyQueryHookResult = ReturnType<typeof useApplicationsNatureLazyQuery>
export type ApplicationsNatureQueryResult = Apollo.QueryResult<
  ApplicationsNatureQuery,
  ApplicationsNatureQueryVariables
>
export const ApplicationsOptionsDocument = gql`
  query applicationsOptions($filter: ApplicationFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    applications(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        id
        attributes {
          title
          project {
            data {
              attributes {
                title
              }
            }
          }
        }
      }
    }
  }
`
export type ApplicationsOptionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApplicationsOptionsQuery, ApplicationsOptionsQueryVariables>,
  "query"
>

export const ApplicationsOptionsComponent = (props: ApplicationsOptionsComponentProps) => (
  <ApolloReactComponents.Query<ApplicationsOptionsQuery, ApplicationsOptionsQueryVariables>
    query={ApplicationsOptionsDocument}
    {...props}
  />
)

export function useApplicationsOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationsOptionsQuery, ApplicationsOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationsOptionsQuery, ApplicationsOptionsQueryVariables>(
    ApplicationsOptionsDocument,
    options
  )
}
export function useApplicationsOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsOptionsQuery, ApplicationsOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationsOptionsQuery, ApplicationsOptionsQueryVariables>(
    ApplicationsOptionsDocument,
    options
  )
}
export type ApplicationsOptionsQueryHookResult = ReturnType<typeof useApplicationsOptionsQuery>
export type ApplicationsOptionsLazyQueryHookResult = ReturnType<typeof useApplicationsOptionsLazyQuery>
export type ApplicationsOptionsQueryResult = Apollo.QueryResult<
  ApplicationsOptionsQuery,
  ApplicationsOptionsQueryVariables
>
export const ApplicationsPageDocument = gql`
  query applicationsPage(
    $filter: ApplicationFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    applications(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          uuid
          status
          title
          createdAt
          submittedDate
          approvedDate
          progress
          approvals {
            data {
              id
              attributes {
                name
              }
            }
          }
          project {
            data {
              id
              attributes {
                owner {
                  data {
                    id
                    attributes {
                      company {
                        data {
                          id
                          attributes {
                            name
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          applicationType {
            data {
              id
              attributes {
                title
                slug
              }
            }
          }
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ApplicationsPageComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApplicationsPageQuery, ApplicationsPageQueryVariables>,
  "query"
>

export const ApplicationsPageComponent = (props: ApplicationsPageComponentProps) => (
  <ApolloReactComponents.Query<ApplicationsPageQuery, ApplicationsPageQueryVariables>
    query={ApplicationsPageDocument}
    {...props}
  />
)

export function useApplicationsPageQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationsPageQuery, ApplicationsPageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationsPageQuery, ApplicationsPageQueryVariables>(ApplicationsPageDocument, options)
}
export function useApplicationsPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsPageQuery, ApplicationsPageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationsPageQuery, ApplicationsPageQueryVariables>(ApplicationsPageDocument, options)
}
export type ApplicationsPageQueryHookResult = ReturnType<typeof useApplicationsPageQuery>
export type ApplicationsPageLazyQueryHookResult = ReturnType<typeof useApplicationsPageLazyQuery>
export type ApplicationsPageQueryResult = Apollo.QueryResult<ApplicationsPageQuery, ApplicationsPageQueryVariables>
export const ApplicationsServiceProviderStatisticsDocument = gql`
  query applicationsServiceProviderStatistics($filter: ApplicationFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    applications(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        id
        attributes {
          status
          createdAt
          isGovernmentWork
          approvals {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ApplicationsServiceProviderStatisticsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ApplicationsServiceProviderStatisticsQuery,
    ApplicationsServiceProviderStatisticsQueryVariables
  >,
  "query"
>

export const ApplicationsServiceProviderStatisticsComponent = (
  props: ApplicationsServiceProviderStatisticsComponentProps
) => (
  <ApolloReactComponents.Query<
    ApplicationsServiceProviderStatisticsQuery,
    ApplicationsServiceProviderStatisticsQueryVariables
  >
    query={ApplicationsServiceProviderStatisticsDocument}
    {...props}
  />
)

export function useApplicationsServiceProviderStatisticsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ApplicationsServiceProviderStatisticsQuery,
    ApplicationsServiceProviderStatisticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ApplicationsServiceProviderStatisticsQuery,
    ApplicationsServiceProviderStatisticsQueryVariables
  >(ApplicationsServiceProviderStatisticsDocument, options)
}
export function useApplicationsServiceProviderStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApplicationsServiceProviderStatisticsQuery,
    ApplicationsServiceProviderStatisticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ApplicationsServiceProviderStatisticsQuery,
    ApplicationsServiceProviderStatisticsQueryVariables
  >(ApplicationsServiceProviderStatisticsDocument, options)
}
export type ApplicationsServiceProviderStatisticsQueryHookResult = ReturnType<
  typeof useApplicationsServiceProviderStatisticsQuery
>
export type ApplicationsServiceProviderStatisticsLazyQueryHookResult = ReturnType<
  typeof useApplicationsServiceProviderStatisticsLazyQuery
>
export type ApplicationsServiceProviderStatisticsQueryResult = Apollo.QueryResult<
  ApplicationsServiceProviderStatisticsQuery,
  ApplicationsServiceProviderStatisticsQueryVariables
>
export const ApplicationsSiderStatisticsDocument = gql`
  query applicationsSiderStatistics($filter: ApplicationFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    applications(filters: $filter, sort: $sort, pagination: { pageSize: 10 }) {
      data {
        id
        attributes {
          createdAt
          title
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ApplicationsSiderStatisticsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ApplicationsSiderStatisticsQuery,
    ApplicationsSiderStatisticsQueryVariables
  >,
  "query"
>

export const ApplicationsSiderStatisticsComponent = (props: ApplicationsSiderStatisticsComponentProps) => (
  <ApolloReactComponents.Query<ApplicationsSiderStatisticsQuery, ApplicationsSiderStatisticsQueryVariables>
    query={ApplicationsSiderStatisticsDocument}
    {...props}
  />
)

export function useApplicationsSiderStatisticsQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationsSiderStatisticsQuery, ApplicationsSiderStatisticsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationsSiderStatisticsQuery, ApplicationsSiderStatisticsQueryVariables>(
    ApplicationsSiderStatisticsDocument,
    options
  )
}
export function useApplicationsSiderStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsSiderStatisticsQuery, ApplicationsSiderStatisticsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationsSiderStatisticsQuery, ApplicationsSiderStatisticsQueryVariables>(
    ApplicationsSiderStatisticsDocument,
    options
  )
}
export type ApplicationsSiderStatisticsQueryHookResult = ReturnType<typeof useApplicationsSiderStatisticsQuery>
export type ApplicationsSiderStatisticsLazyQueryHookResult = ReturnType<typeof useApplicationsSiderStatisticsLazyQuery>
export type ApplicationsSiderStatisticsQueryResult = Apollo.QueryResult<
  ApplicationsSiderStatisticsQuery,
  ApplicationsSiderStatisticsQueryVariables
>
export const ApplicationsStatusStatisticsDocument = gql`
  query applicationsStatusStatistics($filter: ApplicationFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    applications(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        id
        attributes {
          status
          createdAt
          approvedDate
          isGovernmentWork
          project {
            data {
              id
              attributes {
                applicant {
                  data {
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export type ApplicationsStatusStatisticsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ApplicationsStatusStatisticsQuery,
    ApplicationsStatusStatisticsQueryVariables
  >,
  "query"
>

export const ApplicationsStatusStatisticsComponent = (props: ApplicationsStatusStatisticsComponentProps) => (
  <ApolloReactComponents.Query<ApplicationsStatusStatisticsQuery, ApplicationsStatusStatisticsQueryVariables>
    query={ApplicationsStatusStatisticsDocument}
    {...props}
  />
)

export function useApplicationsStatusStatisticsQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationsStatusStatisticsQuery, ApplicationsStatusStatisticsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationsStatusStatisticsQuery, ApplicationsStatusStatisticsQueryVariables>(
    ApplicationsStatusStatisticsDocument,
    options
  )
}
export function useApplicationsStatusStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApplicationsStatusStatisticsQuery,
    ApplicationsStatusStatisticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationsStatusStatisticsQuery, ApplicationsStatusStatisticsQueryVariables>(
    ApplicationsStatusStatisticsDocument,
    options
  )
}
export type ApplicationsStatusStatisticsQueryHookResult = ReturnType<typeof useApplicationsStatusStatisticsQuery>
export type ApplicationsStatusStatisticsLazyQueryHookResult = ReturnType<
  typeof useApplicationsStatusStatisticsLazyQuery
>
export type ApplicationsStatusStatisticsQueryResult = Apollo.QueryResult<
  ApplicationsStatusStatisticsQuery,
  ApplicationsStatusStatisticsQueryVariables
>
export const ApplicationsTableDocument = gql`
  query applicationsTable(
    $filter: ApplicationFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    applications(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...ApplicationTable
      }
      meta {
        ...Meta
      }
    }
  }
  ${ApplicationTableFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ApplicationsTableComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApplicationsTableQuery, ApplicationsTableQueryVariables>,
  "query"
>

export const ApplicationsTableComponent = (props: ApplicationsTableComponentProps) => (
  <ApolloReactComponents.Query<ApplicationsTableQuery, ApplicationsTableQueryVariables>
    query={ApplicationsTableDocument}
    {...props}
  />
)

export function useApplicationsTableQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationsTableQuery, ApplicationsTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationsTableQuery, ApplicationsTableQueryVariables>(ApplicationsTableDocument, options)
}
export function useApplicationsTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsTableQuery, ApplicationsTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationsTableQuery, ApplicationsTableQueryVariables>(
    ApplicationsTableDocument,
    options
  )
}
export type ApplicationsTableQueryHookResult = ReturnType<typeof useApplicationsTableQuery>
export type ApplicationsTableLazyQueryHookResult = ReturnType<typeof useApplicationsTableLazyQuery>
export type ApplicationsTableQueryResult = Apollo.QueryResult<ApplicationsTableQuery, ApplicationsTableQueryVariables>
export const ApplicationsTotalStatisticsDocument = gql`
  query applicationsTotalStatistics($filter: ApplicationFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    applications(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        id
        attributes {
          status
          createdAt
          project {
            data {
              attributes {
                start
                end
              }
            }
          }
        }
      }
    }
  }
`
export type ApplicationsTotalStatisticsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ApplicationsTotalStatisticsQuery,
    ApplicationsTotalStatisticsQueryVariables
  >,
  "query"
>

export const ApplicationsTotalStatisticsComponent = (props: ApplicationsTotalStatisticsComponentProps) => (
  <ApolloReactComponents.Query<ApplicationsTotalStatisticsQuery, ApplicationsTotalStatisticsQueryVariables>
    query={ApplicationsTotalStatisticsDocument}
    {...props}
  />
)

export function useApplicationsTotalStatisticsQuery(
  baseOptions?: Apollo.QueryHookOptions<ApplicationsTotalStatisticsQuery, ApplicationsTotalStatisticsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationsTotalStatisticsQuery, ApplicationsTotalStatisticsQueryVariables>(
    ApplicationsTotalStatisticsDocument,
    options
  )
}
export function useApplicationsTotalStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsTotalStatisticsQuery, ApplicationsTotalStatisticsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationsTotalStatisticsQuery, ApplicationsTotalStatisticsQueryVariables>(
    ApplicationsTotalStatisticsDocument,
    options
  )
}
export type ApplicationsTotalStatisticsQueryHookResult = ReturnType<typeof useApplicationsTotalStatisticsQuery>
export type ApplicationsTotalStatisticsLazyQueryHookResult = ReturnType<typeof useApplicationsTotalStatisticsLazyQuery>
export type ApplicationsTotalStatisticsQueryResult = Apollo.QueryResult<
  ApplicationsTotalStatisticsQuery,
  ApplicationsTotalStatisticsQueryVariables
>
export const ApplicationsUnreadRepliesDocument = gql`
  query applicationsUnreadReplies($input: ApplicationsUnreadRepliesInput!) {
    applicationsUnreadReplies(input: $input) {
      applicationId
      unread
    }
  }
`
export type ApplicationsUnreadRepliesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApplicationsUnreadRepliesQuery, ApplicationsUnreadRepliesQueryVariables>,
  "query"
> &
  ({ variables: ApplicationsUnreadRepliesQueryVariables; skip?: boolean } | { skip: boolean })

export const ApplicationsUnreadRepliesComponent = (props: ApplicationsUnreadRepliesComponentProps) => (
  <ApolloReactComponents.Query<ApplicationsUnreadRepliesQuery, ApplicationsUnreadRepliesQueryVariables>
    query={ApplicationsUnreadRepliesDocument}
    {...props}
  />
)

export function useApplicationsUnreadRepliesQuery(
  baseOptions: Apollo.QueryHookOptions<ApplicationsUnreadRepliesQuery, ApplicationsUnreadRepliesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApplicationsUnreadRepliesQuery, ApplicationsUnreadRepliesQueryVariables>(
    ApplicationsUnreadRepliesDocument,
    options
  )
}
export function useApplicationsUnreadRepliesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsUnreadRepliesQuery, ApplicationsUnreadRepliesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApplicationsUnreadRepliesQuery, ApplicationsUnreadRepliesQueryVariables>(
    ApplicationsUnreadRepliesDocument,
    options
  )
}
export type ApplicationsUnreadRepliesQueryHookResult = ReturnType<typeof useApplicationsUnreadRepliesQuery>
export type ApplicationsUnreadRepliesLazyQueryHookResult = ReturnType<typeof useApplicationsUnreadRepliesLazyQuery>
export type ApplicationsUnreadRepliesQueryResult = Apollo.QueryResult<
  ApplicationsUnreadRepliesQuery,
  ApplicationsUnreadRepliesQueryVariables
>
export const ApprovalDocument = gql`
  query approval($id: ID!) {
    approval(id: $id) {
      data {
        ...Approval
      }
    }
  }
  ${ApprovalFragmentDoc}
  ${FileFragmentDoc}
  ${UserProfileLimitedFragmentDoc}
`
export type ApprovalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApprovalQuery, ApprovalQueryVariables>,
  "query"
> &
  ({ variables: ApprovalQueryVariables; skip?: boolean } | { skip: boolean })

export const ApprovalComponent = (props: ApprovalComponentProps) => (
  <ApolloReactComponents.Query<ApprovalQuery, ApprovalQueryVariables> query={ApprovalDocument} {...props} />
)

export function useApprovalQuery(baseOptions: Apollo.QueryHookOptions<ApprovalQuery, ApprovalQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApprovalQuery, ApprovalQueryVariables>(ApprovalDocument, options)
}
export function useApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApprovalQuery, ApprovalQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApprovalQuery, ApprovalQueryVariables>(ApprovalDocument, options)
}
export type ApprovalQueryHookResult = ReturnType<typeof useApprovalQuery>
export type ApprovalLazyQueryHookResult = ReturnType<typeof useApprovalLazyQuery>
export type ApprovalQueryResult = Apollo.QueryResult<ApprovalQuery, ApprovalQueryVariables>
export const ApprovalEmailsDocument = gql`
  query approvalEmails($approvalId: ID!) {
    approvalEmails(input: { approvalId: $approvalId }) {
      data {
        ...EmailMessage
      }
    }
  }
  ${EmailMessageFragmentDoc}
  ${FileFragmentDoc}
`
export type ApprovalEmailsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApprovalEmailsQuery, ApprovalEmailsQueryVariables>,
  "query"
> &
  ({ variables: ApprovalEmailsQueryVariables; skip?: boolean } | { skip: boolean })

export const ApprovalEmailsComponent = (props: ApprovalEmailsComponentProps) => (
  <ApolloReactComponents.Query<ApprovalEmailsQuery, ApprovalEmailsQueryVariables>
    query={ApprovalEmailsDocument}
    {...props}
  />
)

export function useApprovalEmailsQuery(
  baseOptions: Apollo.QueryHookOptions<ApprovalEmailsQuery, ApprovalEmailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApprovalEmailsQuery, ApprovalEmailsQueryVariables>(ApprovalEmailsDocument, options)
}
export function useApprovalEmailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApprovalEmailsQuery, ApprovalEmailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApprovalEmailsQuery, ApprovalEmailsQueryVariables>(ApprovalEmailsDocument, options)
}
export type ApprovalEmailsQueryHookResult = ReturnType<typeof useApprovalEmailsQuery>
export type ApprovalEmailsLazyQueryHookResult = ReturnType<typeof useApprovalEmailsLazyQuery>
export type ApprovalEmailsQueryResult = Apollo.QueryResult<ApprovalEmailsQuery, ApprovalEmailsQueryVariables>
export const ApprovalsDocument = gql`
  query approvals($filter: ApprovalFiltersInput, $sort: [String] = ["createdAt:DESC"], $pagination: PaginationArg) {
    approvals(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...Approval
      }
      meta {
        ...Meta
      }
    }
  }
  ${ApprovalFragmentDoc}
  ${FileFragmentDoc}
  ${UserProfileLimitedFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ApprovalsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApprovalsQuery, ApprovalsQueryVariables>,
  "query"
>

export const ApprovalsComponent = (props: ApprovalsComponentProps) => (
  <ApolloReactComponents.Query<ApprovalsQuery, ApprovalsQueryVariables> query={ApprovalsDocument} {...props} />
)

export function useApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<ApprovalsQuery, ApprovalsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApprovalsQuery, ApprovalsQueryVariables>(ApprovalsDocument, options)
}
export function useApprovalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApprovalsQuery, ApprovalsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApprovalsQuery, ApprovalsQueryVariables>(ApprovalsDocument, options)
}
export type ApprovalsQueryHookResult = ReturnType<typeof useApprovalsQuery>
export type ApprovalsLazyQueryHookResult = ReturnType<typeof useApprovalsLazyQuery>
export type ApprovalsQueryResult = Apollo.QueryResult<ApprovalsQuery, ApprovalsQueryVariables>
export const ApprovalsTableDocument = gql`
  query approvalsTable(
    $filter: ApprovalFiltersInput
    $sort: [String] = ["deliveryDate:DESC"]
    $pagination: PaginationArg
  ) {
    approvals(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...ApprovalTable
      }
      meta {
        ...Meta
      }
    }
  }
  ${ApprovalTableFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ApprovalsTableComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApprovalsTableQuery, ApprovalsTableQueryVariables>,
  "query"
>

export const ApprovalsTableComponent = (props: ApprovalsTableComponentProps) => (
  <ApolloReactComponents.Query<ApprovalsTableQuery, ApprovalsTableQueryVariables>
    query={ApprovalsTableDocument}
    {...props}
  />
)

export function useApprovalsTableQuery(
  baseOptions?: Apollo.QueryHookOptions<ApprovalsTableQuery, ApprovalsTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApprovalsTableQuery, ApprovalsTableQueryVariables>(ApprovalsTableDocument, options)
}
export function useApprovalsTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApprovalsTableQuery, ApprovalsTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApprovalsTableQuery, ApprovalsTableQueryVariables>(ApprovalsTableDocument, options)
}
export type ApprovalsTableQueryHookResult = ReturnType<typeof useApprovalsTableQuery>
export type ApprovalsTableLazyQueryHookResult = ReturnType<typeof useApprovalsTableLazyQuery>
export type ApprovalsTableQueryResult = Apollo.QueryResult<ApprovalsTableQuery, ApprovalsTableQueryVariables>
export const ApprovalsUnreadRepliesDocument = gql`
  query approvalsUnreadReplies($applicationId: ID!) {
    approvalsUnreadReplies(input: { applicationId: $applicationId }) {
      approvalId
      unread
    }
  }
`
export type ApprovalsUnreadRepliesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ApprovalsUnreadRepliesQuery, ApprovalsUnreadRepliesQueryVariables>,
  "query"
> &
  ({ variables: ApprovalsUnreadRepliesQueryVariables; skip?: boolean } | { skip: boolean })

export const ApprovalsUnreadRepliesComponent = (props: ApprovalsUnreadRepliesComponentProps) => (
  <ApolloReactComponents.Query<ApprovalsUnreadRepliesQuery, ApprovalsUnreadRepliesQueryVariables>
    query={ApprovalsUnreadRepliesDocument}
    {...props}
  />
)

export function useApprovalsUnreadRepliesQuery(
  baseOptions: Apollo.QueryHookOptions<ApprovalsUnreadRepliesQuery, ApprovalsUnreadRepliesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ApprovalsUnreadRepliesQuery, ApprovalsUnreadRepliesQueryVariables>(
    ApprovalsUnreadRepliesDocument,
    options
  )
}
export function useApprovalsUnreadRepliesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApprovalsUnreadRepliesQuery, ApprovalsUnreadRepliesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ApprovalsUnreadRepliesQuery, ApprovalsUnreadRepliesQueryVariables>(
    ApprovalsUnreadRepliesDocument,
    options
  )
}
export type ApprovalsUnreadRepliesQueryHookResult = ReturnType<typeof useApprovalsUnreadRepliesQuery>
export type ApprovalsUnreadRepliesLazyQueryHookResult = ReturnType<typeof useApprovalsUnreadRepliesLazyQuery>
export type ApprovalsUnreadRepliesQueryResult = Apollo.QueryResult<
  ApprovalsUnreadRepliesQuery,
  ApprovalsUnreadRepliesQueryVariables
>
export const AreaDocument = gql`
  query area($id: ID!) {
    area(id: $id) {
      data {
        ...Area
      }
    }
  }
  ${AreaFragmentDoc}
  ${FileFragmentDoc}
`
export type AreaComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<AreaQuery, AreaQueryVariables>,
  "query"
> &
  ({ variables: AreaQueryVariables; skip?: boolean } | { skip: boolean })

export const AreaComponent = (props: AreaComponentProps) => (
  <ApolloReactComponents.Query<AreaQuery, AreaQueryVariables> query={AreaDocument} {...props} />
)

export function useAreaQuery(baseOptions: Apollo.QueryHookOptions<AreaQuery, AreaQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AreaQuery, AreaQueryVariables>(AreaDocument, options)
}
export function useAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreaQuery, AreaQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AreaQuery, AreaQueryVariables>(AreaDocument, options)
}
export type AreaQueryHookResult = ReturnType<typeof useAreaQuery>
export type AreaLazyQueryHookResult = ReturnType<typeof useAreaLazyQuery>
export type AreaQueryResult = Apollo.QueryResult<AreaQuery, AreaQueryVariables>
export const AreasDocument = gql`
  query areas($filter: AreaFiltersInput, $sort: [String] = ["createdAt:DESC"], $pagination: PaginationArg) {
    areas(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...Area
      }
      meta {
        ...Meta
      }
    }
  }
  ${AreaFragmentDoc}
  ${FileFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type AreasComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<AreasQuery, AreasQueryVariables>,
  "query"
>

export const AreasComponent = (props: AreasComponentProps) => (
  <ApolloReactComponents.Query<AreasQuery, AreasQueryVariables> query={AreasDocument} {...props} />
)

export function useAreasQuery(baseOptions?: Apollo.QueryHookOptions<AreasQuery, AreasQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AreasQuery, AreasQueryVariables>(AreasDocument, options)
}
export function useAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreasQuery, AreasQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AreasQuery, AreasQueryVariables>(AreasDocument, options)
}
export type AreasQueryHookResult = ReturnType<typeof useAreasQuery>
export type AreasLazyQueryHookResult = ReturnType<typeof useAreasLazyQuery>
export type AreasQueryResult = Apollo.QueryResult<AreasQuery, AreasQueryVariables>
export const AreasGeoJsonDocument = gql`
  query areasGeoJson($filter: AreaFiltersInput, $sort: [String] = ["createdAt:DESC"], $pagination: PaginationArg) {
    areas(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          name
          type
          geoJson {
            data {
              ...File
            }
          }
          company {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${FileFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type AreasGeoJsonComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<AreasGeoJsonQuery, AreasGeoJsonQueryVariables>,
  "query"
>

export const AreasGeoJsonComponent = (props: AreasGeoJsonComponentProps) => (
  <ApolloReactComponents.Query<AreasGeoJsonQuery, AreasGeoJsonQueryVariables> query={AreasGeoJsonDocument} {...props} />
)

export function useAreasGeoJsonQuery(
  baseOptions?: Apollo.QueryHookOptions<AreasGeoJsonQuery, AreasGeoJsonQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AreasGeoJsonQuery, AreasGeoJsonQueryVariables>(AreasGeoJsonDocument, options)
}
export function useAreasGeoJsonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AreasGeoJsonQuery, AreasGeoJsonQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AreasGeoJsonQuery, AreasGeoJsonQueryVariables>(AreasGeoJsonDocument, options)
}
export type AreasGeoJsonQueryHookResult = ReturnType<typeof useAreasGeoJsonQuery>
export type AreasGeoJsonLazyQueryHookResult = ReturnType<typeof useAreasGeoJsonLazyQuery>
export type AreasGeoJsonQueryResult = Apollo.QueryResult<AreasGeoJsonQuery, AreasGeoJsonQueryVariables>
export const AreasSpatialStatusDocument = gql`
  query areasSpatialStatus($ids: [ID!]!) {
    areasSpatialStatus(ids: $ids) {
      available
      error
      items {
        areaId
        synced
        cellCount
        updatedAt
        active
      }
    }
  }
`
export type AreasSpatialStatusComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<AreasSpatialStatusQuery, AreasSpatialStatusQueryVariables>,
  "query"
> &
  ({ variables: AreasSpatialStatusQueryVariables; skip?: boolean } | { skip: boolean })

export const AreasSpatialStatusComponent = (props: AreasSpatialStatusComponentProps) => (
  <ApolloReactComponents.Query<AreasSpatialStatusQuery, AreasSpatialStatusQueryVariables>
    query={AreasSpatialStatusDocument}
    {...props}
  />
)

export function useAreasSpatialStatusQuery(
  baseOptions: Apollo.QueryHookOptions<AreasSpatialStatusQuery, AreasSpatialStatusQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AreasSpatialStatusQuery, AreasSpatialStatusQueryVariables>(AreasSpatialStatusDocument, options)
}
export function useAreasSpatialStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AreasSpatialStatusQuery, AreasSpatialStatusQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AreasSpatialStatusQuery, AreasSpatialStatusQueryVariables>(
    AreasSpatialStatusDocument,
    options
  )
}
export type AreasSpatialStatusQueryHookResult = ReturnType<typeof useAreasSpatialStatusQuery>
export type AreasSpatialStatusLazyQueryHookResult = ReturnType<typeof useAreasSpatialStatusLazyQuery>
export type AreasSpatialStatusQueryResult = Apollo.QueryResult<
  AreasSpatialStatusQuery,
  AreasSpatialStatusQueryVariables
>
export const AssistanceRequestDocument = gql`
  query assistanceRequest($id: ID!) {
    assistanceRequest(id: $id) {
      data {
        ...AssistanceRequest
      }
    }
  }
  ${AssistanceRequestFragmentDoc}
`
export type AssistanceRequestComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<AssistanceRequestQuery, AssistanceRequestQueryVariables>,
  "query"
> &
  ({ variables: AssistanceRequestQueryVariables; skip?: boolean } | { skip: boolean })

export const AssistanceRequestComponent = (props: AssistanceRequestComponentProps) => (
  <ApolloReactComponents.Query<AssistanceRequestQuery, AssistanceRequestQueryVariables>
    query={AssistanceRequestDocument}
    {...props}
  />
)

export function useAssistanceRequestQuery(
  baseOptions: Apollo.QueryHookOptions<AssistanceRequestQuery, AssistanceRequestQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AssistanceRequestQuery, AssistanceRequestQueryVariables>(AssistanceRequestDocument, options)
}
export function useAssistanceRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AssistanceRequestQuery, AssistanceRequestQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AssistanceRequestQuery, AssistanceRequestQueryVariables>(
    AssistanceRequestDocument,
    options
  )
}
export type AssistanceRequestQueryHookResult = ReturnType<typeof useAssistanceRequestQuery>
export type AssistanceRequestLazyQueryHookResult = ReturnType<typeof useAssistanceRequestLazyQuery>
export type AssistanceRequestQueryResult = Apollo.QueryResult<AssistanceRequestQuery, AssistanceRequestQueryVariables>
export const AssistanceRequestsDocument = gql`
  query assistanceRequests(
    $filter: AssistanceRequestFiltersInput
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    assistanceRequests(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...AssistanceRequest
      }
      meta {
        ...Meta
      }
    }
  }
  ${AssistanceRequestFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type AssistanceRequestsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<AssistanceRequestsQuery, AssistanceRequestsQueryVariables>,
  "query"
>

export const AssistanceRequestsComponent = (props: AssistanceRequestsComponentProps) => (
  <ApolloReactComponents.Query<AssistanceRequestsQuery, AssistanceRequestsQueryVariables>
    query={AssistanceRequestsDocument}
    {...props}
  />
)

export function useAssistanceRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<AssistanceRequestsQuery, AssistanceRequestsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AssistanceRequestsQuery, AssistanceRequestsQueryVariables>(AssistanceRequestsDocument, options)
}
export function useAssistanceRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AssistanceRequestsQuery, AssistanceRequestsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AssistanceRequestsQuery, AssistanceRequestsQueryVariables>(
    AssistanceRequestsDocument,
    options
  )
}
export type AssistanceRequestsQueryHookResult = ReturnType<typeof useAssistanceRequestsQuery>
export type AssistanceRequestsLazyQueryHookResult = ReturnType<typeof useAssistanceRequestsLazyQuery>
export type AssistanceRequestsQueryResult = Apollo.QueryResult<
  AssistanceRequestsQuery,
  AssistanceRequestsQueryVariables
>
export const ClientApplicationsDocument = gql`
  query clientApplications(
    $filter: ApplicationFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    applications(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          project {
            data {
              id
              attributes {
                owner {
                  data {
                    id
                    attributes {
                      fullName
                      primaryEmail
                    }
                  }
                }
              }
            }
          }
          uuid
          status
          title
          createdAt
          submittedDate
          applicationType {
            data {
              id
              attributes {
                title
              }
            }
          }
          company {
            data {
              id
              attributes {
                name
              }
            }
          }
          progress
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ClientApplicationsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ClientApplicationsQuery, ClientApplicationsQueryVariables>,
  "query"
>

export const ClientApplicationsComponent = (props: ClientApplicationsComponentProps) => (
  <ApolloReactComponents.Query<ClientApplicationsQuery, ClientApplicationsQueryVariables>
    query={ClientApplicationsDocument}
    {...props}
  />
)

export function useClientApplicationsQuery(
  baseOptions?: Apollo.QueryHookOptions<ClientApplicationsQuery, ClientApplicationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ClientApplicationsQuery, ClientApplicationsQueryVariables>(ClientApplicationsDocument, options)
}
export function useClientApplicationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ClientApplicationsQuery, ClientApplicationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ClientApplicationsQuery, ClientApplicationsQueryVariables>(
    ClientApplicationsDocument,
    options
  )
}
export type ClientApplicationsQueryHookResult = ReturnType<typeof useClientApplicationsQuery>
export type ClientApplicationsLazyQueryHookResult = ReturnType<typeof useClientApplicationsLazyQuery>
export type ClientApplicationsQueryResult = Apollo.QueryResult<
  ClientApplicationsQuery,
  ClientApplicationsQueryVariables
>
export const CompaniesDocument = gql`
  query companies($filter: CompanyFiltersInput, $sort: [String] = ["createdAt:DESC"], $pagination: PaginationArg) {
    companies(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...Company
      }
      meta {
        ...Meta
      }
    }
  }
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${FileFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type CompaniesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompaniesQuery, CompaniesQueryVariables>,
  "query"
>

export const CompaniesComponent = (props: CompaniesComponentProps) => (
  <ApolloReactComponents.Query<CompaniesQuery, CompaniesQueryVariables> query={CompaniesDocument} {...props} />
)

export function useCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options)
}
export function useCompaniesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options)
}
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>
export type CompaniesQueryResult = Apollo.QueryResult<CompaniesQuery, CompaniesQueryVariables>
export const CompaniesAreasDocument = gql`
  query companiesAreas($filter: CompanyFiltersInput, $sort: [String] = ["createdAt:DESC"], $pagination: PaginationArg) {
    companies(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          name
          companyType
          fullCountryCoverage
          provincesCoverage
          districtsCoverage
          localMunicipalitiesCoverage
          provinceBorders(pagination: { limit: -1 }) {
            data {
              id
            }
          }
          districtMunicipalityBorders(pagination: { limit: -1 }) {
            data {
              id
            }
          }
          localMunicipalityBorders(pagination: { limit: -1 }) {
            data {
              id
            }
          }
          areas(filters: { category: { eq: "general" }, active: { eq: true } }, pagination: { limit: -1 }) {
            data {
              id
              attributes {
                name
                category
                geoJson {
                  data {
                    ...File
                  }
                }
              }
            }
          }
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${FileFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type CompaniesAreasComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompaniesAreasQuery, CompaniesAreasQueryVariables>,
  "query"
>

export const CompaniesAreasComponent = (props: CompaniesAreasComponentProps) => (
  <ApolloReactComponents.Query<CompaniesAreasQuery, CompaniesAreasQueryVariables>
    query={CompaniesAreasDocument}
    {...props}
  />
)

export function useCompaniesAreasQuery(
  baseOptions?: Apollo.QueryHookOptions<CompaniesAreasQuery, CompaniesAreasQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompaniesAreasQuery, CompaniesAreasQueryVariables>(CompaniesAreasDocument, options)
}
export function useCompaniesAreasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompaniesAreasQuery, CompaniesAreasQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompaniesAreasQuery, CompaniesAreasQueryVariables>(CompaniesAreasDocument, options)
}
export type CompaniesAreasQueryHookResult = ReturnType<typeof useCompaniesAreasQuery>
export type CompaniesAreasLazyQueryHookResult = ReturnType<typeof useCompaniesAreasLazyQuery>
export type CompaniesAreasQueryResult = Apollo.QueryResult<CompaniesAreasQuery, CompaniesAreasQueryVariables>
export const CompanyNamesDocument = gql`
  query companyNames($filter: CompanyFiltersInput, $sort: [String] = ["createdAt:DESC"], $pagination: PaginationArg) {
    companies(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...CompanyInfo
      }
      meta {
        ...Meta
      }
    }
  }
  ${CompanyInfoFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type CompanyNamesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompanyNamesQuery, CompanyNamesQueryVariables>,
  "query"
>

export const CompanyNamesComponent = (props: CompanyNamesComponentProps) => (
  <ApolloReactComponents.Query<CompanyNamesQuery, CompanyNamesQueryVariables> query={CompanyNamesDocument} {...props} />
)

export function useCompanyNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<CompanyNamesQuery, CompanyNamesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompanyNamesQuery, CompanyNamesQueryVariables>(CompanyNamesDocument, options)
}
export function useCompanyNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompanyNamesQuery, CompanyNamesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompanyNamesQuery, CompanyNamesQueryVariables>(CompanyNamesDocument, options)
}
export type CompanyNamesQueryHookResult = ReturnType<typeof useCompanyNamesQuery>
export type CompanyNamesLazyQueryHookResult = ReturnType<typeof useCompanyNamesLazyQuery>
export type CompanyNamesQueryResult = Apollo.QueryResult<CompanyNamesQuery, CompanyNamesQueryVariables>
export const CompaniesStatisticsChartDocument = gql`
  query companiesStatisticsChart(
    $filter: CompanyFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    companies(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          name
          statistics
        }
      }
    }
  }
`
export type CompaniesStatisticsChartComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompaniesStatisticsChartQuery, CompaniesStatisticsChartQueryVariables>,
  "query"
>

export const CompaniesStatisticsChartComponent = (props: CompaniesStatisticsChartComponentProps) => (
  <ApolloReactComponents.Query<CompaniesStatisticsChartQuery, CompaniesStatisticsChartQueryVariables>
    query={CompaniesStatisticsChartDocument}
    {...props}
  />
)

export function useCompaniesStatisticsChartQuery(
  baseOptions?: Apollo.QueryHookOptions<CompaniesStatisticsChartQuery, CompaniesStatisticsChartQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompaniesStatisticsChartQuery, CompaniesStatisticsChartQueryVariables>(
    CompaniesStatisticsChartDocument,
    options
  )
}
export function useCompaniesStatisticsChartLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompaniesStatisticsChartQuery, CompaniesStatisticsChartQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompaniesStatisticsChartQuery, CompaniesStatisticsChartQueryVariables>(
    CompaniesStatisticsChartDocument,
    options
  )
}
export type CompaniesStatisticsChartQueryHookResult = ReturnType<typeof useCompaniesStatisticsChartQuery>
export type CompaniesStatisticsChartLazyQueryHookResult = ReturnType<typeof useCompaniesStatisticsChartLazyQuery>
export type CompaniesStatisticsChartQueryResult = Apollo.QueryResult<
  CompaniesStatisticsChartQuery,
  CompaniesStatisticsChartQueryVariables
>
export const CompaniesWithAreaIdsDocument = gql`
  query companiesWithAreaIds(
    $filter: CompanyFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    companies(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...CompanyBase
        attributes {
          areas(pagination: { limit: -1 }) {
            data {
              id
            }
          }
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${CompanyBaseFragmentDoc}
  ${FileFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type CompaniesWithAreaIdsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompaniesWithAreaIdsQuery, CompaniesWithAreaIdsQueryVariables>,
  "query"
>

export const CompaniesWithAreaIdsComponent = (props: CompaniesWithAreaIdsComponentProps) => (
  <ApolloReactComponents.Query<CompaniesWithAreaIdsQuery, CompaniesWithAreaIdsQueryVariables>
    query={CompaniesWithAreaIdsDocument}
    {...props}
  />
)

export function useCompaniesWithAreaIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<CompaniesWithAreaIdsQuery, CompaniesWithAreaIdsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompaniesWithAreaIdsQuery, CompaniesWithAreaIdsQueryVariables>(
    CompaniesWithAreaIdsDocument,
    options
  )
}
export function useCompaniesWithAreaIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompaniesWithAreaIdsQuery, CompaniesWithAreaIdsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompaniesWithAreaIdsQuery, CompaniesWithAreaIdsQueryVariables>(
    CompaniesWithAreaIdsDocument,
    options
  )
}
export type CompaniesWithAreaIdsQueryHookResult = ReturnType<typeof useCompaniesWithAreaIdsQuery>
export type CompaniesWithAreaIdsLazyQueryHookResult = ReturnType<typeof useCompaniesWithAreaIdsLazyQuery>
export type CompaniesWithAreaIdsQueryResult = Apollo.QueryResult<
  CompaniesWithAreaIdsQuery,
  CompaniesWithAreaIdsQueryVariables
>
export const CompaniesWithEmployeesDocument = gql`
  query companiesWithEmployees($filter: CompanyFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    companies(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        id
        attributes {
          name
          companyType
          userProfiles {
            data {
              ...UserProfile
            }
          }
        }
      }
    }
  }
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type CompaniesWithEmployeesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompaniesWithEmployeesQuery, CompaniesWithEmployeesQueryVariables>,
  "query"
>

export const CompaniesWithEmployeesComponent = (props: CompaniesWithEmployeesComponentProps) => (
  <ApolloReactComponents.Query<CompaniesWithEmployeesQuery, CompaniesWithEmployeesQueryVariables>
    query={CompaniesWithEmployeesDocument}
    {...props}
  />
)

export function useCompaniesWithEmployeesQuery(
  baseOptions?: Apollo.QueryHookOptions<CompaniesWithEmployeesQuery, CompaniesWithEmployeesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompaniesWithEmployeesQuery, CompaniesWithEmployeesQueryVariables>(
    CompaniesWithEmployeesDocument,
    options
  )
}
export function useCompaniesWithEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompaniesWithEmployeesQuery, CompaniesWithEmployeesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompaniesWithEmployeesQuery, CompaniesWithEmployeesQueryVariables>(
    CompaniesWithEmployeesDocument,
    options
  )
}
export type CompaniesWithEmployeesQueryHookResult = ReturnType<typeof useCompaniesWithEmployeesQuery>
export type CompaniesWithEmployeesLazyQueryHookResult = ReturnType<typeof useCompaniesWithEmployeesLazyQuery>
export type CompaniesWithEmployeesQueryResult = Apollo.QueryResult<
  CompaniesWithEmployeesQuery,
  CompaniesWithEmployeesQueryVariables
>
export const CompanyDocument = gql`
  query company($id: ID!) {
    company(id: $id) {
      data {
        ...Company
      }
    }
  }
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${FileFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type CompanyComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompanyQuery, CompanyQueryVariables>,
  "query"
> &
  ({ variables: CompanyQueryVariables; skip?: boolean } | { skip: boolean })

export const CompanyComponent = (props: CompanyComponentProps) => (
  <ApolloReactComponents.Query<CompanyQuery, CompanyQueryVariables> query={CompanyDocument} {...props} />
)

export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options)
}
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options)
}
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>
export const CompanyForApprovalDocument = gql`
  query companyForApproval($id: ID!) {
    company(id: $id) {
      data {
        id
        attributes {
          name
          organization {
            data {
              id
            }
          }
          letterTemplates {
            data {
              id
              attributes {
                type
              }
            }
          }
          areas(pagination: { limit: -1 }) {
            data {
              id
              attributes {
                company {
                  data {
                    id
                  }
                }
                category
                geoJson {
                  data {
                    ...File
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${FileFragmentDoc}
`
export type CompanyForApprovalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompanyForApprovalQuery, CompanyForApprovalQueryVariables>,
  "query"
> &
  ({ variables: CompanyForApprovalQueryVariables; skip?: boolean } | { skip: boolean })

export const CompanyForApprovalComponent = (props: CompanyForApprovalComponentProps) => (
  <ApolloReactComponents.Query<CompanyForApprovalQuery, CompanyForApprovalQueryVariables>
    query={CompanyForApprovalDocument}
    {...props}
  />
)

export function useCompanyForApprovalQuery(
  baseOptions: Apollo.QueryHookOptions<CompanyForApprovalQuery, CompanyForApprovalQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompanyForApprovalQuery, CompanyForApprovalQueryVariables>(CompanyForApprovalDocument, options)
}
export function useCompanyForApprovalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompanyForApprovalQuery, CompanyForApprovalQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompanyForApprovalQuery, CompanyForApprovalQueryVariables>(
    CompanyForApprovalDocument,
    options
  )
}
export type CompanyForApprovalQueryHookResult = ReturnType<typeof useCompanyForApprovalQuery>
export type CompanyForApprovalLazyQueryHookResult = ReturnType<typeof useCompanyForApprovalLazyQuery>
export type CompanyForApprovalQueryResult = Apollo.QueryResult<
  CompanyForApprovalQuery,
  CompanyForApprovalQueryVariables
>
export const CompanyStatsDocument = gql`
  query companyStats($id: ID!) {
    company(id: $id) {
      data {
        id
        attributes {
          statisticsUpdate
          statistics
        }
      }
    }
  }
`
export type CompanyStatsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompanyStatsQuery, CompanyStatsQueryVariables>,
  "query"
> &
  ({ variables: CompanyStatsQueryVariables; skip?: boolean } | { skip: boolean })

export const CompanyStatsComponent = (props: CompanyStatsComponentProps) => (
  <ApolloReactComponents.Query<CompanyStatsQuery, CompanyStatsQueryVariables> query={CompanyStatsDocument} {...props} />
)

export function useCompanyStatsQuery(
  baseOptions: Apollo.QueryHookOptions<CompanyStatsQuery, CompanyStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompanyStatsQuery, CompanyStatsQueryVariables>(CompanyStatsDocument, options)
}
export function useCompanyStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompanyStatsQuery, CompanyStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompanyStatsQuery, CompanyStatsQueryVariables>(CompanyStatsDocument, options)
}
export type CompanyStatsQueryHookResult = ReturnType<typeof useCompanyStatsQuery>
export type CompanyStatsLazyQueryHookResult = ReturnType<typeof useCompanyStatsLazyQuery>
export type CompanyStatsQueryResult = Apollo.QueryResult<CompanyStatsQuery, CompanyStatsQueryVariables>
export const CompanyUpdateRequestDocument = gql`
  query companyUpdateRequest($id: ID!) {
    companyUpdateRequest(id: $id) {
      data {
        ...CompanyUpdateRequest
      }
    }
  }
  ${CompanyUpdateRequestFragmentDoc}
  ${FileFragmentDoc}
`
export type CompanyUpdateRequestComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompanyUpdateRequestQuery, CompanyUpdateRequestQueryVariables>,
  "query"
> &
  ({ variables: CompanyUpdateRequestQueryVariables; skip?: boolean } | { skip: boolean })

export const CompanyUpdateRequestComponent = (props: CompanyUpdateRequestComponentProps) => (
  <ApolloReactComponents.Query<CompanyUpdateRequestQuery, CompanyUpdateRequestQueryVariables>
    query={CompanyUpdateRequestDocument}
    {...props}
  />
)

export function useCompanyUpdateRequestQuery(
  baseOptions: Apollo.QueryHookOptions<CompanyUpdateRequestQuery, CompanyUpdateRequestQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompanyUpdateRequestQuery, CompanyUpdateRequestQueryVariables>(
    CompanyUpdateRequestDocument,
    options
  )
}
export function useCompanyUpdateRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompanyUpdateRequestQuery, CompanyUpdateRequestQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompanyUpdateRequestQuery, CompanyUpdateRequestQueryVariables>(
    CompanyUpdateRequestDocument,
    options
  )
}
export type CompanyUpdateRequestQueryHookResult = ReturnType<typeof useCompanyUpdateRequestQuery>
export type CompanyUpdateRequestLazyQueryHookResult = ReturnType<typeof useCompanyUpdateRequestLazyQuery>
export type CompanyUpdateRequestQueryResult = Apollo.QueryResult<
  CompanyUpdateRequestQuery,
  CompanyUpdateRequestQueryVariables
>
export const CompanyUpdateRequestsDocument = gql`
  query companyUpdateRequests(
    $filter: CompanyUpdateRequestFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    companyUpdateRequests(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          name
          status
          createdAt
          isArchived
          link
          applicant {
            data {
              id
              attributes {
                fullName
                primaryEmail
              }
            }
          }
          email
          phone
          address
          applicationMethods {
            data {
              id
              attributes {
                title
                slug
              }
            }
          }
          documents {
            data {
              id
            }
          }
          company {
            data {
              id
              attributes {
                name
              }
            }
          }
          comments
          applicationMethodDescription
          employees
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type CompanyUpdateRequestsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompanyUpdateRequestsQuery, CompanyUpdateRequestsQueryVariables>,
  "query"
>

export const CompanyUpdateRequestsComponent = (props: CompanyUpdateRequestsComponentProps) => (
  <ApolloReactComponents.Query<CompanyUpdateRequestsQuery, CompanyUpdateRequestsQueryVariables>
    query={CompanyUpdateRequestsDocument}
    {...props}
  />
)

export function useCompanyUpdateRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<CompanyUpdateRequestsQuery, CompanyUpdateRequestsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompanyUpdateRequestsQuery, CompanyUpdateRequestsQueryVariables>(
    CompanyUpdateRequestsDocument,
    options
  )
}
export function useCompanyUpdateRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompanyUpdateRequestsQuery, CompanyUpdateRequestsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompanyUpdateRequestsQuery, CompanyUpdateRequestsQueryVariables>(
    CompanyUpdateRequestsDocument,
    options
  )
}
export type CompanyUpdateRequestsQueryHookResult = ReturnType<typeof useCompanyUpdateRequestsQuery>
export type CompanyUpdateRequestsLazyQueryHookResult = ReturnType<typeof useCompanyUpdateRequestsLazyQuery>
export type CompanyUpdateRequestsQueryResult = Apollo.QueryResult<
  CompanyUpdateRequestsQuery,
  CompanyUpdateRequestsQueryVariables
>
export const CompletionCertificateDocument = gql`
  query completionCertificate($id: ID!) {
    completionCertificate(id: $id) {
      data {
        ...CompletionCertificate
      }
    }
  }
  ${CompletionCertificateFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type CompletionCertificateComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompletionCertificateQuery, CompletionCertificateQueryVariables>,
  "query"
> &
  ({ variables: CompletionCertificateQueryVariables; skip?: boolean } | { skip: boolean })

export const CompletionCertificateComponent = (props: CompletionCertificateComponentProps) => (
  <ApolloReactComponents.Query<CompletionCertificateQuery, CompletionCertificateQueryVariables>
    query={CompletionCertificateDocument}
    {...props}
  />
)

export function useCompletionCertificateQuery(
  baseOptions: Apollo.QueryHookOptions<CompletionCertificateQuery, CompletionCertificateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompletionCertificateQuery, CompletionCertificateQueryVariables>(
    CompletionCertificateDocument,
    options
  )
}
export function useCompletionCertificateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompletionCertificateQuery, CompletionCertificateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompletionCertificateQuery, CompletionCertificateQueryVariables>(
    CompletionCertificateDocument,
    options
  )
}
export type CompletionCertificateQueryHookResult = ReturnType<typeof useCompletionCertificateQuery>
export type CompletionCertificateLazyQueryHookResult = ReturnType<typeof useCompletionCertificateLazyQuery>
export type CompletionCertificateQueryResult = Apollo.QueryResult<
  CompletionCertificateQuery,
  CompletionCertificateQueryVariables
>
export const CompletionCertificatesDocument = gql`
  query completionCertificates(
    $filter: CompletionCertificateFiltersInput
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    completionCertificates(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...CompletionCertificate
      }
      meta {
        ...Meta
      }
    }
  }
  ${CompletionCertificateFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type CompletionCertificatesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CompletionCertificatesQuery, CompletionCertificatesQueryVariables>,
  "query"
>

export const CompletionCertificatesComponent = (props: CompletionCertificatesComponentProps) => (
  <ApolloReactComponents.Query<CompletionCertificatesQuery, CompletionCertificatesQueryVariables>
    query={CompletionCertificatesDocument}
    {...props}
  />
)

export function useCompletionCertificatesQuery(
  baseOptions?: Apollo.QueryHookOptions<CompletionCertificatesQuery, CompletionCertificatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompletionCertificatesQuery, CompletionCertificatesQueryVariables>(
    CompletionCertificatesDocument,
    options
  )
}
export function useCompletionCertificatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompletionCertificatesQuery, CompletionCertificatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompletionCertificatesQuery, CompletionCertificatesQueryVariables>(
    CompletionCertificatesDocument,
    options
  )
}
export type CompletionCertificatesQueryHookResult = ReturnType<typeof useCompletionCertificatesQuery>
export type CompletionCertificatesLazyQueryHookResult = ReturnType<typeof useCompletionCertificatesLazyQuery>
export type CompletionCertificatesQueryResult = Apollo.QueryResult<
  CompletionCertificatesQuery,
  CompletionCertificatesQueryVariables
>
export const ConfigurationsDocument = gql`
  query configurations(
    $filter: ConfigurationFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    configurations(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...Configuration
      }
      meta {
        ...Meta
      }
    }
  }
  ${ConfigurationFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ConfigurationsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ConfigurationsQuery, ConfigurationsQueryVariables>,
  "query"
>

export const ConfigurationsComponent = (props: ConfigurationsComponentProps) => (
  <ApolloReactComponents.Query<ConfigurationsQuery, ConfigurationsQueryVariables>
    query={ConfigurationsDocument}
    {...props}
  />
)

export function useConfigurationsQuery(
  baseOptions?: Apollo.QueryHookOptions<ConfigurationsQuery, ConfigurationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ConfigurationsQuery, ConfigurationsQueryVariables>(ConfigurationsDocument, options)
}
export function useConfigurationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationsQuery, ConfigurationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ConfigurationsQuery, ConfigurationsQueryVariables>(ConfigurationsDocument, options)
}
export type ConfigurationsQueryHookResult = ReturnType<typeof useConfigurationsQuery>
export type ConfigurationsLazyQueryHookResult = ReturnType<typeof useConfigurationsLazyQuery>
export type ConfigurationsQueryResult = Apollo.QueryResult<ConfigurationsQuery, ConfigurationsQueryVariables>
export const CountryBordersGeoJsonDocument = gql`
  query countryBordersGeoJson {
    countryBordersGeoJson
  }
`
export type CountryBordersGeoJsonComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CountryBordersGeoJsonQuery, CountryBordersGeoJsonQueryVariables>,
  "query"
>

export const CountryBordersGeoJsonComponent = (props: CountryBordersGeoJsonComponentProps) => (
  <ApolloReactComponents.Query<CountryBordersGeoJsonQuery, CountryBordersGeoJsonQueryVariables>
    query={CountryBordersGeoJsonDocument}
    {...props}
  />
)

export function useCountryBordersGeoJsonQuery(
  baseOptions?: Apollo.QueryHookOptions<CountryBordersGeoJsonQuery, CountryBordersGeoJsonQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CountryBordersGeoJsonQuery, CountryBordersGeoJsonQueryVariables>(
    CountryBordersGeoJsonDocument,
    options
  )
}
export function useCountryBordersGeoJsonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CountryBordersGeoJsonQuery, CountryBordersGeoJsonQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CountryBordersGeoJsonQuery, CountryBordersGeoJsonQueryVariables>(
    CountryBordersGeoJsonDocument,
    options
  )
}
export type CountryBordersGeoJsonQueryHookResult = ReturnType<typeof useCountryBordersGeoJsonQuery>
export type CountryBordersGeoJsonLazyQueryHookResult = ReturnType<typeof useCountryBordersGeoJsonLazyQuery>
export type CountryBordersGeoJsonQueryResult = Apollo.QueryResult<
  CountryBordersGeoJsonQuery,
  CountryBordersGeoJsonQueryVariables
>
export const CustomersTableDocument = gql`
  query customersTable(
    $filter: UserProfileFiltersInput
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    userProfiles(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          fullName
          status
          primaryEmail
          applicantProjects {
            data {
              id
              attributes {
                applications {
                  data {
                    id
                  }
                }
              }
            }
          }
          ownerProjects(pagination: { limit: -1 }) {
            data {
              id
              attributes {
                applications(pagination: { limit: -1 }) {
                  data {
                    id
                  }
                }
              }
            }
          }
          organization {
            data {
              id
              attributes {
                name
              }
            }
          }
          company {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type CustomersTableComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CustomersTableQuery, CustomersTableQueryVariables>,
  "query"
>

export const CustomersTableComponent = (props: CustomersTableComponentProps) => (
  <ApolloReactComponents.Query<CustomersTableQuery, CustomersTableQueryVariables>
    query={CustomersTableDocument}
    {...props}
  />
)

export function useCustomersTableQuery(
  baseOptions?: Apollo.QueryHookOptions<CustomersTableQuery, CustomersTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CustomersTableQuery, CustomersTableQueryVariables>(CustomersTableDocument, options)
}
export function useCustomersTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CustomersTableQuery, CustomersTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CustomersTableQuery, CustomersTableQueryVariables>(CustomersTableDocument, options)
}
export type CustomersTableQueryHookResult = ReturnType<typeof useCustomersTableQuery>
export type CustomersTableLazyQueryHookResult = ReturnType<typeof useCustomersTableLazyQuery>
export type CustomersTableQueryResult = Apollo.QueryResult<CustomersTableQuery, CustomersTableQueryVariables>
export const DeletableApplicationDocumentsDocument = gql`
  query deletableApplicationDocuments($applicationId: ID!) {
    deletableApplicationDocuments(applicationId: $applicationId)
  }
`
export type DeletableApplicationDocumentsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    DeletableApplicationDocumentsQuery,
    DeletableApplicationDocumentsQueryVariables
  >,
  "query"
> &
  ({ variables: DeletableApplicationDocumentsQueryVariables; skip?: boolean } | { skip: boolean })

export const DeletableApplicationDocumentsComponent = (props: DeletableApplicationDocumentsComponentProps) => (
  <ApolloReactComponents.Query<DeletableApplicationDocumentsQuery, DeletableApplicationDocumentsQueryVariables>
    query={DeletableApplicationDocumentsDocument}
    {...props}
  />
)

export function useDeletableApplicationDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<DeletableApplicationDocumentsQuery, DeletableApplicationDocumentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DeletableApplicationDocumentsQuery, DeletableApplicationDocumentsQueryVariables>(
    DeletableApplicationDocumentsDocument,
    options
  )
}
export function useDeletableApplicationDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DeletableApplicationDocumentsQuery,
    DeletableApplicationDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DeletableApplicationDocumentsQuery, DeletableApplicationDocumentsQueryVariables>(
    DeletableApplicationDocumentsDocument,
    options
  )
}
export type DeletableApplicationDocumentsQueryHookResult = ReturnType<typeof useDeletableApplicationDocumentsQuery>
export type DeletableApplicationDocumentsLazyQueryHookResult = ReturnType<
  typeof useDeletableApplicationDocumentsLazyQuery
>
export type DeletableApplicationDocumentsQueryResult = Apollo.QueryResult<
  DeletableApplicationDocumentsQuery,
  DeletableApplicationDocumentsQueryVariables
>
export const DeliveryConfirmationDocument = gql`
  query deliveryConfirmation($id: ID!) {
    deliveryConfirmation(id: $id) {
      data {
        id
        attributes {
          contactFullName
          position
          phone
          email
          notes
          company
          address
          deliveryDateTime
          byFullName
          byCompany
          byPhone
          byEmail
          deliveryPoint
          approval {
            data {
              id
            }
          }
          files {
            data {
              id
              attributes {
                name
                url
              }
            }
          }
          deliveryPdfReport {
            data {
              ...File
            }
          }
        }
      }
    }
  }
  ${FileFragmentDoc}
`
export type DeliveryConfirmationComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<DeliveryConfirmationQuery, DeliveryConfirmationQueryVariables>,
  "query"
> &
  ({ variables: DeliveryConfirmationQueryVariables; skip?: boolean } | { skip: boolean })

export const DeliveryConfirmationComponent = (props: DeliveryConfirmationComponentProps) => (
  <ApolloReactComponents.Query<DeliveryConfirmationQuery, DeliveryConfirmationQueryVariables>
    query={DeliveryConfirmationDocument}
    {...props}
  />
)

export function useDeliveryConfirmationQuery(
  baseOptions: Apollo.QueryHookOptions<DeliveryConfirmationQuery, DeliveryConfirmationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DeliveryConfirmationQuery, DeliveryConfirmationQueryVariables>(
    DeliveryConfirmationDocument,
    options
  )
}
export function useDeliveryConfirmationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DeliveryConfirmationQuery, DeliveryConfirmationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DeliveryConfirmationQuery, DeliveryConfirmationQueryVariables>(
    DeliveryConfirmationDocument,
    options
  )
}
export type DeliveryConfirmationQueryHookResult = ReturnType<typeof useDeliveryConfirmationQuery>
export type DeliveryConfirmationLazyQueryHookResult = ReturnType<typeof useDeliveryConfirmationLazyQuery>
export type DeliveryConfirmationQueryResult = Apollo.QueryResult<
  DeliveryConfirmationQuery,
  DeliveryConfirmationQueryVariables
>
export const DeliveryConfirmationsDocument = gql`
  query deliveryConfirmations($approvalId: ID!) {
    deliveryConfirmations(filters: { approval: { id: { eq: $approvalId } } }) {
      data {
        id
        attributes {
          contactFullName
          position
          phone
          email
          notes
          company
          address
          deliveryDateTime
          byFullName
          byCompany
          byPhone
          byEmail
          deliveryPoint
          approval {
            data {
              id
            }
          }
          files {
            data {
              id
              attributes {
                name
                url
              }
            }
          }
        }
      }
    }
  }
`
export type DeliveryConfirmationsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<DeliveryConfirmationsQuery, DeliveryConfirmationsQueryVariables>,
  "query"
> &
  ({ variables: DeliveryConfirmationsQueryVariables; skip?: boolean } | { skip: boolean })

export const DeliveryConfirmationsComponent = (props: DeliveryConfirmationsComponentProps) => (
  <ApolloReactComponents.Query<DeliveryConfirmationsQuery, DeliveryConfirmationsQueryVariables>
    query={DeliveryConfirmationsDocument}
    {...props}
  />
)

export function useDeliveryConfirmationsQuery(
  baseOptions: Apollo.QueryHookOptions<DeliveryConfirmationsQuery, DeliveryConfirmationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DeliveryConfirmationsQuery, DeliveryConfirmationsQueryVariables>(
    DeliveryConfirmationsDocument,
    options
  )
}
export function useDeliveryConfirmationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DeliveryConfirmationsQuery, DeliveryConfirmationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DeliveryConfirmationsQuery, DeliveryConfirmationsQueryVariables>(
    DeliveryConfirmationsDocument,
    options
  )
}
export type DeliveryConfirmationsQueryHookResult = ReturnType<typeof useDeliveryConfirmationsQuery>
export type DeliveryConfirmationsLazyQueryHookResult = ReturnType<typeof useDeliveryConfirmationsLazyQuery>
export type DeliveryConfirmationsQueryResult = Apollo.QueryResult<
  DeliveryConfirmationsQuery,
  DeliveryConfirmationsQueryVariables
>
export const DeliveryManagementApplicationsDocument = gql`
  query deliveryManagementApplications($filter: ApplicationFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    applications(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        id
        attributes {
          title
          uuid
          submittedDate
          applicationType {
            data {
              id
              attributes {
                title
              }
            }
          }
          project {
            data {
              id
              attributes {
                applicant {
                  data {
                    id
                    attributes {
                      fullName
                    }
                  }
                }
              }
            }
          }
          approvals(pagination: { limit: -1 }) {
            data {
              id
              attributes {
                uuid
                application {
                  data {
                    id
                    attributes {
                      title
                    }
                  }
                }
                company {
                  data {
                    id
                    attributes {
                      name
                      address
                      phone
                      emails
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export type DeliveryManagementApplicationsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    DeliveryManagementApplicationsQuery,
    DeliveryManagementApplicationsQueryVariables
  >,
  "query"
>

export const DeliveryManagementApplicationsComponent = (props: DeliveryManagementApplicationsComponentProps) => (
  <ApolloReactComponents.Query<DeliveryManagementApplicationsQuery, DeliveryManagementApplicationsQueryVariables>
    query={DeliveryManagementApplicationsDocument}
    {...props}
  />
)

export function useDeliveryManagementApplicationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DeliveryManagementApplicationsQuery,
    DeliveryManagementApplicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DeliveryManagementApplicationsQuery, DeliveryManagementApplicationsQueryVariables>(
    DeliveryManagementApplicationsDocument,
    options
  )
}
export function useDeliveryManagementApplicationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DeliveryManagementApplicationsQuery,
    DeliveryManagementApplicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DeliveryManagementApplicationsQuery, DeliveryManagementApplicationsQueryVariables>(
    DeliveryManagementApplicationsDocument,
    options
  )
}
export type DeliveryManagementApplicationsQueryHookResult = ReturnType<typeof useDeliveryManagementApplicationsQuery>
export type DeliveryManagementApplicationsLazyQueryHookResult = ReturnType<
  typeof useDeliveryManagementApplicationsLazyQuery
>
export type DeliveryManagementApplicationsQueryResult = Apollo.QueryResult<
  DeliveryManagementApplicationsQuery,
  DeliveryManagementApplicationsQueryVariables
>
export const DepositDocument = gql`
  query deposit($id: ID!) {
    deposit(id: $id) {
      data {
        ...Deposit
      }
    }
  }
  ${DepositFragmentDoc}
  ${FileFragmentDoc}
`
export type DepositComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<DepositQuery, DepositQueryVariables>,
  "query"
> &
  ({ variables: DepositQueryVariables; skip?: boolean } | { skip: boolean })

export const DepositComponent = (props: DepositComponentProps) => (
  <ApolloReactComponents.Query<DepositQuery, DepositQueryVariables> query={DepositDocument} {...props} />
)

export function useDepositQuery(baseOptions: Apollo.QueryHookOptions<DepositQuery, DepositQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DepositQuery, DepositQueryVariables>(DepositDocument, options)
}
export function useDepositLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepositQuery, DepositQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DepositQuery, DepositQueryVariables>(DepositDocument, options)
}
export type DepositQueryHookResult = ReturnType<typeof useDepositQuery>
export type DepositLazyQueryHookResult = ReturnType<typeof useDepositLazyQuery>
export type DepositQueryResult = Apollo.QueryResult<DepositQuery, DepositQueryVariables>
export const DepositsDocument = gql`
  query deposits($filter: DepositFiltersInput, $sort: [String] = ["createdAt:DESC"], $pagination: PaginationArg) {
    deposits(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...Deposit
      }
      meta {
        ...Meta
      }
    }
  }
  ${DepositFragmentDoc}
  ${FileFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type DepositsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<DepositsQuery, DepositsQueryVariables>,
  "query"
>

export const DepositsComponent = (props: DepositsComponentProps) => (
  <ApolloReactComponents.Query<DepositsQuery, DepositsQueryVariables> query={DepositsDocument} {...props} />
)

export function useDepositsQuery(baseOptions?: Apollo.QueryHookOptions<DepositsQuery, DepositsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DepositsQuery, DepositsQueryVariables>(DepositsDocument, options)
}
export function useDepositsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepositsQuery, DepositsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DepositsQuery, DepositsQueryVariables>(DepositsDocument, options)
}
export type DepositsQueryHookResult = ReturnType<typeof useDepositsQuery>
export type DepositsLazyQueryHookResult = ReturnType<typeof useDepositsLazyQuery>
export type DepositsQueryResult = Apollo.QueryResult<DepositsQuery, DepositsQueryVariables>
export const DiscussionTopicsDocument = gql`
  query discussionTopics($filter: DiscussionTopicFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    discussionTopics(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...DiscussionTopic
      }
    }
  }
  ${DiscussionTopicFragmentDoc}
`
export type DiscussionTopicsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<DiscussionTopicsQuery, DiscussionTopicsQueryVariables>,
  "query"
>

export const DiscussionTopicsComponent = (props: DiscussionTopicsComponentProps) => (
  <ApolloReactComponents.Query<DiscussionTopicsQuery, DiscussionTopicsQueryVariables>
    query={DiscussionTopicsDocument}
    {...props}
  />
)

export function useDiscussionTopicsQuery(
  baseOptions?: Apollo.QueryHookOptions<DiscussionTopicsQuery, DiscussionTopicsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DiscussionTopicsQuery, DiscussionTopicsQueryVariables>(DiscussionTopicsDocument, options)
}
export function useDiscussionTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DiscussionTopicsQuery, DiscussionTopicsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DiscussionTopicsQuery, DiscussionTopicsQueryVariables>(DiscussionTopicsDocument, options)
}
export type DiscussionTopicsQueryHookResult = ReturnType<typeof useDiscussionTopicsQuery>
export type DiscussionTopicsLazyQueryHookResult = ReturnType<typeof useDiscussionTopicsLazyQuery>
export type DiscussionTopicsQueryResult = Apollo.QueryResult<DiscussionTopicsQuery, DiscussionTopicsQueryVariables>
export const DistrictMunicipalityBordersGeoJsonDocument = gql`
  query districtMunicipalityBordersGeoJson {
    districtMunicipalityBordersGeoJson
  }
`
export type DistrictMunicipalityBordersGeoJsonComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    DistrictMunicipalityBordersGeoJsonQuery,
    DistrictMunicipalityBordersGeoJsonQueryVariables
  >,
  "query"
>

export const DistrictMunicipalityBordersGeoJsonComponent = (
  props: DistrictMunicipalityBordersGeoJsonComponentProps
) => (
  <ApolloReactComponents.Query<
    DistrictMunicipalityBordersGeoJsonQuery,
    DistrictMunicipalityBordersGeoJsonQueryVariables
  >
    query={DistrictMunicipalityBordersGeoJsonDocument}
    {...props}
  />
)

export function useDistrictMunicipalityBordersGeoJsonQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DistrictMunicipalityBordersGeoJsonQuery,
    DistrictMunicipalityBordersGeoJsonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DistrictMunicipalityBordersGeoJsonQuery, DistrictMunicipalityBordersGeoJsonQueryVariables>(
    DistrictMunicipalityBordersGeoJsonDocument,
    options
  )
}
export function useDistrictMunicipalityBordersGeoJsonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DistrictMunicipalityBordersGeoJsonQuery,
    DistrictMunicipalityBordersGeoJsonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DistrictMunicipalityBordersGeoJsonQuery, DistrictMunicipalityBordersGeoJsonQueryVariables>(
    DistrictMunicipalityBordersGeoJsonDocument,
    options
  )
}
export type DistrictMunicipalityBordersGeoJsonQueryHookResult = ReturnType<
  typeof useDistrictMunicipalityBordersGeoJsonQuery
>
export type DistrictMunicipalityBordersGeoJsonLazyQueryHookResult = ReturnType<
  typeof useDistrictMunicipalityBordersGeoJsonLazyQuery
>
export type DistrictMunicipalityBordersGeoJsonQueryResult = Apollo.QueryResult<
  DistrictMunicipalityBordersGeoJsonQuery,
  DistrictMunicipalityBordersGeoJsonQueryVariables
>
export const DocumentTypesDocument = gql`
  query documentTypes($filter: DocumentTypeFiltersInput, $sort: [String] = ["createdAt:ASC"]) {
    documentTypes(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...DocumentType
      }
    }
  }
  ${DocumentTypeFragmentDoc}
`
export type DocumentTypesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<DocumentTypesQuery, DocumentTypesQueryVariables>,
  "query"
>

export const DocumentTypesComponent = (props: DocumentTypesComponentProps) => (
  <ApolloReactComponents.Query<DocumentTypesQuery, DocumentTypesQueryVariables>
    query={DocumentTypesDocument}
    {...props}
  />
)

export function useDocumentTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<DocumentTypesQuery, DocumentTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DocumentTypesQuery, DocumentTypesQueryVariables>(DocumentTypesDocument, options)
}
export function useDocumentTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DocumentTypesQuery, DocumentTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DocumentTypesQuery, DocumentTypesQueryVariables>(DocumentTypesDocument, options)
}
export type DocumentTypesQueryHookResult = ReturnType<typeof useDocumentTypesQuery>
export type DocumentTypesLazyQueryHookResult = ReturnType<typeof useDocumentTypesLazyQuery>
export type DocumentTypesQueryResult = Apollo.QueryResult<DocumentTypesQuery, DocumentTypesQueryVariables>
export const EmailByIdDocument = gql`
  query emailById($id: ID!) {
    emailById(input: { id: $id }) {
      data {
        ...EmailMessage
      }
    }
  }
  ${EmailMessageFragmentDoc}
  ${FileFragmentDoc}
`
export type EmailByIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<EmailByIdQuery, EmailByIdQueryVariables>,
  "query"
> &
  ({ variables: EmailByIdQueryVariables; skip?: boolean } | { skip: boolean })

export const EmailByIdComponent = (props: EmailByIdComponentProps) => (
  <ApolloReactComponents.Query<EmailByIdQuery, EmailByIdQueryVariables> query={EmailByIdDocument} {...props} />
)

export function useEmailByIdQuery(baseOptions: Apollo.QueryHookOptions<EmailByIdQuery, EmailByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<EmailByIdQuery, EmailByIdQueryVariables>(EmailByIdDocument, options)
}
export function useEmailByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EmailByIdQuery, EmailByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<EmailByIdQuery, EmailByIdQueryVariables>(EmailByIdDocument, options)
}
export type EmailByIdQueryHookResult = ReturnType<typeof useEmailByIdQuery>
export type EmailByIdLazyQueryHookResult = ReturnType<typeof useEmailByIdLazyQuery>
export type EmailByIdQueryResult = Apollo.QueryResult<EmailByIdQuery, EmailByIdQueryVariables>
export const EmailLogsDocument = gql`
  query emailLogs($input: EmailLogsInput) {
    emailLogs(input: $input) {
      nextCursor
      items {
        id
        event
        timestamp
        sender
        recipient
        recipientDomain
        recipientProvider
        subject
        attachmentsCount
        size
      }
    }
  }
`
export type EmailLogsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<EmailLogsQuery, EmailLogsQueryVariables>,
  "query"
>

export const EmailLogsComponent = (props: EmailLogsComponentProps) => (
  <ApolloReactComponents.Query<EmailLogsQuery, EmailLogsQueryVariables> query={EmailLogsDocument} {...props} />
)

export function useEmailLogsQuery(baseOptions?: Apollo.QueryHookOptions<EmailLogsQuery, EmailLogsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<EmailLogsQuery, EmailLogsQueryVariables>(EmailLogsDocument, options)
}
export function useEmailLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EmailLogsQuery, EmailLogsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<EmailLogsQuery, EmailLogsQueryVariables>(EmailLogsDocument, options)
}
export type EmailLogsQueryHookResult = ReturnType<typeof useEmailLogsQuery>
export type EmailLogsLazyQueryHookResult = ReturnType<typeof useEmailLogsLazyQuery>
export type EmailLogsQueryResult = Apollo.QueryResult<EmailLogsQuery, EmailLogsQueryVariables>
export const EmailThreadDocument = gql`
  query emailThread($emailId: ID!) {
    emailThread(input: { emailId: $emailId }) {
      data {
        ...EmailMessage
      }
    }
  }
  ${EmailMessageFragmentDoc}
  ${FileFragmentDoc}
`
export type EmailThreadComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<EmailThreadQuery, EmailThreadQueryVariables>,
  "query"
> &
  ({ variables: EmailThreadQueryVariables; skip?: boolean } | { skip: boolean })

export const EmailThreadComponent = (props: EmailThreadComponentProps) => (
  <ApolloReactComponents.Query<EmailThreadQuery, EmailThreadQueryVariables> query={EmailThreadDocument} {...props} />
)

export function useEmailThreadQuery(baseOptions: Apollo.QueryHookOptions<EmailThreadQuery, EmailThreadQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<EmailThreadQuery, EmailThreadQueryVariables>(EmailThreadDocument, options)
}
export function useEmailThreadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EmailThreadQuery, EmailThreadQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<EmailThreadQuery, EmailThreadQueryVariables>(EmailThreadDocument, options)
}
export type EmailThreadQueryHookResult = ReturnType<typeof useEmailThreadQuery>
export type EmailThreadLazyQueryHookResult = ReturnType<typeof useEmailThreadLazyQuery>
export type EmailThreadQueryResult = Apollo.QueryResult<EmailThreadQuery, EmailThreadQueryVariables>
export const EnforcementDocument = gql`
  query enforcement($id: ID!) {
    enforcement(id: $id) {
      data {
        ...Enforcement
      }
    }
  }
  ${EnforcementFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type EnforcementComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<EnforcementQuery, EnforcementQueryVariables>,
  "query"
> &
  ({ variables: EnforcementQueryVariables; skip?: boolean } | { skip: boolean })

export const EnforcementComponent = (props: EnforcementComponentProps) => (
  <ApolloReactComponents.Query<EnforcementQuery, EnforcementQueryVariables> query={EnforcementDocument} {...props} />
)

export function useEnforcementQuery(baseOptions: Apollo.QueryHookOptions<EnforcementQuery, EnforcementQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<EnforcementQuery, EnforcementQueryVariables>(EnforcementDocument, options)
}
export function useEnforcementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EnforcementQuery, EnforcementQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<EnforcementQuery, EnforcementQueryVariables>(EnforcementDocument, options)
}
export type EnforcementQueryHookResult = ReturnType<typeof useEnforcementQuery>
export type EnforcementLazyQueryHookResult = ReturnType<typeof useEnforcementLazyQuery>
export type EnforcementQueryResult = Apollo.QueryResult<EnforcementQuery, EnforcementQueryVariables>
export const EnforcementsDocument = gql`
  query enforcements(
    $filter: EnforcementFiltersInput
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    enforcements(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...Enforcement
      }
      meta {
        ...Meta
      }
    }
  }
  ${EnforcementFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type EnforcementsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<EnforcementsQuery, EnforcementsQueryVariables>,
  "query"
>

export const EnforcementsComponent = (props: EnforcementsComponentProps) => (
  <ApolloReactComponents.Query<EnforcementsQuery, EnforcementsQueryVariables> query={EnforcementsDocument} {...props} />
)

export function useEnforcementsQuery(
  baseOptions?: Apollo.QueryHookOptions<EnforcementsQuery, EnforcementsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<EnforcementsQuery, EnforcementsQueryVariables>(EnforcementsDocument, options)
}
export function useEnforcementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EnforcementsQuery, EnforcementsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<EnforcementsQuery, EnforcementsQueryVariables>(EnforcementsDocument, options)
}
export type EnforcementsQueryHookResult = ReturnType<typeof useEnforcementsQuery>
export type EnforcementsLazyQueryHookResult = ReturnType<typeof useEnforcementsLazyQuery>
export type EnforcementsQueryResult = Apollo.QueryResult<EnforcementsQuery, EnforcementsQueryVariables>
export const ExternalApiClientsDocument = gql`
  query externalApiClients {
    externalApiClients {
      ...ExternalApiClient
    }
  }
  ${ExternalApiClientFragmentDoc}
`
export type ExternalApiClientsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ExternalApiClientsQuery, ExternalApiClientsQueryVariables>,
  "query"
>

export const ExternalApiClientsComponent = (props: ExternalApiClientsComponentProps) => (
  <ApolloReactComponents.Query<ExternalApiClientsQuery, ExternalApiClientsQueryVariables>
    query={ExternalApiClientsDocument}
    {...props}
  />
)

export function useExternalApiClientsQuery(
  baseOptions?: Apollo.QueryHookOptions<ExternalApiClientsQuery, ExternalApiClientsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ExternalApiClientsQuery, ExternalApiClientsQueryVariables>(ExternalApiClientsDocument, options)
}
export function useExternalApiClientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ExternalApiClientsQuery, ExternalApiClientsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ExternalApiClientsQuery, ExternalApiClientsQueryVariables>(
    ExternalApiClientsDocument,
    options
  )
}
export type ExternalApiClientsQueryHookResult = ReturnType<typeof useExternalApiClientsQuery>
export type ExternalApiClientsLazyQueryHookResult = ReturnType<typeof useExternalApiClientsLazyQuery>
export type ExternalApiClientsQueryResult = Apollo.QueryResult<
  ExternalApiClientsQuery,
  ExternalApiClientsQueryVariables
>
export const FeatureCatalogDocument = gql`
  query featureCatalog {
    featureCatalog {
      key
      label
      description
      category
      valueType
      defaultValue
      deprecated
      min
      max
      options
    }
  }
`
export type FeatureCatalogComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<FeatureCatalogQuery, FeatureCatalogQueryVariables>,
  "query"
>

export const FeatureCatalogComponent = (props: FeatureCatalogComponentProps) => (
  <ApolloReactComponents.Query<FeatureCatalogQuery, FeatureCatalogQueryVariables>
    query={FeatureCatalogDocument}
    {...props}
  />
)

export function useFeatureCatalogQuery(
  baseOptions?: Apollo.QueryHookOptions<FeatureCatalogQuery, FeatureCatalogQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FeatureCatalogQuery, FeatureCatalogQueryVariables>(FeatureCatalogDocument, options)
}
export function useFeatureCatalogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FeatureCatalogQuery, FeatureCatalogQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FeatureCatalogQuery, FeatureCatalogQueryVariables>(FeatureCatalogDocument, options)
}
export type FeatureCatalogQueryHookResult = ReturnType<typeof useFeatureCatalogQuery>
export type FeatureCatalogLazyQueryHookResult = ReturnType<typeof useFeatureCatalogLazyQuery>
export type FeatureCatalogQueryResult = Apollo.QueryResult<FeatureCatalogQuery, FeatureCatalogQueryVariables>
export const GetProjectIdByUidDocument = gql`
  query getProjectIdByUid($filter: ProjectFiltersInput) {
    projects(filters: $filter) {
      data {
        id
      }
    }
  }
`
export type GetProjectIdByUidComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetProjectIdByUidQuery, GetProjectIdByUidQueryVariables>,
  "query"
>

export const GetProjectIdByUidComponent = (props: GetProjectIdByUidComponentProps) => (
  <ApolloReactComponents.Query<GetProjectIdByUidQuery, GetProjectIdByUidQueryVariables>
    query={GetProjectIdByUidDocument}
    {...props}
  />
)

export function useGetProjectIdByUidQuery(
  baseOptions?: Apollo.QueryHookOptions<GetProjectIdByUidQuery, GetProjectIdByUidQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetProjectIdByUidQuery, GetProjectIdByUidQueryVariables>(GetProjectIdByUidDocument, options)
}
export function useGetProjectIdByUidLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProjectIdByUidQuery, GetProjectIdByUidQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetProjectIdByUidQuery, GetProjectIdByUidQueryVariables>(
    GetProjectIdByUidDocument,
    options
  )
}
export type GetProjectIdByUidQueryHookResult = ReturnType<typeof useGetProjectIdByUidQuery>
export type GetProjectIdByUidLazyQueryHookResult = ReturnType<typeof useGetProjectIdByUidLazyQuery>
export type GetProjectIdByUidQueryResult = Apollo.QueryResult<GetProjectIdByUidQuery, GetProjectIdByUidQueryVariables>
export const GetUserStartNoticeDocument = gql`
  query getUserStartNotice($id: ID!) {
    userProfile(id: $id) {
      data {
        id
        attributes {
          isStartNoticeShown
        }
      }
    }
  }
`
export type GetUserStartNoticeComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetUserStartNoticeQuery, GetUserStartNoticeQueryVariables>,
  "query"
> &
  ({ variables: GetUserStartNoticeQueryVariables; skip?: boolean } | { skip: boolean })

export const GetUserStartNoticeComponent = (props: GetUserStartNoticeComponentProps) => (
  <ApolloReactComponents.Query<GetUserStartNoticeQuery, GetUserStartNoticeQueryVariables>
    query={GetUserStartNoticeDocument}
    {...props}
  />
)

export function useGetUserStartNoticeQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserStartNoticeQuery, GetUserStartNoticeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserStartNoticeQuery, GetUserStartNoticeQueryVariables>(GetUserStartNoticeDocument, options)
}
export function useGetUserStartNoticeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserStartNoticeQuery, GetUserStartNoticeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserStartNoticeQuery, GetUserStartNoticeQueryVariables>(
    GetUserStartNoticeDocument,
    options
  )
}
export type GetUserStartNoticeQueryHookResult = ReturnType<typeof useGetUserStartNoticeQuery>
export type GetUserStartNoticeLazyQueryHookResult = ReturnType<typeof useGetUserStartNoticeLazyQuery>
export type GetUserStartNoticeQueryResult = Apollo.QueryResult<
  GetUserStartNoticeQuery,
  GetUserStartNoticeQueryVariables
>
export const GuideTopicDocument = gql`
  query guideTopic($id: ID!) {
    guideTopic(id: $id) {
      data {
        id
        attributes {
          title
          content
          video {
            data {
              attributes {
                name
                url
              }
            }
          }
          images {
            data {
              attributes {
                name
                url
              }
            }
          }
        }
      }
    }
  }
`
export type GuideTopicComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GuideTopicQuery, GuideTopicQueryVariables>,
  "query"
> &
  ({ variables: GuideTopicQueryVariables; skip?: boolean } | { skip: boolean })

export const GuideTopicComponent = (props: GuideTopicComponentProps) => (
  <ApolloReactComponents.Query<GuideTopicQuery, GuideTopicQueryVariables> query={GuideTopicDocument} {...props} />
)

export function useGuideTopicQuery(baseOptions: Apollo.QueryHookOptions<GuideTopicQuery, GuideTopicQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GuideTopicQuery, GuideTopicQueryVariables>(GuideTopicDocument, options)
}
export function useGuideTopicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GuideTopicQuery, GuideTopicQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GuideTopicQuery, GuideTopicQueryVariables>(GuideTopicDocument, options)
}
export type GuideTopicQueryHookResult = ReturnType<typeof useGuideTopicQuery>
export type GuideTopicLazyQueryHookResult = ReturnType<typeof useGuideTopicLazyQuery>
export type GuideTopicQueryResult = Apollo.QueryResult<GuideTopicQuery, GuideTopicQueryVariables>
export const GuideTopicsTableDocument = gql`
  query guideTopicsTable(
    $filter: GuideTopicFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    guideTopics(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          title
          slug
        }
      }
    }
  }
`
export type GuideTopicsTableComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GuideTopicsTableQuery, GuideTopicsTableQueryVariables>,
  "query"
>

export const GuideTopicsTableComponent = (props: GuideTopicsTableComponentProps) => (
  <ApolloReactComponents.Query<GuideTopicsTableQuery, GuideTopicsTableQueryVariables>
    query={GuideTopicsTableDocument}
    {...props}
  />
)

export function useGuideTopicsTableQuery(
  baseOptions?: Apollo.QueryHookOptions<GuideTopicsTableQuery, GuideTopicsTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GuideTopicsTableQuery, GuideTopicsTableQueryVariables>(GuideTopicsTableDocument, options)
}
export function useGuideTopicsTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GuideTopicsTableQuery, GuideTopicsTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GuideTopicsTableQuery, GuideTopicsTableQueryVariables>(GuideTopicsTableDocument, options)
}
export type GuideTopicsTableQueryHookResult = ReturnType<typeof useGuideTopicsTableQuery>
export type GuideTopicsTableLazyQueryHookResult = ReturnType<typeof useGuideTopicsTableLazyQuery>
export type GuideTopicsTableQueryResult = Apollo.QueryResult<GuideTopicsTableQuery, GuideTopicsTableQueryVariables>
export const InboundEmailArchiveIndexDocument = gql`
  query inboundEmailArchiveIndex($input: InboundEmailArchiveIndexInput!) {
    inboundEmailArchiveIndex(input: $input) {
      fileName
      csv
      count
    }
  }
`
export type InboundEmailArchiveIndexComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<InboundEmailArchiveIndexQuery, InboundEmailArchiveIndexQueryVariables>,
  "query"
> &
  ({ variables: InboundEmailArchiveIndexQueryVariables; skip?: boolean } | { skip: boolean })

export const InboundEmailArchiveIndexComponent = (props: InboundEmailArchiveIndexComponentProps) => (
  <ApolloReactComponents.Query<InboundEmailArchiveIndexQuery, InboundEmailArchiveIndexQueryVariables>
    query={InboundEmailArchiveIndexDocument}
    {...props}
  />
)

export function useInboundEmailArchiveIndexQuery(
  baseOptions: Apollo.QueryHookOptions<InboundEmailArchiveIndexQuery, InboundEmailArchiveIndexQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<InboundEmailArchiveIndexQuery, InboundEmailArchiveIndexQueryVariables>(
    InboundEmailArchiveIndexDocument,
    options
  )
}
export function useInboundEmailArchiveIndexLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InboundEmailArchiveIndexQuery, InboundEmailArchiveIndexQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<InboundEmailArchiveIndexQuery, InboundEmailArchiveIndexQueryVariables>(
    InboundEmailArchiveIndexDocument,
    options
  )
}
export type InboundEmailArchiveIndexQueryHookResult = ReturnType<typeof useInboundEmailArchiveIndexQuery>
export type InboundEmailArchiveIndexLazyQueryHookResult = ReturnType<typeof useInboundEmailArchiveIndexLazyQuery>
export type InboundEmailArchiveIndexQueryResult = Apollo.QueryResult<
  InboundEmailArchiveIndexQuery,
  InboundEmailArchiveIndexQueryVariables
>
export const IncomingEmailsDocument = gql`
  query incomingEmails($input: IncomingEmailsInput) {
    incomingEmails(input: $input) {
      total
      unread
      items {
        id
        status
        kind
        subject
        from
        to
        createdAt
        deliveredAt
        isRead
        attachmentsCount
        organizationId
        organizationName
        applicationId
        applicationTitle
        applicationUuid
        approvalId
        approvalCompanyName
        approvalName
      }
    }
  }
`
export type IncomingEmailsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<IncomingEmailsQuery, IncomingEmailsQueryVariables>,
  "query"
>

export const IncomingEmailsComponent = (props: IncomingEmailsComponentProps) => (
  <ApolloReactComponents.Query<IncomingEmailsQuery, IncomingEmailsQueryVariables>
    query={IncomingEmailsDocument}
    {...props}
  />
)

export function useIncomingEmailsQuery(
  baseOptions?: Apollo.QueryHookOptions<IncomingEmailsQuery, IncomingEmailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IncomingEmailsQuery, IncomingEmailsQueryVariables>(IncomingEmailsDocument, options)
}
export function useIncomingEmailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IncomingEmailsQuery, IncomingEmailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IncomingEmailsQuery, IncomingEmailsQueryVariables>(IncomingEmailsDocument, options)
}
export type IncomingEmailsQueryHookResult = ReturnType<typeof useIncomingEmailsQuery>
export type IncomingEmailsLazyQueryHookResult = ReturnType<typeof useIncomingEmailsLazyQuery>
export type IncomingEmailsQueryResult = Apollo.QueryResult<IncomingEmailsQuery, IncomingEmailsQueryVariables>
export const IncomingEmailsUnreadDocument = gql`
  query incomingEmailsUnread {
    incomingEmailsUnread
  }
`
export type IncomingEmailsUnreadComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<IncomingEmailsUnreadQuery, IncomingEmailsUnreadQueryVariables>,
  "query"
>

export const IncomingEmailsUnreadComponent = (props: IncomingEmailsUnreadComponentProps) => (
  <ApolloReactComponents.Query<IncomingEmailsUnreadQuery, IncomingEmailsUnreadQueryVariables>
    query={IncomingEmailsUnreadDocument}
    {...props}
  />
)

export function useIncomingEmailsUnreadQuery(
  baseOptions?: Apollo.QueryHookOptions<IncomingEmailsUnreadQuery, IncomingEmailsUnreadQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IncomingEmailsUnreadQuery, IncomingEmailsUnreadQueryVariables>(
    IncomingEmailsUnreadDocument,
    options
  )
}
export function useIncomingEmailsUnreadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IncomingEmailsUnreadQuery, IncomingEmailsUnreadQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IncomingEmailsUnreadQuery, IncomingEmailsUnreadQueryVariables>(
    IncomingEmailsUnreadDocument,
    options
  )
}
export type IncomingEmailsUnreadQueryHookResult = ReturnType<typeof useIncomingEmailsUnreadQuery>
export type IncomingEmailsUnreadLazyQueryHookResult = ReturnType<typeof useIncomingEmailsUnreadLazyQuery>
export type IncomingEmailsUnreadQueryResult = Apollo.QueryResult<
  IncomingEmailsUnreadQuery,
  IncomingEmailsUnreadQueryVariables
>
export const InviteRequiredDocTypesDocument = gql`
  query inviteRequiredDocTypes($filter: InviteRequiredDocumentTypeFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    inviteRequiredDocumentTypes(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...InviteRequiredDocumentType
      }
    }
  }
  ${InviteRequiredDocumentTypeFragmentDoc}
`
export type InviteRequiredDocTypesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<InviteRequiredDocTypesQuery, InviteRequiredDocTypesQueryVariables>,
  "query"
>

export const InviteRequiredDocTypesComponent = (props: InviteRequiredDocTypesComponentProps) => (
  <ApolloReactComponents.Query<InviteRequiredDocTypesQuery, InviteRequiredDocTypesQueryVariables>
    query={InviteRequiredDocTypesDocument}
    {...props}
  />
)

export function useInviteRequiredDocTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<InviteRequiredDocTypesQuery, InviteRequiredDocTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<InviteRequiredDocTypesQuery, InviteRequiredDocTypesQueryVariables>(
    InviteRequiredDocTypesDocument,
    options
  )
}
export function useInviteRequiredDocTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InviteRequiredDocTypesQuery, InviteRequiredDocTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<InviteRequiredDocTypesQuery, InviteRequiredDocTypesQueryVariables>(
    InviteRequiredDocTypesDocument,
    options
  )
}
export type InviteRequiredDocTypesQueryHookResult = ReturnType<typeof useInviteRequiredDocTypesQuery>
export type InviteRequiredDocTypesLazyQueryHookResult = ReturnType<typeof useInviteRequiredDocTypesLazyQuery>
export type InviteRequiredDocTypesQueryResult = Apollo.QueryResult<
  InviteRequiredDocTypesQuery,
  InviteRequiredDocTypesQueryVariables
>
export const InvoiceDocument = gql`
  query invoice($id: ID!) {
    invoice(id: $id) {
      data {
        ...Invoice
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${FileFragmentDoc}
`
export type InvoiceComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<InvoiceQuery, InvoiceQueryVariables>,
  "query"
> &
  ({ variables: InvoiceQueryVariables; skip?: boolean } | { skip: boolean })

export const InvoiceComponent = (props: InvoiceComponentProps) => (
  <ApolloReactComponents.Query<InvoiceQuery, InvoiceQueryVariables> query={InvoiceDocument} {...props} />
)

export function useInvoiceQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options)
}
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options)
}
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>
export type InvoiceQueryResult = Apollo.QueryResult<InvoiceQuery, InvoiceQueryVariables>
export const KickoffInviteDocument = gql`
  query kickoffInvite($id: ID!) {
    kickoffInvite(id: $id) {
      data {
        ...KickoffInvite
      }
    }
  }
  ${KickoffInviteFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type KickoffInviteComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<KickoffInviteQuery, KickoffInviteQueryVariables>,
  "query"
> &
  ({ variables: KickoffInviteQueryVariables; skip?: boolean } | { skip: boolean })

export const KickoffInviteComponent = (props: KickoffInviteComponentProps) => (
  <ApolloReactComponents.Query<KickoffInviteQuery, KickoffInviteQueryVariables>
    query={KickoffInviteDocument}
    {...props}
  />
)

export function useKickoffInviteQuery(
  baseOptions: Apollo.QueryHookOptions<KickoffInviteQuery, KickoffInviteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<KickoffInviteQuery, KickoffInviteQueryVariables>(KickoffInviteDocument, options)
}
export function useKickoffInviteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<KickoffInviteQuery, KickoffInviteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<KickoffInviteQuery, KickoffInviteQueryVariables>(KickoffInviteDocument, options)
}
export type KickoffInviteQueryHookResult = ReturnType<typeof useKickoffInviteQuery>
export type KickoffInviteLazyQueryHookResult = ReturnType<typeof useKickoffInviteLazyQuery>
export type KickoffInviteQueryResult = Apollo.QueryResult<KickoffInviteQuery, KickoffInviteQueryVariables>
export const KickoffInvitesDocument = gql`
  query kickoffInvites(
    $filter: KickoffInviteFiltersInput
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    kickoffInvites(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...KickoffInvite
      }
      meta {
        ...Meta
      }
    }
  }
  ${KickoffInviteFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type KickoffInvitesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<KickoffInvitesQuery, KickoffInvitesQueryVariables>,
  "query"
>

export const KickoffInvitesComponent = (props: KickoffInvitesComponentProps) => (
  <ApolloReactComponents.Query<KickoffInvitesQuery, KickoffInvitesQueryVariables>
    query={KickoffInvitesDocument}
    {...props}
  />
)

export function useKickoffInvitesQuery(
  baseOptions?: Apollo.QueryHookOptions<KickoffInvitesQuery, KickoffInvitesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<KickoffInvitesQuery, KickoffInvitesQueryVariables>(KickoffInvitesDocument, options)
}
export function useKickoffInvitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<KickoffInvitesQuery, KickoffInvitesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<KickoffInvitesQuery, KickoffInvitesQueryVariables>(KickoffInvitesDocument, options)
}
export type KickoffInvitesQueryHookResult = ReturnType<typeof useKickoffInvitesQuery>
export type KickoffInvitesLazyQueryHookResult = ReturnType<typeof useKickoffInvitesLazyQuery>
export type KickoffInvitesQueryResult = Apollo.QueryResult<KickoffInvitesQuery, KickoffInvitesQueryVariables>
export const KickoffRecordDocument = gql`
  query kickoffRecord($id: ID!) {
    kickoffRecord(id: $id) {
      data {
        ...KickoffRecord
      }
    }
  }
  ${KickoffRecordFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type KickoffRecordComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<KickoffRecordQuery, KickoffRecordQueryVariables>,
  "query"
> &
  ({ variables: KickoffRecordQueryVariables; skip?: boolean } | { skip: boolean })

export const KickoffRecordComponent = (props: KickoffRecordComponentProps) => (
  <ApolloReactComponents.Query<KickoffRecordQuery, KickoffRecordQueryVariables>
    query={KickoffRecordDocument}
    {...props}
  />
)

export function useKickoffRecordQuery(
  baseOptions: Apollo.QueryHookOptions<KickoffRecordQuery, KickoffRecordQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<KickoffRecordQuery, KickoffRecordQueryVariables>(KickoffRecordDocument, options)
}
export function useKickoffRecordLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<KickoffRecordQuery, KickoffRecordQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<KickoffRecordQuery, KickoffRecordQueryVariables>(KickoffRecordDocument, options)
}
export type KickoffRecordQueryHookResult = ReturnType<typeof useKickoffRecordQuery>
export type KickoffRecordLazyQueryHookResult = ReturnType<typeof useKickoffRecordLazyQuery>
export type KickoffRecordQueryResult = Apollo.QueryResult<KickoffRecordQuery, KickoffRecordQueryVariables>
export const KickoffRecordsDocument = gql`
  query kickoffRecords(
    $filter: KickoffRecordFiltersInput
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    kickoffRecords(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...KickoffRecord
      }
      meta {
        ...Meta
      }
    }
  }
  ${KickoffRecordFragmentDoc}
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type KickoffRecordsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<KickoffRecordsQuery, KickoffRecordsQueryVariables>,
  "query"
>

export const KickoffRecordsComponent = (props: KickoffRecordsComponentProps) => (
  <ApolloReactComponents.Query<KickoffRecordsQuery, KickoffRecordsQueryVariables>
    query={KickoffRecordsDocument}
    {...props}
  />
)

export function useKickoffRecordsQuery(
  baseOptions?: Apollo.QueryHookOptions<KickoffRecordsQuery, KickoffRecordsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<KickoffRecordsQuery, KickoffRecordsQueryVariables>(KickoffRecordsDocument, options)
}
export function useKickoffRecordsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<KickoffRecordsQuery, KickoffRecordsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<KickoffRecordsQuery, KickoffRecordsQueryVariables>(KickoffRecordsDocument, options)
}
export type KickoffRecordsQueryHookResult = ReturnType<typeof useKickoffRecordsQuery>
export type KickoffRecordsLazyQueryHookResult = ReturnType<typeof useKickoffRecordsLazyQuery>
export type KickoffRecordsQueryResult = Apollo.QueryResult<KickoffRecordsQuery, KickoffRecordsQueryVariables>
export const LetterTemplateDocument = gql`
  query letterTemplate($id: ID!) {
    letterTemplate(id: $id) {
      data {
        ...LetterTemplate
      }
    }
  }
  ${LetterTemplateFragmentDoc}
  ${FileFragmentDoc}
`
export type LetterTemplateComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<LetterTemplateQuery, LetterTemplateQueryVariables>,
  "query"
> &
  ({ variables: LetterTemplateQueryVariables; skip?: boolean } | { skip: boolean })

export const LetterTemplateComponent = (props: LetterTemplateComponentProps) => (
  <ApolloReactComponents.Query<LetterTemplateQuery, LetterTemplateQueryVariables>
    query={LetterTemplateDocument}
    {...props}
  />
)

export function useLetterTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<LetterTemplateQuery, LetterTemplateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LetterTemplateQuery, LetterTemplateQueryVariables>(LetterTemplateDocument, options)
}
export function useLetterTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LetterTemplateQuery, LetterTemplateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<LetterTemplateQuery, LetterTemplateQueryVariables>(LetterTemplateDocument, options)
}
export type LetterTemplateQueryHookResult = ReturnType<typeof useLetterTemplateQuery>
export type LetterTemplateLazyQueryHookResult = ReturnType<typeof useLetterTemplateLazyQuery>
export type LetterTemplateQueryResult = Apollo.QueryResult<LetterTemplateQuery, LetterTemplateQueryVariables>
export const LetterTemplatesDocument = gql`
  query letterTemplates($filter: LetterTemplateFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    letterTemplates(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...LetterTemplate
      }
    }
  }
  ${LetterTemplateFragmentDoc}
  ${FileFragmentDoc}
`
export type LetterTemplatesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<LetterTemplatesQuery, LetterTemplatesQueryVariables>,
  "query"
>

export const LetterTemplatesComponent = (props: LetterTemplatesComponentProps) => (
  <ApolloReactComponents.Query<LetterTemplatesQuery, LetterTemplatesQueryVariables>
    query={LetterTemplatesDocument}
    {...props}
  />
)

export function useLetterTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<LetterTemplatesQuery, LetterTemplatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LetterTemplatesQuery, LetterTemplatesQueryVariables>(LetterTemplatesDocument, options)
}
export function useLetterTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LetterTemplatesQuery, LetterTemplatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<LetterTemplatesQuery, LetterTemplatesQueryVariables>(LetterTemplatesDocument, options)
}
export type LetterTemplatesQueryHookResult = ReturnType<typeof useLetterTemplatesQuery>
export type LetterTemplatesLazyQueryHookResult = ReturnType<typeof useLetterTemplatesLazyQuery>
export type LetterTemplatesQueryResult = Apollo.QueryResult<LetterTemplatesQuery, LetterTemplatesQueryVariables>
export const LicenseUpdateRequestsDocument = gql`
  query licenseUpdateRequests(
    $filter: LicenseUpdateRequestFiltersInput
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    licenseUpdateRequests(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          createdAt
          status
          userProfile {
            data {
              id
              attributes {
                avatar {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                fullName
                status
                licenseType
                company {
                  data {
                    attributes {
                      name
                    }
                  }
                }
                address
                primaryPhone
                primaryEmail
              }
            }
          }
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type LicenseUpdateRequestsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<LicenseUpdateRequestsQuery, LicenseUpdateRequestsQueryVariables>,
  "query"
>

export const LicenseUpdateRequestsComponent = (props: LicenseUpdateRequestsComponentProps) => (
  <ApolloReactComponents.Query<LicenseUpdateRequestsQuery, LicenseUpdateRequestsQueryVariables>
    query={LicenseUpdateRequestsDocument}
    {...props}
  />
)

export function useLicenseUpdateRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<LicenseUpdateRequestsQuery, LicenseUpdateRequestsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LicenseUpdateRequestsQuery, LicenseUpdateRequestsQueryVariables>(
    LicenseUpdateRequestsDocument,
    options
  )
}
export function useLicenseUpdateRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LicenseUpdateRequestsQuery, LicenseUpdateRequestsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<LicenseUpdateRequestsQuery, LicenseUpdateRequestsQueryVariables>(
    LicenseUpdateRequestsDocument,
    options
  )
}
export type LicenseUpdateRequestsQueryHookResult = ReturnType<typeof useLicenseUpdateRequestsQuery>
export type LicenseUpdateRequestsLazyQueryHookResult = ReturnType<typeof useLicenseUpdateRequestsLazyQuery>
export type LicenseUpdateRequestsQueryResult = Apollo.QueryResult<
  LicenseUpdateRequestsQuery,
  LicenseUpdateRequestsQueryVariables
>
export const LocalMunicipalityBordersGeoJsonDocument = gql`
  query localMunicipalityBordersGeoJson {
    localMunicipalityBordersGeoJson
  }
`
export type LocalMunicipalityBordersGeoJsonComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    LocalMunicipalityBordersGeoJsonQuery,
    LocalMunicipalityBordersGeoJsonQueryVariables
  >,
  "query"
>

export const LocalMunicipalityBordersGeoJsonComponent = (props: LocalMunicipalityBordersGeoJsonComponentProps) => (
  <ApolloReactComponents.Query<LocalMunicipalityBordersGeoJsonQuery, LocalMunicipalityBordersGeoJsonQueryVariables>
    query={LocalMunicipalityBordersGeoJsonDocument}
    {...props}
  />
)

export function useLocalMunicipalityBordersGeoJsonQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LocalMunicipalityBordersGeoJsonQuery,
    LocalMunicipalityBordersGeoJsonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LocalMunicipalityBordersGeoJsonQuery, LocalMunicipalityBordersGeoJsonQueryVariables>(
    LocalMunicipalityBordersGeoJsonDocument,
    options
  )
}
export function useLocalMunicipalityBordersGeoJsonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LocalMunicipalityBordersGeoJsonQuery,
    LocalMunicipalityBordersGeoJsonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<LocalMunicipalityBordersGeoJsonQuery, LocalMunicipalityBordersGeoJsonQueryVariables>(
    LocalMunicipalityBordersGeoJsonDocument,
    options
  )
}
export type LocalMunicipalityBordersGeoJsonQueryHookResult = ReturnType<typeof useLocalMunicipalityBordersGeoJsonQuery>
export type LocalMunicipalityBordersGeoJsonLazyQueryHookResult = ReturnType<
  typeof useLocalMunicipalityBordersGeoJsonLazyQuery
>
export type LocalMunicipalityBordersGeoJsonQueryResult = Apollo.QueryResult<
  LocalMunicipalityBordersGeoJsonQuery,
  LocalMunicipalityBordersGeoJsonQueryVariables
>
export const MeDocument = gql`
  query me {
    me {
      id
      uuid
      email
      username
      paymentOverdueBlocked
      role {
        data {
          id
          attributes {
            name
          }
        }
      }
      userProfile {
        data {
          id
          attributes {
            fullName
            primaryEmail
            primaryPhone
            secondaryEmail
            secondaryPhone
            address
            position
            profileType
            orgAgentStatus
            platformType
            licenseType
            levelOfApproval
            batchAutoApproval
            isZoomNotice
            isNda
            isOnboarded
            isPrimaryApplicant
            isDefaultAgent
            status
            aoiGeneralStats
            aoiProvincesStats
            avatar {
              data {
                id
                attributes {
                  url
                }
              }
            }
            signature {
              data {
                id
                attributes {
                  name
                  url
                  hash
                }
              }
            }
            customerOf(pagination: { limit: -1 }) {
              data {
                id
              }
            }
            contractingCompanies {
              data {
                id
                attributes {
                  name
                }
              }
            }
            organization {
              data {
                id
                attributes {
                  slug
                  activationDate
                  createdAt
                  processingType
                }
              }
            }
            company {
              data {
                id
                attributes {
                  name
                  companyType
                  registrationNumber
                  vatNumber
                  address
                  emails
                  letterTemplates {
                    data {
                      id
                      attributes {
                        type
                      }
                    }
                  }
                  userProfiles(pagination: { limit: -1 }) {
                    data {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      organization {
        data {
          id
          attributes {
            type
            uuid
            slug
            activationDate
            email
            processingType
            automatedApproval
          }
        }
      }
    }
  }
`
export type MeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MeQuery, MeQueryVariables>, "query">

export const MeComponent = (props: MeComponentProps) => (
  <ApolloReactComponents.Query<MeQuery, MeQueryVariables> query={MeDocument} {...props} />
)

export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options)
}
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options)
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>
export const MigrationJobStatusDocument = gql`
  query migrationJobStatus($jobId: String!) {
    migrationJobStatus(jobId: $jobId) {
      jobId
      status
      progress
      statistics {
        total
        copied
        skipped
        failed
        updated
        currentFileIndex
        currentFileName
      }
      errors {
        fileId
        fileName
        error
      }
      createdAt
      updatedAt
      dryRun
    }
  }
`
export type MigrationJobStatusComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<MigrationJobStatusQuery, MigrationJobStatusQueryVariables>,
  "query"
> &
  ({ variables: MigrationJobStatusQueryVariables; skip?: boolean } | { skip: boolean })

export const MigrationJobStatusComponent = (props: MigrationJobStatusComponentProps) => (
  <ApolloReactComponents.Query<MigrationJobStatusQuery, MigrationJobStatusQueryVariables>
    query={MigrationJobStatusDocument}
    {...props}
  />
)

export function useMigrationJobStatusQuery(
  baseOptions: Apollo.QueryHookOptions<MigrationJobStatusQuery, MigrationJobStatusQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MigrationJobStatusQuery, MigrationJobStatusQueryVariables>(MigrationJobStatusDocument, options)
}
export function useMigrationJobStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MigrationJobStatusQuery, MigrationJobStatusQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MigrationJobStatusQuery, MigrationJobStatusQueryVariables>(
    MigrationJobStatusDocument,
    options
  )
}
export type MigrationJobStatusQueryHookResult = ReturnType<typeof useMigrationJobStatusQuery>
export type MigrationJobStatusLazyQueryHookResult = ReturnType<typeof useMigrationJobStatusLazyQuery>
export type MigrationJobStatusQueryResult = Apollo.QueryResult<
  MigrationJobStatusQuery,
  MigrationJobStatusQueryVariables
>
export const MyOrgFeaturesDocument = gql`
  query myOrgFeatures {
    myOrgFeatures
  }
`
export type MyOrgFeaturesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<MyOrgFeaturesQuery, MyOrgFeaturesQueryVariables>,
  "query"
>

export const MyOrgFeaturesComponent = (props: MyOrgFeaturesComponentProps) => (
  <ApolloReactComponents.Query<MyOrgFeaturesQuery, MyOrgFeaturesQueryVariables>
    query={MyOrgFeaturesDocument}
    {...props}
  />
)

export function useMyOrgFeaturesQuery(
  baseOptions?: Apollo.QueryHookOptions<MyOrgFeaturesQuery, MyOrgFeaturesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MyOrgFeaturesQuery, MyOrgFeaturesQueryVariables>(MyOrgFeaturesDocument, options)
}
export function useMyOrgFeaturesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyOrgFeaturesQuery, MyOrgFeaturesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MyOrgFeaturesQuery, MyOrgFeaturesQueryVariables>(MyOrgFeaturesDocument, options)
}
export type MyOrgFeaturesQueryHookResult = ReturnType<typeof useMyOrgFeaturesQuery>
export type MyOrgFeaturesLazyQueryHookResult = ReturnType<typeof useMyOrgFeaturesLazyQuery>
export type MyOrgFeaturesQueryResult = Apollo.QueryResult<MyOrgFeaturesQuery, MyOrgFeaturesQueryVariables>
export const NoteDocument = gql`
  query note($id: ID!) {
    note(id: $id) {
      data {
        ...Note
      }
    }
  }
  ${NoteFragmentDoc}
  ${FileFragmentDoc}
`
export type NoteComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<NoteQuery, NoteQueryVariables>,
  "query"
> &
  ({ variables: NoteQueryVariables; skip?: boolean } | { skip: boolean })

export const NoteComponent = (props: NoteComponentProps) => (
  <ApolloReactComponents.Query<NoteQuery, NoteQueryVariables> query={NoteDocument} {...props} />
)

export function useNoteQuery(baseOptions: Apollo.QueryHookOptions<NoteQuery, NoteQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NoteQuery, NoteQueryVariables>(NoteDocument, options)
}
export function useNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteQuery, NoteQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NoteQuery, NoteQueryVariables>(NoteDocument, options)
}
export type NoteQueryHookResult = ReturnType<typeof useNoteQuery>
export type NoteLazyQueryHookResult = ReturnType<typeof useNoteLazyQuery>
export type NoteQueryResult = Apollo.QueryResult<NoteQuery, NoteQueryVariables>
export const NotesDocument = gql`
  query notes($filter: NoteFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    notes(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...Note
      }
    }
  }
  ${NoteFragmentDoc}
  ${FileFragmentDoc}
`
export type NotesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<NotesQuery, NotesQueryVariables>,
  "query"
>

export const NotesComponent = (props: NotesComponentProps) => (
  <ApolloReactComponents.Query<NotesQuery, NotesQueryVariables> query={NotesDocument} {...props} />
)

export function useNotesQuery(baseOptions?: Apollo.QueryHookOptions<NotesQuery, NotesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options)
}
export function useNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesQuery, NotesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options)
}
export type NotesQueryHookResult = ReturnType<typeof useNotesQuery>
export type NotesLazyQueryHookResult = ReturnType<typeof useNotesLazyQuery>
export type NotesQueryResult = Apollo.QueryResult<NotesQuery, NotesQueryVariables>
export const NotificationsMessagesDocument = gql`
  query notificationsMessages(
    $filter: NotificationMessageFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    notificationMessages(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...NotificationMessage
      }
      meta {
        ...Meta
      }
    }
  }
  ${NotificationMessageFragmentDoc}
  ${FileFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type NotificationsMessagesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<NotificationsMessagesQuery, NotificationsMessagesQueryVariables>,
  "query"
>

export const NotificationsMessagesComponent = (props: NotificationsMessagesComponentProps) => (
  <ApolloReactComponents.Query<NotificationsMessagesQuery, NotificationsMessagesQueryVariables>
    query={NotificationsMessagesDocument}
    {...props}
  />
)

export function useNotificationsMessagesQuery(
  baseOptions?: Apollo.QueryHookOptions<NotificationsMessagesQuery, NotificationsMessagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NotificationsMessagesQuery, NotificationsMessagesQueryVariables>(
    NotificationsMessagesDocument,
    options
  )
}
export function useNotificationsMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NotificationsMessagesQuery, NotificationsMessagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NotificationsMessagesQuery, NotificationsMessagesQueryVariables>(
    NotificationsMessagesDocument,
    options
  )
}
export type NotificationsMessagesQueryHookResult = ReturnType<typeof useNotificationsMessagesQuery>
export type NotificationsMessagesLazyQueryHookResult = ReturnType<typeof useNotificationsMessagesLazyQuery>
export type NotificationsMessagesQueryResult = Apollo.QueryResult<
  NotificationsMessagesQuery,
  NotificationsMessagesQueryVariables
>
export const NotificationsMessagesUserTotalDocument = gql`
  query notificationsMessagesUserTotal(
    $filter: NotificationMessageFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    notificationMessages(filters: $filter, sort: $sort, pagination: $pagination) {
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type NotificationsMessagesUserTotalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    NotificationsMessagesUserTotalQuery,
    NotificationsMessagesUserTotalQueryVariables
  >,
  "query"
>

export const NotificationsMessagesUserTotalComponent = (props: NotificationsMessagesUserTotalComponentProps) => (
  <ApolloReactComponents.Query<NotificationsMessagesUserTotalQuery, NotificationsMessagesUserTotalQueryVariables>
    query={NotificationsMessagesUserTotalDocument}
    {...props}
  />
)

export function useNotificationsMessagesUserTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NotificationsMessagesUserTotalQuery,
    NotificationsMessagesUserTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NotificationsMessagesUserTotalQuery, NotificationsMessagesUserTotalQueryVariables>(
    NotificationsMessagesUserTotalDocument,
    options
  )
}
export function useNotificationsMessagesUserTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotificationsMessagesUserTotalQuery,
    NotificationsMessagesUserTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NotificationsMessagesUserTotalQuery, NotificationsMessagesUserTotalQueryVariables>(
    NotificationsMessagesUserTotalDocument,
    options
  )
}
export type NotificationsMessagesUserTotalQueryHookResult = ReturnType<typeof useNotificationsMessagesUserTotalQuery>
export type NotificationsMessagesUserTotalLazyQueryHookResult = ReturnType<
  typeof useNotificationsMessagesUserTotalLazyQuery
>
export type NotificationsMessagesUserTotalQueryResult = Apollo.QueryResult<
  NotificationsMessagesUserTotalQuery,
  NotificationsMessagesUserTotalQueryVariables
>
export const OrgUtilityGeometryDocument = gql`
  query orgUtilityGeometry($bbox: [Float!]!) {
    orgUtilityGeometryGeoJson(input: { bbox: $bbox }) {
      geojson
      cellsGeojson
      zoomInRequired
    }
  }
`
export type OrgUtilityGeometryComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<OrgUtilityGeometryQuery, OrgUtilityGeometryQueryVariables>,
  "query"
> &
  ({ variables: OrgUtilityGeometryQueryVariables; skip?: boolean } | { skip: boolean })

export const OrgUtilityGeometryComponent = (props: OrgUtilityGeometryComponentProps) => (
  <ApolloReactComponents.Query<OrgUtilityGeometryQuery, OrgUtilityGeometryQueryVariables>
    query={OrgUtilityGeometryDocument}
    {...props}
  />
)

export function useOrgUtilityGeometryQuery(
  baseOptions: Apollo.QueryHookOptions<OrgUtilityGeometryQuery, OrgUtilityGeometryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrgUtilityGeometryQuery, OrgUtilityGeometryQueryVariables>(OrgUtilityGeometryDocument, options)
}
export function useOrgUtilityGeometryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrgUtilityGeometryQuery, OrgUtilityGeometryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrgUtilityGeometryQuery, OrgUtilityGeometryQueryVariables>(
    OrgUtilityGeometryDocument,
    options
  )
}
export type OrgUtilityGeometryQueryHookResult = ReturnType<typeof useOrgUtilityGeometryQuery>
export type OrgUtilityGeometryLazyQueryHookResult = ReturnType<typeof useOrgUtilityGeometryLazyQuery>
export type OrgUtilityGeometryQueryResult = Apollo.QueryResult<
  OrgUtilityGeometryQuery,
  OrgUtilityGeometryQueryVariables
>
export const OrgWebsiteDocument = gql`
  query orgWebsite {
    orgWebsite {
      data {
        id
        attributes {
          orgHomePage {
            __typename
            ...OrgHome
          }
        }
      }
    }
  }
  ${OrgHomeFragmentDoc}
  ${FileFragmentDoc}
`
export type OrgWebsiteComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<OrgWebsiteQuery, OrgWebsiteQueryVariables>,
  "query"
>

export const OrgWebsiteComponent = (props: OrgWebsiteComponentProps) => (
  <ApolloReactComponents.Query<OrgWebsiteQuery, OrgWebsiteQueryVariables> query={OrgWebsiteDocument} {...props} />
)

export function useOrgWebsiteQuery(baseOptions?: Apollo.QueryHookOptions<OrgWebsiteQuery, OrgWebsiteQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrgWebsiteQuery, OrgWebsiteQueryVariables>(OrgWebsiteDocument, options)
}
export function useOrgWebsiteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrgWebsiteQuery, OrgWebsiteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrgWebsiteQuery, OrgWebsiteQueryVariables>(OrgWebsiteDocument, options)
}
export type OrgWebsiteQueryHookResult = ReturnType<typeof useOrgWebsiteQuery>
export type OrgWebsiteLazyQueryHookResult = ReturnType<typeof useOrgWebsiteLazyQuery>
export type OrgWebsiteQueryResult = Apollo.QueryResult<OrgWebsiteQuery, OrgWebsiteQueryVariables>
export const OrganizationDocument = gql`
  query organization($id: ID!) {
    organization(id: $id) {
      data {
        ...Organization
      }
    }
  }
  ${OrganizationFragmentDoc}
  ${FileFragmentDoc}
  ${ConfigurationFragmentDoc}
`
export type OrganizationComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<OrganizationQuery, OrganizationQueryVariables>,
  "query"
> &
  ({ variables: OrganizationQueryVariables; skip?: boolean } | { skip: boolean })

export const OrganizationComponent = (props: OrganizationComponentProps) => (
  <ApolloReactComponents.Query<OrganizationQuery, OrganizationQueryVariables> query={OrganizationDocument} {...props} />
)

export function useOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options)
}
export function useOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options)
}
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>
export const OrganizationCompaniesDocument = gql`
  query organizationCompanies($organizationId: ID!) {
    companies(filters: { organization: { id: { eq: $organizationId } } }, pagination: { limit: -1 }) {
      data {
        id
        attributes {
          companyType
        }
      }
    }
  }
`
export type OrganizationCompaniesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<OrganizationCompaniesQuery, OrganizationCompaniesQueryVariables>,
  "query"
> &
  ({ variables: OrganizationCompaniesQueryVariables; skip?: boolean } | { skip: boolean })

export const OrganizationCompaniesComponent = (props: OrganizationCompaniesComponentProps) => (
  <ApolloReactComponents.Query<OrganizationCompaniesQuery, OrganizationCompaniesQueryVariables>
    query={OrganizationCompaniesDocument}
    {...props}
  />
)

export function useOrganizationCompaniesQuery(
  baseOptions: Apollo.QueryHookOptions<OrganizationCompaniesQuery, OrganizationCompaniesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrganizationCompaniesQuery, OrganizationCompaniesQueryVariables>(
    OrganizationCompaniesDocument,
    options
  )
}
export function useOrganizationCompaniesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrganizationCompaniesQuery, OrganizationCompaniesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrganizationCompaniesQuery, OrganizationCompaniesQueryVariables>(
    OrganizationCompaniesDocument,
    options
  )
}
export type OrganizationCompaniesQueryHookResult = ReturnType<typeof useOrganizationCompaniesQuery>
export type OrganizationCompaniesLazyQueryHookResult = ReturnType<typeof useOrganizationCompaniesLazyQuery>
export type OrganizationCompaniesQueryResult = Apollo.QueryResult<
  OrganizationCompaniesQuery,
  OrganizationCompaniesQueryVariables
>
export const OrganizationFeatureHistoryDocument = gql`
  query organizationFeatureHistory($organizationId: Int!) {
    organizationFeatureHistory(organizationId: $organizationId) {
      id
      key
      previousValue
      newValue
      changedByEmail
      reason
      changedAt
      organization {
        id
        name
        slug
      }
    }
  }
`
export type OrganizationFeatureHistoryComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    OrganizationFeatureHistoryQuery,
    OrganizationFeatureHistoryQueryVariables
  >,
  "query"
> &
  ({ variables: OrganizationFeatureHistoryQueryVariables; skip?: boolean } | { skip: boolean })

export const OrganizationFeatureHistoryComponent = (props: OrganizationFeatureHistoryComponentProps) => (
  <ApolloReactComponents.Query<OrganizationFeatureHistoryQuery, OrganizationFeatureHistoryQueryVariables>
    query={OrganizationFeatureHistoryDocument}
    {...props}
  />
)

export function useOrganizationFeatureHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<OrganizationFeatureHistoryQuery, OrganizationFeatureHistoryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrganizationFeatureHistoryQuery, OrganizationFeatureHistoryQueryVariables>(
    OrganizationFeatureHistoryDocument,
    options
  )
}
export function useOrganizationFeatureHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrganizationFeatureHistoryQuery, OrganizationFeatureHistoryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrganizationFeatureHistoryQuery, OrganizationFeatureHistoryQueryVariables>(
    OrganizationFeatureHistoryDocument,
    options
  )
}
export type OrganizationFeatureHistoryQueryHookResult = ReturnType<typeof useOrganizationFeatureHistoryQuery>
export type OrganizationFeatureHistoryLazyQueryHookResult = ReturnType<typeof useOrganizationFeatureHistoryLazyQuery>
export type OrganizationFeatureHistoryQueryResult = Apollo.QueryResult<
  OrganizationFeatureHistoryQuery,
  OrganizationFeatureHistoryQueryVariables
>
export const OrganizationFeatureMatrixDocument = gql`
  query organizationFeatureMatrix {
    organizationFeatureMatrix {
      organizationId
      organizationName
      organizationSlug
      organizationLogoUrl
      organizationProcessingType
      organizationPaymentOverdue
      features {
        key
        value
        source
        expiresAt
      }
    }
  }
`
export type OrganizationFeatureMatrixComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<OrganizationFeatureMatrixQuery, OrganizationFeatureMatrixQueryVariables>,
  "query"
>

export const OrganizationFeatureMatrixComponent = (props: OrganizationFeatureMatrixComponentProps) => (
  <ApolloReactComponents.Query<OrganizationFeatureMatrixQuery, OrganizationFeatureMatrixQueryVariables>
    query={OrganizationFeatureMatrixDocument}
    {...props}
  />
)

export function useOrganizationFeatureMatrixQuery(
  baseOptions?: Apollo.QueryHookOptions<OrganizationFeatureMatrixQuery, OrganizationFeatureMatrixQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrganizationFeatureMatrixQuery, OrganizationFeatureMatrixQueryVariables>(
    OrganizationFeatureMatrixDocument,
    options
  )
}
export function useOrganizationFeatureMatrixLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrganizationFeatureMatrixQuery, OrganizationFeatureMatrixQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrganizationFeatureMatrixQuery, OrganizationFeatureMatrixQueryVariables>(
    OrganizationFeatureMatrixDocument,
    options
  )
}
export type OrganizationFeatureMatrixQueryHookResult = ReturnType<typeof useOrganizationFeatureMatrixQuery>
export type OrganizationFeatureMatrixLazyQueryHookResult = ReturnType<typeof useOrganizationFeatureMatrixLazyQuery>
export type OrganizationFeatureMatrixQueryResult = Apollo.QueryResult<
  OrganizationFeatureMatrixQuery,
  OrganizationFeatureMatrixQueryVariables
>
export const OrganizationGeneralStatsDocument = gql`
  query organizationGeneralStats($id: ID!) {
    organization(id: $id) {
      data {
        id
        attributes {
          generalStats
        }
      }
    }
  }
`
export type OrganizationGeneralStatsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<OrganizationGeneralStatsQuery, OrganizationGeneralStatsQueryVariables>,
  "query"
> &
  ({ variables: OrganizationGeneralStatsQueryVariables; skip?: boolean } | { skip: boolean })

export const OrganizationGeneralStatsComponent = (props: OrganizationGeneralStatsComponentProps) => (
  <ApolloReactComponents.Query<OrganizationGeneralStatsQuery, OrganizationGeneralStatsQueryVariables>
    query={OrganizationGeneralStatsDocument}
    {...props}
  />
)

export function useOrganizationGeneralStatsQuery(
  baseOptions: Apollo.QueryHookOptions<OrganizationGeneralStatsQuery, OrganizationGeneralStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrganizationGeneralStatsQuery, OrganizationGeneralStatsQueryVariables>(
    OrganizationGeneralStatsDocument,
    options
  )
}
export function useOrganizationGeneralStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrganizationGeneralStatsQuery, OrganizationGeneralStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrganizationGeneralStatsQuery, OrganizationGeneralStatsQueryVariables>(
    OrganizationGeneralStatsDocument,
    options
  )
}
export type OrganizationGeneralStatsQueryHookResult = ReturnType<typeof useOrganizationGeneralStatsQuery>
export type OrganizationGeneralStatsLazyQueryHookResult = ReturnType<typeof useOrganizationGeneralStatsLazyQuery>
export type OrganizationGeneralStatsQueryResult = Apollo.QueryResult<
  OrganizationGeneralStatsQuery,
  OrganizationGeneralStatsQueryVariables
>
export const OrganizationIdsDocument = gql`
  query organizationIds(
    $filter: OrganizationFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    organizations(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          name
          slug
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type OrganizationIdsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<OrganizationIdsQuery, OrganizationIdsQueryVariables>,
  "query"
>

export const OrganizationIdsComponent = (props: OrganizationIdsComponentProps) => (
  <ApolloReactComponents.Query<OrganizationIdsQuery, OrganizationIdsQueryVariables>
    query={OrganizationIdsDocument}
    {...props}
  />
)

export function useOrganizationIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<OrganizationIdsQuery, OrganizationIdsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrganizationIdsQuery, OrganizationIdsQueryVariables>(OrganizationIdsDocument, options)
}
export function useOrganizationIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrganizationIdsQuery, OrganizationIdsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrganizationIdsQuery, OrganizationIdsQueryVariables>(OrganizationIdsDocument, options)
}
export type OrganizationIdsQueryHookResult = ReturnType<typeof useOrganizationIdsQuery>
export type OrganizationIdsLazyQueryHookResult = ReturnType<typeof useOrganizationIdsLazyQuery>
export type OrganizationIdsQueryResult = Apollo.QueryResult<OrganizationIdsQuery, OrganizationIdsQueryVariables>
export const OrganizationStatsDocument = gql`
  query organizationStats($id: ID!) {
    organization(id: $id) {
      data {
        id
        attributes {
          statistics
          statisticsUpdate
        }
      }
    }
  }
`
export type OrganizationStatsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<OrganizationStatsQuery, OrganizationStatsQueryVariables>,
  "query"
> &
  ({ variables: OrganizationStatsQueryVariables; skip?: boolean } | { skip: boolean })

export const OrganizationStatsComponent = (props: OrganizationStatsComponentProps) => (
  <ApolloReactComponents.Query<OrganizationStatsQuery, OrganizationStatsQueryVariables>
    query={OrganizationStatsDocument}
    {...props}
  />
)

export function useOrganizationStatsQuery(
  baseOptions: Apollo.QueryHookOptions<OrganizationStatsQuery, OrganizationStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrganizationStatsQuery, OrganizationStatsQueryVariables>(OrganizationStatsDocument, options)
}
export function useOrganizationStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrganizationStatsQuery, OrganizationStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrganizationStatsQuery, OrganizationStatsQueryVariables>(
    OrganizationStatsDocument,
    options
  )
}
export type OrganizationStatsQueryHookResult = ReturnType<typeof useOrganizationStatsQuery>
export type OrganizationStatsLazyQueryHookResult = ReturnType<typeof useOrganizationStatsLazyQuery>
export type OrganizationStatsQueryResult = Apollo.QueryResult<OrganizationStatsQuery, OrganizationStatsQueryVariables>
export const OrganizationsDocument = gql`
  query organizations(
    $filter: OrganizationFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    organizations(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...Organization
      }
      meta {
        ...Meta
      }
    }
  }
  ${OrganizationFragmentDoc}
  ${FileFragmentDoc}
  ${ConfigurationFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type OrganizationsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<OrganizationsQuery, OrganizationsQueryVariables>,
  "query"
>

export const OrganizationsComponent = (props: OrganizationsComponentProps) => (
  <ApolloReactComponents.Query<OrganizationsQuery, OrganizationsQueryVariables>
    query={OrganizationsDocument}
    {...props}
  />
)

export function useOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options)
}
export function useOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options)
}
export type OrganizationsQueryHookResult = ReturnType<typeof useOrganizationsQuery>
export type OrganizationsLazyQueryHookResult = ReturnType<typeof useOrganizationsLazyQuery>
export type OrganizationsQueryResult = Apollo.QueryResult<OrganizationsQuery, OrganizationsQueryVariables>
export const OrganizationsGeneralInfoDocument = gql`
  query organizationsGeneralInfo($filter: OrganizationFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    organizations(filters: $filter, sort: $sort) {
      data {
        id
        attributes {
          name
          published
          slug
          primaryColor
          fontColor
          heroSection {
            id
            title
            subtitle
            description
            media {
              data {
                ...File
              }
            }
          }
          heroLogo {
            data {
              ...File
            }
          }
          userGuide {
            data {
              ...File
            }
          }
          logoWithCompanyName {
            data {
              attributes {
                url
              }
            }
          }
        }
      }
    }
  }
  ${FileFragmentDoc}
`
export type OrganizationsGeneralInfoComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<OrganizationsGeneralInfoQuery, OrganizationsGeneralInfoQueryVariables>,
  "query"
>

export const OrganizationsGeneralInfoComponent = (props: OrganizationsGeneralInfoComponentProps) => (
  <ApolloReactComponents.Query<OrganizationsGeneralInfoQuery, OrganizationsGeneralInfoQueryVariables>
    query={OrganizationsGeneralInfoDocument}
    {...props}
  />
)

export function useOrganizationsGeneralInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<OrganizationsGeneralInfoQuery, OrganizationsGeneralInfoQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrganizationsGeneralInfoQuery, OrganizationsGeneralInfoQueryVariables>(
    OrganizationsGeneralInfoDocument,
    options
  )
}
export function useOrganizationsGeneralInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsGeneralInfoQuery, OrganizationsGeneralInfoQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrganizationsGeneralInfoQuery, OrganizationsGeneralInfoQueryVariables>(
    OrganizationsGeneralInfoDocument,
    options
  )
}
export type OrganizationsGeneralInfoQueryHookResult = ReturnType<typeof useOrganizationsGeneralInfoQuery>
export type OrganizationsGeneralInfoLazyQueryHookResult = ReturnType<typeof useOrganizationsGeneralInfoLazyQuery>
export type OrganizationsGeneralInfoQueryResult = Apollo.QueryResult<
  OrganizationsGeneralInfoQuery,
  OrganizationsGeneralInfoQueryVariables
>
export const OrganizationsIdsDocument = gql`
  query organizationsIds($filter: OrganizationFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    organizations(filters: $filter, sort: $sort) {
      data {
        id
        attributes {
          slug
        }
      }
    }
  }
`
export type OrganizationsIdsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<OrganizationsIdsQuery, OrganizationsIdsQueryVariables>,
  "query"
>

export const OrganizationsIdsComponent = (props: OrganizationsIdsComponentProps) => (
  <ApolloReactComponents.Query<OrganizationsIdsQuery, OrganizationsIdsQueryVariables>
    query={OrganizationsIdsDocument}
    {...props}
  />
)

export function useOrganizationsIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<OrganizationsIdsQuery, OrganizationsIdsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrganizationsIdsQuery, OrganizationsIdsQueryVariables>(OrganizationsIdsDocument, options)
}
export function useOrganizationsIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsIdsQuery, OrganizationsIdsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrganizationsIdsQuery, OrganizationsIdsQueryVariables>(OrganizationsIdsDocument, options)
}
export type OrganizationsIdsQueryHookResult = ReturnType<typeof useOrganizationsIdsQuery>
export type OrganizationsIdsLazyQueryHookResult = ReturnType<typeof useOrganizationsIdsLazyQuery>
export type OrganizationsIdsQueryResult = Apollo.QueryResult<OrganizationsIdsQuery, OrganizationsIdsQueryVariables>
export const PaymentDocument = gql`
  query payment($id: ID!) {
    payment(id: $id) {
      data {
        ...Payment
      }
    }
  }
  ${PaymentFragmentDoc}
  ${FileFragmentDoc}
`
export type PaymentComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<PaymentQuery, PaymentQueryVariables>,
  "query"
> &
  ({ variables: PaymentQueryVariables; skip?: boolean } | { skip: boolean })

export const PaymentComponent = (props: PaymentComponentProps) => (
  <ApolloReactComponents.Query<PaymentQuery, PaymentQueryVariables> query={PaymentDocument} {...props} />
)

export function usePaymentQuery(baseOptions: Apollo.QueryHookOptions<PaymentQuery, PaymentQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PaymentQuery, PaymentQueryVariables>(PaymentDocument, options)
}
export function usePaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentQuery, PaymentQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PaymentQuery, PaymentQueryVariables>(PaymentDocument, options)
}
export type PaymentQueryHookResult = ReturnType<typeof usePaymentQuery>
export type PaymentLazyQueryHookResult = ReturnType<typeof usePaymentLazyQuery>
export type PaymentQueryResult = Apollo.QueryResult<PaymentQuery, PaymentQueryVariables>
export const PaymentsDocument = gql`
  query payments($filter: PaymentFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    payments(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...Payment
      }
    }
  }
  ${PaymentFragmentDoc}
  ${FileFragmentDoc}
`
export type PaymentsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<PaymentsQuery, PaymentsQueryVariables>,
  "query"
>

export const PaymentsComponent = (props: PaymentsComponentProps) => (
  <ApolloReactComponents.Query<PaymentsQuery, PaymentsQueryVariables> query={PaymentsDocument} {...props} />
)

export function usePaymentsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options)
}
export function usePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options)
}
export type PaymentsQueryHookResult = ReturnType<typeof usePaymentsQuery>
export type PaymentsLazyQueryHookResult = ReturnType<typeof usePaymentsLazyQuery>
export type PaymentsQueryResult = Apollo.QueryResult<PaymentsQuery, PaymentsQueryVariables>
export const ProjectDocument = gql`
  query project($id: ID!) {
    project(id: $id) {
      data {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
  ${ProvinceFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${ApplicationNatureFragmentDoc}
`
export type ProjectComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ProjectQuery, ProjectQueryVariables>,
  "query"
> &
  ({ variables: ProjectQueryVariables; skip?: boolean } | { skip: boolean })

export const ProjectComponent = (props: ProjectComponentProps) => (
  <ApolloReactComponents.Query<ProjectQuery, ProjectQueryVariables> query={ProjectDocument} {...props} />
)

export function useProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options)
}
export function useProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options)
}
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>
export type ProjectQueryResult = Apollo.QueryResult<ProjectQuery, ProjectQueryVariables>
export const ProjectAffectedGeometryDocument = gql`
  query projectAffectedGeometry($id: ID!) {
    project(id: $id) {
      data {
        id
        attributes {
          affectedGeometry(pagination: { limit: -1 }) {
            data {
              ...Area
            }
          }
        }
      }
    }
  }
  ${AreaFragmentDoc}
  ${FileFragmentDoc}
`
export type ProjectAffectedGeometryComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ProjectAffectedGeometryQuery, ProjectAffectedGeometryQueryVariables>,
  "query"
> &
  ({ variables: ProjectAffectedGeometryQueryVariables; skip?: boolean } | { skip: boolean })

export const ProjectAffectedGeometryComponent = (props: ProjectAffectedGeometryComponentProps) => (
  <ApolloReactComponents.Query<ProjectAffectedGeometryQuery, ProjectAffectedGeometryQueryVariables>
    query={ProjectAffectedGeometryDocument}
    {...props}
  />
)

export function useProjectAffectedGeometryQuery(
  baseOptions: Apollo.QueryHookOptions<ProjectAffectedGeometryQuery, ProjectAffectedGeometryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectAffectedGeometryQuery, ProjectAffectedGeometryQueryVariables>(
    ProjectAffectedGeometryDocument,
    options
  )
}
export function useProjectAffectedGeometryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProjectAffectedGeometryQuery, ProjectAffectedGeometryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectAffectedGeometryQuery, ProjectAffectedGeometryQueryVariables>(
    ProjectAffectedGeometryDocument,
    options
  )
}
export type ProjectAffectedGeometryQueryHookResult = ReturnType<typeof useProjectAffectedGeometryQuery>
export type ProjectAffectedGeometryLazyQueryHookResult = ReturnType<typeof useProjectAffectedGeometryLazyQuery>
export type ProjectAffectedGeometryQueryResult = Apollo.QueryResult<
  ProjectAffectedGeometryQuery,
  ProjectAffectedGeometryQueryVariables
>
export const ProjectCoverageBordersDocument = gql`
  query projectCoverageBorders($projectId: ID!) {
    projectCoverageBorders(projectId: $projectId) {
      level
      borderId
      name
      companies
    }
  }
`
export type ProjectCoverageBordersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ProjectCoverageBordersQuery, ProjectCoverageBordersQueryVariables>,
  "query"
> &
  ({ variables: ProjectCoverageBordersQueryVariables; skip?: boolean } | { skip: boolean })

export const ProjectCoverageBordersComponent = (props: ProjectCoverageBordersComponentProps) => (
  <ApolloReactComponents.Query<ProjectCoverageBordersQuery, ProjectCoverageBordersQueryVariables>
    query={ProjectCoverageBordersDocument}
    {...props}
  />
)

export function useProjectCoverageBordersQuery(
  baseOptions: Apollo.QueryHookOptions<ProjectCoverageBordersQuery, ProjectCoverageBordersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectCoverageBordersQuery, ProjectCoverageBordersQueryVariables>(
    ProjectCoverageBordersDocument,
    options
  )
}
export function useProjectCoverageBordersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProjectCoverageBordersQuery, ProjectCoverageBordersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectCoverageBordersQuery, ProjectCoverageBordersQueryVariables>(
    ProjectCoverageBordersDocument,
    options
  )
}
export type ProjectCoverageBordersQueryHookResult = ReturnType<typeof useProjectCoverageBordersQuery>
export type ProjectCoverageBordersLazyQueryHookResult = ReturnType<typeof useProjectCoverageBordersLazyQuery>
export type ProjectCoverageBordersQueryResult = Apollo.QueryResult<
  ProjectCoverageBordersQuery,
  ProjectCoverageBordersQueryVariables
>
export const ProjectNatureDocumentsDocument = gql`
  query projectNatureDocuments($id: ID!) {
    project(id: $id) {
      data {
        id
        attributes {
          category
          levelOfServices
          applications(pagination: { limit: -1 }) {
            data {
              id
              attributes {
                status
                affectedCompanies(pagination: { limit: -1 }) {
                  data {
                    id
                  }
                }
                requiredDocuments {
                  id
                  docTypeName
                  description
                  documents {
                    data {
                      id
                    }
                  }
                }
                approvals(pagination: { limit: -1 }) {
                  data {
                    id
                    attributes {
                      company {
                        data {
                          id
                          attributes {
                            documentTypes(pagination: { limit: -1 }) {
                              data {
                                id
                                attributes {
                                  title
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export type ProjectNatureDocumentsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ProjectNatureDocumentsQuery, ProjectNatureDocumentsQueryVariables>,
  "query"
> &
  ({ variables: ProjectNatureDocumentsQueryVariables; skip?: boolean } | { skip: boolean })

export const ProjectNatureDocumentsComponent = (props: ProjectNatureDocumentsComponentProps) => (
  <ApolloReactComponents.Query<ProjectNatureDocumentsQuery, ProjectNatureDocumentsQueryVariables>
    query={ProjectNatureDocumentsDocument}
    {...props}
  />
)

export function useProjectNatureDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<ProjectNatureDocumentsQuery, ProjectNatureDocumentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectNatureDocumentsQuery, ProjectNatureDocumentsQueryVariables>(
    ProjectNatureDocumentsDocument,
    options
  )
}
export function useProjectNatureDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProjectNatureDocumentsQuery, ProjectNatureDocumentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectNatureDocumentsQuery, ProjectNatureDocumentsQueryVariables>(
    ProjectNatureDocumentsDocument,
    options
  )
}
export type ProjectNatureDocumentsQueryHookResult = ReturnType<typeof useProjectNatureDocumentsQuery>
export type ProjectNatureDocumentsLazyQueryHookResult = ReturnType<typeof useProjectNatureDocumentsLazyQuery>
export type ProjectNatureDocumentsQueryResult = Apollo.QueryResult<
  ProjectNatureDocumentsQuery,
  ProjectNatureDocumentsQueryVariables
>
export const ProjectsDocument = gql`
  query projects($filter: ProjectFiltersInput, $pagination: PaginationArg, $sort: [String] = ["createdAt:DESC"]) {
    projects(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...Project
      }
      meta {
        ...Meta
      }
    }
  }
  ${ProjectFragmentDoc}
  ${ProvinceFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${ApplicationNatureFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ProjectsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ProjectsQuery, ProjectsQueryVariables>,
  "query"
>

export const ProjectsComponent = (props: ProjectsComponentProps) => (
  <ApolloReactComponents.Query<ProjectsQuery, ProjectsQueryVariables> query={ProjectsDocument} {...props} />
)

export function useProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options)
}
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options)
}
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>
export const ProjectsCoordinatesDocument = gql`
  query projectsCoordinates(
    $pagination: PaginationArg
    $filter: ProjectFiltersInput
    $includeApprovals: Boolean = false
    $applicationsFilter: ApplicationFiltersInput
    $approvalsFilter: ApprovalFiltersInput
  ) {
    projects(pagination: $pagination, filters: $filter) {
      data {
        id
        attributes {
          projectCenter
          category
          status
          organization {
            data {
              id
              attributes {
                slug
              }
            }
          }
          applications(pagination: { limit: 20 }, filters: $applicationsFilter) @include(if: $includeApprovals) {
            data {
              id
              attributes {
                approvals(pagination: { limit: 20 }, filters: $approvalsFilter) {
                  data {
                    id
                    attributes {
                      status
                      company {
                        data {
                          id
                          attributes {
                            organization {
                              data {
                                id
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ProjectsCoordinatesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ProjectsCoordinatesQuery, ProjectsCoordinatesQueryVariables>,
  "query"
>

export const ProjectsCoordinatesComponent = (props: ProjectsCoordinatesComponentProps) => (
  <ApolloReactComponents.Query<ProjectsCoordinatesQuery, ProjectsCoordinatesQueryVariables>
    query={ProjectsCoordinatesDocument}
    {...props}
  />
)

export function useProjectsCoordinatesQuery(
  baseOptions?: Apollo.QueryHookOptions<ProjectsCoordinatesQuery, ProjectsCoordinatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectsCoordinatesQuery, ProjectsCoordinatesQueryVariables>(
    ProjectsCoordinatesDocument,
    options
  )
}
export function useProjectsCoordinatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProjectsCoordinatesQuery, ProjectsCoordinatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectsCoordinatesQuery, ProjectsCoordinatesQueryVariables>(
    ProjectsCoordinatesDocument,
    options
  )
}
export type ProjectsCoordinatesQueryHookResult = ReturnType<typeof useProjectsCoordinatesQuery>
export type ProjectsCoordinatesLazyQueryHookResult = ReturnType<typeof useProjectsCoordinatesLazyQuery>
export type ProjectsCoordinatesQueryResult = Apollo.QueryResult<
  ProjectsCoordinatesQuery,
  ProjectsCoordinatesQueryVariables
>
export const ProjectsOptionsDocument = gql`
  query projectsOptions(
    $filter: ProjectFiltersInput
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    projects(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          title
        }
      }
    }
  }
`
export type ProjectsOptionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ProjectsOptionsQuery, ProjectsOptionsQueryVariables>,
  "query"
>

export const ProjectsOptionsComponent = (props: ProjectsOptionsComponentProps) => (
  <ApolloReactComponents.Query<ProjectsOptionsQuery, ProjectsOptionsQueryVariables>
    query={ProjectsOptionsDocument}
    {...props}
  />
)

export function useProjectsOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<ProjectsOptionsQuery, ProjectsOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectsOptionsQuery, ProjectsOptionsQueryVariables>(ProjectsOptionsDocument, options)
}
export function useProjectsOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProjectsOptionsQuery, ProjectsOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectsOptionsQuery, ProjectsOptionsQueryVariables>(ProjectsOptionsDocument, options)
}
export type ProjectsOptionsQueryHookResult = ReturnType<typeof useProjectsOptionsQuery>
export type ProjectsOptionsLazyQueryHookResult = ReturnType<typeof useProjectsOptionsLazyQuery>
export type ProjectsOptionsQueryResult = Apollo.QueryResult<ProjectsOptionsQuery, ProjectsOptionsQueryVariables>
export const ProjectsOverviewDocument = gql`
  query projectsOverview(
    $filter: ProjectFiltersInput
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    projects(filters: $filter, pagination: $pagination, sort: $sort) {
      data {
        id
        attributes {
          projectCenter
          category
          status
          organization {
            data {
              id
            }
          }
          applications(pagination: { limit: 50 }) {
            data {
              id
              attributes {
                effectiveDate
                effectiveDateOnly
                approvals(pagination: { limit: 50 }) {
                  data {
                    id
                    attributes {
                      name
                      company {
                        data {
                          id
                          attributes {
                            name
                            organization {
                              data {
                                id
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ProjectsOverviewComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>,
  "query"
>

export const ProjectsOverviewComponent = (props: ProjectsOverviewComponentProps) => (
  <ApolloReactComponents.Query<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>
    query={ProjectsOverviewDocument}
    {...props}
  />
)

export function useProjectsOverviewQuery(
  baseOptions?: Apollo.QueryHookOptions<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>(ProjectsOverviewDocument, options)
}
export function useProjectsOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>(ProjectsOverviewDocument, options)
}
export type ProjectsOverviewQueryHookResult = ReturnType<typeof useProjectsOverviewQuery>
export type ProjectsOverviewLazyQueryHookResult = ReturnType<typeof useProjectsOverviewLazyQuery>
export type ProjectsOverviewQueryResult = Apollo.QueryResult<ProjectsOverviewQuery, ProjectsOverviewQueryVariables>
export const ProjectsSiderStatisticsDocument = gql`
  query projectsSiderStatistics(
    $filter: ProjectFiltersInput
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    projects(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          createdAt
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ProjectsSiderStatisticsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ProjectsSiderStatisticsQuery, ProjectsSiderStatisticsQueryVariables>,
  "query"
>

export const ProjectsSiderStatisticsComponent = (props: ProjectsSiderStatisticsComponentProps) => (
  <ApolloReactComponents.Query<ProjectsSiderStatisticsQuery, ProjectsSiderStatisticsQueryVariables>
    query={ProjectsSiderStatisticsDocument}
    {...props}
  />
)

export function useProjectsSiderStatisticsQuery(
  baseOptions?: Apollo.QueryHookOptions<ProjectsSiderStatisticsQuery, ProjectsSiderStatisticsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectsSiderStatisticsQuery, ProjectsSiderStatisticsQueryVariables>(
    ProjectsSiderStatisticsDocument,
    options
  )
}
export function useProjectsSiderStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProjectsSiderStatisticsQuery, ProjectsSiderStatisticsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectsSiderStatisticsQuery, ProjectsSiderStatisticsQueryVariables>(
    ProjectsSiderStatisticsDocument,
    options
  )
}
export type ProjectsSiderStatisticsQueryHookResult = ReturnType<typeof useProjectsSiderStatisticsQuery>
export type ProjectsSiderStatisticsLazyQueryHookResult = ReturnType<typeof useProjectsSiderStatisticsLazyQuery>
export type ProjectsSiderStatisticsQueryResult = Apollo.QueryResult<
  ProjectsSiderStatisticsQuery,
  ProjectsSiderStatisticsQueryVariables
>
export const ProjectsTableDocument = gql`
  query projectsTable($filter: ProjectFiltersInput, $pagination: PaginationArg, $sort: [String] = ["createdAt:DESC"]) {
    projects(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...ProjectTable
      }
      meta {
        ...Meta
      }
    }
  }
  ${ProjectTableFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ProjectsTableComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ProjectsTableQuery, ProjectsTableQueryVariables>,
  "query"
>

export const ProjectsTableComponent = (props: ProjectsTableComponentProps) => (
  <ApolloReactComponents.Query<ProjectsTableQuery, ProjectsTableQueryVariables>
    query={ProjectsTableDocument}
    {...props}
  />
)

export function useProjectsTableQuery(
  baseOptions?: Apollo.QueryHookOptions<ProjectsTableQuery, ProjectsTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectsTableQuery, ProjectsTableQueryVariables>(ProjectsTableDocument, options)
}
export function useProjectsTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProjectsTableQuery, ProjectsTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectsTableQuery, ProjectsTableQueryVariables>(ProjectsTableDocument, options)
}
export type ProjectsTableQueryHookResult = ReturnType<typeof useProjectsTableQuery>
export type ProjectsTableLazyQueryHookResult = ReturnType<typeof useProjectsTableLazyQuery>
export type ProjectsTableQueryResult = Apollo.QueryResult<ProjectsTableQuery, ProjectsTableQueryVariables>
export const ProvinceBordersGeoJsonDocument = gql`
  query provinceBordersGeoJson {
    provinceBordersGeoJson
  }
`
export type ProvinceBordersGeoJsonComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ProvinceBordersGeoJsonQuery, ProvinceBordersGeoJsonQueryVariables>,
  "query"
>

export const ProvinceBordersGeoJsonComponent = (props: ProvinceBordersGeoJsonComponentProps) => (
  <ApolloReactComponents.Query<ProvinceBordersGeoJsonQuery, ProvinceBordersGeoJsonQueryVariables>
    query={ProvinceBordersGeoJsonDocument}
    {...props}
  />
)

export function useProvinceBordersGeoJsonQuery(
  baseOptions?: Apollo.QueryHookOptions<ProvinceBordersGeoJsonQuery, ProvinceBordersGeoJsonQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProvinceBordersGeoJsonQuery, ProvinceBordersGeoJsonQueryVariables>(
    ProvinceBordersGeoJsonDocument,
    options
  )
}
export function useProvinceBordersGeoJsonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProvinceBordersGeoJsonQuery, ProvinceBordersGeoJsonQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProvinceBordersGeoJsonQuery, ProvinceBordersGeoJsonQueryVariables>(
    ProvinceBordersGeoJsonDocument,
    options
  )
}
export type ProvinceBordersGeoJsonQueryHookResult = ReturnType<typeof useProvinceBordersGeoJsonQuery>
export type ProvinceBordersGeoJsonLazyQueryHookResult = ReturnType<typeof useProvinceBordersGeoJsonLazyQuery>
export type ProvinceBordersGeoJsonQueryResult = Apollo.QueryResult<
  ProvinceBordersGeoJsonQuery,
  ProvinceBordersGeoJsonQueryVariables
>
export const ProvincesDocument = gql`
  query provinces($filter: ProvinceFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    provinces(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...Province
      }
    }
  }
  ${ProvinceFragmentDoc}
  ${FileFragmentDoc}
`
export type ProvincesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ProvincesQuery, ProvincesQueryVariables>,
  "query"
>

export const ProvincesComponent = (props: ProvincesComponentProps) => (
  <ApolloReactComponents.Query<ProvincesQuery, ProvincesQueryVariables> query={ProvincesDocument} {...props} />
)

export function useProvincesQuery(baseOptions?: Apollo.QueryHookOptions<ProvincesQuery, ProvincesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProvincesQuery, ProvincesQueryVariables>(ProvincesDocument, options)
}
export function useProvincesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProvincesQuery, ProvincesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProvincesQuery, ProvincesQueryVariables>(ProvincesDocument, options)
}
export type ProvincesQueryHookResult = ReturnType<typeof useProvincesQuery>
export type ProvincesLazyQueryHookResult = ReturnType<typeof useProvincesLazyQuery>
export type ProvincesQueryResult = Apollo.QueryResult<ProvincesQuery, ProvincesQueryVariables>
export const QuotationDocument = gql`
  query quotation($id: ID!) {
    quotation(id: $id) {
      data {
        ...Quotation
      }
    }
  }
  ${QuotationFragmentDoc}
  ${QuoteItemFragmentDoc}
`
export type QuotationComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<QuotationQuery, QuotationQueryVariables>,
  "query"
> &
  ({ variables: QuotationQueryVariables; skip?: boolean } | { skip: boolean })

export const QuotationComponent = (props: QuotationComponentProps) => (
  <ApolloReactComponents.Query<QuotationQuery, QuotationQueryVariables> query={QuotationDocument} {...props} />
)

export function useQuotationQuery(baseOptions: Apollo.QueryHookOptions<QuotationQuery, QuotationQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<QuotationQuery, QuotationQueryVariables>(QuotationDocument, options)
}
export function useQuotationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<QuotationQuery, QuotationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<QuotationQuery, QuotationQueryVariables>(QuotationDocument, options)
}
export type QuotationQueryHookResult = ReturnType<typeof useQuotationQuery>
export type QuotationLazyQueryHookResult = ReturnType<typeof useQuotationLazyQuery>
export type QuotationQueryResult = Apollo.QueryResult<QuotationQuery, QuotationQueryVariables>
export const QuoteItemsDocument = gql`
  query quoteItems($filter: QuoteItemFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    quoteItems(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...QuoteItem
      }
    }
  }
  ${QuoteItemFragmentDoc}
`
export type QuoteItemsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<QuoteItemsQuery, QuoteItemsQueryVariables>,
  "query"
>

export const QuoteItemsComponent = (props: QuoteItemsComponentProps) => (
  <ApolloReactComponents.Query<QuoteItemsQuery, QuoteItemsQueryVariables> query={QuoteItemsDocument} {...props} />
)

export function useQuoteItemsQuery(baseOptions?: Apollo.QueryHookOptions<QuoteItemsQuery, QuoteItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<QuoteItemsQuery, QuoteItemsQueryVariables>(QuoteItemsDocument, options)
}
export function useQuoteItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<QuoteItemsQuery, QuoteItemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<QuoteItemsQuery, QuoteItemsQueryVariables>(QuoteItemsDocument, options)
}
export type QuoteItemsQueryHookResult = ReturnType<typeof useQuoteItemsQuery>
export type QuoteItemsLazyQueryHookResult = ReturnType<typeof useQuoteItemsLazyQuery>
export type QuoteItemsQueryResult = Apollo.QueryResult<QuoteItemsQuery, QuoteItemsQueryVariables>
export const QuoteRequestDocument = gql`
  query quoteRequest($id: ID!) {
    quoteRequest(id: $id) {
      data {
        id
        attributes {
          createdAt
          status
          firstName
          lastName
          email
          companyName
          phone
          responseDate
          responseMessage
          checkResults
          isArchived
          geoJson {
            data {
              ...File
            }
          }
          uploadedFiles {
            data {
              ...File
            }
          }
          mapSnapshots {
            data {
              ...File
            }
          }
          projectNature {
            data {
              id
              attributes {
                title
              }
            }
          }
          description
          clientUploadedFiles {
            data {
              ...File
            }
          }
        }
      }
    }
  }
  ${FileFragmentDoc}
`
export type QuoteRequestComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<QuoteRequestQuery, QuoteRequestQueryVariables>,
  "query"
> &
  ({ variables: QuoteRequestQueryVariables; skip?: boolean } | { skip: boolean })

export const QuoteRequestComponent = (props: QuoteRequestComponentProps) => (
  <ApolloReactComponents.Query<QuoteRequestQuery, QuoteRequestQueryVariables> query={QuoteRequestDocument} {...props} />
)

export function useQuoteRequestQuery(
  baseOptions: Apollo.QueryHookOptions<QuoteRequestQuery, QuoteRequestQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<QuoteRequestQuery, QuoteRequestQueryVariables>(QuoteRequestDocument, options)
}
export function useQuoteRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<QuoteRequestQuery, QuoteRequestQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<QuoteRequestQuery, QuoteRequestQueryVariables>(QuoteRequestDocument, options)
}
export type QuoteRequestQueryHookResult = ReturnType<typeof useQuoteRequestQuery>
export type QuoteRequestLazyQueryHookResult = ReturnType<typeof useQuoteRequestLazyQuery>
export type QuoteRequestQueryResult = Apollo.QueryResult<QuoteRequestQuery, QuoteRequestQueryVariables>
export const QuoteRequestsDocument = gql`
  query quoteRequests(
    $filter: QuoteRequestFiltersInput
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    quoteRequests(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          firstName
          lastName
          email
          phone
          companyName
          status
          createdAt
          isArchived
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type QuoteRequestsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<QuoteRequestsQuery, QuoteRequestsQueryVariables>,
  "query"
>

export const QuoteRequestsComponent = (props: QuoteRequestsComponentProps) => (
  <ApolloReactComponents.Query<QuoteRequestsQuery, QuoteRequestsQueryVariables>
    query={QuoteRequestsDocument}
    {...props}
  />
)

export function useQuoteRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<QuoteRequestsQuery, QuoteRequestsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<QuoteRequestsQuery, QuoteRequestsQueryVariables>(QuoteRequestsDocument, options)
}
export function useQuoteRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<QuoteRequestsQuery, QuoteRequestsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<QuoteRequestsQuery, QuoteRequestsQueryVariables>(QuoteRequestsDocument, options)
}
export type QuoteRequestsQueryHookResult = ReturnType<typeof useQuoteRequestsQuery>
export type QuoteRequestsLazyQueryHookResult = ReturnType<typeof useQuoteRequestsLazyQuery>
export type QuoteRequestsQueryResult = Apollo.QueryResult<QuoteRequestsQuery, QuoteRequestsQueryVariables>
export const ReportsDocument = gql`
  query reports($filter: ReportFiltersInput, $sort: [String] = ["createdAt:DESC"], $pagination: PaginationArg) {
    reports(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...Report
      }
      meta {
        ...Meta
      }
    }
  }
  ${ReportFragmentDoc}
  ${FileFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type ReportsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<ReportsQuery, ReportsQueryVariables>,
  "query"
>

export const ReportsComponent = (props: ReportsComponentProps) => (
  <ApolloReactComponents.Query<ReportsQuery, ReportsQueryVariables> query={ReportsDocument} {...props} />
)

export function useReportsQuery(baseOptions?: Apollo.QueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options)
}
export function useReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options)
}
export type ReportsQueryHookResult = ReturnType<typeof useReportsQuery>
export type ReportsLazyQueryHookResult = ReturnType<typeof useReportsLazyQuery>
export type ReportsQueryResult = Apollo.QueryResult<ReportsQuery, ReportsQueryVariables>
export const RolesDocument = gql`
  query roles($filter: UsersPermissionsRoleFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    usersPermissionsRoles(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...Role
      }
    }
  }
  ${RoleFragmentDoc}
`
export type RolesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<RolesQuery, RolesQueryVariables>,
  "query"
>

export const RolesComponent = (props: RolesComponentProps) => (
  <ApolloReactComponents.Query<RolesQuery, RolesQueryVariables> query={RolesDocument} {...props} />
)

export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options)
}
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options)
}
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>
export const SearchConsoleStatsDocument = gql`
  query searchConsoleStats {
    searchConsoleStats {
      state
      message
      siteUrl
      from
      to
      current {
        clicks
        impressions
        ctr
        position
      }
      previous {
        clicks
        impressions
        ctr
        position
      }
      daily {
        date
        clicks
        impressions
      }
      queries {
        key
        clicks
        impressions
        ctr
        position
      }
      pages {
        key
        clicks
        impressions
        ctr
        position
      }
      fetchedAt
    }
  }
`
export type SearchConsoleStatsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<SearchConsoleStatsQuery, SearchConsoleStatsQueryVariables>,
  "query"
>

export const SearchConsoleStatsComponent = (props: SearchConsoleStatsComponentProps) => (
  <ApolloReactComponents.Query<SearchConsoleStatsQuery, SearchConsoleStatsQueryVariables>
    query={SearchConsoleStatsDocument}
    {...props}
  />
)

export function useSearchConsoleStatsQuery(
  baseOptions?: Apollo.QueryHookOptions<SearchConsoleStatsQuery, SearchConsoleStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchConsoleStatsQuery, SearchConsoleStatsQueryVariables>(SearchConsoleStatsDocument, options)
}
export function useSearchConsoleStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchConsoleStatsQuery, SearchConsoleStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchConsoleStatsQuery, SearchConsoleStatsQueryVariables>(
    SearchConsoleStatsDocument,
    options
  )
}
export type SearchConsoleStatsQueryHookResult = ReturnType<typeof useSearchConsoleStatsQuery>
export type SearchConsoleStatsLazyQueryHookResult = ReturnType<typeof useSearchConsoleStatsLazyQuery>
export type SearchConsoleStatsQueryResult = Apollo.QueryResult<
  SearchConsoleStatsQuery,
  SearchConsoleStatsQueryVariables
>
export const SettingsDocument = gql`
  query settings {
    setting {
      data {
        ...Settings
      }
    }
  }
  ${SettingsFragmentDoc}
  ${FileFragmentDoc}
`
export type SettingsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<SettingsQuery, SettingsQueryVariables>,
  "query"
>

export const SettingsComponent = (props: SettingsComponentProps) => (
  <ApolloReactComponents.Query<SettingsQuery, SettingsQueryVariables> query={SettingsDocument} {...props} />
)

export function useSettingsQuery(baseOptions?: Apollo.QueryHookOptions<SettingsQuery, SettingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options)
}
export function useSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsQuery, SettingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options)
}
export type SettingsQueryHookResult = ReturnType<typeof useSettingsQuery>
export type SettingsLazyQueryHookResult = ReturnType<typeof useSettingsLazyQuery>
export type SettingsQueryResult = Apollo.QueryResult<SettingsQuery, SettingsQueryVariables>
export const SpatialGridDocument = gql`
  query spatialGrid($bbox: [Float!]) {
    spatialGrid {
      data {
        id
        attributes {
          name
          cellCount_L0
          cellCount_L1
          cellCount_L2
          cellCount_L3
          description
          geojson(bbox: $bbox)
          geoPackage {
            data {
              ...File
            }
          }
        }
      }
    }
  }
  ${FileFragmentDoc}
`
export type SpatialGridComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<SpatialGridQuery, SpatialGridQueryVariables>,
  "query"
>

export const SpatialGridComponent = (props: SpatialGridComponentProps) => (
  <ApolloReactComponents.Query<SpatialGridQuery, SpatialGridQueryVariables> query={SpatialGridDocument} {...props} />
)

export function useSpatialGridQuery(
  baseOptions?: Apollo.QueryHookOptions<SpatialGridQuery, SpatialGridQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SpatialGridQuery, SpatialGridQueryVariables>(SpatialGridDocument, options)
}
export function useSpatialGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SpatialGridQuery, SpatialGridQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SpatialGridQuery, SpatialGridQueryVariables>(SpatialGridDocument, options)
}
export type SpatialGridQueryHookResult = ReturnType<typeof useSpatialGridQuery>
export type SpatialGridLazyQueryHookResult = ReturnType<typeof useSpatialGridLazyQuery>
export type SpatialGridQueryResult = Apollo.QueryResult<SpatialGridQuery, SpatialGridQueryVariables>
export const SpatialJobRunsDocument = gql`
  query spatialJobRuns {
    spatialJobRuns {
      job
      status
      startedAt
      finishedAt
      durationMs
      userId
      summary
    }
  }
`
export type SpatialJobRunsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<SpatialJobRunsQuery, SpatialJobRunsQueryVariables>,
  "query"
>

export const SpatialJobRunsComponent = (props: SpatialJobRunsComponentProps) => (
  <ApolloReactComponents.Query<SpatialJobRunsQuery, SpatialJobRunsQueryVariables>
    query={SpatialJobRunsDocument}
    {...props}
  />
)

export function useSpatialJobRunsQuery(
  baseOptions?: Apollo.QueryHookOptions<SpatialJobRunsQuery, SpatialJobRunsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SpatialJobRunsQuery, SpatialJobRunsQueryVariables>(SpatialJobRunsDocument, options)
}
export function useSpatialJobRunsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SpatialJobRunsQuery, SpatialJobRunsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SpatialJobRunsQuery, SpatialJobRunsQueryVariables>(SpatialJobRunsDocument, options)
}
export type SpatialJobRunsQueryHookResult = ReturnType<typeof useSpatialJobRunsQuery>
export type SpatialJobRunsLazyQueryHookResult = ReturnType<typeof useSpatialJobRunsLazyQuery>
export type SpatialJobRunsQueryResult = Apollo.QueryResult<SpatialJobRunsQuery, SpatialJobRunsQueryVariables>
export const SupportTopicsDocument = gql`
  query supportTopics($filter: SupportTopicFiltersInput, $sort: [String] = ["createdAt:ASC"]) {
    supportTopics(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        id
        attributes {
          title
          description
        }
      }
    }
  }
`
export type SupportTopicsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<SupportTopicsQuery, SupportTopicsQueryVariables>,
  "query"
>

export const SupportTopicsComponent = (props: SupportTopicsComponentProps) => (
  <ApolloReactComponents.Query<SupportTopicsQuery, SupportTopicsQueryVariables>
    query={SupportTopicsDocument}
    {...props}
  />
)

export function useSupportTopicsQuery(
  baseOptions?: Apollo.QueryHookOptions<SupportTopicsQuery, SupportTopicsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SupportTopicsQuery, SupportTopicsQueryVariables>(SupportTopicsDocument, options)
}
export function useSupportTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SupportTopicsQuery, SupportTopicsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SupportTopicsQuery, SupportTopicsQueryVariables>(SupportTopicsDocument, options)
}
export type SupportTopicsQueryHookResult = ReturnType<typeof useSupportTopicsQuery>
export type SupportTopicsLazyQueryHookResult = ReturnType<typeof useSupportTopicsLazyQuery>
export type SupportTopicsQueryResult = Apollo.QueryResult<SupportTopicsQuery, SupportTopicsQueryVariables>
export const SurveyDocument = gql`
  query survey($id: ID!) {
    survey(id: $id) {
      data {
        ...Survey
      }
    }
  }
  ${SurveyFragmentDoc}
  ${FileFragmentDoc}
`
export type SurveyComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<SurveyQuery, SurveyQueryVariables>,
  "query"
> &
  ({ variables: SurveyQueryVariables; skip?: boolean } | { skip: boolean })

export const SurveyComponent = (props: SurveyComponentProps) => (
  <ApolloReactComponents.Query<SurveyQuery, SurveyQueryVariables> query={SurveyDocument} {...props} />
)

export function useSurveyQuery(baseOptions: Apollo.QueryHookOptions<SurveyQuery, SurveyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options)
}
export function useSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyQuery, SurveyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options)
}
export type SurveyQueryHookResult = ReturnType<typeof useSurveyQuery>
export type SurveyLazyQueryHookResult = ReturnType<typeof useSurveyLazyQuery>
export type SurveyQueryResult = Apollo.QueryResult<SurveyQuery, SurveyQueryVariables>
export const SurveysDocument = gql`
  query surveys($filter: SurveyFiltersInput, $sort: [String] = ["createdAt:DESC"], $pagination: PaginationArg) {
    surveys(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        ...Survey
      }
      meta {
        ...Meta
      }
    }
  }
  ${SurveyFragmentDoc}
  ${FileFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type SurveysComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<SurveysQuery, SurveysQueryVariables>,
  "query"
>

export const SurveysComponent = (props: SurveysComponentProps) => (
  <ApolloReactComponents.Query<SurveysQuery, SurveysQueryVariables> query={SurveysDocument} {...props} />
)

export function useSurveysQuery(baseOptions?: Apollo.QueryHookOptions<SurveysQuery, SurveysQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SurveysQuery, SurveysQueryVariables>(SurveysDocument, options)
}
export function useSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveysQuery, SurveysQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SurveysQuery, SurveysQueryVariables>(SurveysDocument, options)
}
export type SurveysQueryHookResult = ReturnType<typeof useSurveysQuery>
export type SurveysLazyQueryHookResult = ReturnType<typeof useSurveysLazyQuery>
export type SurveysQueryResult = Apollo.QueryResult<SurveysQuery, SurveysQueryVariables>
export const TaskDocument = gql`
  query task($id: ID!) {
    task(id: $id) {
      data {
        ...Task
      }
    }
  }
  ${TaskFragmentDoc}
`
export type TaskComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<TaskQuery, TaskQueryVariables>,
  "query"
> &
  ({ variables: TaskQueryVariables; skip?: boolean } | { skip: boolean })

export const TaskComponent = (props: TaskComponentProps) => (
  <ApolloReactComponents.Query<TaskQuery, TaskQueryVariables> query={TaskDocument} {...props} />
)

export function useTaskQuery(baseOptions: Apollo.QueryHookOptions<TaskQuery, TaskQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options)
}
export function useTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQuery, TaskQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options)
}
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>
export type TaskQueryResult = Apollo.QueryResult<TaskQuery, TaskQueryVariables>
export const TasksDocument = gql`
  query tasks($filter: TaskFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    tasks(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...Task
      }
    }
  }
  ${TaskFragmentDoc}
`
export type TasksComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<TasksQuery, TasksQueryVariables>,
  "query"
>

export const TasksComponent = (props: TasksComponentProps) => (
  <ApolloReactComponents.Query<TasksQuery, TasksQueryVariables> query={TasksDocument} {...props} />
)

export function useTasksQuery(baseOptions?: Apollo.QueryHookOptions<TasksQuery, TasksQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options)
}
export function useTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksQuery, TasksQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options)
}
export type TasksQueryHookResult = ReturnType<typeof useTasksQuery>
export type TasksLazyQueryHookResult = ReturnType<typeof useTasksLazyQuery>
export type TasksQueryResult = Apollo.QueryResult<TasksQuery, TasksQueryVariables>
export const TemplateDocumentDocument = gql`
  query templateDocument($id: ID!) {
    documentTemplate(id: $id) {
      data {
        ...DocumentTemplate
      }
    }
  }
  ${DocumentTemplateFragmentDoc}
`
export type TemplateDocumentComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<TemplateDocumentQuery, TemplateDocumentQueryVariables>,
  "query"
> &
  ({ variables: TemplateDocumentQueryVariables; skip?: boolean } | { skip: boolean })

export const TemplateDocumentComponent = (props: TemplateDocumentComponentProps) => (
  <ApolloReactComponents.Query<TemplateDocumentQuery, TemplateDocumentQueryVariables>
    query={TemplateDocumentDocument}
    {...props}
  />
)

export function useTemplateDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<TemplateDocumentQuery, TemplateDocumentQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TemplateDocumentQuery, TemplateDocumentQueryVariables>(TemplateDocumentDocument, options)
}
export function useTemplateDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TemplateDocumentQuery, TemplateDocumentQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TemplateDocumentQuery, TemplateDocumentQueryVariables>(TemplateDocumentDocument, options)
}
export type TemplateDocumentQueryHookResult = ReturnType<typeof useTemplateDocumentQuery>
export type TemplateDocumentLazyQueryHookResult = ReturnType<typeof useTemplateDocumentLazyQuery>
export type TemplateDocumentQueryResult = Apollo.QueryResult<TemplateDocumentQuery, TemplateDocumentQueryVariables>
export const TemplateSubjectDocument = gql`
  query templateSubject($id: ID!) {
    templateSubject(id: $id) {
      data {
        ...TemplateSubject
      }
    }
  }
  ${TemplateSubjectFragmentDoc}
  ${DocumentTemplateFragmentDoc}
`
export type TemplateSubjectComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<TemplateSubjectQuery, TemplateSubjectQueryVariables>,
  "query"
> &
  ({ variables: TemplateSubjectQueryVariables; skip?: boolean } | { skip: boolean })

export const TemplateSubjectComponent = (props: TemplateSubjectComponentProps) => (
  <ApolloReactComponents.Query<TemplateSubjectQuery, TemplateSubjectQueryVariables>
    query={TemplateSubjectDocument}
    {...props}
  />
)

export function useTemplateSubjectQuery(
  baseOptions: Apollo.QueryHookOptions<TemplateSubjectQuery, TemplateSubjectQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TemplateSubjectQuery, TemplateSubjectQueryVariables>(TemplateSubjectDocument, options)
}
export function useTemplateSubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TemplateSubjectQuery, TemplateSubjectQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TemplateSubjectQuery, TemplateSubjectQueryVariables>(TemplateSubjectDocument, options)
}
export type TemplateSubjectQueryHookResult = ReturnType<typeof useTemplateSubjectQuery>
export type TemplateSubjectLazyQueryHookResult = ReturnType<typeof useTemplateSubjectLazyQuery>
export type TemplateSubjectQueryResult = Apollo.QueryResult<TemplateSubjectQuery, TemplateSubjectQueryVariables>
export const TemplatesSubjectsDocument = gql`
  query templatesSubjects($filter: TemplateSubjectFiltersInput, $sort: [String] = ["createdAt:DESC"]) {
    templateSubjects(filters: $filter, sort: $sort, pagination: { limit: -1 }) {
      data {
        ...TemplateSubject
      }
    }
  }
  ${TemplateSubjectFragmentDoc}
  ${DocumentTemplateFragmentDoc}
`
export type TemplatesSubjectsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<TemplatesSubjectsQuery, TemplatesSubjectsQueryVariables>,
  "query"
>

export const TemplatesSubjectsComponent = (props: TemplatesSubjectsComponentProps) => (
  <ApolloReactComponents.Query<TemplatesSubjectsQuery, TemplatesSubjectsQueryVariables>
    query={TemplatesSubjectsDocument}
    {...props}
  />
)

export function useTemplatesSubjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<TemplatesSubjectsQuery, TemplatesSubjectsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TemplatesSubjectsQuery, TemplatesSubjectsQueryVariables>(TemplatesSubjectsDocument, options)
}
export function useTemplatesSubjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TemplatesSubjectsQuery, TemplatesSubjectsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TemplatesSubjectsQuery, TemplatesSubjectsQueryVariables>(
    TemplatesSubjectsDocument,
    options
  )
}
export type TemplatesSubjectsQueryHookResult = ReturnType<typeof useTemplatesSubjectsQuery>
export type TemplatesSubjectsLazyQueryHookResult = ReturnType<typeof useTemplatesSubjectsLazyQuery>
export type TemplatesSubjectsQueryResult = Apollo.QueryResult<TemplatesSubjectsQuery, TemplatesSubjectsQueryVariables>
export const UserDocument = gql`
  query user($id: ID!) {
    usersPermissionsUser(id: $id) {
      data {
        id
        attributes {
          email
          uuid
          confirmed
          blocked
          userProfile {
            data {
              id
            }
          }
          organization {
            data {
              ...Organization
            }
          }
          role {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
  ${OrganizationFragmentDoc}
  ${FileFragmentDoc}
  ${ConfigurationFragmentDoc}
`
export type UserComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<UserQuery, UserQueryVariables>,
  "query"
> &
  ({ variables: UserQueryVariables; skip?: boolean } | { skip: boolean })

export const UserComponent = (props: UserComponentProps) => (
  <ApolloReactComponents.Query<UserQuery, UserQueryVariables> query={UserDocument} {...props} />
)

export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options)
}
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options)
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>
export const UserProfileDocument = gql`
  query userProfile($id: ID!) {
    userProfile(id: $id) {
      data {
        ...UserProfile
      }
    }
  }
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
`
export type UserProfileComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<UserProfileQuery, UserProfileQueryVariables>,
  "query"
> &
  ({ variables: UserProfileQueryVariables; skip?: boolean } | { skip: boolean })

export const UserProfileComponent = (props: UserProfileComponentProps) => (
  <ApolloReactComponents.Query<UserProfileQuery, UserProfileQueryVariables> query={UserProfileDocument} {...props} />
)

export function useUserProfileQuery(baseOptions: Apollo.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options)
}
export function useUserProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options)
}
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>
export const UserProfilesDocument = gql`
  query userProfiles(
    $filter: UserProfileFiltersInput!
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    userProfiles(filters: $filter, pagination: $pagination, sort: $sort) {
      data {
        ...UserProfile
      }
      meta {
        ...Meta
      }
    }
  }
  ${UserProfileFragmentDoc}
  ${FileFragmentDoc}
  ${CompanyFragmentDoc}
  ${CompanyBaseFragmentDoc}
  ${LetterTemplateFragmentDoc}
  ${ApplicationMethodFragmentDoc}
  ${DocumentTypeFragmentDoc}
  ${ApplicationTypeFragmentDoc}
  ${AreaFragmentDoc}
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type UserProfilesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<UserProfilesQuery, UserProfilesQueryVariables>,
  "query"
> &
  ({ variables: UserProfilesQueryVariables; skip?: boolean } | { skip: boolean })

export const UserProfilesComponent = (props: UserProfilesComponentProps) => (
  <ApolloReactComponents.Query<UserProfilesQuery, UserProfilesQueryVariables> query={UserProfilesDocument} {...props} />
)

export function useUserProfilesQuery(
  baseOptions: Apollo.QueryHookOptions<UserProfilesQuery, UserProfilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserProfilesQuery, UserProfilesQueryVariables>(UserProfilesDocument, options)
}
export function useUserProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserProfilesQuery, UserProfilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserProfilesQuery, UserProfilesQueryVariables>(UserProfilesDocument, options)
}
export type UserProfilesQueryHookResult = ReturnType<typeof useUserProfilesQuery>
export type UserProfilesLazyQueryHookResult = ReturnType<typeof useUserProfilesLazyQuery>
export type UserProfilesQueryResult = Apollo.QueryResult<UserProfilesQuery, UserProfilesQueryVariables>
export const UserProfilesSelectOptionsDocument = gql`
  query userProfilesSelectOptions(
    $filter: UserProfileFiltersInput!
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    userProfiles(filters: $filter, pagination: $pagination, sort: $sort) {
      data {
        id
        attributes {
          fullName
          primaryEmail
        }
      }
      meta {
        ...Meta
      }
    }
  }
  ${MetaFragmentDoc}
  ${PaginationFragmentDoc}
`
export type UserProfilesSelectOptionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<UserProfilesSelectOptionsQuery, UserProfilesSelectOptionsQueryVariables>,
  "query"
> &
  ({ variables: UserProfilesSelectOptionsQueryVariables; skip?: boolean } | { skip: boolean })

export const UserProfilesSelectOptionsComponent = (props: UserProfilesSelectOptionsComponentProps) => (
  <ApolloReactComponents.Query<UserProfilesSelectOptionsQuery, UserProfilesSelectOptionsQueryVariables>
    query={UserProfilesSelectOptionsDocument}
    {...props}
  />
)

export function useUserProfilesSelectOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<UserProfilesSelectOptionsQuery, UserProfilesSelectOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserProfilesSelectOptionsQuery, UserProfilesSelectOptionsQueryVariables>(
    UserProfilesSelectOptionsDocument,
    options
  )
}
export function useUserProfilesSelectOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserProfilesSelectOptionsQuery, UserProfilesSelectOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserProfilesSelectOptionsQuery, UserProfilesSelectOptionsQueryVariables>(
    UserProfilesSelectOptionsDocument,
    options
  )
}
export type UserProfilesSelectOptionsQueryHookResult = ReturnType<typeof useUserProfilesSelectOptionsQuery>
export type UserProfilesSelectOptionsLazyQueryHookResult = ReturnType<typeof useUserProfilesSelectOptionsLazyQuery>
export type UserProfilesSelectOptionsQueryResult = Apollo.QueryResult<
  UserProfilesSelectOptionsQuery,
  UserProfilesSelectOptionsQueryVariables
>
export const UserProfilesStatisticsChartDocument = gql`
  query userProfilesStatisticsChart(
    $filter: UserProfileFiltersInput!
    $pagination: PaginationArg
    $sort: [String] = ["createdAt:DESC"]
  ) {
    userProfiles(filters: $filter, pagination: $pagination, sort: $sort) {
      data {
        id
        attributes {
          fullName
          statistics
        }
      }
    }
  }
`
export type UserProfilesStatisticsChartComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    UserProfilesStatisticsChartQuery,
    UserProfilesStatisticsChartQueryVariables
  >,
  "query"
> &
  ({ variables: UserProfilesStatisticsChartQueryVariables; skip?: boolean } | { skip: boolean })

export const UserProfilesStatisticsChartComponent = (props: UserProfilesStatisticsChartComponentProps) => (
  <ApolloReactComponents.Query<UserProfilesStatisticsChartQuery, UserProfilesStatisticsChartQueryVariables>
    query={UserProfilesStatisticsChartDocument}
    {...props}
  />
)

export function useUserProfilesStatisticsChartQuery(
  baseOptions: Apollo.QueryHookOptions<UserProfilesStatisticsChartQuery, UserProfilesStatisticsChartQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserProfilesStatisticsChartQuery, UserProfilesStatisticsChartQueryVariables>(
    UserProfilesStatisticsChartDocument,
    options
  )
}
export function useUserProfilesStatisticsChartLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserProfilesStatisticsChartQuery, UserProfilesStatisticsChartQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserProfilesStatisticsChartQuery, UserProfilesStatisticsChartQueryVariables>(
    UserProfilesStatisticsChartDocument,
    options
  )
}
export type UserProfilesStatisticsChartQueryHookResult = ReturnType<typeof useUserProfilesStatisticsChartQuery>
export type UserProfilesStatisticsChartLazyQueryHookResult = ReturnType<typeof useUserProfilesStatisticsChartLazyQuery>
export type UserProfilesStatisticsChartQueryResult = Apollo.QueryResult<
  UserProfilesStatisticsChartQuery,
  UserProfilesStatisticsChartQueryVariables
>
export const UsersDocument = gql`
  query users(
    $filter: UsersPermissionsUserFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    usersPermissionsUsers(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          email
          userProfile {
            data {
              attributes {
                company {
                  data {
                    id
                    attributes {
                      name
                    }
                  }
                }
                fullName
                avatar {
                  data {
                    id
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export type UsersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<UsersQuery, UsersQueryVariables>,
  "query"
>

export const UsersComponent = (props: UsersComponentProps) => (
  <ApolloReactComponents.Query<UsersQuery, UsersQueryVariables> query={UsersDocument} {...props} />
)

export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options)
}
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options)
}
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>
export const WayleaveFormDocument = gql`
  query wayleaveForm($id: ID!) {
    wayleaveForm(id: $id) {
      data {
        id
        attributes {
          name
          document {
            data {
              attributes {
                name
                url
                ext
              }
            }
          }
        }
      }
    }
  }
`
export type WayleaveFormComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<WayleaveFormQuery, WayleaveFormQueryVariables>,
  "query"
> &
  ({ variables: WayleaveFormQueryVariables; skip?: boolean } | { skip: boolean })

export const WayleaveFormComponent = (props: WayleaveFormComponentProps) => (
  <ApolloReactComponents.Query<WayleaveFormQuery, WayleaveFormQueryVariables> query={WayleaveFormDocument} {...props} />
)

export function useWayleaveFormQuery(
  baseOptions: Apollo.QueryHookOptions<WayleaveFormQuery, WayleaveFormQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<WayleaveFormQuery, WayleaveFormQueryVariables>(WayleaveFormDocument, options)
}
export function useWayleaveFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WayleaveFormQuery, WayleaveFormQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<WayleaveFormQuery, WayleaveFormQueryVariables>(WayleaveFormDocument, options)
}
export type WayleaveFormQueryHookResult = ReturnType<typeof useWayleaveFormQuery>
export type WayleaveFormLazyQueryHookResult = ReturnType<typeof useWayleaveFormLazyQuery>
export type WayleaveFormQueryResult = Apollo.QueryResult<WayleaveFormQuery, WayleaveFormQueryVariables>
export const WayleaveFormsTableDocument = gql`
  query wayleaveFormsTable(
    $filter: WayleaveFormFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    wayleaveForms(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`
export type WayleaveFormsTableComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<WayleaveFormsTableQuery, WayleaveFormsTableQueryVariables>,
  "query"
>

export const WayleaveFormsTableComponent = (props: WayleaveFormsTableComponentProps) => (
  <ApolloReactComponents.Query<WayleaveFormsTableQuery, WayleaveFormsTableQueryVariables>
    query={WayleaveFormsTableDocument}
    {...props}
  />
)

export function useWayleaveFormsTableQuery(
  baseOptions?: Apollo.QueryHookOptions<WayleaveFormsTableQuery, WayleaveFormsTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<WayleaveFormsTableQuery, WayleaveFormsTableQueryVariables>(WayleaveFormsTableDocument, options)
}
export function useWayleaveFormsTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WayleaveFormsTableQuery, WayleaveFormsTableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<WayleaveFormsTableQuery, WayleaveFormsTableQueryVariables>(
    WayleaveFormsTableDocument,
    options
  )
}
export type WayleaveFormsTableQueryHookResult = ReturnType<typeof useWayleaveFormsTableQuery>
export type WayleaveFormsTableLazyQueryHookResult = ReturnType<typeof useWayleaveFormsTableLazyQuery>
export type WayleaveFormsTableQueryResult = Apollo.QueryResult<
  WayleaveFormsTableQuery,
  WayleaveFormsTableQueryVariables
>
export const WebsiteDocument = gql`
  query website {
    website {
      data {
        ...Website
      }
    }
  }
  ${WebsiteFragmentDoc}
  ${SeoFragmentDoc}
  ${HomeFragmentDoc}
  ${FileFragmentDoc}
  ${FreeQuoteFragmentDoc}
  ${InfoPageFragmentDoc}
`
export type WebsiteComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<WebsiteQuery, WebsiteQueryVariables>,
  "query"
>

export const WebsiteComponent = (props: WebsiteComponentProps) => (
  <ApolloReactComponents.Query<WebsiteQuery, WebsiteQueryVariables> query={WebsiteDocument} {...props} />
)

export function useWebsiteQuery(baseOptions?: Apollo.QueryHookOptions<WebsiteQuery, WebsiteQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<WebsiteQuery, WebsiteQueryVariables>(WebsiteDocument, options)
}
export function useWebsiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteQuery, WebsiteQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<WebsiteQuery, WebsiteQueryVariables>(WebsiteDocument, options)
}
export type WebsiteQueryHookResult = ReturnType<typeof useWebsiteQuery>
export type WebsiteLazyQueryHookResult = ReturnType<typeof useWebsiteLazyQuery>
export type WebsiteQueryResult = Apollo.QueryResult<WebsiteQuery, WebsiteQueryVariables>
export const WebsiteMediaFilesDocument = gql`
  query websiteMediaFiles(
    $filter: WebsiteMediaFileFiltersInput
    $sort: [String] = ["createdAt:DESC"]
    $pagination: PaginationArg
  ) {
    websiteMediaFiles(filters: $filter, sort: $sort, pagination: $pagination) {
      data {
        id
        attributes {
          slug
          image {
            data {
              ...File
            }
          }
        }
      }
    }
  }
  ${FileFragmentDoc}
`
export type WebsiteMediaFilesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<WebsiteMediaFilesQuery, WebsiteMediaFilesQueryVariables>,
  "query"
>

export const WebsiteMediaFilesComponent = (props: WebsiteMediaFilesComponentProps) => (
  <ApolloReactComponents.Query<WebsiteMediaFilesQuery, WebsiteMediaFilesQueryVariables>
    query={WebsiteMediaFilesDocument}
    {...props}
  />
)

export function useWebsiteMediaFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<WebsiteMediaFilesQuery, WebsiteMediaFilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<WebsiteMediaFilesQuery, WebsiteMediaFilesQueryVariables>(WebsiteMediaFilesDocument, options)
}
export function useWebsiteMediaFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WebsiteMediaFilesQuery, WebsiteMediaFilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<WebsiteMediaFilesQuery, WebsiteMediaFilesQueryVariables>(
    WebsiteMediaFilesDocument,
    options
  )
}
export type WebsiteMediaFilesQueryHookResult = ReturnType<typeof useWebsiteMediaFilesQuery>
export type WebsiteMediaFilesLazyQueryHookResult = ReturnType<typeof useWebsiteMediaFilesLazyQuery>
export type WebsiteMediaFilesQueryResult = Apollo.QueryResult<WebsiteMediaFilesQuery, WebsiteMediaFilesQueryVariables>
